{
  "package": "@moreyears/icons",
  "version": "1.0.0",
  "exportedAt": "2026-02-15T17:14:42.033Z",
  "weights": [
    "Broken",
    "Line Duotone",
    "Linear",
    "Outline",
    "Bold",
    "Bold Duotone"
  ],
  "categories": {
    "messages-conversation": {
      "name": "Messages, Conversation",
      "slug": "messages-conversation",
      "icons": [
        "chat-round-dots",
        "dialog",
        "chat-round-line",
        "chat-round",
        "chat-round-money",
        "chat-round-video",
        "chat-round-like",
        "chat-round-check",
        "chat-round-call",
        "chat-round-unread",
        "chat-dots",
        "dialog-2",
        "chat-line",
        "chat-unread",
        "chat-square",
        "chat-square-like",
        "chat-square-code",
        "chat-square-check",
        "chat-square-arrow",
        "chat-square-call",
        "check-read",
        "unread",
        "inbox-unread",
        "inbox-out",
        "inbox-in",
        "inbox-line",
        "inbox-archive",
        "inbox",
        "mailbox",
        "letter",
        "letter-unread",
        "letter-opened",
        "pen-2",
        "pen",
        "pen-new-square",
        "pen-new-round",
        "forward",
        "multiple-forward-right",
        "multiple-forward-left",
        "square-forward",
        "paperclip",
        "paperclip-rounded-2",
        "paperclip-rounded",
        "paperclip-2",
        "square-share-line",
        "plain",
        "plain-2",
        "plain-3"
      ]
    },
    "arrows": {
      "name": "Arrows",
      "slug": "arrows",
      "icons": [
        "square-double-alt-arrow-down",
        "square-double-alt-arrow-up",
        "square-double-alt-arrow-right",
        "square-double-alt-arrow-left",
        "square-alt-arrow-right",
        "square-alt-arrow-left",
        "square-alt-arrow-up",
        "square-alt-arrow-down",
        "square-arrow-right",
        "square-arrow-left",
        "square-arrow-up",
        "square-arrow-down",
        "square-arrow-left-down",
        "square-arrow-right-down",
        "square-arrow-right-up",
        "square-arrow-left-up",
        "square-sort-vertical",
        "square-transfer-vertical",
        "square-sort-horizontal",
        "square-transfer-horizontal",
        "round-alt-arrow-right",
        "round-alt-arrow-left",
        "round-arrow-up",
        "round-arrow-left",
        "round-arrow-down",
        "round-arrow-left-down",
        "round-arrow-right-down",
        "round-double-alt-arrow-down",
        "round-arrow-left-up",
        "round-sort-vertical",
        "round-transfer-horizontal",
        "round-arrow-right",
        "round-transfer-vertical",
        "round-arrow-right-up",
        "round-alt-arrow-down",
        "round-alt-arrow-up",
        "round-sort-horizontal",
        "round-double-alt-arrow-right",
        "round-double-alt-arrow-left",
        "round-double-alt-arrow-up",
        "round-transfer-diagonal",
        "transfer-horizontal",
        "transfer-vertical",
        "sort-vertical",
        "sort-horizontal",
        "double-alt-arrow-down",
        "double-alt-arrow-up",
        "double-alt-arrow-right",
        "double-alt-arrow-left",
        "arrow-down",
        "arrow-up",
        "arrow-left-down",
        "arrow-right-down",
        "arrow-left-up",
        "arrow-right-up",
        "arrow-left",
        "arrow-right",
        "alt-arrow-down",
        "alt-arrow-up",
        "alt-arrow-left",
        "alt-arrow-right",
        "restart",
        "refresh",
        "refresh-circle",
        "restart-circle",
        "refresh-square",
        "restart-square"
      ]
    },
    "map-location": {
      "name": "Map & Location",
      "slug": "map-location",
      "icons": [
        "map-point",
        "map-point-wave",
        "map-point-rotate",
        "map-point-favourite",
        "map-point-remove",
        "map-point-add",
        "map-point-search",
        "map-point-hospital",
        "map-point-school",
        "people-nearby",
        "compass",
        "compass-square",
        "map",
        "point-on-map",
        "global",
        "map-arrow-up",
        "map-arrow-down",
        "map-arrow-right",
        "map-arrow-left",
        "map-arrow-square",
        "branching-paths-up",
        "branching-paths-down",
        "route",
        "signpost",
        "signpost-2",
        "streets-navigation",
        "streets",
        "streets-map-point",
        "point-on-map-perspective",
        "radar",
        "radar-2",
        "routing",
        "routing-2",
        "routing-3",
        "gps",
        "compass-big",
        "globus"
      ]
    },
    "video-audio-sound": {
      "name": "Video, Audio, Sound",
      "slug": "video-audio-sound",
      "icons": [
        "gallery",
        "music-note-4",
        "rewind-5-seconds-back",
        "clapperboard",
        "video-frame",
        "soundwave",
        "record-circle",
        "record",
        "microphone-2",
        "library",
        "repeat",
        "volume-loud",
        "volume-small",
        "video-frame-cut",
        "clapperboard-play",
        "rewind-5-seconds-forward",
        "gallery-minimalistic",
        "repeat-one",
        "music-note-3",
        "soundwave-square",
        "album",
        "stop",
        "vinyl-record",
        "microphone-3",
        "muted",
        "clapperboard-open",
        "rewind-15-seconds-forward",
        "music-note-2",
        "repeat-one-minimalistic",
        "gallery-download",
        "microphone",
        "video-frame-cut-2",
        "soundwave-circle",
        "gallery-wide",
        "play",
        "vinyl",
        "pause",
        "video-frame-replace",
        "volume",
        "play-stream",
        "clapperboard-open-play",
        "rewind-15-seconds-back",
        "video-library",
        "music-note",
        "microphone-large",
        "gallery-send",
        "gallery-add",
        "rewind-forward",
        "clapperboard-edit",
        "rewind-10-seconds-back",
        "music-library-2",
        "volume-cross",
        "podcast",
        "wallpaper",
        "music-notes",
        "video-frame-2",
        "music-library",
        "video-frame-play-horizontal",
        "gallery-remove",
        "music-note-slider",
        "upload-track-2",
        "rewind-10-seconds-forward",
        "clapperboard-text",
        "rewind-back",
        "video-frame-play-vertical",
        "upload-track",
        "skip-next",
        "music-note-slider-2",
        "gallery-check",
        "gallery-edit",
        "skip-previous",
        "panorama",
        "play-circle",
        "pause-circle",
        "gallery-favourite",
        "gallery-circle",
        "stop-circle",
        "gallery-round",
        "rewind-forward-circle",
        "rewind-back-circle",
        "videocamera",
        "videocamera-record",
        "videocamera-add",
        "stream",
        "camera-square",
        "camera",
        "camera-add",
        "camera-minimalistic",
        "camera-rotate",
        "shuffle",
        "reel",
        "reel-2",
        "playback-speed",
        "pip-2",
        "pip",
        "to-pip",
        "quit-pip",
        "full-screen",
        "quit-full-screen",
        "quit-full-screen-square",
        "quit-full-screen-circle",
        "full-screen-square",
        "full-screen-circle"
      ]
    },
    "money": {
      "name": "Money",
      "slug": "money",
      "icons": [
        "wallet",
        "wallet-2",
        "cardholder",
        "wallet-money",
        "ticker-star",
        "ticket",
        "ticket-sale",
        "card",
        "card-2",
        "card-transfer",
        "card-send",
        "card-recive",
        "card-search",
        "verified-check",
        "sale",
        "sale-square",
        "tag",
        "tag-price",
        "tag-horizontal",
        "euro",
        "ruble",
        "dollar",
        "dollar-minimalistic",
        "banknote",
        "banknote-2",
        "wad-of-money",
        "safe-square",
        "safe-circle",
        "safe-2",
        "cash-out",
        "bill-list",
        "bill-cross",
        "bill-check",
        "bill",
        "money-bag"
      ]
    },
    "electronic-devices": {
      "name": "Electronic, Devices",
      "slug": "electronic-devices",
      "icons": [
        "gamepad-old",
        "gamepad-minimalistic",
        "gamepad-no-charge",
        "gamepad",
        "gamepad-charge",
        "iphone",
        "smartphone",
        "smartphone-2",
        "smartphone-update",
        "smartphone-rotate-orientation",
        "smartphone-vibration",
        "smartphone-rotate-2",
        "smartphone-rotate-angle",
        "tablet",
        "headphones-round",
        "headphones-round-sound",
        "headphones-square",
        "headphones-square-sound",
        "server",
        "server-2",
        "server-square",
        "server-path",
        "server-minimalistic",
        "server-square-update",
        "server-square-cloud",
        "mouse-minimalistic",
        "mouse",
        "mouse-circle",
        "airbuds",
        "airbuds-case",
        "airbuds-case-minimalistic",
        "airbuds-case-charge",
        "airbuds-case-open",
        "airbuds-check",
        "airbuds-remove",
        "airbuds-charge",
        "airbuds-right",
        "airbuds-left",
        "laptop-minimalistic",
        "laptop-3",
        "laptop-2",
        "laptop",
        "cpu",
        "cpu-bolt",
        "turntable",
        "turntable-minimalistic",
        "turntable-music-note",
        "boombox",
        "cassette",
        "cassette-2",
        "monitor",
        "monitor-camera",
        "monitor-smartphone",
        "printer-2",
        "printer",
        "printer-minimalistic",
        "bluetooth",
        "bluetooth-wave",
        "bluetooth-square",
        "bluetooth-circle",
        "keyboard",
        "telescope",
        "smart-speaker-2",
        "smart-speaker",
        "smart-speaker-minimalistic",
        "gameboy",
        "display",
        "tv",
        "radio-minimalistic",
        "radio",
        "sim-card",
        "sim-cards",
        "sim-card-minimalistic",
        "projector",
        "sd-card",
        "diskette",
        "plug-circle",
        "wireless-charge",
        "devices",
        "ssd-round",
        "ssd-square",
        "cloud-storage",
        "flash-drive",
        "lightning",
        "weigher",
        "lightbulb",
        "lightbulb-bolt",
        "lightbulb-minimalistic",
        "socket"
      ]
    },
    "weather": {
      "name": "Weather",
      "slug": "weather",
      "icons": [
        "cloud",
        "clouds",
        "cloud-plus",
        "cloud-minus",
        "clound-cross",
        "cloud-check",
        "cloud-bolt",
        "cloud-sun",
        "fog",
        "cloud-bolt-minimalistic",
        "cloud-sun-2",
        "cloud-snowfall",
        "cloud-storm",
        "cloud-rain",
        "cloud-waterdrop",
        "cloud-waterdrops",
        "tornado",
        "cloud-snowfall-minimalistic",
        "cloud-download",
        "cloud-upload",
        "moon",
        "moon-stars",
        "stars",
        "moon-sleep",
        "cloudy-moon",
        "sun-2",
        "sun",
        "moon-fog",
        "snowflake",
        "sun-fog",
        "sunrise",
        "sunset",
        "wind",
        "waterdrops",
        "tornado-small",
        "temperature"
      ]
    },
    "files": {
      "name": "Files",
      "slug": "files",
      "icons": [
        "file",
        "file-text",
        "file-check",
        "file-remove",
        "file-favourite",
        "file-send",
        "file-left",
        "file-right",
        "file-download",
        "figma-file",
        "code-file",
        "cloud-file",
        "file-smile",
        "file-corrupted",
        "zip-file"
      ]
    },
    "astronomy": {
      "name": "Astronomy",
      "slug": "astronomy",
      "icons": [
        "black-hole",
        "black-hole-2",
        "black-hole-3",
        "men",
        "women",
        "atom",
        "planet",
        "planet-2",
        "planet-3",
        "planet-4",
        "earth",
        "asteroid",
        "satellite",
        "infinity",
        "rocket",
        "rocket-2",
        "star-circle",
        "star-angle",
        "star-fall",
        "star-rainbow",
        "star",
        "stars",
        "stars-line",
        "stars-minimalistic",
        "star-fall-minimalistic",
        "star-fall-minimalistic-2",
        "star-fall-2",
        "star-ring",
        "star-rings",
        "ufo",
        "ufo-2",
        "ufo-3"
      ]
    },
    "folders": {
      "name": "Folders",
      "slug": "folders",
      "icons": [
        "folder",
        "folder-2",
        "folder-with-files",
        "folder-check",
        "folder-error",
        "remove-folder",
        "add-folder",
        "folder-favourite-star",
        "folder-favourite-bookmark",
        "move-to-folder",
        "folder-path-connect",
        "folder-cloud",
        "folder-security",
        "folder-open"
      ]
    },
    "faces-emotions-stickers": {
      "name": "Faces, Emotions, Stickers",
      "slug": "faces-emotions-stickers",
      "icons": [
        "smile-circle",
        "smile-square",
        "expressionless-circle",
        "expressionless-square",
        "sad-circle",
        "sad-square",
        "face-scan-square",
        "face-scan-circle",
        "emoji-funny-square",
        "emoji-funny-circle",
        "sticker-smile-square",
        "sticker-circle",
        "sticker-square",
        "sticker-smile-circle-2",
        "sticker-smile-circle",
        "sleeping-circle",
        "sleeping-square",
        "confounded-circle",
        "confounded-square",
        "facemask-circle",
        "facemask-square"
      ]
    },
    "sports": {
      "name": "Sports",
      "slug": "sports",
      "icons": [
        "bicycling-round",
        "skateboarding-round",
        "skateboarding",
        "skateboard",
        "bicycling",
        "running",
        "running-round",
        "running-2",
        "walking-round",
        "walking",
        "hiking",
        "hiking-round",
        "hiking-minimalistic",
        "meditation-round",
        "meditation",
        "stretching",
        "stretching-round",
        "treadmill",
        "treadmill-round",
        "swimming",
        "water",
        "water-sun",
        "dumbbell",
        "dumbbells",
        "dumbbells-2",
        "dumbbell-large",
        "dumbbell-large-minimalistic",
        "dumbbell-small",
        "ranking",
        "body-shape-minimalistic",
        "body-shape",
        "golf",
        "tennis",
        "tennis-2",
        "volleyball",
        "volleyball-2",
        "football",
        "rugby",
        "basketball",
        "balls",
        "bowling"
      ]
    },
    "search": {
      "name": "Search",
      "slug": "search",
      "icons": [
        "minimalistic-magnifer",
        "minimalistic-magnifer-zoom-in",
        "minimalistic-magnifer-zoom-out",
        "minimalistic-magnifer-bug",
        "magnifer",
        "magnifer-zoom-in",
        "magnifer-zoom-out",
        "magnifer-bug",
        "rounded-magnifer",
        "rounded-magnifer-zoom-in",
        "rounded-magnifer-zoom-out",
        "rounded-magnifer-bug"
      ]
    },
    "time": {
      "name": "Time",
      "slug": "time",
      "icons": [
        "clock-circle",
        "history",
        "clock-square",
        "alarm",
        "alarm-sleep",
        "alarm-play",
        "alarm-pause",
        "alarm-add",
        "alarm-remove",
        "alarm-turn-off",
        "stopwatch",
        "stopwatch-play",
        "stopwatch-pause",
        "history-2",
        "history-3",
        "hourglass",
        "hourglass-line",
        "calendar-minimalistic",
        "calendar",
        "calendar-mark",
        "calendar-date",
        "calendar-search",
        "calendar-add",
        "watch-round",
        "watch-square",
        "watch-square-minimalistic",
        "watch-square-minimalistic-charge"
      ]
    },
    "list": {
      "name": "List",
      "slug": "list",
      "icons": [
        "plaaylist-minimalistic",
        "playlist-2",
        "playlist-minimalistic-2",
        "playlist-minimalistic-3",
        "list-heart",
        "list-heart-minimalistic",
        "list-down-minimalistic",
        "list-down",
        "list-check",
        "list-check-minimalistic",
        "list-cross",
        "list-cross-minimalistic",
        "sort-from-top-to-bottom",
        "sort-from-bottom-to-top",
        "list",
        "sort-by-alphabet",
        "sort-by-time",
        "list-up",
        "list-up-minimalistic",
        "list-arrow-up",
        "list-arrow-up-minimalistic",
        "list-arrow-down",
        "list-arrow-down-minimalistic",
        "playlist",
        "bill",
        "checklist-minimalistic",
        "checklist",
        "list"
      ]
    },
    "essentional-ui": {
      "name": "Essentional, UI",
      "slug": "essentional-ui",
      "icons": [
        "check-circle",
        "close-circle",
        "add-circle",
        "question-circle",
        "danger-circle",
        "info-circle",
        "minus-circle",
        "forbidden-circle",
        "forbidden",
        "danger",
        "danger-triangle",
        "check-square",
        "close-square",
        "add-square",
        "question-square",
        "danger-square",
        "info-square",
        "minus-square",
        "revote",
        "menu-dots-circle",
        "menu-dots-square",
        "menu-dots",
        "home",
        "home-2",
        "home-smile",
        "home-add",
        "home-wifi",
        "smart-home",
        "home-angle",
        "home-angle-2",
        "home-smile-angle",
        "home-add-angle",
        "home-wifi-angle",
        "smart-home-angle",
        "battery-full-minimalistic",
        "battery-half-minimalistic",
        "battery-low-minimalistic",
        "battery-charge-minimalistic",
        "battery-full",
        "battery-half",
        "battery-low",
        "battery-charge",
        "slider-vertical",
        "slider-vertical-minimalistic",
        "slider-horizontal",
        "slider-minimalistic-horizontal",
        "database",
        "traffic-economy",
        "traffic",
        "crown-minimalistic",
        "crown-star",
        "crown-line",
        "crown",
        "pin",
        "pin-list",
        "pin-circle",
        "trash-bin-minimalistic",
        "trash-bin-trash",
        "trash-bin-minimalistic-2",
        "trash-bin-2",
        "share",
        "share-circle",
        "target",
        "waterdrop",
        "plate",
        "broom",
        "copy",
        "subtitles",
        "cat",
        "umbrella",
        "ghost",
        "ghost-smile",
        "posts-carousel-vertical",
        "posts-carousel-horizontal",
        "bolt",
        "bolt-circle",
        "power",
        "fuel",
        "figma",
        "winrar",
        "help",
        "flag",
        "flag-2",
        "balloon",
        "paw",
        "cup",
        "cup-star",
        "cup-first",
        "cup-music",
        "special-effects",
        "xxx",
        "explicit",
        "high-quality",
        "high-definition",
        "4k",
        "creative-commons",
        "copyright",
        "augmented-reality",
        "hamburger-menu",
        "reorder",
        "sort",
        "filter",
        "paper-bin",
        "glasses",
        "scissors",
        "scissors-square",
        "box-minimalistic",
        "box",
        "feed",
        "ferris-wheel",
        "perfume",
        "sleeping",
        "delivery",
        "gift",
        "magic-stick",
        "magic-stick-2",
        "magic-stick-3",
        "sledgehammer",
        "magnet",
        "magnet-wave",
        "flashlight",
        "flashlight-on",
        "cursor",
        "cursor-square",
        "cosmetic",
        "mirror",
        "confetti-minimalistic",
        "confetti",
        "hanger",
        "hanger-2",
        "body",
        "t-shirt",
        "skirt",
        "accessibility",
        "mask-sad",
        "mask-happly",
        "masks",
        "mention-square",
        "mention-circle"
      ]
    },
    "call": {
      "name": "Call",
      "slug": "call",
      "icons": [
        "end-call-rounded",
        "phone-rounded",
        "phone-calling-rounded",
        "call-cancel-rounded",
        "outgoing-call-rounded",
        "incoming-call-rounded",
        "call-dropped-rounded",
        "call-chat-rounded",
        "call-medicine-rounded",
        "phone",
        "end-call",
        "phone-calling",
        "call-cancel",
        "outgoing-call",
        "incoming-call",
        "call-dropped",
        "call-chat",
        "call-medicine",
        "record-minimalistic",
        "record-square",
        "record-circle"
      ]
    },
    "medicine": {
      "name": "Medicine",
      "slug": "medicine",
      "icons": [
        "dna",
        "bacteria",
        "syringe",
        "jar-of-pills",
        "jar-of-pills-2",
        "stethoscope",
        "pills-2",
        "pills-3",
        "benzene-ring",
        "thermometer",
        "dropper",
        "dropper-2",
        "dropper-3",
        "dropper-minimalistic",
        "dropper-minimalistic-2",
        "adhesive-plaster",
        "adhesive-plaster-2",
        "pill",
        "pills",
        "bone",
        "bone-crack",
        "bone-broken",
        "bones",
        "test-tube",
        "test-tube-minimalistic",
        "pulse-2",
        "pulse",
        "heart-pulse",
        "heart-pulse-2",
        "medical-kit",
        "health",
        "virus"
      ]
    },
    "home-furniture": {
      "name": "Home, Furniture",
      "slug": "home-furniture",
      "icons": [
        "condicioner",
        "condicioner-2",
        "speaker",
        "speaker-minimalistic",
        "remote-controller",
        "remote-controller-minimalistic",
        "remote-controller-2",
        "washing-machine-minimalistic",
        "washing-machine",
        "sofa",
        "sofa-2",
        "sofa-3",
        "bedside-table-4",
        "closet",
        "trellis",
        "mirror",
        "bath",
        "chandelier",
        "closet-2",
        "bed",
        "chair-2",
        "lamp",
        "floor-lamp",
        "floor-lamp-minimalistic",
        "bedside-table",
        "bedside-table-2",
        "bedside-table-3",
        "smart-vacuum-cleaner",
        "smart-vacuum-cleaner-2",
        "fridge",
        "armchair",
        "armchair-2",
        "chair",
        "bar-chair",
        "volume-knob"
      ]
    },
    "network-it-programming": {
      "name": "Network, IT, Programming",
      "slug": "network-it-programming",
      "icons": [
        "wi-fi-router-round",
        "wi-fi-router-minimalistic",
        "wi-fi-router",
        "sidebar-minimalistic",
        "siderbar",
        "sidebar-code",
        "translation-2",
        "window-frame",
        "usb-circle",
        "usb",
        "usb-square",
        "screencast",
        "code-circle",
        "code-square",
        "code",
        "code-2",
        "slash-square",
        "slash-circle",
        "programming",
        "screencast-2",
        "translation",
        "station",
        "station-minimalistic",
        "structure",
        "command",
        "bug-minimalistic",
        "bug",
        "hashtag",
        "hashtag-square",
        "hashtag-circle",
        "hashtag-chat"
      ]
    },
    "settings-fine-tuning": {
      "name": "Settings, Fine Tuning",
      "slug": "settings-fine-tuning",
      "icons": [
        "settings-minimalistic",
        "settings",
        "widget",
        "widget-2",
        "widget-6",
        "widget-3",
        "widget-4",
        "widget-5",
        "widget-add",
        "tuning-square",
        "tuning-square-2",
        "tuning",
        "tuning-2",
        "tuning-3",
        "tuning-4"
      ]
    },
    "text-formatting": {
      "name": "Text Formatting",
      "slug": "text-formatting",
      "icons": [
        "eraser",
        "eraser-square",
        "eraser-circle",
        "text-italic",
        "text-italic-square",
        "text-italic-circle",
        "text-circle",
        "text-cross-circle",
        "text-underline-circle",
        "text-bold-circle",
        "text",
        "text-cross",
        "text-square",
        "text-cross-square",
        "text-underline",
        "text-underline-cross",
        "text-bold",
        "text-bold-square",
        "paragraph-spacing",
        "text-square-2",
        "text-selection",
        "link-circle",
        "link-square",
        "link-broken-minimalistic",
        "link",
        "link-broken",
        "link-minimalistic",
        "link-minimalistic-2",
        "link-round",
        "link-round-angle",
        "backspace",
        "text-field",
        "text-field-focus"
      ]
    },
    "business-statistic": {
      "name": "Business, Statistic",
      "slug": "business-statistic",
      "icons": [
        "pie-chart",
        "pie-chart-2",
        "pie-chart-3",
        "round-graph",
        "graph",
        "graph-up",
        "graph-new",
        "graph-new-up",
        "graph-down",
        "graph-down-new",
        "presentation-graph",
        "diagram-up",
        "diagram-down",
        "chart",
        "chart-square",
        "chat-square-2",
        "course-up",
        "course-down",
        "chart-2"
      ]
    },
    "shopping-ecommerce": {
      "name": "Shopping, Ecommerce",
      "slug": "shopping-ecommerce",
      "icons": [
        "cart-4",
        "cart-large",
        "cart-large-2",
        "cart-large-minimalistic",
        "cart-check",
        "cart-cross",
        "cart-plus",
        "cart-large-3",
        "cart-large-4",
        "cart",
        "cart-2",
        "cart-3",
        "cart-5",
        "bag",
        "bag-check",
        "bag-cross",
        "bag-2",
        "bag-3",
        "bag-4",
        "bag-music",
        "bag-smile",
        "bag-music-2",
        "bag-5",
        "bag-heart",
        "shop",
        "shop-minimalistic",
        "shop-2"
      ]
    },
    "nature-travel": {
      "name": "Nature, Travel",
      "slug": "nature-travel",
      "icons": [
        "fire",
        "flame",
        "fire-minimalistic",
        "fire-square",
        "bonfire",
        "leaf",
        "suitcase",
        "suitcase-tag",
        "suitcase-lines"
      ]
    },
    "school": {
      "name": "School",
      "slug": "school",
      "icons": [
        "diploma",
        "diploma-verified",
        "case-round-minimalistic",
        "case-minimalistic",
        "case",
        "case-round",
        "square-academic-cap",
        "square-academic-cap-2",
        "notebook-minimalistic",
        "notebook-bookmark",
        "notebook",
        "notebook-square",
        "book",
        "book-minimalistic",
        "book-bookmark",
        "book-bookmark-minimalistic",
        "book-2",
        "backpack",
        "plus-minus",
        "calculator-minimalistic",
        "calculator",
        "bookmark",
        "bookmark-square-minimalistic",
        "bookmark-opened",
        "bookmark-circle",
        "bookmark-square",
        "passport",
        "passport-minimalistic",
        "document"
      ]
    },
    "design-tools": {
      "name": "Design, Tools",
      "slug": "design-tools",
      "icons": [
        "ruler",
        "ruler-pen",
        "ruler-cross-pen",
        "ruler-angular",
        "pipette",
        "three-squares",
        "filters",
        "flip-horizontal",
        "flip-vertical",
        "colour-tuneing",
        "radial-blur",
        "mirror-left",
        "mirror-right",
        "crop-minimalistic",
        "crop",
        "layers-minimalistic",
        "layers",
        "palette",
        "palette-round",
        "pallete-2",
        "paint-roller",
        "align-left",
        "align-right",
        "align-bottom",
        "align-top",
        "align-vertical-center",
        "align-horizontal-center",
        "align-horizonta-spacing",
        "align-vertical-spacing"
      ]
    },
    "food-kitchen": {
      "name": "Food, Kitchen",
      "slug": "food-kitchen",
      "icons": [
        "cup-hot",
        "cup",
        "tea-cup",
        "bottle",
        "cup-paper",
        "donut",
        "donut-bitten",
        "chef-hat",
        "chef-hat-minimalistic",
        "chef-hat-heart",
        "wineglass-triangle",
        "wineglass",
        "rolling-pin",
        "corkscrew",
        "ladle",
        "whisk",
        "oven-mitts",
        "oven-mitts-minimalistic"
      ]
    },
    "like": {
      "name": "Like",
      "slug": "like",
      "icons": [
        "heart",
        "star",
        "heart-angle",
        "star-shine",
        "heart-broken",
        "hearts",
        "heart-lock",
        "heart-unlock",
        "heart-shine",
        "like",
        "dislike",
        "medal-ribbons-star",
        "medal-ribbon-star",
        "medal-ribbon",
        "medal-star",
        "medal-star-circle",
        "medal-star-square"
      ]
    },
    "arrows-action": {
      "name": "Arrows Action",
      "slug": "arrows-action",
      "icons": [
        "send-twice-square",
        "recive-twice-square",
        "upload-twice-square",
        "download-twice-square",
        "send-square",
        "recive-square",
        "upload-square",
        "download-square",
        "undo-left-round",
        "undo-right-round",
        "undo-left",
        "undo-right",
        "undo-left-round-square",
        "undo-right-round-square",
        "undo-left-square",
        "undo-right-square",
        "square-bottom-up",
        "square-bottom-down",
        "square-top-up",
        "square-top-down",
        "scale",
        "minimize",
        "maximize",
        "circle-bottom-up",
        "circle-bottom-down",
        "circle-top-down",
        "circle-top-up",
        "reorder",
        "maximize-square-3",
        "minimize-square-3",
        "maximize-square",
        "maximize-square-minimalistic",
        "minimize-square",
        "minimize-square-minimalistic",
        "maximize-square-2",
        "minimize-square-2",
        "logout-2",
        "login-2",
        "logout",
        "login",
        "import",
        "export",
        "upload",
        "download",
        "upload-minimalistic",
        "download-minimalistic",
        "login-3",
        "logout-3",
        "exit",
        "screen-share",
        "forward",
        "reply",
        "forward-2",
        "reply-2",
        "arrow-to-down-left",
        "arrow-to-down-right",
        "arrow-to-top-right",
        "arrow-to-top-left"
      ]
    },
    "notes": {
      "name": "Notes",
      "slug": "notes",
      "icons": [
        "document",
        "document-text",
        "document-add",
        "document-medicine",
        "documents",
        "documents-minimalistic",
        "notes-minimalistic",
        "notes",
        "clipboard",
        "clipboard-list",
        "clipboard-text",
        "clipboard-remove",
        "clipboard-add",
        "clipboard-check",
        "notebook",
        "archive-down-minimlistic",
        "archive-up-minimlistic",
        "archive-minimalistic",
        "archive-down",
        "archive-up",
        "archive-check",
        "archive"
      ]
    },
    "notifications": {
      "name": "Notifications",
      "slug": "notifications",
      "icons": [
        "notification-unread",
        "notification-unread-lines",
        "notification-remove",
        "notification-lines-remove",
        "bell",
        "bell-bing",
        "bell-off"
      ]
    },
    "security": {
      "name": "Security",
      "slug": "security",
      "icons": [
        "bomb",
        "bomb-minimalistic",
        "bomb-emoji",
        "lock",
        "lock-unlocked",
        "lock-password",
        "lock-password-unlocked",
        "lock-keyhole-minimalistic",
        "lock-keyhole-minimalistic-unlocked",
        "lock-keyhole",
        "lock-keyhole-unlocked",
        "eye",
        "eye-closed",
        "siren-rounded",
        "siren",
        "password",
        "password-minimalistic",
        "password-minimalistic-input",
        "key",
        "key-square",
        "key-square-2",
        "key-minimalistic",
        "key-minimalistic-square",
        "key-minimalistic-square-2",
        "key-minimalistic-2",
        "key-minimalistic-square-3",
        "incognito",
        "shield-minimalistic",
        "shield-up",
        "shield",
        "shield-star",
        "shield-check",
        "shield-warning",
        "shield-minus",
        "shield-plus",
        "shield-cross",
        "shield-keyhole",
        "shield-keyhole-minimalistic",
        "shield-user",
        "shield-network",
        "qr-code",
        "scanner-2",
        "code-scan",
        "scanner",
        "object-scan",
        "eye-scan"
      ]
    },
    "users": {
      "name": "Users",
      "slug": "users",
      "icons": [
        "user-rounded",
        "users-group-rounded",
        "users-group-two-rounded",
        "user-check-rounded",
        "user-cross-rounded",
        "user-plus-rounded",
        "user-minus-rounded",
        "user-block-rounded",
        "user-circle",
        "user-speak-rounded",
        "user-heart-rounded",
        "user-id",
        "user",
        "user-check",
        "user-plus",
        "user-cross",
        "user-minus",
        "user-block",
        "user-speak",
        "user-heart",
        "user-hands",
        "user-hand-up"
      ]
    },
    "building-infrastructure": {
      "name": "Building, Infrastructure",
      "slug": "building-infrastructure",
      "icons": [
        "city",
        "buildings",
        "buildings-2",
        "buildings-3",
        "garage",
        "home",
        "hospital"
      ]
    },
    "hands": {
      "name": "Hands",
      "slug": "hands",
      "icons": [
        "hand-heart",
        "hand-stars",
        "hand-pills",
        "hand-money",
        "hand-shake"
      ]
    },
    "transport-parts-service": {
      "name": "Transport, Parts, Service",
      "slug": "transport-parts-service",
      "icons": [
        "gas-station",
        "electric-refueling",
        "shock-absorber",
        "accumulator",
        "transmission",
        "transmission-circle",
        "transmission-square",
        "suspension",
        "suspension-bolt",
        "suspension-cross",
        "tram",
        "bus",
        "wheel-angle",
        "wheel",
        "spedometer-middle",
        "spedometer-max",
        "spedometer-low",
        "scooter",
        "kick-scooter"
      ]
    },
    "health-benefits": {
      "name": "Health Benefits",
      "slug": "health-benefits",
      "icons": [
        "tooth",
        "sleep-rest",
        "relax",
        "cognitive",
        "virus-immunity",
        "stomach-digestion",
        "lungs",
        "kidney",
        "brain",
        "bacteria",
        "allergens",
        "eye-health",
        "skin"
      ]
    },
    "ingredients": {
      "name": "Ingredients",
      "slug": "ingredients",
      "icons": [
        "vegetables",
        "knife-fork",
        "carrot",
        "fish",
        "cake",
        "meat",
        "chicken-steam",
        "mint",
        "sesame",
        "apple",
        "shrimp",
        "peanut",
        "egg-fresh",
        "egg-fried",
        "soy-bean",
        "legume",
        "cheese-dairy",
        "grain",
        "sprout",
        "gluten"
      ]
    },
    "dogs": {
      "name": "Dogs",
      "slug": "dogs",
      "icons": [
        "paw-flex",
        "dog-1",
        "dog-side",
        "dog-2",
        "pet-food"
      ]
    },
    "additional": {
      "name": "Additional",
      "slug": "additional",
      "icons": [
        "add",
        "subtract",
        "arrow-left",
        "arrow-right",
        "arrow-up",
        "arrow-down",
        "lightning"
      ]
    }
  },
  "icons": {
    "messages-conversation/chat-round-dots": {
      "name": "Chat Round Dots",
      "slug": "chat-round-dots",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-dots",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-dots.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-dots.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-dots.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-dots.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-dots.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-dots.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "loading",
        "mail",
        "message",
        "thinking",
        "typing"
      ]
    },
    "messages-conversation/dialog": {
      "name": "Dialog",
      "slug": "dialog",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/dialog",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/dialog.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/dialog.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/dialog.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/dialog.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/dialog.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/dialog.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "discussion",
        "email",
        "mail",
        "message",
        "talk",
        "two-way"
      ]
    },
    "messages-conversation/chat-round-line": {
      "name": "Chat Round Line",
      "slug": "chat-round-line",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-line.svg"
        }
      ],
      "tags": [
        "bubble",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "text"
      ]
    },
    "messages-conversation/chat-round": {
      "name": "Chat Round",
      "slug": "chat-round",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round.svg"
        }
      ],
      "tags": [
        "bubble",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message"
      ]
    },
    "messages-conversation/chat-round-money": {
      "name": "Chat Round Money",
      "slug": "chat-round-money",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-money",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-money.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-money.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-money.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-money.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-money.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-money.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "finance",
        "mail",
        "message",
        "payment",
        "transaction"
      ]
    },
    "messages-conversation/chat-round-video": {
      "name": "Chat Round Video",
      "slug": "chat-round-video",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-video",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-video.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-video.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-video.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-video.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-video.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-video.svg"
        }
      ],
      "tags": [
        "call",
        "chat",
        "communication",
        "conversation",
        "email",
        "facetime",
        "mail",
        "message",
        "video-chat"
      ]
    },
    "messages-conversation/chat-round-like": {
      "name": "Chat Round Like",
      "slug": "chat-round-like",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-like",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-like.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-like.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-like.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-like.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-like.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-like.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "liked",
        "mail",
        "message",
        "reaction",
        "thumbs-up"
      ]
    },
    "messages-conversation/chat-round-check": {
      "name": "Chat Round Check",
      "slug": "chat-round-check",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-check.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "confirmed",
        "conversation",
        "delivered",
        "email",
        "mail",
        "message",
        "sent"
      ]
    },
    "messages-conversation/chat-round-call": {
      "name": "Chat Round Call",
      "slug": "chat-round-call",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-call",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-call.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-call.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-call.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-call.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-call.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-call.svg"
        }
      ],
      "tags": [
        "audio",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "phone",
        "voice-chat"
      ]
    },
    "messages-conversation/chat-round-unread": {
      "name": "Chat Round Unread",
      "slug": "chat-round-unread",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-round-unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-round-unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-round-unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-round-unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-round-unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-round-unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-round-unread.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "new-message",
        "notification",
        "unseen"
      ]
    },
    "messages-conversation/chat-dots": {
      "name": "Chat Dots",
      "slug": "chat-dots",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-dots",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-dots.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-dots.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-dots.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-dots.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-dots.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-dots.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "composing",
        "conversation",
        "email",
        "loading",
        "mail",
        "message",
        "thinking",
        "typing"
      ]
    },
    "messages-conversation/dialog-2": {
      "name": "Dialog 2",
      "slug": "dialog-2",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/dialog-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/dialog-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/dialog-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/dialog-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/dialog-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/dialog-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/dialog-2.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "discussion",
        "email",
        "mail",
        "message",
        "talk"
      ]
    },
    "messages-conversation/chat-line": {
      "name": "Chat Line",
      "slug": "chat-line",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-line.svg"
        }
      ],
      "tags": [
        "bubble",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "text"
      ]
    },
    "messages-conversation/chat-unread": {
      "name": "Chat Unread",
      "slug": "chat-unread",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-unread.svg"
        }
      ],
      "tags": [
        "badge",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "new-message",
        "notification"
      ]
    },
    "messages-conversation/chat-square": {
      "name": "Chat Square",
      "slug": "chat-square",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square.svg"
        }
      ],
      "tags": [
        "bubble",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "text"
      ]
    },
    "messages-conversation/chat-square-like": {
      "name": "Chat Square Like",
      "slug": "chat-square-like",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square-like",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square-like.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square-like.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square-like.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square-like.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square-like.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square-like.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "liked",
        "mail",
        "message",
        "reaction",
        "thumbs-up"
      ]
    },
    "messages-conversation/chat-square-code": {
      "name": "Chat Square Code",
      "slug": "chat-square-code",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square-code",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square-code.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square-code.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square-code.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square-code.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square-code.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square-code.svg"
        }
      ],
      "tags": [
        "chat",
        "code-review",
        "communication",
        "conversation",
        "developer",
        "email",
        "mail",
        "message",
        "snippet",
        "technical"
      ]
    },
    "messages-conversation/chat-square-check": {
      "name": "Chat Square Check",
      "slug": "chat-square-check",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square-check.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "confirmed",
        "conversation",
        "delivered",
        "email",
        "mail",
        "message",
        "sent"
      ]
    },
    "messages-conversation/chat-square-arrow": {
      "name": "Chat Square Arrow",
      "slug": "chat-square-arrow",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square-arrow",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square-arrow.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square-arrow.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square-arrow.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square-arrow.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square-arrow.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square-arrow.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "forward",
        "mail",
        "message",
        "redirect",
        "share"
      ]
    },
    "messages-conversation/chat-square-call": {
      "name": "Chat Square Call",
      "slug": "chat-square-call",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/chat-square-call",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/chat-square-call.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/chat-square-call.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/chat-square-call.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/chat-square-call.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/chat-square-call.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/chat-square-call.svg"
        }
      ],
      "tags": [
        "audio",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "phone",
        "voice-chat"
      ]
    },
    "messages-conversation/check-read": {
      "name": "Check Read",
      "slug": "check-read",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/check-read",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/check-read.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/check-read.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/check-read.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/check-read.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/check-read.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/check-read.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "delivered",
        "double-tick",
        "email",
        "mail",
        "message",
        "read-receipt",
        "seen"
      ]
    },
    "messages-conversation/unread": {
      "name": "Unread",
      "slug": "unread",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/unread.svg"
        }
      ],
      "tags": [
        "badge",
        "chat",
        "communication",
        "conversation",
        "dot",
        "email",
        "mail",
        "message",
        "new",
        "notification",
        "unseen"
      ]
    },
    "messages-conversation/inbox-unread": {
      "name": "Inbox Unread",
      "slug": "inbox-unread",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox-unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox-unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox-unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox-unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox-unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox-unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox-unread.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "new",
        "notification",
        "pending",
        "unread"
      ]
    },
    "messages-conversation/inbox-out": {
      "name": "Inbox Out",
      "slug": "inbox-out",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox-out",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox-out.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox-out.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox-out.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox-out.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox-out.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox-out.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "outbox",
        "outgoing",
        "sent"
      ]
    },
    "messages-conversation/inbox-in": {
      "name": "Inbox In",
      "slug": "inbox-in",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox-in",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox-in.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox-in.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox-in.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox-in.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox-in.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox-in.svg"
        }
      ],
      "tags": [
        "arrive",
        "chat",
        "communication",
        "conversation",
        "email",
        "incoming",
        "mail",
        "message",
        "receive"
      ]
    },
    "messages-conversation/inbox-line": {
      "name": "Inbox Line",
      "slug": "inbox-line",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox-line.svg"
        }
      ],
      "tags": [
        "chat",
        "clean",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "messages",
        "tray"
      ]
    },
    "messages-conversation/inbox-archive": {
      "name": "Inbox Archive",
      "slug": "inbox-archive",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox-archive",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox-archive.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox-archive.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox-archive.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox-archive.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox-archive.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox-archive.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "filed",
        "mail",
        "message",
        "old",
        "saved",
        "store"
      ]
    },
    "messages-conversation/inbox": {
      "name": "Inbox",
      "slug": "inbox",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/inbox",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/inbox.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/inbox.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/inbox.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/inbox.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/inbox.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/inbox.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "mailbox",
        "message",
        "messages",
        "received",
        "tray"
      ]
    },
    "messages-conversation/mailbox": {
      "name": "Mailbox",
      "slug": "mailbox",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/mailbox",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/mailbox.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/mailbox.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/mailbox.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/mailbox.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/mailbox.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/mailbox.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "letterbox",
        "mail",
        "message",
        "postal",
        "postbox"
      ]
    },
    "messages-conversation/letter": {
      "name": "Letter",
      "slug": "letter",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/letter",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/letter.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/letter.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/letter.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/letter.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/letter.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/letter.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "envelope",
        "mail",
        "message",
        "post"
      ]
    },
    "messages-conversation/letter-unread": {
      "name": "Letter Unread",
      "slug": "letter-unread",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/letter-unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/letter-unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/letter-unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/letter-unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/letter-unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/letter-unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/letter-unread.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "new",
        "notification",
        "unread"
      ]
    },
    "messages-conversation/letter-opened": {
      "name": "Letter Opened",
      "slug": "letter-opened",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/letter-opened",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/letter-opened.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/letter-opened.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/letter-opened.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/letter-opened.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/letter-opened.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/letter-opened.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "opened",
        "read",
        "viewed"
      ]
    },
    "messages-conversation/pen-2": {
      "name": "Pen 2",
      "slug": "pen-2",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/pen-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/pen-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/pen-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/pen-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/pen-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/pen-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/pen-2.svg"
        }
      ],
      "tags": [
        "author",
        "chat",
        "communication",
        "compose",
        "conversation",
        "edit",
        "email",
        "mail",
        "message",
        "write"
      ]
    },
    "messages-conversation/pen": {
      "name": "Pen",
      "slug": "pen",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/pen",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/pen.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/pen.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/pen.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/pen.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/pen.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/pen.svg"
        }
      ],
      "tags": [
        "author",
        "chat",
        "communication",
        "compose",
        "conversation",
        "edit",
        "email",
        "mail",
        "message",
        "write"
      ]
    },
    "messages-conversation/pen-new-square": {
      "name": "Pen New Square",
      "slug": "pen-new-square",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/pen-new-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/pen-new-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/pen-new-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/pen-new-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/pen-new-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/pen-new-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/pen-new-square.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "compose",
        "conversation",
        "create",
        "email",
        "mail",
        "message",
        "new-message",
        "write"
      ]
    },
    "messages-conversation/pen-new-round": {
      "name": "Pen New Round",
      "slug": "pen-new-round",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/pen-new-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/pen-new-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/pen-new-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/pen-new-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/pen-new-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/pen-new-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/pen-new-round.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "compose",
        "conversation",
        "create",
        "email",
        "mail",
        "message",
        "new-message",
        "write"
      ]
    },
    "messages-conversation/forward": {
      "name": "Forward",
      "slug": "forward",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/forward.svg"
        }
      ],
      "tags": [
        "advance",
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "next",
        "send"
      ]
    },
    "messages-conversation/multiple-forward-right": {
      "name": "Multiple Forward Right",
      "slug": "multiple-forward-right",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/multiple-forward-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/multiple-forward-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/multiple-forward-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/multiple-forward-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/multiple-forward-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/multiple-forward-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/multiple-forward-right.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "fast-forward",
        "mail",
        "message",
        "skip-ahead"
      ]
    },
    "messages-conversation/multiple-forward-left": {
      "name": "Multiple Forward Left",
      "slug": "multiple-forward-left",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/multiple-forward-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/multiple-forward-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/multiple-forward-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/multiple-forward-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/multiple-forward-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/multiple-forward-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/multiple-forward-left.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "fast-forward",
        "mail",
        "message",
        "rewind",
        "skip-back"
      ]
    },
    "messages-conversation/square-forward": {
      "name": "Square Forward",
      "slug": "square-forward",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/square-forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/square-forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/square-forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/square-forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/square-forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/square-forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/square-forward.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "redirect",
        "send",
        "share"
      ]
    },
    "messages-conversation/paperclip": {
      "name": "Paperclip",
      "slug": "paperclip",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/paperclip",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/paperclip.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/paperclip.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/paperclip.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/paperclip.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/paperclip.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/paperclip.svg"
        }
      ],
      "tags": [
        "attach",
        "attachment",
        "chat",
        "clip",
        "communication",
        "conversation",
        "email",
        "file",
        "mail",
        "message"
      ]
    },
    "messages-conversation/paperclip-rounded-2": {
      "name": "Paperclip Rounded 2",
      "slug": "paperclip-rounded-2",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/paperclip-rounded-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/paperclip-rounded-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/paperclip-rounded-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/paperclip-rounded-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/paperclip-rounded-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/paperclip-rounded-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/paperclip-rounded-2.svg"
        }
      ],
      "tags": [
        "attach",
        "attachment",
        "chat",
        "clip",
        "communication",
        "conversation",
        "email",
        "mail",
        "message"
      ]
    },
    "messages-conversation/paperclip-rounded": {
      "name": "Paperclip Rounded",
      "slug": "paperclip-rounded",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/paperclip-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/paperclip-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/paperclip-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/paperclip-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/paperclip-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/paperclip-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/paperclip-rounded.svg"
        }
      ],
      "tags": [
        "attach",
        "attachment",
        "chat",
        "clip",
        "communication",
        "conversation",
        "email",
        "mail",
        "message"
      ]
    },
    "messages-conversation/paperclip-2": {
      "name": "Paperclip 2",
      "slug": "paperclip-2",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/paperclip-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/paperclip-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/paperclip-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/paperclip-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/paperclip-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/paperclip-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/paperclip-2.svg"
        }
      ],
      "tags": [
        "attach",
        "attachment",
        "chat",
        "clip",
        "communication",
        "conversation",
        "email",
        "mail",
        "message"
      ]
    },
    "messages-conversation/square-share-line": {
      "name": "Square Share Line",
      "slug": "square-share-line",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/square-share-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/square-share-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/square-share-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/square-share-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/square-share-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/square-share-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/square-share-line.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "external",
        "link",
        "mail",
        "message",
        "share"
      ]
    },
    "messages-conversation/plain": {
      "name": "Plain",
      "slug": "plain",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/plain",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/plain.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/plain.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/plain.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/plain.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/plain.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/plain.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "dispatch",
        "email",
        "mail",
        "message",
        "paper-plane",
        "send",
        "submit"
      ]
    },
    "messages-conversation/plain-2": {
      "name": "Plain 2",
      "slug": "plain-2",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/plain-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/plain-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/plain-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/plain-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/plain-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/plain-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/plain-2.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "paper-plane",
        "send",
        "submit"
      ]
    },
    "messages-conversation/plain-3": {
      "name": "Plain 3",
      "slug": "plain-3",
      "category": "messages-conversation",
      "categoryName": "Messages, Conversation",
      "id": "messages-conversation/plain-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/messages-conversation/plain-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/messages-conversation/plain-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/messages-conversation/plain-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/messages-conversation/plain-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/messages-conversation/plain-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/messages-conversation/plain-3.svg"
        }
      ],
      "tags": [
        "chat",
        "communication",
        "conversation",
        "email",
        "mail",
        "message",
        "paper-plane",
        "send",
        "submit"
      ]
    },
    "arrows/square-double-alt-arrow-down": {
      "name": "Square Double Alt Arrow Down",
      "slug": "square-double-alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-double-alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-double-alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-double-alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-double-alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-double-alt-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-double-alt-arrow-up": {
      "name": "Square Double Alt Arrow Up",
      "slug": "square-double-alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-double-alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-double-alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-double-alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-double-alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-double-alt-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-double-alt-arrow-right": {
      "name": "Square Double Alt Arrow Right",
      "slug": "square-double-alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-double-alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-double-alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-double-alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-double-alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-double-alt-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-double-alt-arrow-left": {
      "name": "Square Double Alt Arrow Left",
      "slug": "square-double-alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-double-alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-double-alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-double-alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-double-alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-double-alt-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-alt-arrow-right": {
      "name": "Square Alt Arrow Right",
      "slug": "square-alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-alt-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-alt-arrow-left": {
      "name": "Square Alt Arrow Left",
      "slug": "square-alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-alt-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-alt-arrow-up": {
      "name": "Square Alt Arrow Up",
      "slug": "square-alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-alt-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-alt-arrow-down": {
      "name": "Square Alt Arrow Down",
      "slug": "square-alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-alt-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-right": {
      "name": "Square Arrow Right",
      "slug": "square-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-left": {
      "name": "Square Arrow Left",
      "slug": "square-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-up": {
      "name": "Square Arrow Up",
      "slug": "square-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-down": {
      "name": "Square Arrow Down",
      "slug": "square-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-left-down": {
      "name": "Square Arrow Left Down",
      "slug": "square-arrow-left-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-left-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-left-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-left-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-left-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-left-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-left-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-left-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-right-down": {
      "name": "Square Arrow Right Down",
      "slug": "square-arrow-right-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-right-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-right-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-right-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-right-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-right-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-right-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-right-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-right-up": {
      "name": "Square Arrow Right Up",
      "slug": "square-arrow-right-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-right-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-right-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-right-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-right-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-right-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-right-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-right-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-arrow-left-up": {
      "name": "Square Arrow Left Up",
      "slug": "square-arrow-left-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-arrow-left-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-arrow-left-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-arrow-left-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-arrow-left-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-arrow-left-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-arrow-left-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-arrow-left-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-sort-vertical": {
      "name": "Square Sort Vertical",
      "slug": "square-sort-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-sort-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-sort-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-sort-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-sort-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-sort-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-sort-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-sort-vertical.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-transfer-vertical": {
      "name": "Square Transfer Vertical",
      "slug": "square-transfer-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-transfer-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-transfer-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-transfer-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-transfer-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-transfer-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-transfer-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-transfer-vertical.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-sort-horizontal": {
      "name": "Square Sort Horizontal",
      "slug": "square-sort-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-sort-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-sort-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-sort-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-sort-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-sort-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-sort-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-sort-horizontal.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/square-transfer-horizontal": {
      "name": "Square Transfer Horizontal",
      "slug": "square-transfer-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/square-transfer-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/square-transfer-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/square-transfer-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/square-transfer-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/square-transfer-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/square-transfer-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/square-transfer-horizontal.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-alt-arrow-right": {
      "name": "Round Alt Arrow Right",
      "slug": "round-alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-alt-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-alt-arrow-left": {
      "name": "Round Alt Arrow Left",
      "slug": "round-alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-alt-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-up": {
      "name": "Round Arrow Up",
      "slug": "round-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-left": {
      "name": "Round Arrow Left",
      "slug": "round-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-down": {
      "name": "Round Arrow Down",
      "slug": "round-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-left-down": {
      "name": "Round Arrow Left Down",
      "slug": "round-arrow-left-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-left-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-left-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-left-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-left-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-left-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-left-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-left-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-right-down": {
      "name": "Round Arrow Right Down",
      "slug": "round-arrow-right-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-right-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-right-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-right-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-right-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-right-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-right-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-right-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-double-alt-arrow-down": {
      "name": "Round Double Alt Arrow Down",
      "slug": "round-double-alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-double-alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-double-alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-double-alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-double-alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-double-alt-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-left-up": {
      "name": "Round Arrow Left Up",
      "slug": "round-arrow-left-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-left-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-left-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-left-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-left-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-left-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-left-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-left-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-sort-vertical": {
      "name": "Round Sort Vertical",
      "slug": "round-sort-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-sort-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-sort-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-sort-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-sort-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-sort-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-sort-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-sort-vertical.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-transfer-horizontal": {
      "name": "Round Transfer Horizontal",
      "slug": "round-transfer-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-transfer-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-transfer-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-transfer-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-transfer-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-transfer-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-transfer-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-transfer-horizontal.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-right": {
      "name": "Round Arrow Right",
      "slug": "round-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-transfer-vertical": {
      "name": "Round Transfer Vertical",
      "slug": "round-transfer-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-transfer-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-transfer-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-transfer-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-transfer-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-transfer-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-transfer-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-transfer-vertical.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-arrow-right-up": {
      "name": "Round Arrow Right Up",
      "slug": "round-arrow-right-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-arrow-right-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-arrow-right-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-arrow-right-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-arrow-right-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-arrow-right-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-arrow-right-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-arrow-right-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-alt-arrow-down": {
      "name": "Round Alt Arrow Down",
      "slug": "round-alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-alt-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-alt-arrow-up": {
      "name": "Round Alt Arrow Up",
      "slug": "round-alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-alt-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-sort-horizontal": {
      "name": "Round Sort Horizontal",
      "slug": "round-sort-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-sort-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-sort-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-sort-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-sort-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-sort-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-sort-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-sort-horizontal.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-double-alt-arrow-right": {
      "name": "Round Double Alt Arrow Right",
      "slug": "round-double-alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-double-alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-double-alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-double-alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-double-alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-double-alt-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-double-alt-arrow-left": {
      "name": "Round Double Alt Arrow Left",
      "slug": "round-double-alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-double-alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-double-alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-double-alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-double-alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-double-alt-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-double-alt-arrow-up": {
      "name": "Round Double Alt Arrow Up",
      "slug": "round-double-alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-double-alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-double-alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-double-alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-double-alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-double-alt-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/round-transfer-diagonal": {
      "name": "Round Transfer Diagonal",
      "slug": "round-transfer-diagonal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/round-transfer-diagonal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/round-transfer-diagonal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/round-transfer-diagonal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/round-transfer-diagonal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/round-transfer-diagonal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/round-transfer-diagonal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/round-transfer-diagonal.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/transfer-horizontal": {
      "name": "Transfer Horizontal",
      "slug": "transfer-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/transfer-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/transfer-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/transfer-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/transfer-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/transfer-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/transfer-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/transfer-horizontal.svg"
        }
      ],
      "tags": [
        "direction",
        "exchange",
        "horizontal",
        "move",
        "navigation",
        "pointer",
        "swap",
        "switch"
      ]
    },
    "arrows/transfer-vertical": {
      "name": "Transfer Vertical",
      "slug": "transfer-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/transfer-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/transfer-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/transfer-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/transfer-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/transfer-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/transfer-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/transfer-vertical.svg"
        }
      ],
      "tags": [
        "direction",
        "exchange",
        "move",
        "navigation",
        "pointer",
        "swap",
        "switch",
        "vertical"
      ]
    },
    "arrows/sort-vertical": {
      "name": "Sort Vertical",
      "slug": "sort-vertical",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/sort-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/sort-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/sort-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/sort-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/sort-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/sort-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/sort-vertical.svg"
        }
      ],
      "tags": [
        "arrange",
        "direction",
        "move",
        "navigation",
        "pointer",
        "reorder",
        "vertical"
      ]
    },
    "arrows/sort-horizontal": {
      "name": "Sort Horizontal",
      "slug": "sort-horizontal",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/sort-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/sort-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/sort-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/sort-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/sort-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/sort-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/sort-horizontal.svg"
        }
      ],
      "tags": [
        "arrange",
        "direction",
        "horizontal",
        "move",
        "navigation",
        "pointer",
        "reorder"
      ]
    },
    "arrows/double-alt-arrow-down": {
      "name": "Double Alt Arrow Down",
      "slug": "double-alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/double-alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/double-alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/double-alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/double-alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/double-alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/double-alt-arrow-down.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "fast",
        "move",
        "navigation",
        "page-down",
        "pointer",
        "skip"
      ]
    },
    "arrows/double-alt-arrow-up": {
      "name": "Double Alt Arrow Up",
      "slug": "double-alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/double-alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/double-alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/double-alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/double-alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/double-alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/double-alt-arrow-up.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "fast",
        "move",
        "navigation",
        "page-up",
        "pointer",
        "skip"
      ]
    },
    "arrows/double-alt-arrow-right": {
      "name": "Double Alt Arrow Right",
      "slug": "double-alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/double-alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/double-alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/double-alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/double-alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/double-alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/double-alt-arrow-right.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "fast",
        "forward",
        "last",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/double-alt-arrow-left": {
      "name": "Double Alt Arrow Left",
      "slug": "double-alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/double-alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/double-alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/double-alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/double-alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/double-alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/double-alt-arrow-left.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "fast",
        "first",
        "move",
        "navigation",
        "pointer",
        "rewind"
      ]
    },
    "arrows/arrow-down": {
      "name": "Arrow Down",
      "slug": "arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-down.svg"
        }
      ],
      "tags": [
        "below",
        "descend",
        "direction",
        "down",
        "dropdown",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/arrow-up": {
      "name": "Arrow Up",
      "slug": "arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-up",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-up.svg"
        }
      ],
      "tags": [
        "above",
        "ascend",
        "direction",
        "move",
        "navigation",
        "pointer",
        "rise",
        "up"
      ]
    },
    "arrows/arrow-left-down": {
      "name": "Arrow Left Down",
      "slug": "arrow-left-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-left-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-left-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-left-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-left-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-left-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-left-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-left-down.svg"
        }
      ],
      "tags": [
        "diagonal",
        "direction",
        "down-left",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/arrow-right-down": {
      "name": "Arrow Right Down",
      "slug": "arrow-right-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-right-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-right-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-right-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-right-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-right-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-right-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-right-down.svg"
        }
      ],
      "tags": [
        "diagonal",
        "direction",
        "down-right",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/arrow-left-up": {
      "name": "Arrow Left Up",
      "slug": "arrow-left-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-left-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-left-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-left-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-left-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-left-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-left-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-left-up.svg"
        }
      ],
      "tags": [
        "diagonal",
        "direction",
        "move",
        "navigation",
        "pointer",
        "up-left"
      ]
    },
    "arrows/arrow-right-up": {
      "name": "Arrow Right Up",
      "slug": "arrow-right-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-right-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-right-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-right-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-right-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-right-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-right-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-right-up.svg"
        }
      ],
      "tags": [
        "diagonal",
        "direction",
        "move",
        "navigation",
        "pointer",
        "up-right"
      ]
    },
    "arrows/arrow-left": {
      "name": "Arrow Left",
      "slug": "arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-left",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-left.svg"
        }
      ],
      "tags": [
        "back",
        "direction",
        "left",
        "move",
        "navigation",
        "pointer",
        "previous",
        "return"
      ]
    },
    "arrows/arrow-right": {
      "name": "Arrow Right",
      "slug": "arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/arrow-right.svg"
        }
      ],
      "tags": [
        "continue",
        "direction",
        "forward",
        "move",
        "navigation",
        "next",
        "pointer",
        "right"
      ]
    },
    "arrows/alt-arrow-down": {
      "name": "Alt Arrow Down",
      "slug": "alt-arrow-down",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/alt-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/alt-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/alt-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/alt-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/alt-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/alt-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/alt-arrow-down.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "down",
        "dropdown",
        "expand",
        "move",
        "navigation",
        "pointer"
      ]
    },
    "arrows/alt-arrow-up": {
      "name": "Alt Arrow Up",
      "slug": "alt-arrow-up",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/alt-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/alt-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/alt-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/alt-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/alt-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/alt-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/alt-arrow-up.svg"
        }
      ],
      "tags": [
        "chevron",
        "collapse",
        "direction",
        "move",
        "navigation",
        "pointer",
        "up"
      ]
    },
    "arrows/alt-arrow-left": {
      "name": "Alt Arrow Left",
      "slug": "alt-arrow-left",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/alt-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/alt-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/alt-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/alt-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/alt-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/alt-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/alt-arrow-left.svg"
        }
      ],
      "tags": [
        "back",
        "chevron",
        "direction",
        "move",
        "navigation",
        "pointer",
        "previous"
      ]
    },
    "arrows/alt-arrow-right": {
      "name": "Alt Arrow Right",
      "slug": "alt-arrow-right",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/alt-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/alt-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/alt-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/alt-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/alt-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/alt-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/alt-arrow-right.svg"
        }
      ],
      "tags": [
        "chevron",
        "direction",
        "forward",
        "move",
        "navigation",
        "next",
        "pointer"
      ]
    },
    "arrows/restart": {
      "name": "Restart",
      "slug": "restart",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/restart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/restart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/restart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/restart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/restart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/restart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/restart.svg"
        }
      ],
      "tags": [
        "again",
        "direction",
        "loop",
        "move",
        "navigation",
        "pointer",
        "redo",
        "reset"
      ]
    },
    "arrows/refresh": {
      "name": "Refresh",
      "slug": "refresh",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/refresh",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/refresh.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/refresh.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/refresh.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/refresh.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/refresh.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/refresh.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer",
        "reload",
        "retry",
        "sync",
        "update"
      ]
    },
    "arrows/refresh-circle": {
      "name": "Refresh Circle",
      "slug": "refresh-circle",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/refresh-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/refresh-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/refresh-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/refresh-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/refresh-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/refresh-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/refresh-circle.svg"
        }
      ],
      "tags": [
        "circle",
        "direction",
        "move",
        "navigation",
        "pointer",
        "reload",
        "retry",
        "sync",
        "update"
      ]
    },
    "arrows/restart-circle": {
      "name": "Restart Circle",
      "slug": "restart-circle",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/restart-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/restart-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/restart-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/restart-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/restart-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/restart-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/restart-circle.svg"
        }
      ],
      "tags": [
        "circle",
        "direction",
        "loop",
        "move",
        "navigation",
        "pointer",
        "redo",
        "reset"
      ]
    },
    "arrows/refresh-square": {
      "name": "Refresh Square",
      "slug": "refresh-square",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/refresh-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/refresh-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/refresh-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/refresh-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/refresh-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/refresh-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/refresh-square.svg"
        }
      ],
      "tags": [
        "direction",
        "move",
        "navigation",
        "pointer",
        "reload",
        "retry",
        "square",
        "sync",
        "update"
      ]
    },
    "arrows/restart-square": {
      "name": "Restart Square",
      "slug": "restart-square",
      "category": "arrows",
      "categoryName": "Arrows",
      "id": "arrows/restart-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows/restart-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows/restart-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows/restart-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows/restart-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows/restart-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows/restart-square.svg"
        }
      ],
      "tags": [
        "direction",
        "loop",
        "move",
        "navigation",
        "pointer",
        "redo",
        "reset",
        "square"
      ]
    },
    "map-location/map-point": {
      "name": "Map Point",
      "slug": "map-point",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point.svg"
        }
      ],
      "tags": [
        "destination",
        "directions",
        "geo",
        "location",
        "map",
        "marker",
        "navigation",
        "pin",
        "place",
        "travel"
      ]
    },
    "map-location/map-point-wave": {
      "name": "Map Point Wave",
      "slug": "map-point-wave",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-wave",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-wave.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-wave.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-wave.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-wave.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-wave.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-wave.svg"
        }
      ],
      "tags": [
        "broadcast",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "nearby",
        "pin",
        "place",
        "signal",
        "travel"
      ]
    },
    "map-location/map-point-rotate": {
      "name": "Map Point Rotate",
      "slug": "map-point-rotate",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-rotate",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-rotate.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-rotate.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-rotate.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-rotate.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-rotate.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-rotate.svg"
        }
      ],
      "tags": [
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "pin",
        "place",
        "spin",
        "travel",
        "update"
      ]
    },
    "map-location/map-point-favourite": {
      "name": "Map Point Favourite",
      "slug": "map-point-favourite",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-favourite",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-favourite.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-favourite.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-favourite.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-favourite.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-favourite.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-favourite.svg"
        }
      ],
      "tags": [
        "bookmark",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "pin",
        "place",
        "saved-place",
        "starred",
        "travel"
      ]
    },
    "map-location/map-point-remove": {
      "name": "Map Point Remove",
      "slug": "map-point-remove",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-remove.svg"
        }
      ],
      "tags": [
        "delete-location",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "pin",
        "place",
        "remove-place",
        "travel"
      ]
    },
    "map-location/map-point-add": {
      "name": "Map Point Add",
      "slug": "map-point-add",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-add.svg"
        }
      ],
      "tags": [
        "add-place",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "new-location",
        "pin",
        "place",
        "travel"
      ]
    },
    "map-location/map-point-search": {
      "name": "Map Point Search",
      "slug": "map-point-search",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-search",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-search.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-search.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-search.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-search.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-search.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-search.svg"
        }
      ],
      "tags": [
        "directions",
        "find-location",
        "geo",
        "location",
        "map",
        "navigation",
        "pin",
        "place",
        "search-place",
        "travel"
      ]
    },
    "map-location/map-point-hospital": {
      "name": "Map Point Hospital",
      "slug": "map-point-hospital",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-hospital",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-hospital.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-hospital.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-hospital.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-hospital.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-hospital.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-hospital.svg"
        }
      ],
      "tags": [
        "clinic",
        "directions",
        "emergency",
        "geo",
        "hospital",
        "location",
        "map",
        "medical",
        "navigation",
        "place",
        "travel"
      ]
    },
    "map-location/map-point-school": {
      "name": "Map Point School",
      "slug": "map-point-school",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-point-school",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-point-school.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-point-school.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-point-school.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-point-school.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-point-school.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-point-school.svg"
        }
      ],
      "tags": [
        "campus",
        "directions",
        "education",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "school",
        "travel"
      ]
    },
    "map-location/people-nearby": {
      "name": "People Nearby",
      "slug": "people-nearby",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/people-nearby",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/people-nearby.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/people-nearby.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/people-nearby.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/people-nearby.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/people-nearby.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/people-nearby.svg"
        }
      ],
      "tags": [
        "around",
        "close",
        "directions",
        "discover",
        "geo",
        "local",
        "location",
        "map",
        "navigation",
        "place",
        "proximity",
        "travel"
      ]
    },
    "map-location/compass": {
      "name": "Compass",
      "slug": "compass",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/compass",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/compass.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/compass.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/compass.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/compass.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/compass.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/compass.svg"
        }
      ],
      "tags": [
        "bearing",
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "north",
        "orientation",
        "place",
        "travel"
      ]
    },
    "map-location/compass-square": {
      "name": "Compass Square",
      "slug": "compass-square",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/compass-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/compass-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/compass-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/compass-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/compass-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/compass-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/compass-square.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "north",
        "orientation",
        "place",
        "travel"
      ]
    },
    "map-location/map": {
      "name": "Map",
      "slug": "map",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map.svg"
        }
      ],
      "tags": [
        "area",
        "atlas",
        "directions",
        "geo",
        "geography",
        "location",
        "map",
        "navigation",
        "place",
        "region",
        "terrain",
        "travel"
      ]
    },
    "map-location/point-on-map": {
      "name": "Point On Map",
      "slug": "point-on-map",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/point-on-map",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/point-on-map.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/point-on-map.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/point-on-map.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/point-on-map.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/point-on-map.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/point-on-map.svg"
        }
      ],
      "tags": [
        "current-location",
        "directions",
        "geo",
        "here",
        "location",
        "map",
        "marker",
        "navigation",
        "place",
        "travel",
        "you-are-here"
      ]
    },
    "map-location/global": {
      "name": "Global",
      "slug": "global",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/global",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/global.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/global.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/global.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/global.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/global.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/global.svg"
        }
      ],
      "tags": [
        "directions",
        "earth",
        "geo",
        "globe",
        "international",
        "language",
        "location",
        "map",
        "navigation",
        "place",
        "travel",
        "world",
        "worldwide"
      ]
    },
    "map-location/map-arrow-up": {
      "name": "Map Arrow Up",
      "slug": "map-arrow-up",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-arrow-up.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "north",
        "place",
        "travel"
      ]
    },
    "map-location/map-arrow-down": {
      "name": "Map Arrow Down",
      "slug": "map-arrow-down",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-arrow-down.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "place",
        "south",
        "travel"
      ]
    },
    "map-location/map-arrow-right": {
      "name": "Map Arrow Right",
      "slug": "map-arrow-right",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-arrow-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-arrow-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-arrow-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-arrow-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-arrow-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-arrow-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-arrow-right.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "east",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "place",
        "travel"
      ]
    },
    "map-location/map-arrow-left": {
      "name": "Map Arrow Left",
      "slug": "map-arrow-left",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-arrow-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-arrow-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-arrow-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-arrow-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-arrow-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-arrow-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-arrow-left.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "place",
        "travel",
        "west"
      ]
    },
    "map-location/map-arrow-square": {
      "name": "Map Arrow Square",
      "slug": "map-arrow-square",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/map-arrow-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/map-arrow-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/map-arrow-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/map-arrow-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/map-arrow-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/map-arrow-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/map-arrow-square.svg"
        }
      ],
      "tags": [
        "cursor",
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigate",
        "navigation",
        "place",
        "travel"
      ]
    },
    "map-location/branching-paths-up": {
      "name": "Branching Paths Up",
      "slug": "branching-paths-up",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/branching-paths-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/branching-paths-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/branching-paths-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/branching-paths-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/branching-paths-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/branching-paths-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/branching-paths-up.svg"
        }
      ],
      "tags": [
        "converge",
        "directions",
        "geo",
        "join",
        "location",
        "map",
        "merge",
        "navigation",
        "place",
        "route",
        "travel"
      ]
    },
    "map-location/branching-paths-down": {
      "name": "Branching Paths Down",
      "slug": "branching-paths-down",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/branching-paths-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/branching-paths-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/branching-paths-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/branching-paths-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/branching-paths-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/branching-paths-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/branching-paths-down.svg"
        }
      ],
      "tags": [
        "decision",
        "directions",
        "diverge",
        "fork",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "route",
        "split",
        "travel"
      ]
    },
    "map-location/route": {
      "name": "Route",
      "slug": "route",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/route",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/route.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/route.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/route.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/route.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/route.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/route.svg"
        }
      ],
      "tags": [
        "directions",
        "geo",
        "journey",
        "location",
        "map",
        "navigation",
        "path",
        "place",
        "road",
        "travel",
        "trip",
        "way"
      ]
    },
    "map-location/signpost": {
      "name": "Signpost",
      "slug": "signpost",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/signpost",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/signpost.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/signpost.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/signpost.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/signpost.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/signpost.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/signpost.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "guide",
        "location",
        "map",
        "navigation",
        "place",
        "road-sign",
        "travel",
        "way",
        "waypoint"
      ]
    },
    "map-location/signpost-2": {
      "name": "Signpost 2",
      "slug": "signpost-2",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/signpost-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/signpost-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/signpost-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/signpost-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/signpost-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/signpost-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/signpost-2.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "guide",
        "location",
        "map",
        "navigation",
        "place",
        "road-sign",
        "travel",
        "way"
      ]
    },
    "map-location/streets-navigation": {
      "name": "Streets Navigation",
      "slug": "streets-navigation",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/streets-navigation",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/streets-navigation.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/streets-navigation.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/streets-navigation.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/streets-navigation.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/streets-navigation.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/streets-navigation.svg"
        }
      ],
      "tags": [
        "GPS",
        "directions",
        "drive",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "road",
        "travel"
      ]
    },
    "map-location/streets": {
      "name": "Streets",
      "slug": "streets",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/streets",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/streets.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/streets.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/streets.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/streets.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/streets.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/streets.svg"
        }
      ],
      "tags": [
        "avenue",
        "city",
        "directions",
        "geo",
        "lane",
        "location",
        "map",
        "navigation",
        "place",
        "road",
        "travel",
        "urban"
      ]
    },
    "map-location/streets-map-point": {
      "name": "Streets Map Point",
      "slug": "streets-map-point",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/streets-map-point",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/streets-map-point.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/streets-map-point.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/streets-map-point.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/streets-map-point.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/streets-map-point.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/streets-map-point.svg"
        }
      ],
      "tags": [
        "address",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "road",
        "travel"
      ]
    },
    "map-location/point-on-map-perspective": {
      "name": "Point On Map Perspective",
      "slug": "point-on-map-perspective",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/point-on-map-perspective",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/point-on-map-perspective.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/point-on-map-perspective.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/point-on-map-perspective.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/point-on-map-perspective.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/point-on-map-perspective.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/point-on-map-perspective.svg"
        }
      ],
      "tags": [
        "3D",
        "directions",
        "geo",
        "location",
        "map",
        "marker",
        "navigation",
        "perspective",
        "place",
        "tilt",
        "travel"
      ]
    },
    "map-location/radar": {
      "name": "Radar",
      "slug": "radar",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/radar",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/radar.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/radar.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/radar.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/radar.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/radar.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/radar.svg"
        }
      ],
      "tags": [
        "detect",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "range",
        "scan",
        "signal",
        "sonar",
        "travel"
      ]
    },
    "map-location/radar-2": {
      "name": "Radar 2",
      "slug": "radar-2",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/radar-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/radar-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/radar-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/radar-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/radar-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/radar-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/radar-2.svg"
        }
      ],
      "tags": [
        "detect",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "scan",
        "signal",
        "travel"
      ]
    },
    "map-location/routing": {
      "name": "Routing",
      "slug": "routing",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/routing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/routing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/routing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/routing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/routing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/routing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/routing.svg"
        }
      ],
      "tags": [
        "directions",
        "geo",
        "journey",
        "location",
        "map",
        "navigation",
        "path",
        "place",
        "travel",
        "way"
      ]
    },
    "map-location/routing-2": {
      "name": "Routing 2",
      "slug": "routing-2",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/routing-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/routing-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/routing-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/routing-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/routing-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/routing-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/routing-2.svg"
        }
      ],
      "tags": [
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "path",
        "place",
        "travel",
        "way"
      ]
    },
    "map-location/routing-3": {
      "name": "Routing 3",
      "slug": "routing-3",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/routing-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/routing-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/routing-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/routing-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/routing-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/routing-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/routing-3.svg"
        }
      ],
      "tags": [
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "path",
        "place",
        "travel",
        "way"
      ]
    },
    "map-location/gps": {
      "name": "GPS",
      "slug": "gps",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/gps",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/gps.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/gps.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/gps.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/gps.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/gps.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/gps.svg"
        }
      ],
      "tags": [
        "coordinate",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "place",
        "position",
        "satellite",
        "tracking",
        "travel"
      ]
    },
    "map-location/compass-big": {
      "name": "Compass Big",
      "slug": "compass-big",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/compass-big",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/compass-big.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/compass-big.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/compass-big.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/compass-big.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/compass-big.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/compass-big.svg"
        }
      ],
      "tags": [
        "direction",
        "directions",
        "geo",
        "location",
        "map",
        "navigation",
        "north",
        "orientation",
        "place",
        "travel"
      ]
    },
    "map-location/globus": {
      "name": "Globus",
      "slug": "globus",
      "category": "map-location",
      "categoryName": "Map & Location",
      "id": "map-location/globus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/map-location/globus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/map-location/globus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/map-location/globus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/map-location/globus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/map-location/globus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/map-location/globus.svg"
        }
      ],
      "tags": [
        "directions",
        "earth",
        "geo",
        "geography",
        "globe",
        "international",
        "location",
        "map",
        "navigation",
        "place",
        "travel",
        "world"
      ]
    },
    "video-audio-sound/gallery": {
      "name": "Gallery",
      "slug": "gallery",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery.svg"
        }
      ],
      "tags": [
        "album",
        "audio",
        "collection",
        "entertainment",
        "grid",
        "images",
        "media",
        "multimedia",
        "music",
        "photos",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-note-4": {
      "name": "Music Note 4",
      "slug": "music-note-4",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note-4.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "melody",
        "multimedia",
        "music",
        "note",
        "sound",
        "tune",
        "video"
      ]
    },
    "video-audio-sound/rewind-5-seconds-back": {
      "name": "Rewind 5 Seconds Back",
      "slug": "rewind-5-seconds-back",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-5-seconds-back",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-5-seconds-back.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-5-seconds-back.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-5-seconds-back.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-5-seconds-back.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-5-seconds-back.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-5-seconds-back.svg"
        }
      ],
      "tags": [
        "5s",
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "rewind",
        "skip-back",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/clapperboard": {
      "name": "Clapperboard",
      "slug": "clapperboard",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard.svg"
        }
      ],
      "tags": [
        "action",
        "audio",
        "cinema",
        "director",
        "entertainment",
        "film",
        "media",
        "movie",
        "multimedia",
        "music",
        "scene",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/video-frame": {
      "name": "Video Frame",
      "slug": "video-frame",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame.svg"
        }
      ],
      "tags": [
        "audio",
        "clip",
        "entertainment",
        "frame",
        "media",
        "multimedia",
        "music",
        "scene",
        "shot",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/soundwave": {
      "name": "Soundwave",
      "slug": "soundwave",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/soundwave",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/soundwave.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/soundwave.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/soundwave.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/soundwave.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/soundwave.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/soundwave.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "equalizer",
        "frequency",
        "media",
        "multimedia",
        "music",
        "signal",
        "sound",
        "video",
        "waveform"
      ]
    },
    "video-audio-sound/record-circle": {
      "name": "Record Circle",
      "slug": "record-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/record-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/record-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/record-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/record-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/record-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/record-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/record-circle.svg"
        }
      ],
      "tags": [
        "active",
        "audio",
        "entertainment",
        "live",
        "media",
        "multimedia",
        "music",
        "recording",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/record": {
      "name": "Record",
      "slug": "record",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/record",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/record.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/record.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/record.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/record.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/record.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/record.svg"
        }
      ],
      "tags": [
        "audio",
        "capture",
        "entertainment",
        "live",
        "media",
        "multimedia",
        "music",
        "recording",
        "red-dot",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/microphone-2": {
      "name": "Microphone 2",
      "slug": "microphone-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/microphone-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/microphone-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/microphone-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/microphone-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/microphone-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/microphone-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/microphone-2.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "mic",
        "multimedia",
        "music",
        "record",
        "sound",
        "video",
        "voice"
      ]
    },
    "video-audio-sound/library": {
      "name": "Library",
      "slug": "library",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/library",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/library.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/library.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/library.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/library.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/library.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/library.svg"
        }
      ],
      "tags": [
        "archive",
        "audio",
        "catalog",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/repeat": {
      "name": "Repeat",
      "slug": "repeat",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/repeat",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/repeat.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/repeat.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/repeat.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/repeat.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/repeat.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/repeat.svg"
        }
      ],
      "tags": [
        "again",
        "audio",
        "cycle",
        "entertainment",
        "loop",
        "media",
        "multimedia",
        "music",
        "replay",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/volume-loud": {
      "name": "Volume Loud",
      "slug": "volume-loud",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/volume-loud",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/volume-loud.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/volume-loud.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/volume-loud.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/volume-loud.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/volume-loud.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/volume-loud.svg"
        }
      ],
      "tags": [
        "audio",
        "blast",
        "entertainment",
        "high-volume",
        "loud",
        "max",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/volume-small": {
      "name": "Volume Small",
      "slug": "volume-small",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/volume-small",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/volume-small.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/volume-small.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/volume-small.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/volume-small.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/volume-small.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/volume-small.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "low",
        "low-volume",
        "media",
        "multimedia",
        "music",
        "quiet",
        "soft",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/video-frame-cut": {
      "name": "Video Frame Cut",
      "slug": "video-frame-cut",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-cut",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-cut.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-cut.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-cut.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-cut.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-cut.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-cut.svg"
        }
      ],
      "tags": [
        "audio",
        "cut",
        "edit",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "splice",
        "trim",
        "video"
      ]
    },
    "video-audio-sound/clapperboard-play": {
      "name": "Clapperboard Play",
      "slug": "clapperboard-play",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard-play",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard-play.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard-play.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard-play.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard-play.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard-play.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard-play.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "film",
        "media",
        "movie",
        "multimedia",
        "music",
        "play",
        "sound",
        "video",
        "watch"
      ]
    },
    "video-audio-sound/rewind-5-seconds-forward": {
      "name": "Rewind 5 Seconds Forward",
      "slug": "rewind-5-seconds-forward",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-5-seconds-forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-5-seconds-forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-5-seconds-forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-5-seconds-forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-5-seconds-forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-5-seconds-forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-5-seconds-forward.svg"
        }
      ],
      "tags": [
        "5s",
        "audio",
        "entertainment",
        "forward",
        "media",
        "multimedia",
        "music",
        "skip",
        "skip-ahead",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/gallery-minimalistic": {
      "name": "Gallery Minimalistic",
      "slug": "gallery-minimalistic",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-minimalistic.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "images",
        "media",
        "minimal",
        "multimedia",
        "music",
        "photos",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/repeat-one": {
      "name": "Repeat One",
      "slug": "repeat-one",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/repeat-one",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/repeat-one.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/repeat-one.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/repeat-one.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/repeat-one.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/repeat-one.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/repeat-one.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "loop-one",
        "media",
        "multimedia",
        "music",
        "single-repeat",
        "song-repeat",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-note-3": {
      "name": "Music Note 3",
      "slug": "music-note-3",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note-3.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "melody",
        "multimedia",
        "music",
        "note",
        "sound",
        "tune",
        "video"
      ]
    },
    "video-audio-sound/soundwave-square": {
      "name": "Soundwave Square",
      "slug": "soundwave-square",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/soundwave-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/soundwave-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/soundwave-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/soundwave-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/soundwave-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/soundwave-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/soundwave-square.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "frequency",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "waveform"
      ]
    },
    "video-audio-sound/album": {
      "name": "Album",
      "slug": "album",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/album",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/album.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/album.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/album.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/album.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/album.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/album.svg"
        }
      ],
      "tags": [
        "CD",
        "audio",
        "collection",
        "cover",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "vinyl"
      ]
    },
    "video-audio-sound/stop": {
      "name": "Stop",
      "slug": "stop",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/stop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/stop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/stop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/stop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/stop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/stop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/stop.svg"
        }
      ],
      "tags": [
        "audio",
        "cease",
        "end",
        "entertainment",
        "halt",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "\u25a0"
      ]
    },
    "video-audio-sound/vinyl-record": {
      "name": "Vinyl Record",
      "slug": "vinyl-record",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/vinyl-record",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/vinyl-record.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/vinyl-record.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/vinyl-record.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/vinyl-record.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/vinyl-record.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/vinyl-record.svg"
        }
      ],
      "tags": [
        "LP",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "retro",
        "sound",
        "turntable",
        "video"
      ]
    },
    "video-audio-sound/microphone-3": {
      "name": "Microphone 3",
      "slug": "microphone-3",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/microphone-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/microphone-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/microphone-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/microphone-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/microphone-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/microphone-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/microphone-3.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "mic",
        "multimedia",
        "music",
        "record",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/muted": {
      "name": "Muted",
      "slug": "muted",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/muted",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/muted.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/muted.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/muted.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/muted.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/muted.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/muted.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "no-sound",
        "off",
        "quiet",
        "silent",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/clapperboard-open": {
      "name": "Clapperboard Open",
      "slug": "clapperboard-open",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard-open",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard-open.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard-open.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard-open.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard-open.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard-open.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard-open.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "film",
        "media",
        "multimedia",
        "music",
        "scene",
        "sound",
        "take",
        "video"
      ]
    },
    "video-audio-sound/rewind-15-seconds-forward": {
      "name": "Rewind 15 Seconds Forward",
      "slug": "rewind-15-seconds-forward",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-15-seconds-forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-15-seconds-forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-15-seconds-forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-15-seconds-forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-15-seconds-forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-15-seconds-forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-15-seconds-forward.svg"
        }
      ],
      "tags": [
        "15s",
        "audio",
        "entertainment",
        "forward",
        "media",
        "multimedia",
        "music",
        "skip",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-note-2": {
      "name": "Music Note 2",
      "slug": "music-note-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note-2.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "melody",
        "multimedia",
        "music",
        "note",
        "song",
        "sound",
        "tune",
        "video"
      ]
    },
    "video-audio-sound/repeat-one-minimalistic": {
      "name": "Repeat One Minimalistic",
      "slug": "repeat-one-minimalistic",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/repeat-one-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/repeat-one-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/repeat-one-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/repeat-one-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/repeat-one-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/repeat-one-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/repeat-one-minimalistic.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "loop-one",
        "media",
        "minimal",
        "multimedia",
        "music",
        "single-repeat",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/gallery-download": {
      "name": "Gallery Download",
      "slug": "gallery-download",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-download",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-download.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-download.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-download.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-download.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-download.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-download.svg"
        }
      ],
      "tags": [
        "audio",
        "download-photo",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "save-image",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/microphone": {
      "name": "Microphone",
      "slug": "microphone",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/microphone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/microphone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/microphone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/microphone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/microphone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/microphone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/microphone.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "mic",
        "multimedia",
        "music",
        "podcast",
        "record",
        "sound",
        "speak",
        "video",
        "voice"
      ]
    },
    "video-audio-sound/video-frame-cut-2": {
      "name": "Video Frame Cut 2",
      "slug": "video-frame-cut-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-cut-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-cut-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-cut-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-cut-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-cut-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-cut-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-cut-2.svg"
        }
      ],
      "tags": [
        "audio",
        "edit",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "splice",
        "trim",
        "video"
      ]
    },
    "video-audio-sound/soundwave-circle": {
      "name": "Soundwave Circle",
      "slug": "soundwave-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/soundwave-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/soundwave-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/soundwave-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/soundwave-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/soundwave-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/soundwave-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/soundwave-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "frequency",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "waveform"
      ]
    },
    "video-audio-sound/gallery-wide": {
      "name": "Gallery Wide",
      "slug": "gallery-wide",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-wide",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-wide.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-wide.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-wide.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-wide.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-wide.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-wide.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "landscape",
        "media",
        "multimedia",
        "music",
        "panorama",
        "sound",
        "video",
        "widescreen"
      ]
    },
    "video-audio-sound/play": {
      "name": "Play",
      "slug": "play",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/play",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/play.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/play.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/play.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/play.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/play.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/play.svg"
        }
      ],
      "tags": [
        "audio",
        "begin",
        "entertainment",
        "listen",
        "media",
        "multimedia",
        "music",
        "resume",
        "sound",
        "start",
        "video",
        "watch",
        "\u25b6"
      ]
    },
    "video-audio-sound/vinyl": {
      "name": "Vinyl",
      "slug": "vinyl",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/vinyl",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/vinyl.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/vinyl.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/vinyl.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/vinyl.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/vinyl.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/vinyl.svg"
        }
      ],
      "tags": [
        "LP",
        "analogue",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "record",
        "retro",
        "sound",
        "turntable",
        "video"
      ]
    },
    "video-audio-sound/pause": {
      "name": "Pause",
      "slug": "pause",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/pause",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/pause.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/pause.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/pause.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/pause.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/pause.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/pause.svg"
        }
      ],
      "tags": [
        "audio",
        "break",
        "entertainment",
        "hold",
        "media",
        "multimedia",
        "music",
        "sound",
        "stop",
        "video",
        "wait"
      ]
    },
    "video-audio-sound/video-frame-replace": {
      "name": "Video Frame Replace",
      "slug": "video-frame-replace",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-replace",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-replace.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-replace.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-replace.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-replace.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-replace.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-replace.svg"
        }
      ],
      "tags": [
        "audio",
        "change",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "substitute",
        "swap",
        "video"
      ]
    },
    "video-audio-sound/volume": {
      "name": "Volume",
      "slug": "volume",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/volume",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/volume.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/volume.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/volume.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/volume.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/volume.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/volume.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "level",
        "media",
        "multimedia",
        "music",
        "sound",
        "speaker",
        "video"
      ]
    },
    "video-audio-sound/play-stream": {
      "name": "Play Stream",
      "slug": "play-stream",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/play-stream",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/play-stream.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/play-stream.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/play-stream.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/play-stream.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/play-stream.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/play-stream.svg"
        }
      ],
      "tags": [
        "audio",
        "broadcast",
        "entertainment",
        "live",
        "media",
        "multimedia",
        "music",
        "sound",
        "streaming",
        "video"
      ]
    },
    "video-audio-sound/clapperboard-open-play": {
      "name": "Clapperboard Open Play",
      "slug": "clapperboard-open-play",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard-open-play",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard-open-play.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard-open-play.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard-open-play.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard-open-play.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard-open-play.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard-open-play.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "film",
        "media",
        "multimedia",
        "music",
        "playing",
        "screening",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/rewind-15-seconds-back": {
      "name": "Rewind 15 Seconds Back",
      "slug": "rewind-15-seconds-back",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-15-seconds-back",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-15-seconds-back.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-15-seconds-back.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-15-seconds-back.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-15-seconds-back.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-15-seconds-back.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-15-seconds-back.svg"
        }
      ],
      "tags": [
        "15s",
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "rewind",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/video-library": {
      "name": "Video Library",
      "slug": "video-library",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-library",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-library.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-library.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-library.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-library.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-library.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-library.svg"
        }
      ],
      "tags": [
        "audio",
        "catalog",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "videos"
      ]
    },
    "video-audio-sound/music-note": {
      "name": "Music Note",
      "slug": "music-note",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "melody",
        "multimedia",
        "music",
        "note",
        "song",
        "sound",
        "tune",
        "video",
        "\u266a"
      ]
    },
    "video-audio-sound/microphone-large": {
      "name": "Microphone Large",
      "slug": "microphone-large",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/microphone-large",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/microphone-large.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/microphone-large.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/microphone-large.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/microphone-large.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/microphone-large.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/microphone-large.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "karaoke",
        "media",
        "mic",
        "multimedia",
        "music",
        "perform",
        "sound",
        "stage",
        "video"
      ]
    },
    "video-audio-sound/gallery-send": {
      "name": "Gallery Send",
      "slug": "gallery-send",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-send",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-send.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-send.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-send.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-send.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-send.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-send.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "send-image",
        "share-photo",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/gallery-add": {
      "name": "Gallery Add",
      "slug": "gallery-add",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-add.svg"
        }
      ],
      "tags": [
        "add-image",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "new-photo",
        "sound",
        "upload-photo",
        "video"
      ]
    },
    "video-audio-sound/rewind-forward": {
      "name": "Rewind Forward",
      "slug": "rewind-forward",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-forward.svg"
        }
      ],
      "tags": [
        "ahead",
        "audio",
        "entertainment",
        "fast-forward",
        "media",
        "multimedia",
        "music",
        "next",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/clapperboard-edit": {
      "name": "Clapperboard Edit",
      "slug": "clapperboard-edit",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard-edit",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard-edit.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard-edit.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard-edit.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard-edit.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard-edit.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard-edit.svg"
        }
      ],
      "tags": [
        "audio",
        "cut",
        "edit",
        "entertainment",
        "film",
        "media",
        "multimedia",
        "music",
        "post-production",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/rewind-10-seconds-back": {
      "name": "Rewind 10 Seconds Back",
      "slug": "rewind-10-seconds-back",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-10-seconds-back",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-10-seconds-back.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-10-seconds-back.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-10-seconds-back.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-10-seconds-back.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-10-seconds-back.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-10-seconds-back.svg"
        }
      ],
      "tags": [
        "10s",
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "rewind",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-library-2": {
      "name": "Music Library 2",
      "slug": "music-library-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-library-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-library-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-library-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-library-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-library-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-library-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-library-2.svg"
        }
      ],
      "tags": [
        "audio",
        "catalog",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "songs",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/volume-cross": {
      "name": "Volume Cross",
      "slug": "volume-cross",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/volume-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/volume-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/volume-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/volume-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/volume-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/volume-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/volume-cross.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "mute",
        "no-sound",
        "off",
        "silent",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/podcast": {
      "name": "Podcast",
      "slug": "podcast",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/podcast",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/podcast.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/podcast.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/podcast.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/podcast.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/podcast.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/podcast.svg"
        }
      ],
      "tags": [
        "RSS",
        "audio",
        "broadcast",
        "entertainment",
        "episode",
        "listen",
        "media",
        "multimedia",
        "music",
        "show",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/wallpaper": {
      "name": "Wallpaper",
      "slug": "wallpaper",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/wallpaper",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/wallpaper.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/wallpaper.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/wallpaper.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/wallpaper.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/wallpaper.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/wallpaper.svg"
        }
      ],
      "tags": [
        "audio",
        "background",
        "desktop",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "screensaver",
        "sound",
        "theme",
        "video"
      ]
    },
    "video-audio-sound/music-notes": {
      "name": "Music Notes",
      "slug": "music-notes",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-notes",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-notes.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-notes.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-notes.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-notes.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-notes.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-notes.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "harmony",
        "media",
        "melody",
        "multimedia",
        "music",
        "song",
        "sound",
        "tune",
        "video",
        "\u266b"
      ]
    },
    "video-audio-sound/video-frame-2": {
      "name": "Video Frame 2",
      "slug": "video-frame-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-2.svg"
        }
      ],
      "tags": [
        "audio",
        "clip",
        "entertainment",
        "frame",
        "media",
        "multimedia",
        "music",
        "scene",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-library": {
      "name": "Music Library",
      "slug": "music-library",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-library",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-library.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-library.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-library.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-library.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-library.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-library.svg"
        }
      ],
      "tags": [
        "audio",
        "catalog",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "songs",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/video-frame-play-horizontal": {
      "name": "Video Frame Play Horizontal",
      "slug": "video-frame-play-horizontal",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-play-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-play-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-play-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-play-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-play-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-play-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-play-horizontal.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "landscape",
        "media",
        "multimedia",
        "music",
        "play",
        "sound",
        "video",
        "widescreen"
      ]
    },
    "video-audio-sound/gallery-remove": {
      "name": "Gallery Remove",
      "slug": "gallery-remove",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-remove.svg"
        }
      ],
      "tags": [
        "audio",
        "delete-photo",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "remove-image",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-note-slider": {
      "name": "Music Note Slider",
      "slug": "music-note-slider",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note-slider",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note-slider.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note-slider.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note-slider.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note-slider.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note-slider.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note-slider.svg"
        }
      ],
      "tags": [
        "DJ",
        "adjust",
        "audio",
        "entertainment",
        "equalizer",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/upload-track-2": {
      "name": "Upload Track 2",
      "slug": "upload-track-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/upload-track-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/upload-track-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/upload-track-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/upload-track-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/upload-track-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/upload-track-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/upload-track-2.svg"
        }
      ],
      "tags": [
        "add-music",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "sound",
        "upload-song",
        "video"
      ]
    },
    "video-audio-sound/rewind-10-seconds-forward": {
      "name": "Rewind 10 Seconds Forward",
      "slug": "rewind-10-seconds-forward",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-10-seconds-forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-10-seconds-forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-10-seconds-forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-10-seconds-forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-10-seconds-forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-10-seconds-forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-10-seconds-forward.svg"
        }
      ],
      "tags": [
        "10s",
        "audio",
        "entertainment",
        "forward",
        "media",
        "multimedia",
        "music",
        "skip",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/clapperboard-text": {
      "name": "Clapperboard Text",
      "slug": "clapperboard-text",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/clapperboard-text",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/clapperboard-text.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/clapperboard-text.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/clapperboard-text.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/clapperboard-text.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/clapperboard-text.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/clapperboard-text.svg"
        }
      ],
      "tags": [
        "audio",
        "dialogue",
        "entertainment",
        "film",
        "media",
        "multimedia",
        "music",
        "script",
        "sound",
        "subtitle",
        "video"
      ]
    },
    "video-audio-sound/rewind-back": {
      "name": "Rewind Back",
      "slug": "rewind-back",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-back",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-back.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-back.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-back.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-back.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-back.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-back.svg"
        }
      ],
      "tags": [
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "previous",
        "rewind",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/video-frame-play-vertical": {
      "name": "Video Frame Play Vertical",
      "slug": "video-frame-play-vertical",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/video-frame-play-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/video-frame-play-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/video-frame-play-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/video-frame-play-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/video-frame-play-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/video-frame-play-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/video-frame-play-vertical.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "play",
        "portrait",
        "sound",
        "vertical-video",
        "video"
      ]
    },
    "video-audio-sound/upload-track": {
      "name": "Upload Track",
      "slug": "upload-track",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/upload-track",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/upload-track.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/upload-track.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/upload-track.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/upload-track.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/upload-track.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/upload-track.svg"
        }
      ],
      "tags": [
        "add-music",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "publish",
        "sound",
        "upload-song",
        "video"
      ]
    },
    "video-audio-sound/skip-next": {
      "name": "Skip Next",
      "slug": "skip-next",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/skip-next",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/skip-next.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/skip-next.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/skip-next.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/skip-next.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/skip-next.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/skip-next.svg"
        }
      ],
      "tags": [
        "advance",
        "audio",
        "entertainment",
        "forward",
        "media",
        "multimedia",
        "music",
        "next-track",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/music-note-slider-2": {
      "name": "Music Note Slider 2",
      "slug": "music-note-slider-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/music-note-slider-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/music-note-slider-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/music-note-slider-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/music-note-slider-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/music-note-slider-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/music-note-slider-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/music-note-slider-2.svg"
        }
      ],
      "tags": [
        "DJ",
        "adjust",
        "audio",
        "entertainment",
        "equalizer",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/gallery-check": {
      "name": "Gallery Check",
      "slug": "gallery-check",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-check.svg"
        }
      ],
      "tags": [
        "approved",
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "selected",
        "sound",
        "verified",
        "video"
      ]
    },
    "video-audio-sound/gallery-edit": {
      "name": "Gallery Edit",
      "slug": "gallery-edit",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-edit",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-edit.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-edit.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-edit.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-edit.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-edit.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-edit.svg"
        }
      ],
      "tags": [
        "adjust",
        "audio",
        "edit-photo",
        "entertainment",
        "media",
        "modify-image",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/skip-previous": {
      "name": "Skip Previous",
      "slug": "skip-previous",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/skip-previous",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/skip-previous.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/skip-previous.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/skip-previous.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/skip-previous.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/skip-previous.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/skip-previous.svg"
        }
      ],
      "tags": [
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "previous-track",
        "rewind",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/panorama": {
      "name": "Panorama",
      "slug": "panorama",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/panorama",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/panorama.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/panorama.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/panorama.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/panorama.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/panorama.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/panorama.svg"
        }
      ],
      "tags": [
        "360",
        "audio",
        "entertainment",
        "landscape",
        "media",
        "multimedia",
        "music",
        "sound",
        "video",
        "wide",
        "widescreen"
      ]
    },
    "video-audio-sound/play-circle": {
      "name": "Play Circle",
      "slug": "play-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/play-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/play-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/play-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/play-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/play-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/play-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/play-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "begin",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "resume",
        "sound",
        "start",
        "video"
      ]
    },
    "video-audio-sound/pause-circle": {
      "name": "Pause Circle",
      "slug": "pause-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/pause-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/pause-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/pause-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/pause-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/pause-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/pause-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/pause-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "hold",
        "media",
        "multimedia",
        "music",
        "sound",
        "stop",
        "video",
        "wait"
      ]
    },
    "video-audio-sound/gallery-favourite": {
      "name": "Gallery Favourite",
      "slug": "gallery-favourite",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-favourite",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-favourite.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-favourite.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-favourite.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-favourite.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-favourite.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-favourite.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "heart",
        "liked-photo",
        "media",
        "multimedia",
        "music",
        "sound",
        "starred",
        "video"
      ]
    },
    "video-audio-sound/gallery-circle": {
      "name": "Gallery Circle",
      "slug": "gallery-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "photos",
        "round",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/stop-circle": {
      "name": "Stop Circle",
      "slug": "stop-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/stop-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/stop-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/stop-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/stop-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/stop-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/stop-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/stop-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "cease",
        "end",
        "entertainment",
        "halt",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/gallery-round": {
      "name": "Gallery Round",
      "slug": "gallery-round",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/gallery-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/gallery-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/gallery-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/gallery-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/gallery-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/gallery-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/gallery-round.svg"
        }
      ],
      "tags": [
        "audio",
        "collection",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "photos",
        "round",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/rewind-forward-circle": {
      "name": "Rewind Forward Circle",
      "slug": "rewind-forward-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-forward-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-forward-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-forward-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-forward-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-forward-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-forward-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-forward-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "fast-forward",
        "media",
        "multimedia",
        "music",
        "next",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/rewind-back-circle": {
      "name": "Rewind Back Circle",
      "slug": "rewind-back-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/rewind-back-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/rewind-back-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/rewind-back-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/rewind-back-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/rewind-back-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/rewind-back-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/rewind-back-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "back",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "previous",
        "rewind",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/videocamera": {
      "name": "Videocamera",
      "slug": "videocamera",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/videocamera",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/videocamera.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/videocamera.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/videocamera.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/videocamera.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/videocamera.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/videocamera.svg"
        }
      ],
      "tags": [
        "audio",
        "camcorder",
        "entertainment",
        "film",
        "media",
        "multimedia",
        "music",
        "record",
        "shoot",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/videocamera-record": {
      "name": "Videocamera Record",
      "slug": "videocamera-record",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/videocamera-record",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/videocamera-record.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/videocamera-record.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/videocamera-record.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/videocamera-record.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/videocamera-record.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/videocamera-record.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "filming",
        "live",
        "media",
        "multimedia",
        "music",
        "recording",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/videocamera-add": {
      "name": "Videocamera Add",
      "slug": "videocamera-add",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/videocamera-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/videocamera-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/videocamera-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/videocamera-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/videocamera-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/videocamera-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/videocamera-add.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "new-video",
        "sound",
        "start-recording",
        "video"
      ]
    },
    "video-audio-sound/stream": {
      "name": "Stream",
      "slug": "stream",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/stream",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/stream.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/stream.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/stream.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/stream.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/stream.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/stream.svg"
        }
      ],
      "tags": [
        "audio",
        "broadcast",
        "entertainment",
        "live",
        "media",
        "multimedia",
        "music",
        "real-time",
        "sound",
        "streaming",
        "video"
      ]
    },
    "video-audio-sound/camera-square": {
      "name": "Camera Square",
      "slug": "camera-square",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/camera-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/camera-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/camera-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/camera-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/camera-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/camera-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/camera-square.svg"
        }
      ],
      "tags": [
        "audio",
        "capture",
        "entertainment",
        "frame",
        "media",
        "multimedia",
        "music",
        "photo",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/camera": {
      "name": "Camera",
      "slug": "camera",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/camera",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/camera.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/camera.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/camera.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/camera.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/camera.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/camera.svg"
        }
      ],
      "tags": [
        "audio",
        "capture",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "photo",
        "photograph",
        "picture",
        "snap",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/camera-add": {
      "name": "Camera Add",
      "slug": "camera-add",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/camera-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/camera-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/camera-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/camera-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/camera-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/camera-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/camera-add.svg"
        }
      ],
      "tags": [
        "audio",
        "capture",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "new-photo",
        "sound",
        "take-picture",
        "video"
      ]
    },
    "video-audio-sound/camera-minimalistic": {
      "name": "Camera Minimalistic",
      "slug": "camera-minimalistic",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/camera-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/camera-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/camera-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/camera-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/camera-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/camera-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/camera-minimalistic.svg"
        }
      ],
      "tags": [
        "audio",
        "capture",
        "entertainment",
        "media",
        "minimal",
        "multimedia",
        "music",
        "photo",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/camera-rotate": {
      "name": "Camera Rotate",
      "slug": "camera-rotate",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/camera-rotate",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/camera-rotate.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/camera-rotate.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/camera-rotate.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/camera-rotate.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/camera-rotate.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/camera-rotate.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "flip",
        "front-camera",
        "media",
        "multimedia",
        "music",
        "selfie",
        "sound",
        "switch",
        "video"
      ]
    },
    "video-audio-sound/shuffle": {
      "name": "Shuffle",
      "slug": "shuffle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/shuffle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/shuffle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/shuffle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/shuffle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/shuffle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/shuffle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/shuffle.svg"
        }
      ],
      "tags": [
        "audio",
        "disorder",
        "entertainment",
        "media",
        "mix",
        "multimedia",
        "music",
        "random",
        "randomize",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/reel": {
      "name": "Reel",
      "slug": "reel",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/reel",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/reel.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/reel.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/reel.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/reel.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/reel.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/reel.svg"
        }
      ],
      "tags": [
        "Instagram",
        "audio",
        "cinema",
        "entertainment",
        "film-reel",
        "media",
        "movie",
        "multimedia",
        "music",
        "short-video",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/reel-2": {
      "name": "Reel 2",
      "slug": "reel-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/reel-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/reel-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/reel-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/reel-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/reel-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/reel-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/reel-2.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "film-reel",
        "media",
        "movie",
        "multimedia",
        "music",
        "short-video",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/playback-speed": {
      "name": "Playback Speed",
      "slug": "playback-speed",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/playback-speed",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/playback-speed.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/playback-speed.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/playback-speed.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/playback-speed.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/playback-speed.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/playback-speed.svg"
        }
      ],
      "tags": [
        "1x",
        "2x",
        "audio",
        "entertainment",
        "fast",
        "media",
        "multimedia",
        "music",
        "rate",
        "slow",
        "sound",
        "speed",
        "video"
      ]
    },
    "video-audio-sound/pip-2": {
      "name": "PIP 2",
      "slug": "pip-2",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/pip-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/pip-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/pip-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/pip-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/pip-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/pip-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/pip-2.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "float",
        "media",
        "multimedia",
        "music",
        "overlay",
        "picture-in-picture",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/pip": {
      "name": "PIP",
      "slug": "pip",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/pip",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/pip.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/pip.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/pip.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/pip.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/pip.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/pip.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "float",
        "media",
        "mini-player",
        "multimedia",
        "music",
        "overlay",
        "picture-in-picture",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/to-pip": {
      "name": "To PIP",
      "slug": "to-pip",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/to-pip",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/to-pip.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/to-pip.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/to-pip.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/to-pip.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/to-pip.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/to-pip.svg"
        }
      ],
      "tags": [
        "audio",
        "enter-pip",
        "entertainment",
        "media",
        "multimedia",
        "music",
        "overlay",
        "picture-in-picture",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/quit-pip": {
      "name": "Quit PIP",
      "slug": "quit-pip",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/quit-pip",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/quit-pip.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/quit-pip.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/quit-pip.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/quit-pip.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/quit-pip.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/quit-pip.svg"
        }
      ],
      "tags": [
        "audio",
        "close-overlay",
        "entertainment",
        "exit-pip",
        "media",
        "multimedia",
        "music",
        "restore",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/full-screen": {
      "name": "Full Screen",
      "slug": "full-screen",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/full-screen",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/full-screen.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/full-screen.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/full-screen.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/full-screen.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/full-screen.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/full-screen.svg"
        }
      ],
      "tags": [
        "audio",
        "enlarge",
        "entertainment",
        "expand",
        "fullscreen",
        "maximize",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/quit-full-screen": {
      "name": "Quit Full Screen",
      "slug": "quit-full-screen",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/quit-full-screen",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/quit-full-screen.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/quit-full-screen.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/quit-full-screen.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/quit-full-screen.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/quit-full-screen.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/quit-full-screen.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "exit-fullscreen",
        "media",
        "minimize",
        "multimedia",
        "music",
        "restore",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/quit-full-screen-square": {
      "name": "Quit Full Screen Square",
      "slug": "quit-full-screen-square",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/quit-full-screen-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/quit-full-screen-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/quit-full-screen-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/quit-full-screen-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/quit-full-screen-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/quit-full-screen-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/quit-full-screen-square.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "exit-fullscreen",
        "media",
        "minimize",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/quit-full-screen-circle": {
      "name": "Quit Full Screen Circle",
      "slug": "quit-full-screen-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/quit-full-screen-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/quit-full-screen-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/quit-full-screen-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/quit-full-screen-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/quit-full-screen-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/quit-full-screen-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/quit-full-screen-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "exit-fullscreen",
        "media",
        "minimize",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/full-screen-square": {
      "name": "Full Screen Square",
      "slug": "full-screen-square",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/full-screen-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/full-screen-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/full-screen-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/full-screen-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/full-screen-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/full-screen-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/full-screen-square.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "expand",
        "fullscreen",
        "maximize",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "video-audio-sound/full-screen-circle": {
      "name": "Full Screen Circle",
      "slug": "full-screen-circle",
      "category": "video-audio-sound",
      "categoryName": "Video, Audio, Sound",
      "id": "video-audio-sound/full-screen-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/video-audio-sound/full-screen-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/video-audio-sound/full-screen-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/video-audio-sound/full-screen-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/video-audio-sound/full-screen-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/video-audio-sound/full-screen-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/video-audio-sound/full-screen-circle.svg"
        }
      ],
      "tags": [
        "audio",
        "entertainment",
        "expand",
        "fullscreen",
        "maximize",
        "media",
        "multimedia",
        "music",
        "sound",
        "video"
      ]
    },
    "money/wallet": {
      "name": "Wallet",
      "slug": "wallet",
      "category": "money",
      "categoryName": "Money",
      "id": "money/wallet",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/wallet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/wallet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/wallet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/wallet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/wallet.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/wallet.svg"
        }
      ],
      "tags": [
        "banking",
        "billfold",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "purse"
      ]
    },
    "money/wallet-2": {
      "name": "Wallet 2",
      "slug": "wallet-2",
      "category": "money",
      "categoryName": "Money",
      "id": "money/wallet-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/wallet-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/wallet-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/wallet-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/wallet-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/wallet-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/wallet-2.svg"
        }
      ],
      "tags": [
        "banking",
        "billfold",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "purse"
      ]
    },
    "money/cardholder": {
      "name": "Cardholder",
      "slug": "cardholder",
      "category": "money",
      "categoryName": "Money",
      "id": "money/cardholder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/cardholder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/cardholder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/cardholder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/cardholder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/cardholder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/cardholder.svg"
        }
      ],
      "tags": [
        "banking",
        "card-case",
        "commerce",
        "currency",
        "finance",
        "financial",
        "holder",
        "money",
        "payment",
        "wallet"
      ]
    },
    "money/wallet-money": {
      "name": "Wallet Money",
      "slug": "wallet-money",
      "category": "money",
      "categoryName": "Money",
      "id": "money/wallet-money",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/wallet-money.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/wallet-money.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/wallet-money.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/wallet-money.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/wallet-money.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/wallet-money.svg"
        }
      ],
      "tags": [
        "balance",
        "banking",
        "cash",
        "commerce",
        "currency",
        "finance",
        "financial",
        "funds",
        "money",
        "payment",
        "savings"
      ]
    },
    "money/ticker-star": {
      "name": "Ticker Star",
      "slug": "ticker-star",
      "category": "money",
      "categoryName": "Money",
      "id": "money/ticker-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/ticker-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/ticker-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/ticker-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/ticker-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/ticker-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/ticker-star.svg"
        }
      ],
      "tags": [
        "VIP",
        "banking",
        "commerce",
        "currency",
        "featured",
        "finance",
        "financial",
        "money",
        "payment",
        "premium",
        "special",
        "ticket"
      ]
    },
    "money/ticket": {
      "name": "Ticket",
      "slug": "ticket",
      "category": "money",
      "categoryName": "Money",
      "id": "money/ticket",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/ticket.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/ticket.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/ticket.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/ticket.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/ticket.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/ticket.svg"
        }
      ],
      "tags": [
        "admission",
        "banking",
        "commerce",
        "coupon",
        "currency",
        "entry",
        "finance",
        "financial",
        "money",
        "pass",
        "payment",
        "voucher"
      ]
    },
    "money/ticket-sale": {
      "name": "Ticket Sale",
      "slug": "ticket-sale",
      "category": "money",
      "categoryName": "Money",
      "id": "money/ticket-sale",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/ticket-sale.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/ticket-sale.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/ticket-sale.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/ticket-sale.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/ticket-sale.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/ticket-sale.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "coupon",
        "currency",
        "deal",
        "discount",
        "finance",
        "financial",
        "money",
        "offer",
        "payment"
      ]
    },
    "money/card": {
      "name": "Card",
      "slug": "card",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card.svg"
        }
      ],
      "tags": [
        "bank-card",
        "banking",
        "commerce",
        "credit-card",
        "currency",
        "debit",
        "finance",
        "financial",
        "mastercard",
        "money",
        "payment",
        "visa"
      ]
    },
    "money/card-2": {
      "name": "Card 2",
      "slug": "card-2",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card-2.svg"
        }
      ],
      "tags": [
        "bank-card",
        "banking",
        "commerce",
        "credit-card",
        "currency",
        "debit",
        "finance",
        "financial",
        "money",
        "payment"
      ]
    },
    "money/card-transfer": {
      "name": "Card Transfer",
      "slug": "card-transfer",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card-transfer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card-transfer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card-transfer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card-transfer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card-transfer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card-transfer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card-transfer.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "exchange",
        "finance",
        "financial",
        "money",
        "payment",
        "swap-card",
        "switch"
      ]
    },
    "money/card-send": {
      "name": "Card Send",
      "slug": "card-send",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card-send",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card-send.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card-send.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card-send.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card-send.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card-send.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card-send.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "pay",
        "payment",
        "send-payment",
        "transfer"
      ]
    },
    "money/card-recive": {
      "name": "Card Recive",
      "slug": "card-recive",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card-recive",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card-recive.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card-recive.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card-recive.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card-recive.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card-recive.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card-recive.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "deposit",
        "finance",
        "financial",
        "incoming",
        "money",
        "payment",
        "receive-payment"
      ]
    },
    "money/card-search": {
      "name": "Card Search",
      "slug": "card-search",
      "category": "money",
      "categoryName": "Money",
      "id": "money/card-search",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/card-search.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/card-search.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/card-search.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/card-search.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/card-search.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/card-search.svg"
        }
      ],
      "tags": [
        "banking",
        "check",
        "commerce",
        "currency",
        "finance",
        "financial",
        "find-transaction",
        "lookup",
        "money",
        "payment"
      ]
    },
    "money/verified-check": {
      "name": "Verified Check",
      "slug": "verified-check",
      "category": "money",
      "categoryName": "Money",
      "id": "money/verified-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/verified-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/verified-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/verified-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/verified-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/verified-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/verified-check.svg"
        }
      ],
      "tags": [
        "approved",
        "authentic",
        "banking",
        "commerce",
        "confirmed",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "trusted",
        "verified"
      ]
    },
    "money/sale": {
      "name": "Sale",
      "slug": "sale",
      "category": "money",
      "categoryName": "Money",
      "id": "money/sale",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/sale.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/sale.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/sale.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/sale.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/sale.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/sale.svg"
        }
      ],
      "tags": [
        "banking",
        "bargain",
        "commerce",
        "currency",
        "deal",
        "discount",
        "finance",
        "financial",
        "money",
        "offer",
        "payment",
        "percent",
        "promotion"
      ]
    },
    "money/sale-square": {
      "name": "Sale Square",
      "slug": "sale-square",
      "category": "money",
      "categoryName": "Money",
      "id": "money/sale-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/sale-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/sale-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/sale-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/sale-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/sale-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/sale-square.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "deal",
        "discount",
        "finance",
        "financial",
        "money",
        "offer",
        "payment",
        "promotion"
      ]
    },
    "money/tag": {
      "name": "Tag",
      "slug": "tag",
      "category": "money",
      "categoryName": "Money",
      "id": "money/tag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/tag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/tag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/tag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/tag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/tag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/tag.svg"
        }
      ],
      "tags": [
        "banking",
        "category",
        "commerce",
        "currency",
        "finance",
        "financial",
        "label",
        "metadata",
        "money",
        "payment",
        "price-tag"
      ]
    },
    "money/tag-price": {
      "name": "Tag Price",
      "slug": "tag-price",
      "category": "money",
      "categoryName": "Money",
      "id": "money/tag-price",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/tag-price.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/tag-price.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/tag-price.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/tag-price.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/tag-price.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/tag-price.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "cost",
        "currency",
        "finance",
        "financial",
        "label",
        "money",
        "payment",
        "price",
        "value"
      ]
    },
    "money/tag-horizontal": {
      "name": "Tag Horizontal",
      "slug": "tag-horizontal",
      "category": "money",
      "categoryName": "Money",
      "id": "money/tag-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/tag-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/tag-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/tag-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/tag-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/tag-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/tag-horizontal.svg"
        }
      ],
      "tags": [
        "banking",
        "category",
        "commerce",
        "currency",
        "finance",
        "financial",
        "label",
        "money",
        "payment",
        "price-tag"
      ]
    },
    "money/euro": {
      "name": "Euro",
      "slug": "euro",
      "category": "money",
      "categoryName": "Money",
      "id": "money/euro",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/euro.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/euro.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/euro.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/euro.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/euro.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/euro.svg"
        }
      ],
      "tags": [
        "EUR",
        "European",
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "price"
      ]
    },
    "money/ruble": {
      "name": "Ruble",
      "slug": "ruble",
      "category": "money",
      "categoryName": "Money",
      "id": "money/ruble",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/ruble.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/ruble.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/ruble.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/ruble.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/ruble.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/ruble.svg"
        }
      ],
      "tags": [
        "RUB",
        "Russian",
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment"
      ]
    },
    "money/dollar": {
      "name": "Dollar",
      "slug": "dollar",
      "category": "money",
      "categoryName": "Money",
      "id": "money/dollar",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/dollar.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/dollar.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/dollar.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/dollar.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/dollar.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/dollar.svg"
        }
      ],
      "tags": [
        "American",
        "USD",
        "banking",
        "commerce",
        "cost",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "price"
      ]
    },
    "money/dollar-minimalistic": {
      "name": "Dollar Minimalistic",
      "slug": "dollar-minimalistic",
      "category": "money",
      "categoryName": "Money",
      "id": "money/dollar-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/dollar-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/dollar-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/dollar-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/dollar-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/dollar-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/dollar-minimalistic.svg"
        }
      ],
      "tags": [
        "USD",
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "minimal",
        "money",
        "payment",
        "price"
      ]
    },
    "money/banknote": {
      "name": "Banknote",
      "slug": "banknote",
      "category": "money",
      "categoryName": "Money",
      "id": "money/banknote",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/banknote.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/banknote.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/banknote.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/banknote.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/banknote.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/banknote.svg"
        }
      ],
      "tags": [
        "banking",
        "bill",
        "cash",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "note",
        "paper-money",
        "payment"
      ]
    },
    "money/banknote-2": {
      "name": "Banknote 2",
      "slug": "banknote-2",
      "category": "money",
      "categoryName": "Money",
      "id": "money/banknote-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/banknote-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/banknote-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/banknote-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/banknote-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/banknote-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/banknote-2.svg"
        }
      ],
      "tags": [
        "banking",
        "bill",
        "cash",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "paper-money",
        "payment"
      ]
    },
    "money/wad-of-money": {
      "name": "Wad Of Money",
      "slug": "wad-of-money",
      "category": "money",
      "categoryName": "Money",
      "id": "money/wad-of-money",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/wad-of-money.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/wad-of-money.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/wad-of-money.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/wad-of-money.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/wad-of-money.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/wad-of-money.svg"
        }
      ],
      "tags": [
        "banking",
        "bundle",
        "cash",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "rich",
        "stack",
        "wealth"
      ]
    },
    "money/safe-square": {
      "name": "Safe Square",
      "slug": "safe-square",
      "category": "money",
      "categoryName": "Money",
      "id": "money/safe-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/safe-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/safe-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/safe-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/safe-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/safe-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/safe-square.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "secure",
        "strongbox",
        "vault"
      ]
    },
    "money/safe-circle": {
      "name": "Safe Circle",
      "slug": "safe-circle",
      "category": "money",
      "categoryName": "Money",
      "id": "money/safe-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/safe-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/safe-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/safe-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/safe-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/safe-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/safe-circle.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "payment",
        "secure",
        "strongbox",
        "vault"
      ]
    },
    "money/safe-2": {
      "name": "Safe 2",
      "slug": "safe-2",
      "category": "money",
      "categoryName": "Money",
      "id": "money/safe-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/safe-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/safe-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/safe-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/safe-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/safe-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/safe-2.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "deposit",
        "finance",
        "financial",
        "money",
        "payment",
        "secure",
        "strongbox",
        "vault"
      ]
    },
    "money/cash-out": {
      "name": "Cash Out",
      "slug": "cash-out",
      "category": "money",
      "categoryName": "Money",
      "id": "money/cash-out",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/cash-out.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/cash-out.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/cash-out.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/cash-out.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/cash-out.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/cash-out.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "expense",
        "finance",
        "financial",
        "money",
        "payment",
        "payout",
        "spend",
        "withdraw"
      ]
    },
    "money/bill-list": {
      "name": "Bill List",
      "slug": "bill-list",
      "category": "money",
      "categoryName": "Money",
      "id": "money/bill-list",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/bill-list.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/bill-list.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/bill-list.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/bill-list.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/bill-list.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/bill-list.svg"
        }
      ],
      "tags": [
        "banking",
        "breakdown",
        "commerce",
        "currency",
        "details",
        "finance",
        "financial",
        "itemized",
        "money",
        "payment",
        "statement"
      ]
    },
    "money/bill-cross": {
      "name": "Bill Cross",
      "slug": "bill-cross",
      "category": "money",
      "categoryName": "Money",
      "id": "money/bill-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/bill-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/bill-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/bill-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/bill-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/bill-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/bill-cross.svg"
        }
      ],
      "tags": [
        "banking",
        "cancelled",
        "commerce",
        "currency",
        "declined",
        "finance",
        "financial",
        "money",
        "payment",
        "rejected",
        "unpaid"
      ]
    },
    "money/bill-check": {
      "name": "Bill Check",
      "slug": "bill-check",
      "category": "money",
      "categoryName": "Money",
      "id": "money/bill-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/bill-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/bill-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/bill-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/bill-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/bill-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/bill-check.svg"
        }
      ],
      "tags": [
        "approved",
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "money",
        "paid",
        "payment",
        "receipt",
        "verified"
      ]
    },
    "money/bill": {
      "name": "Bill",
      "slug": "bill",
      "category": "money",
      "categoryName": "Money",
      "id": "money/bill",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/bill.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/bill.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/bill.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/bill.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/bill.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/bill.svg"
        }
      ],
      "tags": [
        "banking",
        "charge",
        "commerce",
        "currency",
        "finance",
        "financial",
        "invoice",
        "money",
        "payment",
        "receipt",
        "statement"
      ]
    },
    "money/money-bag": {
      "name": "Money Bag",
      "slug": "money-bag",
      "category": "money",
      "categoryName": "Money",
      "id": "money/money-bag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/money/money-bag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/money/money-bag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/money/money-bag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/money/money-bag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/money/money-bag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/money/money-bag.svg"
        }
      ],
      "tags": [
        "banking",
        "commerce",
        "currency",
        "finance",
        "financial",
        "jackpot",
        "money",
        "payment",
        "profit",
        "rich",
        "savings",
        "wealth"
      ]
    },
    "electronic-devices/gamepad-old": {
      "name": "Gamepad Old",
      "slug": "gamepad-old",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gamepad-old",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gamepad-old.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gamepad-old.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gamepad-old.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gamepad-old.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gamepad-old.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gamepad-old.svg"
        }
      ],
      "tags": [
        "classic",
        "controller",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "hardware",
        "retro",
        "tech",
        "technology",
        "vintage"
      ]
    },
    "electronic-devices/gamepad-minimalistic": {
      "name": "Gamepad Minimalistic",
      "slug": "gamepad-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gamepad-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gamepad-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gamepad-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gamepad-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gamepad-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gamepad-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gamepad-minimalistic.svg"
        }
      ],
      "tags": [
        "controller",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "hardware",
        "minimal",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/gamepad-no-charge": {
      "name": "Gamepad No Charge",
      "slug": "gamepad-no-charge",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gamepad-no-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gamepad-no-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gamepad-no-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gamepad-no-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gamepad-no-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gamepad-no-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gamepad-no-charge.svg"
        }
      ],
      "tags": [
        "controller",
        "dead-battery",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/gamepad": {
      "name": "Gamepad",
      "slug": "gamepad",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gamepad",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gamepad.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gamepad.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gamepad.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gamepad.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gamepad.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gamepad.svg"
        }
      ],
      "tags": [
        "console",
        "controller",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "hardware",
        "joystick",
        "play",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/gamepad-charge": {
      "name": "Gamepad Charge",
      "slug": "gamepad-charge",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gamepad-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gamepad-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gamepad-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gamepad-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gamepad-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gamepad-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gamepad-charge.svg"
        }
      ],
      "tags": [
        "battery",
        "charging",
        "controller",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/iphone": {
      "name": "iPhone",
      "slug": "iphone",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/iphone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/iphone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/iphone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/iphone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/iphone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/iphone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/iphone.svg"
        }
      ],
      "tags": [
        "Apple",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "iOS",
        "mobile",
        "phone",
        "smartphone",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/smartphone": {
      "name": "Smartphone",
      "slug": "smartphone",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone.svg"
        }
      ],
      "tags": [
        "Android",
        "cell",
        "device",
        "electronic",
        "gadget",
        "handheld",
        "hardware",
        "mobile",
        "phone",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/smartphone-2": {
      "name": "Smartphone 2",
      "slug": "smartphone-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-2.svg"
        }
      ],
      "tags": [
        "cell",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "mobile",
        "phone",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/smartphone-update": {
      "name": "Smartphone Update",
      "slug": "smartphone-update",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-update",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-update.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-update.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-update.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-update.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-update.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-update.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "phone",
        "refresh",
        "tech",
        "technology",
        "update",
        "upgrade"
      ]
    },
    "electronic-devices/smartphone-rotate-orientation": {
      "name": "Smartphone Rotate Orientation",
      "slug": "smartphone-rotate-orientation",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-rotate-orientation",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-rotate-orientation.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-rotate-orientation.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-rotate-orientation.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-rotate-orientation.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-rotate-orientation.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-rotate-orientation.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "landscape",
        "portrait",
        "rotate",
        "screen-rotation",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/smartphone-vibration": {
      "name": "Smartphone Vibration",
      "slug": "smartphone-vibration",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-vibration",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-vibration.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-vibration.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-vibration.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-vibration.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-vibration.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-vibration.svg"
        }
      ],
      "tags": [
        "alert",
        "device",
        "electronic",
        "gadget",
        "haptic",
        "hardware",
        "phone",
        "silent",
        "tech",
        "technology",
        "vibrate"
      ]
    },
    "electronic-devices/smartphone-rotate-2": {
      "name": "Smartphone Rotate 2",
      "slug": "smartphone-rotate-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-rotate-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-rotate-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-rotate-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-rotate-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-rotate-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-rotate-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-rotate-2.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "landscape",
        "orientation",
        "portrait",
        "rotate",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/smartphone-rotate-angle": {
      "name": "Smartphone Rotate Angle",
      "slug": "smartphone-rotate-angle",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smartphone-rotate-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smartphone-rotate-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smartphone-rotate-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smartphone-rotate-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smartphone-rotate-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smartphone-rotate-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smartphone-rotate-angle.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "orientation",
        "rotate",
        "tech",
        "technology",
        "tilt"
      ]
    },
    "electronic-devices/tablet": {
      "name": "Tablet",
      "slug": "tablet",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/tablet",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/tablet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/tablet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/tablet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/tablet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/tablet.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/tablet.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "iPad",
        "portable",
        "slate",
        "tech",
        "technology",
        "touchscreen"
      ]
    },
    "electronic-devices/headphones-round": {
      "name": "Headphones Round",
      "slug": "headphones-round",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/headphones-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/headphones-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/headphones-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/headphones-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/headphones-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/headphones-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/headphones-round.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "earphones",
        "electronic",
        "gadget",
        "hardware",
        "headset",
        "listening",
        "music",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/headphones-round-sound": {
      "name": "Headphones Round Sound",
      "slug": "headphones-round-sound",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/headphones-round-sound",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/headphones-round-sound.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/headphones-round-sound.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/headphones-round-sound.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/headphones-round-sound.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/headphones-round-sound.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/headphones-round-sound.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "headset",
        "music",
        "playing",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/headphones-square": {
      "name": "Headphones Square",
      "slug": "headphones-square",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/headphones-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/headphones-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/headphones-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/headphones-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/headphones-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/headphones-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/headphones-square.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "headset",
        "music",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/headphones-square-sound": {
      "name": "Headphones Square Sound",
      "slug": "headphones-square-sound",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/headphones-square-sound",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/headphones-square-sound.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/headphones-square-sound.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/headphones-square-sound.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/headphones-square-sound.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/headphones-square-sound.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/headphones-square-sound.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "headset",
        "music",
        "playing",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server": {
      "name": "Server",
      "slug": "server",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server.svg"
        }
      ],
      "tags": [
        "backend",
        "cloud",
        "database",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "hosting",
        "infrastructure",
        "rack",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server-2": {
      "name": "Server 2",
      "slug": "server-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-2.svg"
        }
      ],
      "tags": [
        "backend",
        "database",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "hosting",
        "rack",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server-square": {
      "name": "Server Square",
      "slug": "server-square",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-square.svg"
        }
      ],
      "tags": [
        "backend",
        "database",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "hosting",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server-path": {
      "name": "Server Path",
      "slug": "server-path",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-path",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-path.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-path.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-path.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-path.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-path.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-path.svg"
        }
      ],
      "tags": [
        "connection",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "infrastructure",
        "network",
        "routing",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server-minimalistic": {
      "name": "Server Minimalistic",
      "slug": "server-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-minimalistic.svg"
        }
      ],
      "tags": [
        "backend",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "hosting",
        "minimal",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/server-square-update": {
      "name": "Server Square Update",
      "slug": "server-square-update",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-square-update",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-square-update.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-square-update.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-square-update.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-square-update.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-square-update.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-square-update.svg"
        }
      ],
      "tags": [
        "deploy",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "hosting",
        "maintenance",
        "tech",
        "technology",
        "update"
      ]
    },
    "electronic-devices/server-square-cloud": {
      "name": "Server Square Cloud",
      "slug": "server-square-cloud",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/server-square-cloud",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/server-square-cloud.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/server-square-cloud.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/server-square-cloud.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/server-square-cloud.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/server-square-cloud.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/server-square-cloud.svg"
        }
      ],
      "tags": [
        "SaaS",
        "cloud-computing",
        "cloud-hosting",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/mouse-minimalistic": {
      "name": "Mouse Minimalistic",
      "slug": "mouse-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/mouse-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/mouse-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/mouse-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/mouse-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/mouse-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/mouse-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/mouse-minimalistic.svg"
        }
      ],
      "tags": [
        "click",
        "cursor",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "input",
        "minimal",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/mouse": {
      "name": "Mouse",
      "slug": "mouse",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/mouse",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/mouse.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/mouse.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/mouse.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/mouse.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/mouse.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/mouse.svg"
        }
      ],
      "tags": [
        "click",
        "computer",
        "cursor",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "input",
        "peripheral",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/mouse-circle": {
      "name": "Mouse Circle",
      "slug": "mouse-circle",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/mouse-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/mouse-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/mouse-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/mouse-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/mouse-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/mouse-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/mouse-circle.svg"
        }
      ],
      "tags": [
        "click",
        "cursor",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "input",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds": {
      "name": "Airbuds",
      "slug": "airbuds",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds.svg"
        }
      ],
      "tags": [
        "AirPods",
        "audio",
        "device",
        "earbuds",
        "earphones",
        "electronic",
        "gadget",
        "hardware",
        "headphones",
        "tech",
        "technology",
        "wireless"
      ]
    },
    "electronic-devices/airbuds-case": {
      "name": "Airbuds Case",
      "slug": "airbuds-case",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-case",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-case.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-case.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-case.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-case.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-case.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-case.svg"
        }
      ],
      "tags": [
        "AirPods",
        "case",
        "charging",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-case-minimalistic": {
      "name": "Airbuds Case Minimalistic",
      "slug": "airbuds-case-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-case-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-case-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-case-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-case-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-case-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-case-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-case-minimalistic.svg"
        }
      ],
      "tags": [
        "AirPods",
        "case",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-case-charge": {
      "name": "Airbuds Case Charge",
      "slug": "airbuds-case-charge",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-case-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-case-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-case-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-case-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-case-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-case-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-case-charge.svg"
        }
      ],
      "tags": [
        "AirPods",
        "battery",
        "charging",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-case-open": {
      "name": "Airbuds Case Open",
      "slug": "airbuds-case-open",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-case-open",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-case-open.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-case-open.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-case-open.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-case-open.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-case-open.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-case-open.svg"
        }
      ],
      "tags": [
        "AirPods",
        "case",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "open",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-check": {
      "name": "Airbuds Check",
      "slug": "airbuds-check",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-check.svg"
        }
      ],
      "tags": [
        "connected",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "paired",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-remove": {
      "name": "Airbuds Remove",
      "slug": "airbuds-remove",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-remove.svg"
        }
      ],
      "tags": [
        "device",
        "disconnect",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "tech",
        "technology",
        "unpair"
      ]
    },
    "electronic-devices/airbuds-charge": {
      "name": "Airbuds Charge",
      "slug": "airbuds-charge",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-charge.svg"
        }
      ],
      "tags": [
        "battery",
        "charging",
        "device",
        "earbuds",
        "electronic",
        "gadget",
        "hardware",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-right": {
      "name": "Airbuds Right",
      "slug": "airbuds-right",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-right.svg"
        }
      ],
      "tags": [
        "device",
        "earbud",
        "electronic",
        "gadget",
        "hardware",
        "right",
        "single",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/airbuds-left": {
      "name": "Airbuds Left",
      "slug": "airbuds-left",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/airbuds-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/airbuds-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/airbuds-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/airbuds-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/airbuds-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/airbuds-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/airbuds-left.svg"
        }
      ],
      "tags": [
        "device",
        "earbud",
        "electronic",
        "gadget",
        "hardware",
        "left",
        "single",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/laptop-minimalistic": {
      "name": "Laptop Minimalistic",
      "slug": "laptop-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/laptop-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/laptop-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/laptop-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/laptop-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/laptop-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/laptop-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/laptop-minimalistic.svg"
        }
      ],
      "tags": [
        "computer",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "notebook",
        "tech",
        "technology",
        "work"
      ]
    },
    "electronic-devices/laptop-3": {
      "name": "Laptop 3",
      "slug": "laptop-3",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/laptop-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/laptop-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/laptop-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/laptop-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/laptop-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/laptop-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/laptop-3.svg"
        }
      ],
      "tags": [
        "computer",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "notebook",
        "portable",
        "tech",
        "technology",
        "work"
      ]
    },
    "electronic-devices/laptop-2": {
      "name": "Laptop 2",
      "slug": "laptop-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/laptop-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/laptop-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/laptop-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/laptop-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/laptop-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/laptop-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/laptop-2.svg"
        }
      ],
      "tags": [
        "computer",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "notebook",
        "portable",
        "tech",
        "technology",
        "work"
      ]
    },
    "electronic-devices/laptop": {
      "name": "Laptop",
      "slug": "laptop",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/laptop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/laptop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/laptop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/laptop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/laptop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/laptop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/laptop.svg"
        }
      ],
      "tags": [
        "MacBook",
        "PC",
        "computer",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "notebook",
        "portable",
        "tech",
        "technology",
        "work"
      ]
    },
    "electronic-devices/cpu": {
      "name": "CPU",
      "slug": "cpu",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/cpu",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/cpu.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/cpu.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/cpu.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/cpu.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/cpu.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/cpu.svg"
        }
      ],
      "tags": [
        "chip",
        "computing",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "microchip",
        "processor",
        "silicon",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/cpu-bolt": {
      "name": "CPU Bolt",
      "slug": "cpu-bolt",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/cpu-bolt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/cpu-bolt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/cpu-bolt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/cpu-bolt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/cpu-bolt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/cpu-bolt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/cpu-bolt.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "fast",
        "gadget",
        "hardware",
        "performance",
        "processor",
        "tech",
        "technology",
        "turbo"
      ]
    },
    "electronic-devices/turntable": {
      "name": "Turntable",
      "slug": "turntable",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/turntable",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/turntable.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/turntable.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/turntable.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/turntable.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/turntable.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/turntable.svg"
        }
      ],
      "tags": [
        "DJ",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "music",
        "record-player",
        "retro",
        "tech",
        "technology",
        "vinyl"
      ]
    },
    "electronic-devices/turntable-minimalistic": {
      "name": "Turntable Minimalistic",
      "slug": "turntable-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/turntable-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/turntable-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/turntable-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/turntable-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/turntable-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/turntable-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/turntable-minimalistic.svg"
        }
      ],
      "tags": [
        "DJ",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "music",
        "tech",
        "technology",
        "vinyl"
      ]
    },
    "electronic-devices/turntable-music-note": {
      "name": "Turntable Music Note",
      "slug": "turntable-music-note",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/turntable-music-note",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/turntable-music-note.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/turntable-music-note.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/turntable-music-note.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/turntable-music-note.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/turntable-music-note.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/turntable-music-note.svg"
        }
      ],
      "tags": [
        "DJ",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "music",
        "playing",
        "tech",
        "technology",
        "vinyl"
      ]
    },
    "electronic-devices/boombox": {
      "name": "Boombox",
      "slug": "boombox",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/boombox",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/boombox.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/boombox.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/boombox.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/boombox.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/boombox.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/boombox.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "music",
        "retro",
        "speaker",
        "stereo",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/cassette": {
      "name": "Cassette",
      "slug": "cassette",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/cassette",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/cassette.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/cassette.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/cassette.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/cassette.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/cassette.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/cassette.svg"
        }
      ],
      "tags": [
        "80s",
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "music",
        "retro",
        "tape",
        "tech",
        "technology",
        "vintage"
      ]
    },
    "electronic-devices/cassette-2": {
      "name": "Cassette 2",
      "slug": "cassette-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/cassette-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/cassette-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/cassette-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/cassette-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/cassette-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/cassette-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/cassette-2.svg"
        }
      ],
      "tags": [
        "audio",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "music",
        "retro",
        "tape",
        "tech",
        "technology",
        "vintage"
      ]
    },
    "electronic-devices/monitor": {
      "name": "Monitor",
      "slug": "monitor",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/monitor",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/monitor.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/monitor.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/monitor.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/monitor.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/monitor.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/monitor.svg"
        }
      ],
      "tags": [
        "LCD",
        "computer",
        "desktop",
        "device",
        "display",
        "electronic",
        "gadget",
        "hardware",
        "screen",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/monitor-camera": {
      "name": "Monitor Camera",
      "slug": "monitor-camera",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/monitor-camera",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/monitor-camera.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/monitor-camera.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/monitor-camera.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/monitor-camera.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/monitor-camera.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/monitor-camera.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "meeting",
        "screen",
        "tech",
        "technology",
        "video-call",
        "webcam"
      ]
    },
    "electronic-devices/monitor-smartphone": {
      "name": "Monitor Smartphone",
      "slug": "monitor-smartphone",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/monitor-smartphone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/monitor-smartphone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/monitor-smartphone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/monitor-smartphone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/monitor-smartphone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/monitor-smartphone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/monitor-smartphone.svg"
        }
      ],
      "tags": [
        "adaptive",
        "cross-platform",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "multi-device",
        "responsive",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/printer-2": {
      "name": "Printer 2",
      "slug": "printer-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/printer-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/printer-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/printer-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/printer-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/printer-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/printer-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/printer-2.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "office",
        "output",
        "paper",
        "print",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/printer": {
      "name": "Printer",
      "slug": "printer",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/printer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/printer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/printer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/printer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/printer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/printer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/printer.svg"
        }
      ],
      "tags": [
        "device",
        "document",
        "electronic",
        "gadget",
        "hardware",
        "office",
        "output",
        "paper",
        "print",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/printer-minimalistic": {
      "name": "Printer Minimalistic",
      "slug": "printer-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/printer-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/printer-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/printer-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/printer-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/printer-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/printer-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/printer-minimalistic.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "output",
        "paper",
        "print",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/bluetooth": {
      "name": "Bluetooth",
      "slug": "bluetooth",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/bluetooth",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/bluetooth.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/bluetooth.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/bluetooth.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/bluetooth.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/bluetooth.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/bluetooth.svg"
        }
      ],
      "tags": [
        "connection",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "pair",
        "sync",
        "tech",
        "technology",
        "wireless"
      ]
    },
    "electronic-devices/bluetooth-wave": {
      "name": "Bluetooth Wave",
      "slug": "bluetooth-wave",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/bluetooth-wave",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/bluetooth-wave.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/bluetooth-wave.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/bluetooth-wave.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/bluetooth-wave.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/bluetooth-wave.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/bluetooth-wave.svg"
        }
      ],
      "tags": [
        "active",
        "connected",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "signal",
        "tech",
        "technology",
        "wireless"
      ]
    },
    "electronic-devices/bluetooth-square": {
      "name": "Bluetooth Square",
      "slug": "bluetooth-square",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/bluetooth-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/bluetooth-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/bluetooth-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/bluetooth-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/bluetooth-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/bluetooth-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/bluetooth-square.svg"
        }
      ],
      "tags": [
        "connection",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "pair",
        "tech",
        "technology",
        "wireless"
      ]
    },
    "electronic-devices/bluetooth-circle": {
      "name": "Bluetooth Circle",
      "slug": "bluetooth-circle",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/bluetooth-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/bluetooth-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/bluetooth-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/bluetooth-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/bluetooth-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/bluetooth-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/bluetooth-circle.svg"
        }
      ],
      "tags": [
        "connection",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "pair",
        "tech",
        "technology",
        "wireless"
      ]
    },
    "electronic-devices/keyboard": {
      "name": "Keyboard",
      "slug": "keyboard",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/keyboard",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/keyboard.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/keyboard.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/keyboard.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/keyboard.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/keyboard.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/keyboard.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "input",
        "keys",
        "peripheral",
        "qwerty",
        "tech",
        "technology",
        "typing"
      ]
    },
    "electronic-devices/telescope": {
      "name": "Telescope",
      "slug": "telescope",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/telescope",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/telescope.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/telescope.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/telescope.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/telescope.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/telescope.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/telescope.svg"
        }
      ],
      "tags": [
        "astronomy",
        "device",
        "discover",
        "electronic",
        "gadget",
        "hardware",
        "observe",
        "science",
        "stargazing",
        "tech",
        "technology",
        "zoom"
      ]
    },
    "electronic-devices/smart-speaker-2": {
      "name": "Smart Speaker 2",
      "slug": "smart-speaker-2",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smart-speaker-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smart-speaker-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smart-speaker-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smart-speaker-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smart-speaker-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smart-speaker-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smart-speaker-2.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "smart-home",
        "tech",
        "technology",
        "voice-assistant"
      ]
    },
    "electronic-devices/smart-speaker": {
      "name": "Smart Speaker",
      "slug": "smart-speaker",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smart-speaker",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smart-speaker.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smart-speaker.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smart-speaker.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smart-speaker.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smart-speaker.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smart-speaker.svg"
        }
      ],
      "tags": [
        "Alexa",
        "HomePod",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "smart-home",
        "tech",
        "technology",
        "voice-assistant"
      ]
    },
    "electronic-devices/smart-speaker-minimalistic": {
      "name": "Smart Speaker Minimalistic",
      "slug": "smart-speaker-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/smart-speaker-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/smart-speaker-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/smart-speaker-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/smart-speaker-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/smart-speaker-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/smart-speaker-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/smart-speaker-minimalistic.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "smart-home",
        "tech",
        "technology",
        "voice-assistant"
      ]
    },
    "electronic-devices/gameboy": {
      "name": "Gameboy",
      "slug": "gameboy",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/gameboy",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/gameboy.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/gameboy.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/gameboy.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/gameboy.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/gameboy.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/gameboy.svg"
        }
      ],
      "tags": [
        "Nintendo",
        "console",
        "device",
        "electronic",
        "gadget",
        "gaming",
        "handheld",
        "hardware",
        "portable",
        "retro",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/display": {
      "name": "Display",
      "slug": "display",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/display",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/display.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/display.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/display.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/display.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/display.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/display.svg"
        }
      ],
      "tags": [
        "LCD",
        "desktop",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "monitor",
        "screen",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/tv": {
      "name": "TV",
      "slug": "tv",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/tv",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/tv.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/tv.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/tv.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/tv.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/tv.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/tv.svg"
        }
      ],
      "tags": [
        "device",
        "display",
        "electronic",
        "entertainment",
        "gadget",
        "hardware",
        "monitor",
        "screen",
        "streaming",
        "tech",
        "technology",
        "television"
      ]
    },
    "electronic-devices/radio-minimalistic": {
      "name": "Radio Minimalistic",
      "slug": "radio-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/radio-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/radio-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/radio-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/radio-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/radio-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/radio-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/radio-minimalistic.svg"
        }
      ],
      "tags": [
        "FM",
        "broadcast",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "tech",
        "technology",
        "tune"
      ]
    },
    "electronic-devices/radio": {
      "name": "Radio",
      "slug": "radio",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/radio",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/radio.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/radio.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/radio.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/radio.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/radio.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/radio.svg"
        }
      ],
      "tags": [
        "AM",
        "FM",
        "broadcast",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "retro",
        "station",
        "tech",
        "technology",
        "tune"
      ]
    },
    "electronic-devices/sim-card": {
      "name": "SIM Card",
      "slug": "sim-card",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/sim-card",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/sim-card.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/sim-card.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/sim-card.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/sim-card.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/sim-card.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/sim-card.svg"
        }
      ],
      "tags": [
        "carrier",
        "cellular",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "mobile",
        "phone",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/sim-cards": {
      "name": "SIM Cards",
      "slug": "sim-cards",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/sim-cards",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/sim-cards.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/sim-cards.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/sim-cards.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/sim-cards.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/sim-cards.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/sim-cards.svg"
        }
      ],
      "tags": [
        "cellular",
        "device",
        "dual-SIM",
        "electronic",
        "gadget",
        "hardware",
        "mobile",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/sim-card-minimalistic": {
      "name": "SIM Card Minimalistic",
      "slug": "sim-card-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/sim-card-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/sim-card-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/sim-card-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/sim-card-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/sim-card-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/sim-card-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/sim-card-minimalistic.svg"
        }
      ],
      "tags": [
        "cellular",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "minimal",
        "mobile",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/projector": {
      "name": "Projector",
      "slug": "projector",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/projector",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/projector.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/projector.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/projector.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/projector.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/projector.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/projector.svg"
        }
      ],
      "tags": [
        "cinema",
        "device",
        "display",
        "electronic",
        "gadget",
        "hardware",
        "meeting",
        "presentation",
        "screen",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/sd-card": {
      "name": "SD Card",
      "slug": "sd-card",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/sd-card",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/sd-card.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/sd-card.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/sd-card.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/sd-card.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/sd-card.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/sd-card.svg"
        }
      ],
      "tags": [
        "camera",
        "device",
        "electronic",
        "expandable",
        "gadget",
        "hardware",
        "memory",
        "storage",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/diskette": {
      "name": "Diskette",
      "slug": "diskette",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/diskette",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/diskette.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/diskette.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/diskette.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/diskette.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/diskette.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/diskette.svg"
        }
      ],
      "tags": [
        "device",
        "disk",
        "electronic",
        "floppy",
        "gadget",
        "hardware",
        "retro",
        "save",
        "storage",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/plug-circle": {
      "name": "Plug Circle",
      "slug": "plug-circle",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/plug-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/plug-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/plug-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/plug-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/plug-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/plug-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/plug-circle.svg"
        }
      ],
      "tags": [
        "charge",
        "connect",
        "device",
        "electricity",
        "electronic",
        "gadget",
        "hardware",
        "outlet",
        "power",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/wireless-charge": {
      "name": "Wireless Charge",
      "slug": "wireless-charge",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/wireless-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/wireless-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/wireless-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/wireless-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/wireless-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/wireless-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/wireless-charge.svg"
        }
      ],
      "tags": [
        "Qi",
        "battery",
        "charging",
        "cordless",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "inductive",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/devices": {
      "name": "Devices",
      "slug": "devices",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/devices",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/devices.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/devices.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/devices.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/devices.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/devices.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/devices.svg"
        }
      ],
      "tags": [
        "cross-platform",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "multi-device",
        "responsive",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/ssd-round": {
      "name": "SSD Round",
      "slug": "ssd-round",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/ssd-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/ssd-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/ssd-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/ssd-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/ssd-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/ssd-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/ssd-round.svg"
        }
      ],
      "tags": [
        "device",
        "disk",
        "drive",
        "electronic",
        "fast",
        "gadget",
        "hardware",
        "solid-state",
        "storage",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/ssd-square": {
      "name": "SSD Square",
      "slug": "ssd-square",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/ssd-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/ssd-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/ssd-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/ssd-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/ssd-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/ssd-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/ssd-square.svg"
        }
      ],
      "tags": [
        "device",
        "disk",
        "drive",
        "electronic",
        "fast",
        "gadget",
        "hardware",
        "solid-state",
        "storage",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/cloud-storage": {
      "name": "Cloud Storage",
      "slug": "cloud-storage",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/cloud-storage",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/cloud-storage.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/cloud-storage.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/cloud-storage.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/cloud-storage.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/cloud-storage.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/cloud-storage.svg"
        }
      ],
      "tags": [
        "backup",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "online",
        "remote",
        "server",
        "sync",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/flash-drive": {
      "name": "Flash Drive",
      "slug": "flash-drive",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/flash-drive",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/flash-drive.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/flash-drive.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/flash-drive.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/flash-drive.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/flash-drive.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/flash-drive.svg"
        }
      ],
      "tags": [
        "USB",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "pen-drive",
        "portable",
        "storage",
        "tech",
        "technology",
        "thumb-drive"
      ]
    },
    "electronic-devices/lightning": {
      "name": "Lightning",
      "slug": "lightning",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/lightning",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/lightning.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/lightning.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/lightning.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/lightning.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/lightning.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/lightning.svg"
        }
      ],
      "tags": [
        "bolt",
        "device",
        "electric",
        "electronic",
        "energy",
        "fast",
        "flash",
        "gadget",
        "hardware",
        "power",
        "speed",
        "tech",
        "technology",
        "thunder"
      ]
    },
    "electronic-devices/weigher": {
      "name": "Weigher",
      "slug": "weigher",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/weigher",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/weigher.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/weigher.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/weigher.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/weigher.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/weigher.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/weigher.svg"
        }
      ],
      "tags": [
        "balance",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "mass",
        "measure",
        "scale",
        "tech",
        "technology",
        "weight"
      ]
    },
    "electronic-devices/lightbulb": {
      "name": "Lightbulb",
      "slug": "lightbulb",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/lightbulb",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/lightbulb.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/lightbulb.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/lightbulb.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/lightbulb.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/lightbulb.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/lightbulb.svg"
        }
      ],
      "tags": [
        "bright",
        "creative",
        "device",
        "electronic",
        "gadget",
        "hardware",
        "idea",
        "innovation",
        "lamp",
        "light",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/lightbulb-bolt": {
      "name": "Lightbulb Bolt",
      "slug": "lightbulb-bolt",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/lightbulb-bolt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/lightbulb-bolt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/lightbulb-bolt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/lightbulb-bolt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/lightbulb-bolt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/lightbulb-bolt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/lightbulb-bolt.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "energy",
        "gadget",
        "hardware",
        "idea",
        "innovation",
        "light",
        "power",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/lightbulb-minimalistic": {
      "name": "Lightbulb Minimalistic",
      "slug": "lightbulb-minimalistic",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/lightbulb-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/lightbulb-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/lightbulb-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/lightbulb-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/lightbulb-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/lightbulb-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/lightbulb-minimalistic.svg"
        }
      ],
      "tags": [
        "device",
        "electronic",
        "gadget",
        "hardware",
        "idea",
        "lamp",
        "light",
        "minimal",
        "tech",
        "technology"
      ]
    },
    "electronic-devices/socket": {
      "name": "Socket",
      "slug": "socket",
      "category": "electronic-devices",
      "categoryName": "Electronic, Devices",
      "id": "electronic-devices/socket",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/electronic-devices/socket.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/electronic-devices/socket.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/electronic-devices/socket.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/electronic-devices/socket.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/electronic-devices/socket.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/electronic-devices/socket.svg"
        }
      ],
      "tags": [
        "device",
        "electricity",
        "electronic",
        "gadget",
        "hardware",
        "outlet",
        "plug",
        "power",
        "tech",
        "technology"
      ]
    },
    "weather/cloud": {
      "name": "Cloud",
      "slug": "cloud",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cloudy",
        "cumulus",
        "forecast",
        "overcast",
        "sky",
        "weather"
      ]
    },
    "weather/clouds": {
      "name": "Clouds",
      "slug": "clouds",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/clouds",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/clouds.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/clouds.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/clouds.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/clouds.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/clouds.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/clouds.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cloudy",
        "cover",
        "forecast",
        "grey",
        "overcast",
        "sky",
        "weather"
      ]
    },
    "weather/cloud-plus": {
      "name": "Cloud Plus",
      "slug": "cloud-plus",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-plus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-plus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-plus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-plus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-plus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-plus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-plus.svg"
        }
      ],
      "tags": [
        "add",
        "atmospheric",
        "climate",
        "cloud-storage",
        "forecast",
        "sky",
        "upload",
        "weather"
      ]
    },
    "weather/cloud-minus": {
      "name": "Cloud Minus",
      "slug": "cloud-minus",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-minus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-minus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-minus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-minus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-minus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-minus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-minus.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cloud-storage",
        "delete",
        "forecast",
        "remove",
        "sky",
        "weather"
      ]
    },
    "weather/clound-cross": {
      "name": "Clound Cross",
      "slug": "clound-cross",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/clound-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/clound-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/clound-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/clound-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/clound-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/clound-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/clound-cross.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cloud-error",
        "disconnected",
        "forecast",
        "no-cloud",
        "offline",
        "sky",
        "weather"
      ]
    },
    "weather/cloud-check": {
      "name": "Cloud Check",
      "slug": "cloud-check",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-check.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cloud-ok",
        "forecast",
        "sky",
        "synced",
        "uploaded",
        "verified",
        "weather"
      ]
    },
    "weather/cloud-bolt": {
      "name": "Cloud Bolt",
      "slug": "cloud-bolt",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-bolt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-bolt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-bolt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-bolt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-bolt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-bolt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-bolt.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "electric",
        "forecast",
        "lightning",
        "sky",
        "storm",
        "thunder",
        "weather"
      ]
    },
    "weather/cloud-sun": {
      "name": "Cloud Sun",
      "slug": "cloud-sun",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-sun",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-sun.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-sun.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-sun.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-sun.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-sun.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-sun.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "break",
        "climate",
        "fair",
        "forecast",
        "mild",
        "partly-cloudy",
        "sky",
        "weather"
      ]
    },
    "weather/fog": {
      "name": "Fog",
      "slug": "fog",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/fog",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/fog.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/fog.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/fog.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/fog.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/fog.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/fog.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "foggy",
        "forecast",
        "haze",
        "mist",
        "murky",
        "sky",
        "visibility",
        "weather"
      ]
    },
    "weather/cloud-bolt-minimalistic": {
      "name": "Cloud Bolt Minimalistic",
      "slug": "cloud-bolt-minimalistic",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-bolt-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-bolt-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-bolt-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-bolt-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-bolt-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-bolt-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-bolt-minimalistic.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "forecast",
        "minimal",
        "sky",
        "storm",
        "thunder",
        "weather"
      ]
    },
    "weather/cloud-sun-2": {
      "name": "Cloud Sun 2",
      "slug": "cloud-sun-2",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-sun-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-sun-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-sun-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-sun-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-sun-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-sun-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-sun-2.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "fair",
        "forecast",
        "mild",
        "partly-cloudy",
        "sky",
        "weather"
      ]
    },
    "weather/cloud-snowfall": {
      "name": "Cloud Snowfall",
      "slug": "cloud-snowfall",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-snowfall",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-snowfall.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-snowfall.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-snowfall.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-snowfall.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-snowfall.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-snowfall.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "blizzard",
        "climate",
        "cold",
        "flurry",
        "forecast",
        "sky",
        "snow",
        "weather",
        "winter"
      ]
    },
    "weather/cloud-storm": {
      "name": "Cloud Storm",
      "slug": "cloud-storm",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-storm",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-storm.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-storm.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-storm.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-storm.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-storm.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-storm.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "forecast",
        "severe",
        "sky",
        "storm",
        "tempest",
        "thunder",
        "weather"
      ]
    },
    "weather/cloud-rain": {
      "name": "Cloud Rain",
      "slug": "cloud-rain",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-rain",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-rain.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-rain.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-rain.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-rain.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-rain.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-rain.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "drizzle",
        "forecast",
        "precipitation",
        "rain",
        "rainy",
        "shower",
        "sky",
        "weather",
        "wet"
      ]
    },
    "weather/cloud-waterdrop": {
      "name": "Cloud Waterdrop",
      "slug": "cloud-waterdrop",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-waterdrop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-waterdrop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-waterdrop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-waterdrop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-waterdrop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-waterdrop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-waterdrop.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "drizzle",
        "forecast",
        "light-rain",
        "moisture",
        "rain",
        "sky",
        "weather"
      ]
    },
    "weather/cloud-waterdrops": {
      "name": "Cloud Waterdrops",
      "slug": "cloud-waterdrops",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-waterdrops",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-waterdrops.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-waterdrops.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-waterdrops.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-waterdrops.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-waterdrops.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-waterdrops.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "downpour",
        "forecast",
        "heavy-rain",
        "rain",
        "sky",
        "weather"
      ]
    },
    "weather/tornado": {
      "name": "Tornado",
      "slug": "tornado",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/tornado",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/tornado.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/tornado.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/tornado.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/tornado.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/tornado.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/tornado.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cyclone",
        "forecast",
        "severe",
        "sky",
        "storm",
        "twister",
        "weather",
        "wind"
      ]
    },
    "weather/cloud-snowfall-minimalistic": {
      "name": "Cloud Snowfall Minimalistic",
      "slug": "cloud-snowfall-minimalistic",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-snowfall-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-snowfall-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-snowfall-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-snowfall-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-snowfall-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-snowfall-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-snowfall-minimalistic.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "forecast",
        "minimal",
        "sky",
        "snow",
        "weather",
        "winter"
      ]
    },
    "weather/cloud-download": {
      "name": "Cloud Download",
      "slug": "cloud-download",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-download",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-download.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-download.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-download.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-download.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-download.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-download.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "download",
        "fetch",
        "forecast",
        "save",
        "sky",
        "sync",
        "weather"
      ]
    },
    "weather/cloud-upload": {
      "name": "Cloud Upload",
      "slug": "cloud-upload",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloud-upload",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloud-upload.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloud-upload.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloud-upload.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloud-upload.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloud-upload.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloud-upload.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "backup",
        "climate",
        "forecast",
        "push",
        "sky",
        "sync",
        "upload",
        "weather"
      ]
    },
    "weather/moon": {
      "name": "Moon",
      "slug": "moon",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/moon",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/moon.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/moon.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/moon.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/moon.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/moon.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/moon.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "crescent",
        "dark",
        "evening",
        "forecast",
        "lunar",
        "night",
        "sky",
        "weather"
      ]
    },
    "weather/moon-stars": {
      "name": "Moon Stars",
      "slug": "moon-stars",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/moon-stars",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/moon-stars.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/moon-stars.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/moon-stars.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/moon-stars.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/moon-stars.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/moon-stars.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "clear-night",
        "climate",
        "evening",
        "forecast",
        "night",
        "sky",
        "starry",
        "weather"
      ]
    },
    "weather/stars": {
      "name": "Stars",
      "slug": "stars",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/stars",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/stars.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/stars.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/stars.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/stars.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/stars.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/stars.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "constellation",
        "forecast",
        "night",
        "sky",
        "sparkle",
        "weather"
      ]
    },
    "weather/moon-sleep": {
      "name": "Moon Sleep",
      "slug": "moon-sleep",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/moon-sleep",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/moon-sleep.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/moon-sleep.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/moon-sleep.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/moon-sleep.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/moon-sleep.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/moon-sleep.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "bedtime",
        "climate",
        "forecast",
        "night",
        "rest",
        "sky",
        "sleep",
        "weather",
        "zzz"
      ]
    },
    "weather/cloudy-moon": {
      "name": "Cloudy Moon",
      "slug": "cloudy-moon",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/cloudy-moon",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/cloudy-moon.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/cloudy-moon.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/cloudy-moon.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/cloudy-moon.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/cloudy-moon.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/cloudy-moon.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "dusk",
        "evening",
        "forecast",
        "night",
        "partly-cloudy",
        "sky",
        "weather"
      ]
    },
    "weather/sun-2": {
      "name": "Sun 2",
      "slug": "sun-2",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/sun-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/sun-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/sun-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/sun-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/sun-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/sun-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/sun-2.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "bright",
        "climate",
        "daylight",
        "forecast",
        "sky",
        "sunny",
        "weather"
      ]
    },
    "weather/sun": {
      "name": "Sun",
      "slug": "sun",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/sun",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/sun.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/sun.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/sun.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/sun.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/sun.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/sun.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "bright",
        "clear",
        "climate",
        "daylight",
        "forecast",
        "sky",
        "solar",
        "sunny",
        "warm",
        "weather"
      ]
    },
    "weather/moon-fog": {
      "name": "Moon Fog",
      "slug": "moon-fog",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/moon-fog",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/moon-fog.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/moon-fog.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/moon-fog.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/moon-fog.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/moon-fog.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/moon-fog.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "evening",
        "forecast",
        "hazy",
        "mist",
        "night",
        "sky",
        "weather"
      ]
    },
    "weather/snowflake": {
      "name": "Snowflake",
      "slug": "snowflake",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/snowflake",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/snowflake.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/snowflake.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/snowflake.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/snowflake.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/snowflake.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/snowflake.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cold",
        "forecast",
        "frost",
        "frozen",
        "ice",
        "sky",
        "snow",
        "weather",
        "winter"
      ]
    },
    "weather/sun-fog": {
      "name": "Sun Fog",
      "slug": "sun-fog",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/sun-fog",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/sun-fog.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/sun-fog.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/sun-fog.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/sun-fog.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/sun-fog.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/sun-fog.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "dawn",
        "forecast",
        "haze",
        "misty",
        "morning",
        "sky",
        "weather"
      ]
    },
    "weather/sunrise": {
      "name": "Sunrise",
      "slug": "sunrise",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/sunrise",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/sunrise.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/sunrise.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/sunrise.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/sunrise.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/sunrise.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/sunrise.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "dawn",
        "daybreak",
        "early",
        "forecast",
        "morning",
        "sky",
        "weather"
      ]
    },
    "weather/sunset": {
      "name": "Sunset",
      "slug": "sunset",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/sunset",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/sunset.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/sunset.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/sunset.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/sunset.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/sunset.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/sunset.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "dusk",
        "evening",
        "forecast",
        "golden-hour",
        "sky",
        "twilight",
        "weather"
      ]
    },
    "weather/wind": {
      "name": "Wind",
      "slug": "wind",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/wind",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/wind.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/wind.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/wind.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/wind.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/wind.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/wind.svg"
        }
      ],
      "tags": [
        "air",
        "atmospheric",
        "blow",
        "breeze",
        "climate",
        "forecast",
        "gust",
        "sky",
        "weather",
        "windy"
      ]
    },
    "weather/waterdrops": {
      "name": "Waterdrops",
      "slug": "waterdrops",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/waterdrops",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/waterdrops.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/waterdrops.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/waterdrops.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/waterdrops.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/waterdrops.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/waterdrops.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "drops",
        "forecast",
        "humidity",
        "moisture",
        "rain",
        "sky",
        "water",
        "weather"
      ]
    },
    "weather/tornado-small": {
      "name": "Tornado Small",
      "slug": "tornado-small",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/tornado-small",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/tornado-small.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/tornado-small.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/tornado-small.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/tornado-small.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/tornado-small.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/tornado-small.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "climate",
        "cyclone",
        "forecast",
        "sky",
        "twister",
        "weather",
        "wind"
      ]
    },
    "weather/temperature": {
      "name": "Temperature",
      "slug": "temperature",
      "category": "weather",
      "categoryName": "Weather",
      "id": "weather/temperature",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/weather/temperature.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/weather/temperature.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/weather/temperature.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/weather/temperature.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/weather/temperature.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/weather/temperature.svg"
        }
      ],
      "tags": [
        "atmospheric",
        "celsius",
        "climate",
        "cold",
        "degrees",
        "fahrenheit",
        "forecast",
        "hot",
        "sky",
        "thermometer",
        "weather"
      ]
    },
    "files/file": {
      "name": "File",
      "slug": "file",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file.svg"
        }
      ],
      "tags": [
        "blank",
        "document",
        "file",
        "generic",
        "page",
        "storage"
      ]
    },
    "files/file-text": {
      "name": "File Text",
      "slug": "file-text",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-text",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-text.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-text.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-text.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-text.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-text.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-text.svg"
        }
      ],
      "tags": [
        "content",
        "document",
        "file",
        "readme",
        "storage",
        "text"
      ]
    },
    "files/file-check": {
      "name": "File Check",
      "slug": "file-check",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-check.svg"
        }
      ],
      "tags": [
        "approved",
        "complete",
        "document",
        "done",
        "file",
        "storage",
        "verified"
      ]
    },
    "files/file-remove": {
      "name": "File Remove",
      "slug": "file-remove",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-remove.svg"
        }
      ],
      "tags": [
        "delete",
        "discard",
        "document",
        "file",
        "storage",
        "trash"
      ]
    },
    "files/file-favourite": {
      "name": "File Favourite",
      "slug": "file-favourite",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-favourite",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-favourite.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-favourite.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-favourite.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-favourite.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-favourite.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-favourite.svg"
        }
      ],
      "tags": [
        "bookmarked",
        "document",
        "file",
        "important",
        "starred",
        "storage"
      ]
    },
    "files/file-send": {
      "name": "File Send",
      "slug": "file-send",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-send",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-send.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-send.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-send.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-send.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-send.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-send.svg"
        }
      ],
      "tags": [
        "document",
        "email",
        "file",
        "share",
        "storage",
        "submit",
        "transfer"
      ]
    },
    "files/file-left": {
      "name": "File Left",
      "slug": "file-left",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-left.svg"
        }
      ],
      "tags": [
        "document",
        "file",
        "move",
        "previous",
        "storage",
        "transfer"
      ]
    },
    "files/file-right": {
      "name": "File Right",
      "slug": "file-right",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-right.svg"
        }
      ],
      "tags": [
        "document",
        "file",
        "move",
        "next",
        "storage",
        "transfer"
      ]
    },
    "files/file-download": {
      "name": "File Download",
      "slug": "file-download",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-download",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-download.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-download.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-download.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-download.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-download.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-download.svg"
        }
      ],
      "tags": [
        "document",
        "fetch",
        "file",
        "get",
        "save",
        "storage"
      ]
    },
    "files/figma-file": {
      "name": "Figma File",
      "slug": "figma-file",
      "category": "files",
      "categoryName": "Files",
      "id": "files/figma-file",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/figma-file.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/figma-file.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/figma-file.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/figma-file.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/figma-file.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/figma-file.svg"
        }
      ],
      "tags": [
        "Figma",
        "UI",
        "design",
        "document",
        "file",
        "prototype",
        "storage"
      ]
    },
    "files/code-file": {
      "name": "Code File",
      "slug": "code-file",
      "category": "files",
      "categoryName": "Files",
      "id": "files/code-file",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/code-file.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/code-file.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/code-file.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/code-file.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/code-file.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/code-file.svg"
        }
      ],
      "tags": [
        "code",
        "developer",
        "document",
        "file",
        "programming",
        "script",
        "source",
        "storage"
      ]
    },
    "files/cloud-file": {
      "name": "Cloud File",
      "slug": "cloud-file",
      "category": "files",
      "categoryName": "Files",
      "id": "files/cloud-file",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/cloud-file.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/cloud-file.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/cloud-file.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/cloud-file.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/cloud-file.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/cloud-file.svg"
        }
      ],
      "tags": [
        "backup",
        "cloud",
        "document",
        "file",
        "online",
        "remote",
        "storage",
        "sync"
      ]
    },
    "files/file-smile": {
      "name": "File Smile :)",
      "slug": "file-smile",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-smile",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-smile.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-smile.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-smile.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-smile.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-smile.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-smile.svg"
        }
      ],
      "tags": [
        "document",
        "file",
        "friendly",
        "fun",
        "happy",
        "storage"
      ]
    },
    "files/file-corrupted": {
      "name": "File Corrupted",
      "slug": "file-corrupted",
      "category": "files",
      "categoryName": "Files",
      "id": "files/file-corrupted",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/file-corrupted.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/file-corrupted.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/file-corrupted.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/file-corrupted.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/file-corrupted.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/file-corrupted.svg"
        }
      ],
      "tags": [
        "broken",
        "corrupt",
        "damaged",
        "document",
        "error",
        "file",
        "storage"
      ]
    },
    "files/zip-file": {
      "name": "ZIP File",
      "slug": "zip-file",
      "category": "files",
      "categoryName": "Files",
      "id": "files/zip-file",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/files/zip-file.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/files/zip-file.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/files/zip-file.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/files/zip-file.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/files/zip-file.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/files/zip-file.svg"
        }
      ],
      "tags": [
        "archive",
        "bundle",
        "compressed",
        "document",
        "file",
        "package",
        "storage"
      ]
    },
    "astronomy/black-hole": {
      "name": "Black Hole",
      "slug": "black-hole",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/black-hole",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/black-hole.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/black-hole.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/black-hole.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/black-hole.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/black-hole.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/black-hole.svg"
        }
      ],
      "tags": [
        "cosmos",
        "gravity",
        "science",
        "singularity",
        "space",
        "universe",
        "void"
      ]
    },
    "astronomy/black-hole-2": {
      "name": "Black Hole 2",
      "slug": "black-hole-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/black-hole-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/black-hole-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/black-hole-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/black-hole-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/black-hole-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/black-hole-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/black-hole-2.svg"
        }
      ],
      "tags": [
        "cosmos",
        "gravity",
        "science",
        "singularity",
        "space",
        "universe",
        "void"
      ]
    },
    "astronomy/black-hole-3": {
      "name": "Black Hole 3",
      "slug": "black-hole-3",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/black-hole-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/black-hole-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/black-hole-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/black-hole-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/black-hole-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/black-hole-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/black-hole-3.svg"
        }
      ],
      "tags": [
        "cosmos",
        "gravity",
        "science",
        "singularity",
        "space",
        "universe",
        "void"
      ]
    },
    "astronomy/men": {
      "name": "Men",
      "slug": "men",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/men",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/men.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/men.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/men.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/men.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/men.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/men.svg"
        }
      ],
      "tags": [
        "cosmos",
        "gender",
        "male",
        "man",
        "mars",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/women": {
      "name": "Women",
      "slug": "women",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/women",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/women.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/women.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/women.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/women.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/women.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/women.svg"
        }
      ],
      "tags": [
        "cosmos",
        "female",
        "gender",
        "science",
        "space",
        "universe",
        "venus",
        "woman"
      ]
    },
    "astronomy/atom": {
      "name": "Atom",
      "slug": "atom",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/atom",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/atom.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/atom.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/atom.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/atom.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/atom.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/atom.svg"
        }
      ],
      "tags": [
        "cosmos",
        "molecular",
        "nuclear",
        "particle",
        "physics",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/planet": {
      "name": "Planet",
      "slug": "planet",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/planet",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/planet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/planet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/planet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/planet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/planet.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/planet.svg"
        }
      ],
      "tags": [
        "celestial",
        "cosmos",
        "orbit",
        "science",
        "space",
        "universe",
        "world"
      ]
    },
    "astronomy/planet-2": {
      "name": "Planet 2",
      "slug": "planet-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/planet-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/planet-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/planet-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/planet-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/planet-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/planet-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/planet-2.svg"
        }
      ],
      "tags": [
        "celestial",
        "cosmos",
        "orbit",
        "science",
        "space",
        "universe",
        "world"
      ]
    },
    "astronomy/planet-3": {
      "name": "Planet 3",
      "slug": "planet-3",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/planet-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/planet-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/planet-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/planet-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/planet-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/planet-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/planet-3.svg"
        }
      ],
      "tags": [
        "celestial",
        "cosmos",
        "orbit",
        "science",
        "space",
        "universe",
        "world"
      ]
    },
    "astronomy/planet-4": {
      "name": "Planet 4",
      "slug": "planet-4",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/planet-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/planet-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/planet-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/planet-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/planet-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/planet-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/planet-4.svg"
        }
      ],
      "tags": [
        "celestial",
        "cosmos",
        "orbit",
        "science",
        "space",
        "universe",
        "world"
      ]
    },
    "astronomy/earth": {
      "name": "Earth",
      "slug": "earth",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/earth",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/earth.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/earth.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/earth.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/earth.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/earth.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/earth.svg"
        }
      ],
      "tags": [
        "cosmos",
        "global",
        "globe",
        "international",
        "planet",
        "science",
        "space",
        "universe",
        "world"
      ]
    },
    "astronomy/asteroid": {
      "name": "Asteroid",
      "slug": "asteroid",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/asteroid",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/asteroid.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/asteroid.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/asteroid.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/asteroid.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/asteroid.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/asteroid.svg"
        }
      ],
      "tags": [
        "cosmos",
        "meteor",
        "rock",
        "science",
        "space",
        "space-rock",
        "universe"
      ]
    },
    "astronomy/satellite": {
      "name": "Satellite",
      "slug": "satellite",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/satellite",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/satellite.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/satellite.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/satellite.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/satellite.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/satellite.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/satellite.svg"
        }
      ],
      "tags": [
        "GPS",
        "broadcast",
        "communication",
        "cosmos",
        "orbit",
        "science",
        "signal",
        "space",
        "universe"
      ]
    },
    "astronomy/infinity": {
      "name": "Infinity",
      "slug": "infinity",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/infinity",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/infinity.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/infinity.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/infinity.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/infinity.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/infinity.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/infinity.svg"
        }
      ],
      "tags": [
        "cosmos",
        "endless",
        "eternal",
        "forever",
        "loop",
        "science",
        "space",
        "universe",
        "unlimited"
      ]
    },
    "astronomy/rocket": {
      "name": "Rocket",
      "slug": "rocket",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/rocket",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/rocket.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/rocket.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/rocket.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/rocket.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/rocket.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/rocket.svg"
        }
      ],
      "tags": [
        "boost",
        "cosmos",
        "fly",
        "launch",
        "science",
        "space",
        "spaceship",
        "speed",
        "startup",
        "universe"
      ]
    },
    "astronomy/rocket-2": {
      "name": "Rocket 2",
      "slug": "rocket-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/rocket-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/rocket-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/rocket-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/rocket-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/rocket-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/rocket-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/rocket-2.svg"
        }
      ],
      "tags": [
        "boost",
        "cosmos",
        "fly",
        "launch",
        "science",
        "space",
        "spaceship",
        "speed",
        "startup",
        "universe"
      ]
    },
    "astronomy/star-circle": {
      "name": "Star Circle",
      "slug": "star-circle",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-circle.svg"
        }
      ],
      "tags": [
        "cosmos",
        "favourite",
        "featured",
        "rating",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/star-angle": {
      "name": "Star Angle",
      "slug": "star-angle",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-angle.svg"
        }
      ],
      "tags": [
        "bookmark",
        "cosmos",
        "favourite",
        "rating",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/star-fall": {
      "name": "Star Fall",
      "slug": "star-fall",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-fall",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-fall.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-fall.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-fall.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-fall.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-fall.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-fall.svg"
        }
      ],
      "tags": [
        "cosmos",
        "meteor",
        "science",
        "shooting-star",
        "space",
        "universe",
        "wish"
      ]
    },
    "astronomy/star-rainbow": {
      "name": "Star Rainbow",
      "slug": "star-rainbow",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-rainbow",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-rainbow.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-rainbow.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-rainbow.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-rainbow.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-rainbow.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-rainbow.svg"
        }
      ],
      "tags": [
        "colourful",
        "cosmos",
        "magic",
        "science",
        "space",
        "special",
        "universe"
      ]
    },
    "astronomy/star": {
      "name": "Star",
      "slug": "star",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star.svg"
        }
      ],
      "tags": [
        "bookmark",
        "celestial",
        "cosmos",
        "favourite",
        "night",
        "rating",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/stars": {
      "name": "Stars",
      "slug": "stars",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/stars",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/stars.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/stars.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/stars.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/stars.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/stars.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/stars.svg"
        }
      ],
      "tags": [
        "constellation",
        "cosmos",
        "night",
        "science",
        "sky",
        "space",
        "sparkle",
        "universe"
      ]
    },
    "astronomy/stars-line": {
      "name": "Stars Line",
      "slug": "stars-line",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/stars-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/stars-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/stars-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/stars-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/stars-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/stars-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/stars-line.svg"
        }
      ],
      "tags": [
        "cosmos",
        "night",
        "rating",
        "science",
        "space",
        "sparkle",
        "universe"
      ]
    },
    "astronomy/stars-minimalistic": {
      "name": "Stars Minimalistic",
      "slug": "stars-minimalistic",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/stars-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/stars-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/stars-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/stars-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/stars-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/stars-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/stars-minimalistic.svg"
        }
      ],
      "tags": [
        "cosmos",
        "night",
        "rating",
        "science",
        "space",
        "sparkle",
        "universe"
      ]
    },
    "astronomy/star-fall-minimalistic": {
      "name": "Star Fall Minimalistic",
      "slug": "star-fall-minimalistic",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-fall-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-fall-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-fall-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-fall-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-fall-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-fall-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-fall-minimalistic.svg"
        }
      ],
      "tags": [
        "cosmos",
        "science",
        "shooting-star",
        "space",
        "universe",
        "wish"
      ]
    },
    "astronomy/star-fall-minimalistic-2": {
      "name": "Star Fall Minimalistic 2",
      "slug": "star-fall-minimalistic-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-fall-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-fall-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-fall-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-fall-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-fall-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-fall-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-fall-minimalistic-2.svg"
        }
      ],
      "tags": [
        "cosmos",
        "science",
        "shooting-star",
        "space",
        "universe",
        "wish"
      ]
    },
    "astronomy/star-fall-2": {
      "name": "Star Fall 2",
      "slug": "star-fall-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-fall-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-fall-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-fall-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-fall-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-fall-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-fall-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-fall-2.svg"
        }
      ],
      "tags": [
        "cosmos",
        "meteor",
        "science",
        "shooting-star",
        "space",
        "universe",
        "wish"
      ]
    },
    "astronomy/star-ring": {
      "name": "Star Ring",
      "slug": "star-ring",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-ring",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-ring.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-ring.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-ring.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-ring.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-ring.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-ring.svg"
        }
      ],
      "tags": [
        "cosmos",
        "orbit",
        "ring",
        "saturn",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/star-rings": {
      "name": "Star Rings",
      "slug": "star-rings",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/star-rings",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/star-rings.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/star-rings.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/star-rings.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/star-rings.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/star-rings.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/star-rings.svg"
        }
      ],
      "tags": [
        "cosmos",
        "orbit",
        "rings",
        "saturn",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/ufo": {
      "name": "UFO",
      "slug": "ufo",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/ufo",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/ufo.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/ufo.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/ufo.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/ufo.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/ufo.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/ufo.svg"
        }
      ],
      "tags": [
        "alien",
        "cosmos",
        "extraterrestrial",
        "flying-saucer",
        "sci-fi",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/ufo-2": {
      "name": "UFO 2",
      "slug": "ufo-2",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/ufo-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/ufo-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/ufo-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/ufo-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/ufo-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/ufo-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/ufo-2.svg"
        }
      ],
      "tags": [
        "alien",
        "cosmos",
        "extraterrestrial",
        "flying-saucer",
        "sci-fi",
        "science",
        "space",
        "universe"
      ]
    },
    "astronomy/ufo-3": {
      "name": "UFO 3",
      "slug": "ufo-3",
      "category": "astronomy",
      "categoryName": "Astronomy",
      "id": "astronomy/ufo-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/astronomy/ufo-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/astronomy/ufo-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/astronomy/ufo-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/astronomy/ufo-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/astronomy/ufo-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/astronomy/ufo-3.svg"
        }
      ],
      "tags": [
        "alien",
        "cosmos",
        "extraterrestrial",
        "flying-saucer",
        "sci-fi",
        "science",
        "space",
        "universe"
      ]
    },
    "folders/folder": {
      "name": "Folder",
      "slug": "folder",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder.svg"
        }
      ],
      "tags": [
        "container",
        "directory",
        "folder",
        "organize",
        "storage"
      ]
    },
    "folders/folder-2": {
      "name": "Folder 2",
      "slug": "folder-2",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-2.svg"
        }
      ],
      "tags": [
        "container",
        "directory",
        "folder",
        "organize",
        "storage"
      ]
    },
    "folders/folder-with-files": {
      "name": "Folder With Files",
      "slug": "folder-with-files",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-with-files",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-with-files.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-with-files.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-with-files.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-with-files.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-with-files.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-with-files.svg"
        }
      ],
      "tags": [
        "contents",
        "directory",
        "documents",
        "folder",
        "full",
        "many",
        "organize",
        "storage"
      ]
    },
    "folders/folder-check": {
      "name": "Folder Check",
      "slug": "folder-check",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-check.svg"
        }
      ],
      "tags": [
        "approved",
        "complete",
        "directory",
        "folder",
        "organize",
        "storage",
        "verified"
      ]
    },
    "folders/folder-error": {
      "name": "Folder Error",
      "slug": "folder-error",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-error",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-error.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-error.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-error.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-error.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-error.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-error.svg"
        }
      ],
      "tags": [
        "broken",
        "directory",
        "folder",
        "missing",
        "organize",
        "problem",
        "storage",
        "warning"
      ]
    },
    "folders/remove-folder": {
      "name": "Remove Folder",
      "slug": "remove-folder",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/remove-folder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/remove-folder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/remove-folder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/remove-folder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/remove-folder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/remove-folder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/remove-folder.svg"
        }
      ],
      "tags": [
        "delete",
        "directory",
        "discard",
        "folder",
        "organize",
        "rmdir",
        "storage",
        "trash"
      ]
    },
    "folders/add-folder": {
      "name": "Add Folder",
      "slug": "add-folder",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/add-folder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/add-folder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/add-folder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/add-folder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/add-folder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/add-folder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/add-folder.svg"
        }
      ],
      "tags": [
        "create",
        "directory",
        "folder",
        "mkdir",
        "new-folder",
        "organize",
        "storage"
      ]
    },
    "folders/folder-favourite-star": {
      "name": "Folder Favourite (Star)",
      "slug": "folder-favourite-star",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-favourite-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-favourite-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-favourite-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-favourite-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-favourite-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-favourite-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-favourite-star.svg"
        }
      ],
      "tags": [
        "directory",
        "folder",
        "important",
        "organize",
        "saved",
        "starred",
        "storage"
      ]
    },
    "folders/folder-favourite-bookmark": {
      "name": "Folder Favourite (Bookmark)",
      "slug": "folder-favourite-bookmark",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-favourite-bookmark",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-favourite-bookmark.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-favourite-bookmark.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-favourite-bookmark.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-favourite-bookmark.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-favourite-bookmark.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-favourite-bookmark.svg"
        }
      ],
      "tags": [
        "directory",
        "folder",
        "important",
        "organize",
        "saved",
        "starred",
        "storage"
      ]
    },
    "folders/move-to-folder": {
      "name": "Move To Folder",
      "slug": "move-to-folder",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/move-to-folder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/move-to-folder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/move-to-folder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/move-to-folder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/move-to-folder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/move-to-folder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/move-to-folder.svg"
        }
      ],
      "tags": [
        "directory",
        "file",
        "folder",
        "organize",
        "sort",
        "storage",
        "transfer"
      ]
    },
    "folders/folder-path-connect": {
      "name": "Folder Path Connect",
      "slug": "folder-path-connect",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-path-connect",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-path-connect.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-path-connect.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-path-connect.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-path-connect.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-path-connect.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-path-connect.svg"
        }
      ],
      "tags": [
        "directory",
        "folder",
        "link",
        "network",
        "organize",
        "shared",
        "shortcut",
        "storage"
      ]
    },
    "folders/folder-cloud": {
      "name": "Folder Cloud",
      "slug": "folder-cloud",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-cloud",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-cloud.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-cloud.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-cloud.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-cloud.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-cloud.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-cloud.svg"
        }
      ],
      "tags": [
        "backup",
        "cloud",
        "directory",
        "folder",
        "online",
        "organize",
        "remote",
        "storage",
        "sync"
      ]
    },
    "folders/folder-security": {
      "name": "Folder Security",
      "slug": "folder-security",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-security",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-security.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-security.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-security.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-security.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-security.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-security.svg"
        }
      ],
      "tags": [
        "directory",
        "encrypted",
        "folder",
        "locked",
        "organize",
        "private",
        "protected",
        "secure",
        "storage"
      ]
    },
    "folders/folder-open": {
      "name": "Folder Open",
      "slug": "folder-open",
      "category": "folders",
      "categoryName": "Folders",
      "id": "folders/folder-open",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/folders/folder-open.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/folders/folder-open.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/folders/folder-open.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/folders/folder-open.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/folders/folder-open.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/folders/folder-open.svg"
        }
      ],
      "tags": [
        "browse",
        "directory",
        "explore",
        "folder",
        "opened",
        "organize",
        "storage",
        "view"
      ]
    },
    "faces-emotions-stickers/smile-circle": {
      "name": "Smile Circle",
      "slug": "smile-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/smile-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/smile-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/smile-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/smile-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/smile-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/smile-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/smile-circle.svg"
        }
      ],
      "tags": [
        "content",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "happy",
        "joy",
        "mood",
        "pleased",
        "reaction",
        "smiley"
      ]
    },
    "faces-emotions-stickers/smile-square": {
      "name": "Smile Square",
      "slug": "smile-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/smile-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/smile-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/smile-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/smile-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/smile-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/smile-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/smile-square.svg"
        }
      ],
      "tags": [
        "content",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "happy",
        "mood",
        "pleased",
        "reaction",
        "smiley"
      ]
    },
    "faces-emotions-stickers/expressionless-circle": {
      "name": "Expressionless Circle",
      "slug": "expressionless-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/expressionless-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/expressionless-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/expressionless-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/expressionless-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/expressionless-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/expressionless-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/expressionless-circle.svg"
        }
      ],
      "tags": [
        "blank",
        "deadpan",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "mood",
        "neutral",
        "poker-face",
        "reaction"
      ]
    },
    "faces-emotions-stickers/expressionless-square": {
      "name": "Expressionless Square",
      "slug": "expressionless-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/expressionless-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/expressionless-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/expressionless-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/expressionless-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/expressionless-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/expressionless-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/expressionless-square.svg"
        }
      ],
      "tags": [
        "blank",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "mood",
        "neutral",
        "poker-face",
        "reaction"
      ]
    },
    "faces-emotions-stickers/sad-circle": {
      "name": "Sad Circle",
      "slug": "sad-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sad-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sad-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sad-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sad-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sad-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sad-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sad-circle.svg"
        }
      ],
      "tags": [
        "disappointed",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "frown",
        "mood",
        "reaction",
        "unhappy",
        "upset"
      ]
    },
    "faces-emotions-stickers/sad-square": {
      "name": "Sad Square",
      "slug": "sad-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sad-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sad-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sad-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sad-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sad-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sad-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sad-square.svg"
        }
      ],
      "tags": [
        "disappointed",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "frown",
        "mood",
        "reaction",
        "unhappy"
      ]
    },
    "faces-emotions-stickers/face-scan-square": {
      "name": "Face Scan Square",
      "slug": "face-scan-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/face-scan-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/face-scan-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/face-scan-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/face-scan-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/face-scan-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/face-scan-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/face-scan-square.svg"
        }
      ],
      "tags": [
        "biometric",
        "emoji",
        "emotion",
        "expression",
        "face",
        "facial-recognition",
        "feeling",
        "identify",
        "mood",
        "reaction"
      ]
    },
    "faces-emotions-stickers/face-scan-circle": {
      "name": "Face Scan Circle",
      "slug": "face-scan-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/face-scan-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/face-scan-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/face-scan-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/face-scan-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/face-scan-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/face-scan-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/face-scan-circle.svg"
        }
      ],
      "tags": [
        "biometric",
        "emoji",
        "emotion",
        "expression",
        "face",
        "facial-recognition",
        "feeling",
        "identify",
        "mood",
        "reaction",
        "scan"
      ]
    },
    "faces-emotions-stickers/emoji-funny-square": {
      "name": "Emoji Funny Square",
      "slug": "emoji-funny-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/emoji-funny-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/emoji-funny-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/emoji-funny-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/emoji-funny-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/emoji-funny-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/emoji-funny-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/emoji-funny-square.svg"
        }
      ],
      "tags": [
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "funny",
        "joy",
        "laugh",
        "mood",
        "reaction",
        "silly"
      ]
    },
    "faces-emotions-stickers/emoji-funny-circle": {
      "name": "Emoji Funny Circle",
      "slug": "emoji-funny-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/emoji-funny-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/emoji-funny-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/emoji-funny-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/emoji-funny-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/emoji-funny-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/emoji-funny-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/emoji-funny-circle.svg"
        }
      ],
      "tags": [
        "LOL",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "funny",
        "joy",
        "laugh",
        "mood",
        "reaction",
        "silly"
      ]
    },
    "faces-emotions-stickers/sticker-smile-square": {
      "name": "Sticker Smile Square",
      "slug": "sticker-smile-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sticker-smile-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sticker-smile-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sticker-smile-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sticker-smile-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sticker-smile-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sticker-smile-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sticker-smile-square.svg"
        }
      ],
      "tags": [
        "badge",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "happy",
        "label",
        "mood",
        "reaction"
      ]
    },
    "faces-emotions-stickers/sticker-circle": {
      "name": "Sticker Circle",
      "slug": "sticker-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sticker-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sticker-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sticker-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sticker-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sticker-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sticker-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sticker-circle.svg"
        }
      ],
      "tags": [
        "badge",
        "decal",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "label",
        "mood",
        "reaction",
        "tag"
      ]
    },
    "faces-emotions-stickers/sticker-square": {
      "name": "Sticker Square",
      "slug": "sticker-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sticker-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sticker-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sticker-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sticker-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sticker-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sticker-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sticker-square.svg"
        }
      ],
      "tags": [
        "badge",
        "decal",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "label",
        "mood",
        "reaction",
        "tag"
      ]
    },
    "faces-emotions-stickers/sticker-smile-circle-2": {
      "name": "Sticker Smile Circle 2",
      "slug": "sticker-smile-circle-2",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sticker-smile-circle-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sticker-smile-circle-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sticker-smile-circle-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sticker-smile-circle-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sticker-smile-circle-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sticker-smile-circle-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sticker-smile-circle-2.svg"
        }
      ],
      "tags": [
        "badge",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "happy",
        "label",
        "mood",
        "reaction"
      ]
    },
    "faces-emotions-stickers/sticker-smile-circle": {
      "name": "Sticker Smile Circle",
      "slug": "sticker-smile-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sticker-smile-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sticker-smile-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sticker-smile-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sticker-smile-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sticker-smile-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sticker-smile-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sticker-smile-circle.svg"
        }
      ],
      "tags": [
        "badge",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "fun",
        "happy",
        "label",
        "mood",
        "reaction"
      ]
    },
    "faces-emotions-stickers/sleeping-circle": {
      "name": "Sleeping Circle",
      "slug": "sleeping-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sleeping-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sleeping-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sleeping-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sleeping-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sleeping-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sleeping-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sleeping-circle.svg"
        }
      ],
      "tags": [
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "mood",
        "reaction",
        "rest",
        "sleep",
        "snore",
        "tired",
        "zzz"
      ]
    },
    "faces-emotions-stickers/sleeping-square": {
      "name": "Sleeping Square",
      "slug": "sleeping-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/sleeping-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/sleeping-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/sleeping-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/sleeping-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/sleeping-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/sleeping-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/sleeping-square.svg"
        }
      ],
      "tags": [
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "mood",
        "reaction",
        "rest",
        "sleep",
        "tired",
        "zzz"
      ]
    },
    "faces-emotions-stickers/confounded-circle": {
      "name": "Confounded Circle",
      "slug": "confounded-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/confounded-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/confounded-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/confounded-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/confounded-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/confounded-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/confounded-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/confounded-circle.svg"
        }
      ],
      "tags": [
        "confused",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "frustrated",
        "mood",
        "reaction",
        "troubled",
        "upset"
      ]
    },
    "faces-emotions-stickers/confounded-square": {
      "name": "Confounded Square",
      "slug": "confounded-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/confounded-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/confounded-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/confounded-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/confounded-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/confounded-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/confounded-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/confounded-square.svg"
        }
      ],
      "tags": [
        "confused",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "frustrated",
        "mood",
        "reaction",
        "upset"
      ]
    },
    "faces-emotions-stickers/facemask-circle": {
      "name": "Facemask Circle",
      "slug": "facemask-circle",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/facemask-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/facemask-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/facemask-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/facemask-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/facemask-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/facemask-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/facemask-circle.svg"
        }
      ],
      "tags": [
        "covid",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "health",
        "mask",
        "medical",
        "mood",
        "protection",
        "reaction"
      ]
    },
    "faces-emotions-stickers/facemask-square": {
      "name": "Facemask Square",
      "slug": "facemask-square",
      "category": "faces-emotions-stickers",
      "categoryName": "Faces, Emotions, Stickers",
      "id": "faces-emotions-stickers/facemask-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/faces-emotions-stickers/facemask-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/faces-emotions-stickers/facemask-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/faces-emotions-stickers/facemask-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/faces-emotions-stickers/facemask-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/faces-emotions-stickers/facemask-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/faces-emotions-stickers/facemask-square.svg"
        }
      ],
      "tags": [
        "covid",
        "emoji",
        "emotion",
        "expression",
        "face",
        "feeling",
        "health",
        "mask",
        "medical",
        "mood",
        "reaction"
      ]
    },
    "sports/bicycling-round": {
      "name": "Bicycling Round",
      "slug": "bicycling-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/bicycling-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/bicycling-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/bicycling-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/bicycling-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/bicycling-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/bicycling-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/bicycling-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "bike",
        "cycling",
        "exercise",
        "fitness",
        "gym",
        "ride",
        "sport",
        "workout"
      ]
    },
    "sports/skateboarding-round": {
      "name": "Skateboarding Round",
      "slug": "skateboarding-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/skateboarding-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/skateboarding-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/skateboarding-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/skateboarding-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/skateboarding-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/skateboarding-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/skateboarding-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "skate",
        "sport",
        "street",
        "trick",
        "workout"
      ]
    },
    "sports/skateboarding": {
      "name": "Skateboarding",
      "slug": "skateboarding",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/skateboarding",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/skateboarding.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/skateboarding.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/skateboarding.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/skateboarding.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/skateboarding.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/skateboarding.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "halfpipe",
        "skate",
        "sport",
        "street",
        "trick",
        "workout"
      ]
    },
    "sports/skateboard": {
      "name": "Skateboard",
      "slug": "skateboard",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/skateboard",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/skateboard.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/skateboard.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/skateboard.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/skateboard.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/skateboard.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/skateboard.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "board",
        "exercise",
        "fitness",
        "gym",
        "skate",
        "sport",
        "street",
        "trick",
        "workout"
      ]
    },
    "sports/bicycling": {
      "name": "Bicycling",
      "slug": "bicycling",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/bicycling",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/bicycling.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/bicycling.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/bicycling.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/bicycling.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/bicycling.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/bicycling.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "bicycle",
        "bike",
        "cycling",
        "exercise",
        "fitness",
        "gym",
        "pedal",
        "ride",
        "sport",
        "workout"
      ]
    },
    "sports/running": {
      "name": "Running",
      "slug": "running",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/running",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/running.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/running.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/running.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/running.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/running.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/running.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "cardio",
        "exercise",
        "fitness",
        "gym",
        "jog",
        "marathon",
        "race",
        "sport",
        "sprint",
        "workout"
      ]
    },
    "sports/running-round": {
      "name": "Running Round",
      "slug": "running-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/running-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/running-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/running-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/running-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/running-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/running-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/running-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "jog",
        "race",
        "sport",
        "sprint",
        "workout"
      ]
    },
    "sports/running-2": {
      "name": "Running 2",
      "slug": "running-2",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/running-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/running-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/running-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/running-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/running-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/running-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/running-2.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "cardio",
        "exercise",
        "fitness",
        "gym",
        "jog",
        "race",
        "sport",
        "sprint",
        "workout"
      ]
    },
    "sports/walking-round": {
      "name": "Walking Round",
      "slug": "walking-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/walking-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/walking-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/walking-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/walking-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/walking-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/walking-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/walking-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "pedestrian",
        "sport",
        "step",
        "stroll",
        "workout"
      ]
    },
    "sports/walking": {
      "name": "Walking",
      "slug": "walking",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/walking",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/walking.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/walking.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/walking.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/walking.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/walking.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/walking.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "footstep",
        "gym",
        "pedestrian",
        "sport",
        "step",
        "stroll",
        "workout"
      ]
    },
    "sports/hiking": {
      "name": "Hiking",
      "slug": "hiking",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/hiking",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/hiking.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/hiking.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/hiking.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/hiking.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/hiking.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/hiking.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "mountain",
        "outdoor",
        "sport",
        "trail",
        "trek",
        "walk",
        "workout"
      ]
    },
    "sports/hiking-round": {
      "name": "Hiking Round",
      "slug": "hiking-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/hiking-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/hiking-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/hiking-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/hiking-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/hiking-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/hiking-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/hiking-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "sport",
        "trail",
        "trek",
        "walk",
        "workout"
      ]
    },
    "sports/hiking-minimalistic": {
      "name": "Hiking Minimalistic",
      "slug": "hiking-minimalistic",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/hiking-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/hiking-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/hiking-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/hiking-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/hiking-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/hiking-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/hiking-minimalistic.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "minimal",
        "sport",
        "trek",
        "walk",
        "workout"
      ]
    },
    "sports/meditation-round": {
      "name": "Meditation Round",
      "slug": "meditation-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/meditation-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/meditation-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/meditation-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/meditation-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/meditation-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/meditation-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/meditation-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "mindfulness",
        "sport",
        "workout",
        "yoga",
        "zen"
      ]
    },
    "sports/meditation": {
      "name": "Meditation",
      "slug": "meditation",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/meditation",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/meditation.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/meditation.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/meditation.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/meditation.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/meditation.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/meditation.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "breathe",
        "calm",
        "exercise",
        "fitness",
        "gym",
        "mindfulness",
        "peace",
        "sport",
        "workout",
        "yoga",
        "zen"
      ]
    },
    "sports/stretching": {
      "name": "Stretching",
      "slug": "stretching",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/stretching",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/stretching.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/stretching.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/stretching.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/stretching.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/stretching.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/stretching.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "cool-down",
        "exercise",
        "fitness",
        "flex",
        "gym",
        "mobility",
        "sport",
        "warmup",
        "workout"
      ]
    },
    "sports/stretching-round": {
      "name": "Stretching Round",
      "slug": "stretching-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/stretching-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/stretching-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/stretching-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/stretching-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/stretching-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/stretching-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/stretching-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "flex",
        "gym",
        "mobility",
        "sport",
        "warmup",
        "workout"
      ]
    },
    "sports/treadmill": {
      "name": "Treadmill",
      "slug": "treadmill",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/treadmill",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/treadmill.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/treadmill.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/treadmill.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/treadmill.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/treadmill.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/treadmill.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "cardio",
        "exercise",
        "fitness",
        "gym",
        "indoor",
        "machine",
        "run",
        "sport",
        "workout"
      ]
    },
    "sports/treadmill-round": {
      "name": "Treadmill Round",
      "slug": "treadmill-round",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/treadmill-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/treadmill-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/treadmill-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/treadmill-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/treadmill-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/treadmill-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/treadmill-round.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "cardio",
        "exercise",
        "fitness",
        "gym",
        "indoor",
        "run",
        "sport",
        "workout"
      ]
    },
    "sports/swimming": {
      "name": "Swimming",
      "slug": "swimming",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/swimming",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/swimming.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/swimming.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/swimming.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/swimming.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/swimming.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/swimming.svg"
        }
      ],
      "tags": [
        "active",
        "aquatic",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "pool",
        "sport",
        "stroke",
        "swim",
        "water",
        "workout"
      ]
    },
    "sports/water": {
      "name": "Water",
      "slug": "water",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/water",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/water.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/water.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/water.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/water.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/water.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/water.svg"
        }
      ],
      "tags": [
        "active",
        "aqua",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "liquid",
        "ocean",
        "sea",
        "sport",
        "wave",
        "workout"
      ]
    },
    "sports/water-sun": {
      "name": "Water Sun",
      "slug": "water-sun",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/water-sun",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/water-sun.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/water-sun.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/water-sun.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/water-sun.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/water-sun.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/water-sun.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "beach",
        "exercise",
        "fitness",
        "gym",
        "holiday",
        "sport",
        "summer",
        "tropical",
        "vacation",
        "workout"
      ]
    },
    "sports/dumbbell": {
      "name": "Dumbbell",
      "slug": "dumbbell",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbell",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbell.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbell.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbell.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbell.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbell.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbell.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "barbell",
        "exercise",
        "fitness",
        "gym",
        "iron",
        "lift",
        "sport",
        "strength",
        "weight",
        "workout"
      ]
    },
    "sports/dumbbells": {
      "name": "Dumbbells",
      "slug": "dumbbells",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbells",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbells.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbells.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbells.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbells.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbells.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbells.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "lift",
        "pair",
        "sport",
        "weights",
        "workout"
      ]
    },
    "sports/dumbbells-2": {
      "name": "Dumbbells 2",
      "slug": "dumbbells-2",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbells-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbells-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbells-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbells-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbells-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbells-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbells-2.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "lift",
        "pair",
        "sport",
        "weights",
        "workout"
      ]
    },
    "sports/dumbbell-large": {
      "name": "Dumbbell Large",
      "slug": "dumbbell-large",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbell-large",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbell-large.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbell-large.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbell-large.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbell-large.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbell-large.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbell-large.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "heavy",
        "sport",
        "strength",
        "weight",
        "workout"
      ]
    },
    "sports/dumbbell-large-minimalistic": {
      "name": "Dumbbell Large Minimalistic",
      "slug": "dumbbell-large-minimalistic",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbell-large-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbell-large-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbell-large-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbell-large-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbell-large-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbell-large-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbell-large-minimalistic.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "heavy",
        "minimal",
        "sport",
        "weight",
        "workout"
      ]
    },
    "sports/dumbbell-small": {
      "name": "Dumbbell Small",
      "slug": "dumbbell-small",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/dumbbell-small",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/dumbbell-small.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/dumbbell-small.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/dumbbell-small.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/dumbbell-small.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/dumbbell-small.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/dumbbell-small.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "light",
        "sport",
        "toning",
        "weight",
        "workout"
      ]
    },
    "sports/ranking": {
      "name": "Ranking",
      "slug": "ranking",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/ranking",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/ranking.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/ranking.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/ranking.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/ranking.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/ranking.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/ranking.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "competition",
        "exercise",
        "fitness",
        "gym",
        "leaderboard",
        "position",
        "rank",
        "sport",
        "standing",
        "workout"
      ]
    },
    "sports/body-shape-minimalistic": {
      "name": "Body Shape Minimalistic",
      "slug": "body-shape-minimalistic",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/body-shape-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/body-shape-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/body-shape-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/body-shape-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/body-shape-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/body-shape-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/body-shape-minimalistic.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "exercise",
        "fitness",
        "gym",
        "minimal",
        "physique",
        "silhouette",
        "sport",
        "workout"
      ]
    },
    "sports/body-shape": {
      "name": "Body Shape",
      "slug": "body-shape",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/body-shape",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/body-shape.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/body-shape.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/body-shape.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/body-shape.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/body-shape.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/body-shape.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "build",
        "exercise",
        "figure",
        "fitness",
        "gym",
        "physique",
        "silhouette",
        "sport",
        "workout"
      ]
    },
    "sports/golf": {
      "name": "Golf",
      "slug": "golf",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/golf",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/golf.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/golf.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/golf.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/golf.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/golf.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/golf.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "club",
        "exercise",
        "fitness",
        "green",
        "gym",
        "hole",
        "sport",
        "tee",
        "workout"
      ]
    },
    "sports/tennis": {
      "name": "Tennis",
      "slug": "tennis",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/tennis",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/tennis.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/tennis.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/tennis.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/tennis.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/tennis.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/tennis.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "court",
        "exercise",
        "fitness",
        "gym",
        "match",
        "racket",
        "sport",
        "workout"
      ]
    },
    "sports/tennis-2": {
      "name": "Tennis 2",
      "slug": "tennis-2",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/tennis-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/tennis-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/tennis-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/tennis-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/tennis-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/tennis-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/tennis-2.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "court",
        "exercise",
        "fitness",
        "gym",
        "racket",
        "sport",
        "workout"
      ]
    },
    "sports/volleyball": {
      "name": "Volleyball",
      "slug": "volleyball",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/volleyball",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/volleyball.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/volleyball.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/volleyball.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/volleyball.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/volleyball.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/volleyball.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "beach",
        "exercise",
        "fitness",
        "gym",
        "net",
        "spike",
        "sport",
        "workout"
      ]
    },
    "sports/volleyball-2": {
      "name": "Volleyball 2",
      "slug": "volleyball-2",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/volleyball-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/volleyball-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/volleyball-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/volleyball-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/volleyball-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/volleyball-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/volleyball-2.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "beach",
        "exercise",
        "fitness",
        "gym",
        "net",
        "sport",
        "workout"
      ]
    },
    "sports/football": {
      "name": "Football",
      "slug": "football",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/football",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/football.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/football.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/football.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/football.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/football.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/football.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "exercise",
        "fitness",
        "goal",
        "gym",
        "match",
        "pitch",
        "soccer",
        "sport",
        "workout"
      ]
    },
    "sports/rugby": {
      "name": "Rugby",
      "slug": "rugby",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/rugby",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/rugby.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/rugby.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/rugby.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/rugby.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/rugby.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/rugby.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "exercise",
        "fitness",
        "gym",
        "oval",
        "scrum",
        "sport",
        "tackle",
        "workout"
      ]
    },
    "sports/basketball": {
      "name": "Basketball",
      "slug": "basketball",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/basketball",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/basketball.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/basketball.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/basketball.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/basketball.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/basketball.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/basketball.svg"
        }
      ],
      "tags": [
        "NBA",
        "active",
        "athletic",
        "ball",
        "court",
        "exercise",
        "fitness",
        "gym",
        "hoop",
        "sport",
        "workout"
      ]
    },
    "sports/balls": {
      "name": "Balls",
      "slug": "balls",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/balls",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/balls.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/balls.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/balls.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/balls.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/balls.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/balls.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "exercise",
        "fitness",
        "games",
        "gym",
        "play",
        "sport",
        "sports-balls",
        "workout"
      ]
    },
    "sports/bowling": {
      "name": "Bowling",
      "slug": "bowling",
      "category": "sports",
      "categoryName": "Sports",
      "id": "sports/bowling",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/sports/bowling.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/sports/bowling.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/sports/bowling.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/sports/bowling.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/sports/bowling.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/sports/bowling.svg"
        }
      ],
      "tags": [
        "active",
        "athletic",
        "ball",
        "exercise",
        "fitness",
        "gym",
        "lane",
        "pins",
        "sport",
        "strike",
        "workout"
      ]
    },
    "search/minimalistic-magnifer": {
      "name": "Minimalistic Magnifer",
      "slug": "minimalistic-magnifer",
      "category": "search",
      "categoryName": "Search",
      "id": "search/minimalistic-magnifer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/minimalistic-magnifer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/minimalistic-magnifer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/minimalistic-magnifer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/minimalistic-magnifer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/minimalistic-magnifer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/minimalistic-magnifer.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "lookup",
        "magnify",
        "minimal",
        "search"
      ]
    },
    "search/minimalistic-magnifer-zoom-in": {
      "name": "Minimalistic Magnifer Zoom In",
      "slug": "minimalistic-magnifer-zoom-in",
      "category": "search",
      "categoryName": "Search",
      "id": "search/minimalistic-magnifer-zoom-in",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/minimalistic-magnifer-zoom-in.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/minimalistic-magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/minimalistic-magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/minimalistic-magnifer-zoom-in.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/minimalistic-magnifer-zoom-in.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/minimalistic-magnifer-zoom-in.svg"
        }
      ],
      "tags": [
        "discover",
        "enlarge",
        "find",
        "lookup",
        "magnify",
        "minimal",
        "search",
        "zoom-in"
      ]
    },
    "search/minimalistic-magnifer-zoom-out": {
      "name": "Minimalistic Magnifer Zoom Out",
      "slug": "minimalistic-magnifer-zoom-out",
      "category": "search",
      "categoryName": "Search",
      "id": "search/minimalistic-magnifer-zoom-out",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/minimalistic-magnifer-zoom-out.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/minimalistic-magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/minimalistic-magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/minimalistic-magnifer-zoom-out.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/minimalistic-magnifer-zoom-out.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/minimalistic-magnifer-zoom-out.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "lookup",
        "magnify",
        "minimal",
        "search",
        "shrink",
        "zoom-out"
      ]
    },
    "search/minimalistic-magnifer-bug": {
      "name": "Minimalistic Magnifer Bug",
      "slug": "minimalistic-magnifer-bug",
      "category": "search",
      "categoryName": "Search",
      "id": "search/minimalistic-magnifer-bug",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/minimalistic-magnifer-bug.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/minimalistic-magnifer-bug.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/minimalistic-magnifer-bug.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/minimalistic-magnifer-bug.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/minimalistic-magnifer-bug.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/minimalistic-magnifer-bug.svg"
        }
      ],
      "tags": [
        "debug",
        "discover",
        "find",
        "lookup",
        "magnify",
        "minimal",
        "search",
        "search-bug"
      ]
    },
    "search/magnifer": {
      "name": "Magnifer",
      "slug": "magnifer",
      "category": "search",
      "categoryName": "Search",
      "id": "search/magnifer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/magnifer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/magnifer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/magnifer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/magnifer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/magnifer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/magnifer.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "glass",
        "lens",
        "look",
        "lookup",
        "magnify",
        "search",
        "zoom"
      ]
    },
    "search/magnifer-zoom-in": {
      "name": "Magnifer Zoom In",
      "slug": "magnifer-zoom-in",
      "category": "search",
      "categoryName": "Search",
      "id": "search/magnifer-zoom-in",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/magnifer-zoom-in.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/magnifer-zoom-in.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/magnifer-zoom-in.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/magnifer-zoom-in.svg"
        }
      ],
      "tags": [
        "closer",
        "discover",
        "enlarge",
        "find",
        "lookup",
        "magnify",
        "plus",
        "search",
        "zoom-in"
      ]
    },
    "search/magnifer-zoom-out": {
      "name": "Magnifer Zoom Out",
      "slug": "magnifer-zoom-out",
      "category": "search",
      "categoryName": "Search",
      "id": "search/magnifer-zoom-out",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/magnifer-zoom-out.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/magnifer-zoom-out.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/magnifer-zoom-out.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/magnifer-zoom-out.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "further",
        "lookup",
        "magnify",
        "minus",
        "search",
        "shrink",
        "zoom-out"
      ]
    },
    "search/magnifer-bug": {
      "name": "Magnifer Bug",
      "slug": "magnifer-bug",
      "category": "search",
      "categoryName": "Search",
      "id": "search/magnifer-bug",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/magnifer-bug.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/magnifer-bug.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/magnifer-bug.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/magnifer-bug.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/magnifer-bug.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/magnifer-bug.svg"
        }
      ],
      "tags": [
        "debug",
        "discover",
        "find",
        "find-error",
        "inspect",
        "lookup",
        "magnify",
        "search",
        "search-bug"
      ]
    },
    "search/rounded-magnifer": {
      "name": "Rounded Magnifer",
      "slug": "rounded-magnifer",
      "category": "search",
      "categoryName": "Search",
      "id": "search/rounded-magnifer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/rounded-magnifer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/rounded-magnifer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/rounded-magnifer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/rounded-magnifer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/rounded-magnifer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/rounded-magnifer.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "lookup",
        "magnify",
        "rounded",
        "search"
      ]
    },
    "search/rounded-magnifer-zoom-in": {
      "name": "Rounded Magnifer Zoom In",
      "slug": "rounded-magnifer-zoom-in",
      "category": "search",
      "categoryName": "Search",
      "id": "search/rounded-magnifer-zoom-in",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/rounded-magnifer-zoom-in.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/rounded-magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/rounded-magnifer-zoom-in.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/rounded-magnifer-zoom-in.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/rounded-magnifer-zoom-in.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/rounded-magnifer-zoom-in.svg"
        }
      ],
      "tags": [
        "discover",
        "enlarge",
        "find",
        "lookup",
        "magnify",
        "rounded",
        "search",
        "zoom-in"
      ]
    },
    "search/rounded-magnifer-zoom-out": {
      "name": "Rounded Magnifer Zoom Out",
      "slug": "rounded-magnifer-zoom-out",
      "category": "search",
      "categoryName": "Search",
      "id": "search/rounded-magnifer-zoom-out",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/rounded-magnifer-zoom-out.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/rounded-magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/rounded-magnifer-zoom-out.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/rounded-magnifer-zoom-out.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/rounded-magnifer-zoom-out.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/rounded-magnifer-zoom-out.svg"
        }
      ],
      "tags": [
        "discover",
        "find",
        "lookup",
        "magnify",
        "rounded",
        "search",
        "shrink",
        "zoom-out"
      ]
    },
    "search/rounded-magnifer-bug": {
      "name": "Rounded Magnifer Bug",
      "slug": "rounded-magnifer-bug",
      "category": "search",
      "categoryName": "Search",
      "id": "search/rounded-magnifer-bug",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/search/rounded-magnifer-bug.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/search/rounded-magnifer-bug.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/search/rounded-magnifer-bug.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/search/rounded-magnifer-bug.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/search/rounded-magnifer-bug.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/search/rounded-magnifer-bug.svg"
        }
      ],
      "tags": [
        "debug",
        "discover",
        "find",
        "lookup",
        "magnify",
        "rounded",
        "search",
        "search-bug"
      ]
    },
    "time/clock-circle": {
      "name": "Clock Circle",
      "slug": "clock-circle",
      "category": "time",
      "categoryName": "Time",
      "id": "time/clock-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/clock-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/clock-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/clock-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/clock-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/clock-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/clock-circle.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "hour",
        "round",
        "schedule",
        "time",
        "timer",
        "timing",
        "watch"
      ]
    },
    "time/history": {
      "name": "History",
      "slug": "history",
      "category": "time",
      "categoryName": "Time",
      "id": "time/history",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/history.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/history.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/history.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/history.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/history.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/history.svg"
        }
      ],
      "tags": [
        "activity",
        "clock",
        "date",
        "duration",
        "log",
        "past",
        "previously",
        "recent",
        "schedule",
        "time",
        "timing",
        "undo"
      ]
    },
    "time/clock-square": {
      "name": "Clock Square",
      "slug": "clock-square",
      "category": "time",
      "categoryName": "Time",
      "id": "time/clock-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/clock-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/clock-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/clock-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/clock-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/clock-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/clock-square.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "hour",
        "schedule",
        "time",
        "timer",
        "timing",
        "watch"
      ]
    },
    "time/alarm": {
      "name": "Alarm",
      "slug": "alarm",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm.svg"
        }
      ],
      "tags": [
        "alert",
        "buzzer",
        "clock",
        "date",
        "duration",
        "morning",
        "reminder",
        "schedule",
        "time",
        "timing",
        "wake-up"
      ]
    },
    "time/alarm-sleep": {
      "name": "Alarm Sleep",
      "slug": "alarm-sleep",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-sleep",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-sleep.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-sleep.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-sleep.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-sleep.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-sleep.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-sleep.svg"
        }
      ],
      "tags": [
        "bedtime",
        "clock",
        "date",
        "duration",
        "rest",
        "schedule",
        "snooze",
        "time",
        "timing",
        "zzz"
      ]
    },
    "time/alarm-play": {
      "name": "Alarm Play",
      "slug": "alarm-play",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-play",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-play.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-play.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-play.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-play.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-play.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-play.svg"
        }
      ],
      "tags": [
        "active",
        "clock",
        "date",
        "duration",
        "resume",
        "schedule",
        "start",
        "time",
        "timing"
      ]
    },
    "time/alarm-pause": {
      "name": "Alarm Pause",
      "slug": "alarm-pause",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-pause",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-pause.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-pause.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-pause.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-pause.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-pause.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-pause.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "delay",
        "duration",
        "pause",
        "schedule",
        "snooze",
        "time",
        "timing"
      ]
    },
    "time/alarm-add": {
      "name": "Alarm Add",
      "slug": "alarm-add",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-add.svg"
        }
      ],
      "tags": [
        "clock",
        "create",
        "date",
        "duration",
        "new-alarm",
        "schedule",
        "set-alarm",
        "time",
        "timing"
      ]
    },
    "time/alarm-remove": {
      "name": "Alarm Remove",
      "slug": "alarm-remove",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-remove.svg"
        }
      ],
      "tags": [
        "cancel",
        "clock",
        "date",
        "delete-alarm",
        "dismiss",
        "duration",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/alarm-turn-off": {
      "name": "Alarm Turn Off",
      "slug": "alarm-turn-off",
      "category": "time",
      "categoryName": "Time",
      "id": "time/alarm-turn-off",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/alarm-turn-off.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/alarm-turn-off.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/alarm-turn-off.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/alarm-turn-off.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/alarm-turn-off.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/alarm-turn-off.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "dismiss",
        "duration",
        "schedule",
        "silence",
        "stop",
        "time",
        "timing"
      ]
    },
    "time/stopwatch": {
      "name": "Stopwatch",
      "slug": "stopwatch",
      "category": "time",
      "categoryName": "Time",
      "id": "time/stopwatch",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/stopwatch.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/stopwatch.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/stopwatch.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/stopwatch.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/stopwatch.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/stopwatch.svg"
        }
      ],
      "tags": [
        "chrono",
        "clock",
        "countdown",
        "date",
        "duration",
        "lap",
        "schedule",
        "speed",
        "time",
        "timer",
        "timing"
      ]
    },
    "time/stopwatch-play": {
      "name": "Stopwatch Play",
      "slug": "stopwatch-play",
      "category": "time",
      "categoryName": "Time",
      "id": "time/stopwatch-play",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/stopwatch-play.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/stopwatch-play.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/stopwatch-play.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/stopwatch-play.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/stopwatch-play.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/stopwatch-play.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "running",
        "schedule",
        "start",
        "time",
        "timer",
        "timing"
      ]
    },
    "time/stopwatch-pause": {
      "name": "Stopwatch Pause",
      "slug": "stopwatch-pause",
      "category": "time",
      "categoryName": "Time",
      "id": "time/stopwatch-pause",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/stopwatch-pause.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/stopwatch-pause.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/stopwatch-pause.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/stopwatch-pause.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/stopwatch-pause.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/stopwatch-pause.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "hold",
        "paused",
        "schedule",
        "time",
        "timer",
        "timing"
      ]
    },
    "time/history-2": {
      "name": "History 2",
      "slug": "history-2",
      "category": "time",
      "categoryName": "Time",
      "id": "time/history-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/history-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/history-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/history-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/history-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/history-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/history-2.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "log",
        "past",
        "recent",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/history-3": {
      "name": "History 3",
      "slug": "history-3",
      "category": "time",
      "categoryName": "Time",
      "id": "time/history-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/history-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/history-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/history-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/history-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/history-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/history-3.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "log",
        "past",
        "recent",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/hourglass": {
      "name": "Hourglass",
      "slug": "hourglass",
      "category": "time",
      "categoryName": "Time",
      "id": "time/hourglass",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/hourglass.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/hourglass.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/hourglass.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/hourglass.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/hourglass.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/hourglass.svg"
        }
      ],
      "tags": [
        "clock",
        "countdown",
        "date",
        "duration",
        "loading",
        "patience",
        "sand",
        "schedule",
        "time",
        "timer",
        "timing",
        "wait"
      ]
    },
    "time/hourglass-line": {
      "name": "Hourglass Line",
      "slug": "hourglass-line",
      "category": "time",
      "categoryName": "Time",
      "id": "time/hourglass-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/hourglass-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/hourglass-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/hourglass-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/hourglass-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/hourglass-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/hourglass-line.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "loading",
        "schedule",
        "time",
        "timer",
        "timing",
        "wait"
      ]
    },
    "time/calendar-minimalistic": {
      "name": "Calendar Minimalistic",
      "slug": "calendar-minimalistic",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar-minimalistic.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "minimal",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/calendar": {
      "name": "Calendar",
      "slug": "calendar",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "diary",
        "duration",
        "event",
        "month",
        "planner",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/calendar-mark": {
      "name": "Calendar Mark",
      "slug": "calendar-mark",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar-mark",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar-mark.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar-mark.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar-mark.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar-mark.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar-mark.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar-mark.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "event",
        "flagged",
        "important",
        "marked",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/calendar-date": {
      "name": "Calendar Date",
      "slug": "calendar-date",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar-date",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar-date.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar-date.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar-date.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar-date.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar-date.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar-date.svg"
        }
      ],
      "tags": [
        "appointment",
        "clock",
        "date",
        "day",
        "duration",
        "schedule",
        "specific-date",
        "time",
        "timing"
      ]
    },
    "time/calendar-search": {
      "name": "Calendar Search",
      "slug": "calendar-search",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar-search",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar-search.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar-search.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar-search.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar-search.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar-search.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar-search.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "find-event",
        "lookup",
        "schedule",
        "search-date",
        "time",
        "timing"
      ]
    },
    "time/calendar-add": {
      "name": "Calendar Add",
      "slug": "calendar-add",
      "category": "time",
      "categoryName": "Time",
      "id": "time/calendar-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/calendar-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/calendar-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/calendar-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/calendar-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/calendar-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/calendar-add.svg"
        }
      ],
      "tags": [
        "book",
        "clock",
        "create",
        "date",
        "duration",
        "new-event",
        "schedule",
        "time",
        "timing"
      ]
    },
    "time/watch-round": {
      "name": "Watch Round",
      "slug": "watch-round",
      "category": "time",
      "categoryName": "Time",
      "id": "time/watch-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/watch-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/watch-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/watch-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/watch-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/watch-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/watch-round.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "schedule",
        "smart-watch",
        "time",
        "timepiece",
        "timing",
        "wearable",
        "wristwatch"
      ]
    },
    "time/watch-square": {
      "name": "Watch Square",
      "slug": "watch-square",
      "category": "time",
      "categoryName": "Time",
      "id": "time/watch-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/watch-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/watch-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/watch-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/watch-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/watch-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/watch-square.svg"
        }
      ],
      "tags": [
        "Apple-Watch",
        "clock",
        "date",
        "duration",
        "schedule",
        "smart-watch",
        "time",
        "timing",
        "wristwatch"
      ]
    },
    "time/watch-square-minimalistic": {
      "name": "Watch Square Minimalistic",
      "slug": "watch-square-minimalistic",
      "category": "time",
      "categoryName": "Time",
      "id": "time/watch-square-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/watch-square-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/watch-square-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/watch-square-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/watch-square-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/watch-square-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/watch-square-minimalistic.svg"
        }
      ],
      "tags": [
        "clock",
        "date",
        "duration",
        "minimal",
        "schedule",
        "smart-watch",
        "time",
        "timing",
        "wristwatch"
      ]
    },
    "time/watch-square-minimalistic-charge": {
      "name": "Watch Square Minimalistic Charge",
      "slug": "watch-square-minimalistic-charge",
      "category": "time",
      "categoryName": "Time",
      "id": "time/watch-square-minimalistic-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/time/watch-square-minimalistic-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/time/watch-square-minimalistic-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/time/watch-square-minimalistic-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/time/watch-square-minimalistic-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/time/watch-square-minimalistic-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/time/watch-square-minimalistic-charge.svg"
        }
      ],
      "tags": [
        "battery",
        "charging",
        "clock",
        "date",
        "duration",
        "schedule",
        "smart-watch",
        "time",
        "timing"
      ]
    },
    "list/plaaylist-minimalistic": {
      "name": "Plaaylist Minimalistic",
      "slug": "plaaylist-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/plaaylist-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/plaaylist-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/plaaylist-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/plaaylist-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/plaaylist-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/plaaylist-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/plaaylist-minimalistic.svg"
        }
      ],
      "tags": [
        "list",
        "minimal",
        "order",
        "organize",
        "queue",
        "songs",
        "task",
        "todo",
        "tracklist"
      ]
    },
    "list/playlist-2": {
      "name": "Playlist 2",
      "slug": "playlist-2",
      "category": "list",
      "categoryName": "List",
      "id": "list/playlist-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/playlist-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/playlist-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/playlist-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/playlist-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/playlist-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/playlist-2.svg"
        }
      ],
      "tags": [
        "list",
        "order",
        "organize",
        "queue",
        "songs",
        "task",
        "todo",
        "tracklist"
      ]
    },
    "list/playlist-minimalistic-2": {
      "name": "Playlist Minimalistic 2",
      "slug": "playlist-minimalistic-2",
      "category": "list",
      "categoryName": "List",
      "id": "list/playlist-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/playlist-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/playlist-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/playlist-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/playlist-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/playlist-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/playlist-minimalistic-2.svg"
        }
      ],
      "tags": [
        "list",
        "minimal",
        "order",
        "organize",
        "queue",
        "task",
        "todo",
        "tracklist"
      ]
    },
    "list/playlist-minimalistic-3": {
      "name": "Playlist Minimalistic 3",
      "slug": "playlist-minimalistic-3",
      "category": "list",
      "categoryName": "List",
      "id": "list/playlist-minimalistic-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/playlist-minimalistic-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/playlist-minimalistic-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/playlist-minimalistic-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/playlist-minimalistic-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/playlist-minimalistic-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/playlist-minimalistic-3.svg"
        }
      ],
      "tags": [
        "list",
        "minimal",
        "order",
        "organize",
        "queue",
        "task",
        "todo",
        "tracklist"
      ]
    },
    "list/list-heart": {
      "name": "List Heart",
      "slug": "list-heart",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-heart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-heart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-heart.svg"
        }
      ],
      "tags": [
        "favourites",
        "liked",
        "list",
        "order",
        "organize",
        "saved",
        "task",
        "todo",
        "wishlist"
      ]
    },
    "list/list-heart-minimalistic": {
      "name": "List Heart Minimalistic",
      "slug": "list-heart-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-heart-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-heart-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-heart-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-heart-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-heart-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-heart-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-heart-minimalistic.svg"
        }
      ],
      "tags": [
        "favourites",
        "list",
        "minimal",
        "order",
        "organize",
        "task",
        "todo",
        "wishlist"
      ]
    },
    "list/list-down-minimalistic": {
      "name": "List Down Minimalistic",
      "slug": "list-down-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-down-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-down-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-down-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-down-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-down-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-down-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-down-minimalistic.svg"
        }
      ],
      "tags": [
        "list",
        "lower",
        "minimal",
        "move-down",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/list-down": {
      "name": "List Down",
      "slug": "list-down",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-down.svg"
        }
      ],
      "tags": [
        "list",
        "lower",
        "move-down",
        "order",
        "organize",
        "priority",
        "task",
        "todo"
      ]
    },
    "list/list-check": {
      "name": "List Check",
      "slug": "list-check",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-check.svg"
        }
      ],
      "tags": [
        "approved",
        "completed",
        "done",
        "list",
        "order",
        "organize",
        "task",
        "todo",
        "verified"
      ]
    },
    "list/list-check-minimalistic": {
      "name": "List Check Minimalistic",
      "slug": "list-check-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-check-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-check-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-check-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-check-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-check-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-check-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-check-minimalistic.svg"
        }
      ],
      "tags": [
        "completed",
        "done",
        "list",
        "minimal",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/list-cross": {
      "name": "List Cross",
      "slug": "list-cross",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-cross.svg"
        }
      ],
      "tags": [
        "cancelled",
        "error",
        "failed",
        "list",
        "order",
        "organize",
        "rejected",
        "task",
        "todo"
      ]
    },
    "list/list-cross-minimalistic": {
      "name": "List Cross Minimalistic",
      "slug": "list-cross-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-cross-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-cross-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-cross-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-cross-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-cross-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-cross-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-cross-minimalistic.svg"
        }
      ],
      "tags": [
        "failed",
        "list",
        "minimal",
        "order",
        "organize",
        "rejected",
        "task",
        "todo"
      ]
    },
    "list/sort-from-top-to-bottom": {
      "name": "Sort From Top To Bottom",
      "slug": "sort-from-top-to-bottom",
      "category": "list",
      "categoryName": "List",
      "id": "list/sort-from-top-to-bottom",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/sort-from-top-to-bottom.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/sort-from-top-to-bottom.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/sort-from-top-to-bottom.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/sort-from-top-to-bottom.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/sort-from-top-to-bottom.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/sort-from-top-to-bottom.svg"
        }
      ],
      "tags": [
        "descending",
        "high-to-low",
        "list",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/sort-from-bottom-to-top": {
      "name": "Sort From Bottom To Top",
      "slug": "sort-from-bottom-to-top",
      "category": "list",
      "categoryName": "List",
      "id": "list/sort-from-bottom-to-top",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/sort-from-bottom-to-top.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/sort-from-bottom-to-top.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/sort-from-bottom-to-top.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/sort-from-bottom-to-top.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/sort-from-bottom-to-top.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/sort-from-bottom-to-top.svg"
        }
      ],
      "tags": [
        "ascending",
        "list",
        "low-to-high",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/list": {
      "name": "List",
      "slug": "list",
      "category": "list",
      "categoryName": "List",
      "id": "list/list",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list.svg"
        }
      ],
      "tags": [
        "bullet",
        "enumerate",
        "items",
        "list",
        "menu",
        "options",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/sort-by-alphabet": {
      "name": "Sort By Alphabet",
      "slug": "sort-by-alphabet",
      "category": "list",
      "categoryName": "List",
      "id": "list/sort-by-alphabet",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/sort-by-alphabet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/sort-by-alphabet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/sort-by-alphabet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/sort-by-alphabet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/sort-by-alphabet.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/sort-by-alphabet.svg"
        }
      ],
      "tags": [
        "A-Z",
        "alphabetical",
        "arrange",
        "list",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/sort-by-time": {
      "name": "Sort By Time",
      "slug": "sort-by-time",
      "category": "list",
      "categoryName": "List",
      "id": "list/sort-by-time",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/sort-by-time.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/sort-by-time.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/sort-by-time.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/sort-by-time.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/sort-by-time.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/sort-by-time.svg"
        }
      ],
      "tags": [
        "chronological",
        "date",
        "list",
        "oldest",
        "order",
        "organize",
        "recent",
        "task",
        "todo"
      ]
    },
    "list/list-up": {
      "name": "List Up",
      "slug": "list-up",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-up.svg"
        }
      ],
      "tags": [
        "higher",
        "list",
        "move-up",
        "order",
        "organize",
        "priority",
        "task",
        "todo"
      ]
    },
    "list/list-up-minimalistic": {
      "name": "List Up Minimalistic",
      "slug": "list-up-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-up-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-up-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-up-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-up-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-up-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-up-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-up-minimalistic.svg"
        }
      ],
      "tags": [
        "higher",
        "list",
        "minimal",
        "move-up",
        "order",
        "organize",
        "task",
        "todo"
      ]
    },
    "list/list-arrow-up": {
      "name": "List Arrow Up",
      "slug": "list-arrow-up",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-arrow-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-arrow-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-arrow-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-arrow-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-arrow-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-arrow-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-arrow-up.svg"
        }
      ],
      "tags": [
        "ascending",
        "list",
        "order",
        "organize",
        "sort",
        "task",
        "todo"
      ]
    },
    "list/list-arrow-up-minimalistic": {
      "name": "List Arrow Up Minimalistic",
      "slug": "list-arrow-up-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-arrow-up-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-arrow-up-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-arrow-up-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-arrow-up-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-arrow-up-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-arrow-up-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-arrow-up-minimalistic.svg"
        }
      ],
      "tags": [
        "ascending",
        "list",
        "minimal",
        "order",
        "organize",
        "sort",
        "task",
        "todo"
      ]
    },
    "list/list-arrow-down": {
      "name": "List Arrow Down",
      "slug": "list-arrow-down",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-arrow-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-arrow-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-arrow-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-arrow-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-arrow-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-arrow-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-arrow-down.svg"
        }
      ],
      "tags": [
        "descending",
        "list",
        "order",
        "organize",
        "sort",
        "task",
        "todo"
      ]
    },
    "list/list-arrow-down-minimalistic": {
      "name": "List Arrow Down Minimalistic",
      "slug": "list-arrow-down-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/list-arrow-down-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/list-arrow-down-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/list-arrow-down-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/list-arrow-down-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/list-arrow-down-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/list-arrow-down-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/list-arrow-down-minimalistic.svg"
        }
      ],
      "tags": [
        "descending",
        "list",
        "minimal",
        "order",
        "organize",
        "sort",
        "task",
        "todo"
      ]
    },
    "list/playlist": {
      "name": "Playlist",
      "slug": "playlist",
      "category": "list",
      "categoryName": "List",
      "id": "list/playlist",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/playlist.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/playlist.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/playlist.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/playlist.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/playlist.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/playlist.svg"
        }
      ],
      "tags": [
        "list",
        "music",
        "order",
        "organize",
        "queue",
        "songs",
        "task",
        "todo",
        "tracklist"
      ]
    },
    "list/bill": {
      "name": "Bill",
      "slug": "bill",
      "category": "list",
      "categoryName": "List",
      "id": "list/bill",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/bill.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/bill.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/bill.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/bill.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/bill.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/bill.svg"
        }
      ],
      "tags": [
        "charge",
        "invoice",
        "list",
        "order",
        "organize",
        "receipt",
        "statement",
        "task",
        "todo"
      ]
    },
    "list/checklist-minimalistic": {
      "name": "Checklist Minimalistic",
      "slug": "checklist-minimalistic",
      "category": "list",
      "categoryName": "List",
      "id": "list/checklist-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/checklist-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/checklist-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/checklist-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/checklist-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/checklist-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/checklist-minimalistic.svg"
        }
      ],
      "tags": [
        "list",
        "minimal",
        "order",
        "organize",
        "task",
        "tasks",
        "tick",
        "todo"
      ]
    },
    "list/checklist": {
      "name": "Checklist",
      "slug": "checklist",
      "category": "list",
      "categoryName": "List",
      "id": "list/checklist",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/list/checklist.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/list/checklist.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/list/checklist.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/list/checklist.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/list/checklist.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/list/checklist.svg"
        }
      ],
      "tags": [
        "checkbox",
        "complete",
        "done",
        "list",
        "order",
        "organize",
        "task",
        "tasks",
        "tick",
        "todo"
      ]
    },
    "essentional-ui/check-circle": {
      "name": "Check Circle",
      "slug": "check-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/check-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/check-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/check-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/check-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/check-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/check-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/check-circle.svg"
        }
      ],
      "tags": [
        "approved",
        "complete",
        "confirm",
        "core",
        "done",
        "essential",
        "interface",
        "success",
        "tick",
        "ui",
        "yes"
      ]
    },
    "essentional-ui/close-circle": {
      "name": "Close Circle",
      "slug": "close-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/close-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/close-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/close-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/close-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/close-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/close-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/close-circle.svg"
        }
      ],
      "tags": [
        "cancel",
        "core",
        "cross",
        "delete",
        "dismiss",
        "essential",
        "interface",
        "remove",
        "ui",
        "x"
      ]
    },
    "essentional-ui/add-circle": {
      "name": "Add Circle",
      "slug": "add-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/add-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/add-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/add-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/add-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/add-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/add-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/add-circle.svg"
        }
      ],
      "tags": [
        "circle",
        "core",
        "create",
        "essential",
        "insert",
        "interface",
        "new",
        "plus",
        "ui"
      ]
    },
    "essentional-ui/question-circle": {
      "name": "Question Circle",
      "slug": "question-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/question-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/question-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/question-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/question-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/question-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/question-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/question-circle.svg"
        }
      ],
      "tags": [
        "?",
        "FAQ",
        "core",
        "essential",
        "help",
        "interface",
        "support",
        "ui",
        "unknown"
      ]
    },
    "essentional-ui/danger-circle": {
      "name": "Danger Circle",
      "slug": "danger-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/danger-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/danger-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/danger-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/danger-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/danger-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/danger-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/danger-circle.svg"
        }
      ],
      "tags": [
        "alert",
        "caution",
        "circle",
        "core",
        "error",
        "essential",
        "interface",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/info-circle": {
      "name": "Info Circle",
      "slug": "info-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/info-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/info-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/info-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/info-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/info-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/info-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/info-circle.svg"
        }
      ],
      "tags": [
        "about",
        "core",
        "details",
        "essential",
        "help",
        "i",
        "information",
        "interface",
        "ui"
      ]
    },
    "essentional-ui/minus-circle": {
      "name": "Minus Circle",
      "slug": "minus-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/minus-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/minus-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/minus-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/minus-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/minus-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/minus-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/minus-circle.svg"
        }
      ],
      "tags": [
        "core",
        "decrease",
        "delete",
        "essential",
        "interface",
        "less",
        "remove",
        "subtract",
        "ui"
      ]
    },
    "essentional-ui/forbidden-circle": {
      "name": "Forbidden Circle",
      "slug": "forbidden-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/forbidden-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/forbidden-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/forbidden-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/forbidden-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/forbidden-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/forbidden-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/forbidden-circle.svg"
        }
      ],
      "tags": [
        "banned",
        "blocked",
        "core",
        "essential",
        "interface",
        "prohibited",
        "restricted",
        "ui"
      ]
    },
    "essentional-ui/forbidden": {
      "name": "Forbidden",
      "slug": "forbidden",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/forbidden",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/forbidden.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/forbidden.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/forbidden.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/forbidden.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/forbidden.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/forbidden.svg"
        }
      ],
      "tags": [
        "banned",
        "blocked",
        "core",
        "essential",
        "interface",
        "not-allowed",
        "prohibited",
        "restricted",
        "ui"
      ]
    },
    "essentional-ui/danger": {
      "name": "Danger",
      "slug": "danger",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/danger",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/danger.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/danger.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/danger.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/danger.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/danger.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/danger.svg"
        }
      ],
      "tags": [
        "alert",
        "caution",
        "core",
        "error",
        "essential",
        "hazard",
        "interface",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/danger-triangle": {
      "name": "Danger Triangle",
      "slug": "danger-triangle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/danger-triangle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/danger-triangle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/danger-triangle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/danger-triangle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/danger-triangle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/danger-triangle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/danger-triangle.svg"
        }
      ],
      "tags": [
        "alert",
        "caution",
        "core",
        "essential",
        "exclamation",
        "hazard",
        "interface",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/check-square": {
      "name": "Check Square",
      "slug": "check-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/check-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/check-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/check-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/check-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/check-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/check-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/check-square.svg"
        }
      ],
      "tags": [
        "checkbox",
        "complete",
        "core",
        "done",
        "essential",
        "interface",
        "success",
        "tick",
        "ui"
      ]
    },
    "essentional-ui/close-square": {
      "name": "Close Square",
      "slug": "close-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/close-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/close-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/close-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/close-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/close-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/close-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/close-square.svg"
        }
      ],
      "tags": [
        "cancel",
        "core",
        "cross",
        "delete",
        "essential",
        "interface",
        "remove",
        "ui",
        "x"
      ]
    },
    "essentional-ui/add-square": {
      "name": "Add Square",
      "slug": "add-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/add-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/add-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/add-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/add-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/add-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/add-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/add-square.svg"
        }
      ],
      "tags": [
        "core",
        "create",
        "essential",
        "insert",
        "interface",
        "new",
        "plus",
        "square",
        "ui"
      ]
    },
    "essentional-ui/question-square": {
      "name": "Question Square",
      "slug": "question-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/question-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/question-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/question-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/question-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/question-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/question-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/question-square.svg"
        }
      ],
      "tags": [
        "?",
        "FAQ",
        "core",
        "essential",
        "help",
        "interface",
        "ui",
        "unknown"
      ]
    },
    "essentional-ui/danger-square": {
      "name": "Danger Square",
      "slug": "danger-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/danger-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/danger-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/danger-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/danger-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/danger-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/danger-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/danger-square.svg"
        }
      ],
      "tags": [
        "alert",
        "caution",
        "core",
        "error",
        "essential",
        "interface",
        "square",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/info-square": {
      "name": "Info Square",
      "slug": "info-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/info-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/info-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/info-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/info-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/info-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/info-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/info-square.svg"
        }
      ],
      "tags": [
        "about",
        "core",
        "details",
        "essential",
        "help",
        "information",
        "interface",
        "ui"
      ]
    },
    "essentional-ui/minus-square": {
      "name": "Minus Square",
      "slug": "minus-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/minus-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/minus-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/minus-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/minus-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/minus-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/minus-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/minus-square.svg"
        }
      ],
      "tags": [
        "core",
        "decrease",
        "essential",
        "interface",
        "less",
        "remove",
        "subtract",
        "ui"
      ]
    },
    "essentional-ui/revote": {
      "name": "Revote",
      "slug": "revote",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/revote",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/revote.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/revote.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/revote.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/revote.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/revote.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/revote.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "poll",
        "redo",
        "retry",
        "ui",
        "vote-again"
      ]
    },
    "essentional-ui/menu-dots-circle": {
      "name": "Menu Dots Circle",
      "slug": "menu-dots-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/menu-dots-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/menu-dots-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/menu-dots-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/menu-dots-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/menu-dots-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/menu-dots-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/menu-dots-circle.svg"
        }
      ],
      "tags": [
        "core",
        "ellipsis",
        "essential",
        "interface",
        "more",
        "options",
        "ui"
      ]
    },
    "essentional-ui/menu-dots-square": {
      "name": "Menu Dots Square",
      "slug": "menu-dots-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/menu-dots-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/menu-dots-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/menu-dots-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/menu-dots-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/menu-dots-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/menu-dots-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/menu-dots-square.svg"
        }
      ],
      "tags": [
        "core",
        "ellipsis",
        "essential",
        "interface",
        "more",
        "options",
        "ui"
      ]
    },
    "essentional-ui/menu-dots": {
      "name": "Menu Dots",
      "slug": "menu-dots",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/menu-dots",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/menu-dots.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/menu-dots.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/menu-dots.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/menu-dots.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/menu-dots.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/menu-dots.svg"
        }
      ],
      "tags": [
        "core",
        "ellipsis",
        "essential",
        "interface",
        "kebab",
        "more",
        "options",
        "overflow",
        "three-dots",
        "ui"
      ]
    },
    "essentional-ui/home": {
      "name": "Home",
      "slug": "home",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "homepage",
        "house",
        "interface",
        "main",
        "residence",
        "start",
        "ui"
      ]
    },
    "essentional-ui/home-2": {
      "name": "Home 2",
      "slug": "home-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-2.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "homepage",
        "house",
        "interface",
        "main",
        "ui"
      ]
    },
    "essentional-ui/home-smile": {
      "name": "Home Smile",
      "slug": "home-smile",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-smile",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-smile.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-smile.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-smile.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-smile.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-smile.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-smile.svg"
        }
      ],
      "tags": [
        "core",
        "cozy",
        "essential",
        "happy",
        "house",
        "interface",
        "ui",
        "welcome"
      ]
    },
    "essentional-ui/home-add": {
      "name": "Home Add",
      "slug": "home-add",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-add.svg"
        }
      ],
      "tags": [
        "build",
        "core",
        "create",
        "essential",
        "house",
        "interface",
        "new-home",
        "ui"
      ]
    },
    "essentional-ui/home-wifi": {
      "name": "Home WiFi",
      "slug": "home-wifi",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-wifi",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-wifi.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-wifi.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-wifi.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-wifi.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-wifi.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-wifi.svg"
        }
      ],
      "tags": [
        "IoT",
        "connected",
        "core",
        "essential",
        "interface",
        "smart-home",
        "ui",
        "wireless"
      ]
    },
    "essentional-ui/smart-home": {
      "name": "Smart Home",
      "slug": "smart-home",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/smart-home",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/smart-home.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/smart-home.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/smart-home.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/smart-home.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/smart-home.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/smart-home.svg"
        }
      ],
      "tags": [
        "IoT",
        "automation",
        "connected",
        "core",
        "domotics",
        "essential",
        "interface",
        "ui"
      ]
    },
    "essentional-ui/home-angle": {
      "name": "Home Angle",
      "slug": "home-angle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-angle.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "house",
        "interface",
        "modern",
        "roof",
        "ui"
      ]
    },
    "essentional-ui/home-angle-2": {
      "name": "Home Angle 2",
      "slug": "home-angle-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-angle-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-angle-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-angle-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-angle-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-angle-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-angle-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-angle-2.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "house",
        "interface",
        "modern",
        "roof",
        "ui"
      ]
    },
    "essentional-ui/home-smile-angle": {
      "name": "Home Smile Angle",
      "slug": "home-smile-angle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-smile-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-smile-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-smile-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-smile-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-smile-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-smile-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-smile-angle.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "happy",
        "house",
        "interface",
        "ui",
        "welcome"
      ]
    },
    "essentional-ui/home-add-angle": {
      "name": "Home Add Angle",
      "slug": "home-add-angle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-add-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-add-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-add-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-add-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-add-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-add-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-add-angle.svg"
        }
      ],
      "tags": [
        "core",
        "create",
        "essential",
        "house",
        "interface",
        "new-home",
        "ui"
      ]
    },
    "essentional-ui/home-wifi-angle": {
      "name": "Home WiFi Angle",
      "slug": "home-wifi-angle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/home-wifi-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/home-wifi-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/home-wifi-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/home-wifi-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/home-wifi-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/home-wifi-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/home-wifi-angle.svg"
        }
      ],
      "tags": [
        "IoT",
        "connected",
        "core",
        "essential",
        "interface",
        "smart-home",
        "ui"
      ]
    },
    "essentional-ui/smart-home-angle": {
      "name": "Smart Home Angle",
      "slug": "smart-home-angle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/smart-home-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/smart-home-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/smart-home-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/smart-home-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/smart-home-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/smart-home-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/smart-home-angle.svg"
        }
      ],
      "tags": [
        "IoT",
        "automation",
        "connected",
        "core",
        "essential",
        "interface",
        "ui"
      ]
    },
    "essentional-ui/battery-full-minimalistic": {
      "name": "Battery Full Minimalistic",
      "slug": "battery-full-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-full-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-full-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-full-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-full-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-full-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-full-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-full-minimalistic.svg"
        }
      ],
      "tags": [
        "charged",
        "core",
        "essential",
        "interface",
        "minimal",
        "power",
        "ui"
      ]
    },
    "essentional-ui/battery-half-minimalistic": {
      "name": "Battery Half Minimalistic",
      "slug": "battery-half-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-half-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-half-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-half-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-half-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-half-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-half-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-half-minimalistic.svg"
        }
      ],
      "tags": [
        "50%",
        "core",
        "essential",
        "interface",
        "minimal",
        "power",
        "ui"
      ]
    },
    "essentional-ui/battery-low-minimalistic": {
      "name": "Battery Low Minimalistic",
      "slug": "battery-low-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-low-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-low-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-low-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-low-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-low-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-low-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-low-minimalistic.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "low",
        "minimal",
        "power",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/battery-charge-minimalistic": {
      "name": "Battery Charge Minimalistic",
      "slug": "battery-charge-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-charge-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-charge-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-charge-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-charge-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-charge-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-charge-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-charge-minimalistic.svg"
        }
      ],
      "tags": [
        "charging",
        "core",
        "energy",
        "essential",
        "interface",
        "minimal",
        "power",
        "ui"
      ]
    },
    "essentional-ui/battery-full": {
      "name": "Battery Full",
      "slug": "battery-full",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-full",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-full.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-full.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-full.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-full.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-full.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-full.svg"
        }
      ],
      "tags": [
        "100%",
        "charged",
        "complete",
        "core",
        "essential",
        "interface",
        "power",
        "ui"
      ]
    },
    "essentional-ui/battery-half": {
      "name": "Battery Half",
      "slug": "battery-half",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-half",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-half.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-half.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-half.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-half.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-half.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-half.svg"
        }
      ],
      "tags": [
        "50%",
        "core",
        "essential",
        "interface",
        "mid-charge",
        "power",
        "ui"
      ]
    },
    "essentional-ui/battery-low": {
      "name": "Battery Low",
      "slug": "battery-low",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-low",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-low.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-low.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-low.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-low.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-low.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-low.svg"
        }
      ],
      "tags": [
        "core",
        "dying",
        "essential",
        "interface",
        "low",
        "power",
        "ui",
        "warning"
      ]
    },
    "essentional-ui/battery-charge": {
      "name": "Battery Charge",
      "slug": "battery-charge",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/battery-charge",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/battery-charge.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/battery-charge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/battery-charge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/battery-charge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/battery-charge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/battery-charge.svg"
        }
      ],
      "tags": [
        "charging",
        "core",
        "electric",
        "energy",
        "essential",
        "interface",
        "power",
        "ui"
      ]
    },
    "essentional-ui/slider-vertical": {
      "name": "Slider Vertical",
      "slug": "slider-vertical",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/slider-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/slider-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/slider-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/slider-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/slider-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/slider-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/slider-vertical.svg"
        }
      ],
      "tags": [
        "adjust",
        "control",
        "core",
        "essential",
        "interface",
        "range",
        "ui",
        "vertical"
      ]
    },
    "essentional-ui/slider-vertical-minimalistic": {
      "name": "Slider Vertical Minimalistic",
      "slug": "slider-vertical-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/slider-vertical-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/slider-vertical-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/slider-vertical-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/slider-vertical-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/slider-vertical-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/slider-vertical-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/slider-vertical-minimalistic.svg"
        }
      ],
      "tags": [
        "adjust",
        "control",
        "core",
        "essential",
        "interface",
        "minimal",
        "range",
        "ui"
      ]
    },
    "essentional-ui/slider-horizontal": {
      "name": "Slider Horizontal",
      "slug": "slider-horizontal",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/slider-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/slider-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/slider-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/slider-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/slider-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/slider-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/slider-horizontal.svg"
        }
      ],
      "tags": [
        "adjust",
        "control",
        "core",
        "essential",
        "input",
        "interface",
        "range",
        "scrub",
        "ui"
      ]
    },
    "essentional-ui/slider-minimalistic-horizontal": {
      "name": "Slider Minimalistic Horizontal",
      "slug": "slider-minimalistic-horizontal",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/slider-minimalistic-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/slider-minimalistic-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/slider-minimalistic-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/slider-minimalistic-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/slider-minimalistic-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/slider-minimalistic-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/slider-minimalistic-horizontal.svg"
        }
      ],
      "tags": [
        "adjust",
        "control",
        "core",
        "essential",
        "interface",
        "minimal",
        "range",
        "ui"
      ]
    },
    "essentional-ui/database": {
      "name": "Database",
      "slug": "database",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/database",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/database.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/database.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/database.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/database.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/database.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/database.svg"
        }
      ],
      "tags": [
        "SQL",
        "backend",
        "core",
        "data",
        "essential",
        "interface",
        "server",
        "storage",
        "table",
        "ui"
      ]
    },
    "essentional-ui/traffic-economy": {
      "name": "Traffic Economy",
      "slug": "traffic-economy",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/traffic-economy",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/traffic-economy.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/traffic-economy.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/traffic-economy.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/traffic-economy.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/traffic-economy.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/traffic-economy.svg"
        }
      ],
      "tags": [
        "core",
        "efficient",
        "essential",
        "go",
        "green",
        "interface",
        "signal",
        "ui"
      ]
    },
    "essentional-ui/traffic": {
      "name": "Traffic",
      "slug": "traffic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/traffic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/traffic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/traffic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/traffic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/traffic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/traffic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/traffic.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "road",
        "signal",
        "stop-go",
        "stoplight",
        "ui"
      ]
    },
    "essentional-ui/crown-minimalistic": {
      "name": "Crown Minimalistic",
      "slug": "crown-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/crown-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/crown-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/crown-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/crown-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/crown-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/crown-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/crown-minimalistic.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "king",
        "minimal",
        "premium",
        "queen",
        "royal",
        "ui"
      ]
    },
    "essentional-ui/crown-star": {
      "name": "Crown Star",
      "slug": "crown-star",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/crown-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/crown-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/crown-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/crown-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/crown-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/crown-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/crown-star.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "featured",
        "interface",
        "king",
        "premium",
        "queen",
        "royal",
        "ui"
      ]
    },
    "essentional-ui/crown-line": {
      "name": "Crown Line",
      "slug": "crown-line",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/crown-line",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/crown-line.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/crown-line.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/crown-line.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/crown-line.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/crown-line.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/crown-line.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "king",
        "premium",
        "queen",
        "royal",
        "ui"
      ]
    },
    "essentional-ui/crown": {
      "name": "Crown",
      "slug": "crown",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/crown",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/crown.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/crown.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/crown.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/crown.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/crown.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/crown.svg"
        }
      ],
      "tags": [
        "VIP",
        "core",
        "essential",
        "interface",
        "king",
        "leader",
        "premium",
        "queen",
        "royal",
        "ui"
      ]
    },
    "essentional-ui/pin": {
      "name": "Pin",
      "slug": "pin",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/pin",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/pin.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/pin.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/pin.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/pin.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/pin.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/pin.svg"
        }
      ],
      "tags": [
        "attach",
        "core",
        "essential",
        "interface",
        "location",
        "mark",
        "pushpin",
        "save",
        "thumbtack",
        "ui"
      ]
    },
    "essentional-ui/pin-list": {
      "name": "Pin List",
      "slug": "pin-list",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/pin-list",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/pin-list.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/pin-list.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/pin-list.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/pin-list.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/pin-list.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/pin-list.svg"
        }
      ],
      "tags": [
        "attached",
        "bookmarked",
        "core",
        "essential",
        "interface",
        "pinned",
        "saved",
        "ui"
      ]
    },
    "essentional-ui/pin-circle": {
      "name": "Pin Circle",
      "slug": "pin-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/pin-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/pin-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/pin-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/pin-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/pin-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/pin-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/pin-circle.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "location",
        "mark",
        "thumbtack",
        "ui"
      ]
    },
    "essentional-ui/trash-bin-minimalistic": {
      "name": "Trash Bin Minimalistic",
      "slug": "trash-bin-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/trash-bin-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/trash-bin-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/trash-bin-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/trash-bin-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/trash-bin-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/trash-bin-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/trash-bin-minimalistic.svg"
        }
      ],
      "tags": [
        "bin",
        "core",
        "delete",
        "essential",
        "interface",
        "minimal",
        "remove",
        "rubbish",
        "ui"
      ]
    },
    "essentional-ui/trash-bin-trash": {
      "name": "Trash Bin Trash",
      "slug": "trash-bin-trash",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/trash-bin-trash",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/trash-bin-trash.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/trash-bin-trash.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/trash-bin-trash.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/trash-bin-trash.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/trash-bin-trash.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/trash-bin-trash.svg"
        }
      ],
      "tags": [
        "core",
        "delete",
        "essential",
        "interface",
        "remove",
        "rubbish",
        "ui",
        "waste"
      ]
    },
    "essentional-ui/trash-bin-minimalistic-2": {
      "name": "Trash Bin Minimalistic 2",
      "slug": "trash-bin-minimalistic-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/trash-bin-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/trash-bin-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/trash-bin-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/trash-bin-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/trash-bin-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/trash-bin-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/trash-bin-minimalistic-2.svg"
        }
      ],
      "tags": [
        "core",
        "delete",
        "essential",
        "interface",
        "minimal",
        "remove",
        "rubbish",
        "ui"
      ]
    },
    "essentional-ui/trash-bin-2": {
      "name": "Trash Bin 2",
      "slug": "trash-bin-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/trash-bin-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/trash-bin-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/trash-bin-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/trash-bin-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/trash-bin-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/trash-bin-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/trash-bin-2.svg"
        }
      ],
      "tags": [
        "bin",
        "core",
        "delete",
        "essential",
        "interface",
        "remove",
        "rubbish",
        "ui",
        "waste"
      ]
    },
    "essentional-ui/share": {
      "name": "Share",
      "slug": "share",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/share",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/share.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/share.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/share.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/share.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/share.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/share.svg"
        }
      ],
      "tags": [
        "core",
        "distribute",
        "essential",
        "forward",
        "interface",
        "post",
        "send",
        "social",
        "ui"
      ]
    },
    "essentional-ui/share-circle": {
      "name": "Share Circle",
      "slug": "share-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/share-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/share-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/share-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/share-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/share-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/share-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/share-circle.svg"
        }
      ],
      "tags": [
        "core",
        "distribute",
        "essential",
        "forward",
        "interface",
        "send",
        "social",
        "ui"
      ]
    },
    "essentional-ui/target": {
      "name": "Target",
      "slug": "target",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/target",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/target.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/target.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/target.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/target.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/target.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/target.svg"
        }
      ],
      "tags": [
        "aim",
        "bullseye",
        "core",
        "crosshair",
        "essential",
        "focus",
        "goal",
        "interface",
        "objective",
        "ui"
      ]
    },
    "essentional-ui/waterdrop": {
      "name": "Waterdrop",
      "slug": "waterdrop",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/waterdrop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/waterdrop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/waterdrop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/waterdrop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/waterdrop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/waterdrop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/waterdrop.svg"
        }
      ],
      "tags": [
        "core",
        "droplet",
        "essential",
        "hydration",
        "interface",
        "liquid",
        "rain",
        "ui",
        "water"
      ]
    },
    "essentional-ui/plate": {
      "name": "Plate",
      "slug": "plate",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/plate",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/plate.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/plate.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/plate.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/plate.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/plate.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/plate.svg"
        }
      ],
      "tags": [
        "core",
        "dining",
        "dish",
        "essential",
        "food",
        "interface",
        "meal",
        "restaurant",
        "ui"
      ]
    },
    "essentional-ui/broom": {
      "name": "Broom",
      "slug": "broom",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/broom",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/broom.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/broom.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/broom.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/broom.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/broom.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/broom.svg"
        }
      ],
      "tags": [
        "clean",
        "clear",
        "core",
        "essential",
        "interface",
        "maintenance",
        "sweep",
        "tidy",
        "ui"
      ]
    },
    "essentional-ui/copy": {
      "name": "Copy",
      "slug": "copy",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/copy",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/copy.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/copy.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/copy.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/copy.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/copy.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/copy.svg"
        }
      ],
      "tags": [
        "clipboard",
        "clone",
        "core",
        "duplicate",
        "essential",
        "interface",
        "paste",
        "ui"
      ]
    },
    "essentional-ui/subtitles": {
      "name": "Subtitles",
      "slug": "subtitles",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/subtitles",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/subtitles.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/subtitles.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/subtitles.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/subtitles.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/subtitles.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/subtitles.svg"
        }
      ],
      "tags": [
        "CC",
        "accessibility",
        "captions",
        "core",
        "essential",
        "interface",
        "subs",
        "text",
        "ui"
      ]
    },
    "essentional-ui/cat": {
      "name": "Cat",
      "slug": "cat",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cat",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cat.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cat.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cat.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cat.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cat.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cat.svg"
        }
      ],
      "tags": [
        "animal",
        "core",
        "essential",
        "feline",
        "interface",
        "kitten",
        "pet",
        "ui"
      ]
    },
    "essentional-ui/umbrella": {
      "name": "Umbrella",
      "slug": "umbrella",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/umbrella",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/umbrella.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/umbrella.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/umbrella.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/umbrella.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/umbrella.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/umbrella.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "parasol",
        "protection",
        "rain",
        "shelter",
        "ui",
        "weather"
      ]
    },
    "essentional-ui/ghost": {
      "name": "Ghost",
      "slug": "ghost",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/ghost",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/ghost.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/ghost.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/ghost.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/ghost.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/ghost.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/ghost.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "halloween",
        "hidden",
        "interface",
        "phantom",
        "spirit",
        "spooky",
        "ui"
      ]
    },
    "essentional-ui/ghost-smile": {
      "name": "Ghost Smile",
      "slug": "ghost-smile",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/ghost-smile",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/ghost-smile.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/ghost-smile.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/ghost-smile.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/ghost-smile.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/ghost-smile.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/ghost-smile.svg"
        }
      ],
      "tags": [
        "core",
        "cute",
        "essential",
        "friendly",
        "halloween",
        "interface",
        "spooky",
        "ui"
      ]
    },
    "essentional-ui/posts-carousel-vertical": {
      "name": "Posts Carousel Vertical",
      "slug": "posts-carousel-vertical",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/posts-carousel-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/posts-carousel-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/posts-carousel-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/posts-carousel-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/posts-carousel-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/posts-carousel-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/posts-carousel-vertical.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "feed",
        "interface",
        "scroll",
        "slider",
        "stories",
        "ui"
      ]
    },
    "essentional-ui/posts-carousel-horizontal": {
      "name": "Posts Carousel Horizontal",
      "slug": "posts-carousel-horizontal",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/posts-carousel-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/posts-carousel-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/posts-carousel-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/posts-carousel-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/posts-carousel-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/posts-carousel-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/posts-carousel-horizontal.svg"
        }
      ],
      "tags": [
        "cards",
        "core",
        "essential",
        "gallery",
        "interface",
        "slider",
        "stories",
        "swipe",
        "ui"
      ]
    },
    "essentional-ui/bolt": {
      "name": "Bolt",
      "slug": "bolt",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/bolt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/bolt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/bolt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/bolt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/bolt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/bolt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/bolt.svg"
        }
      ],
      "tags": [
        "core",
        "electric",
        "energy",
        "essential",
        "fast",
        "flash",
        "interface",
        "lightning",
        "power",
        "speed",
        "ui"
      ]
    },
    "essentional-ui/bolt-circle": {
      "name": "Bolt Circle",
      "slug": "bolt-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/bolt-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/bolt-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/bolt-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/bolt-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/bolt-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/bolt-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/bolt-circle.svg"
        }
      ],
      "tags": [
        "circle",
        "core",
        "energy",
        "essential",
        "flash",
        "interface",
        "lightning",
        "power",
        "ui"
      ]
    },
    "essentional-ui/power": {
      "name": "Power",
      "slug": "power",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/power",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/power.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/power.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/power.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/power.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/power.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/power.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "interface",
        "on-off",
        "shutdown",
        "standby",
        "switch",
        "toggle",
        "ui"
      ]
    },
    "essentional-ui/fuel": {
      "name": "Fuel",
      "slug": "fuel",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/fuel",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/fuel.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/fuel.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/fuel.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/fuel.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/fuel.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/fuel.svg"
        }
      ],
      "tags": [
        "core",
        "diesel",
        "energy",
        "essential",
        "gas",
        "interface",
        "petrol",
        "station",
        "ui"
      ]
    },
    "essentional-ui/figma": {
      "name": "Figma",
      "slug": "figma",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/figma",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/figma.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/figma.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/figma.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/figma.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/figma.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/figma.svg"
        }
      ],
      "tags": [
        "UI",
        "core",
        "design",
        "essential",
        "interface",
        "prototype",
        "software",
        "tool",
        "ui"
      ]
    },
    "essentional-ui/winrar": {
      "name": "WinRar",
      "slug": "winrar",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/winrar",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/winrar.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/winrar.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/winrar.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/winrar.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/winrar.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/winrar.svg"
        }
      ],
      "tags": [
        "archive",
        "compress",
        "core",
        "essential",
        "extract",
        "file",
        "interface",
        "ui",
        "zip"
      ]
    },
    "essentional-ui/help": {
      "name": "Help",
      "slug": "help",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/help",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/help.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/help.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/help.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/help.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/help.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/help.svg"
        }
      ],
      "tags": [
        "FAQ",
        "assistance",
        "core",
        "essential",
        "guide",
        "interface",
        "question",
        "support",
        "ui"
      ]
    },
    "essentional-ui/flag": {
      "name": "Flag",
      "slug": "flag",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/flag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/flag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/flag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/flag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/flag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/flag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/flag.svg"
        }
      ],
      "tags": [
        "bookmark",
        "core",
        "country",
        "essential",
        "interface",
        "mark",
        "milestone",
        "report",
        "ui"
      ]
    },
    "essentional-ui/flag-2": {
      "name": "Flag 2",
      "slug": "flag-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/flag-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/flag-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/flag-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/flag-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/flag-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/flag-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/flag-2.svg"
        }
      ],
      "tags": [
        "core",
        "country",
        "essential",
        "interface",
        "mark",
        "milestone",
        "report",
        "ui"
      ]
    },
    "essentional-ui/balloon": {
      "name": "Balloon",
      "slug": "balloon",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/balloon",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/balloon.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/balloon.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/balloon.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/balloon.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/balloon.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/balloon.svg"
        }
      ],
      "tags": [
        "birthday",
        "celebration",
        "core",
        "essential",
        "festive",
        "fun",
        "interface",
        "party",
        "ui"
      ]
    },
    "essentional-ui/paw": {
      "name": "Paw",
      "slug": "paw",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/paw",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/paw.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/paw.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/paw.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/paw.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/paw.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/paw.svg"
        }
      ],
      "tags": [
        "animal",
        "cat",
        "core",
        "dog",
        "essential",
        "footprint",
        "interface",
        "pet",
        "track",
        "ui"
      ]
    },
    "essentional-ui/cup": {
      "name": "Cup",
      "slug": "cup",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cup",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cup.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cup.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cup.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cup.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cup.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cup.svg"
        }
      ],
      "tags": [
        "beverage",
        "coffee",
        "core",
        "drink",
        "essential",
        "interface",
        "mug",
        "tea",
        "ui"
      ]
    },
    "essentional-ui/cup-star": {
      "name": "Cup Star",
      "slug": "cup-star",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cup-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cup-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cup-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cup-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cup-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cup-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cup-star.svg"
        }
      ],
      "tags": [
        "champion",
        "core",
        "essential",
        "featured",
        "interface",
        "trophy",
        "ui",
        "winner"
      ]
    },
    "essentional-ui/cup-first": {
      "name": "Cup First",
      "slug": "cup-first",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cup-first",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cup-first.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cup-first.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cup-first.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cup-first.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cup-first.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cup-first.svg"
        }
      ],
      "tags": [
        "1st",
        "champion",
        "core",
        "essential",
        "gold",
        "interface",
        "trophy",
        "ui",
        "winner"
      ]
    },
    "essentional-ui/cup-music": {
      "name": "Cup Music",
      "slug": "cup-music",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cup-music",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cup-music.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cup-music.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cup-music.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cup-music.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cup-music.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cup-music.svg"
        }
      ],
      "tags": [
        "Grammy",
        "award",
        "core",
        "essential",
        "interface",
        "music",
        "trophy",
        "ui"
      ]
    },
    "essentional-ui/special-effects": {
      "name": "Special Effects",
      "slug": "special-effects",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/special-effects",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/special-effects.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/special-effects.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/special-effects.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/special-effects.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/special-effects.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/special-effects.svg"
        }
      ],
      "tags": [
        "FX",
        "core",
        "enhance",
        "essential",
        "interface",
        "magic",
        "shine",
        "sparkle",
        "ui"
      ]
    },
    "essentional-ui/xxx": {
      "name": "XXX",
      "slug": "xxx",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/xxx",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/xxx.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/xxx.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/xxx.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/xxx.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/xxx.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/xxx.svg"
        }
      ],
      "tags": [
        "adult",
        "blocked",
        "core",
        "essential",
        "interface",
        "mature",
        "restricted",
        "ui"
      ]
    },
    "essentional-ui/explicit": {
      "name": "Explicit",
      "slug": "explicit",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/explicit",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/explicit.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/explicit.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/explicit.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/explicit.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/explicit.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/explicit.svg"
        }
      ],
      "tags": [
        "18+",
        "NSFW",
        "adult",
        "content-warning",
        "core",
        "essential",
        "interface",
        "mature",
        "ui"
      ]
    },
    "essentional-ui/high-quality": {
      "name": "High Quality",
      "slug": "high-quality",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/high-quality",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/high-quality.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/high-quality.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/high-quality.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/high-quality.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/high-quality.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/high-quality.svg"
        }
      ],
      "tags": [
        "HQ",
        "core",
        "crisp",
        "essential",
        "interface",
        "premium",
        "resolution",
        "ui"
      ]
    },
    "essentional-ui/high-definition": {
      "name": "High Definition",
      "slug": "high-definition",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/high-definition",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/high-definition.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/high-definition.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/high-definition.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/high-definition.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/high-definition.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/high-definition.svg"
        }
      ],
      "tags": [
        "HD",
        "core",
        "essential",
        "interface",
        "quality",
        "resolution",
        "ui",
        "video"
      ]
    },
    "essentional-ui/4k": {
      "name": "4K",
      "slug": "4k",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/4k",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/4k.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/4k.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/4k.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/4k.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/4k.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/4k.svg"
        }
      ],
      "tags": [
        "HD",
        "core",
        "display",
        "essential",
        "interface",
        "quality",
        "resolution",
        "ui",
        "ultra",
        "video"
      ]
    },
    "essentional-ui/creative-commons": {
      "name": "Creative Commons",
      "slug": "creative-commons",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/creative-commons",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/creative-commons.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/creative-commons.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/creative-commons.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/creative-commons.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/creative-commons.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/creative-commons.svg"
        }
      ],
      "tags": [
        "CC",
        "core",
        "essential",
        "free",
        "interface",
        "license",
        "open-source",
        "ui"
      ]
    },
    "essentional-ui/copyright": {
      "name": "Copyright",
      "slug": "copyright",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/copyright",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/copyright.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/copyright.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/copyright.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/copyright.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/copyright.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/copyright.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "intellectual-property",
        "interface",
        "legal",
        "rights",
        "ui",
        "\u00a9"
      ]
    },
    "essentional-ui/augmented-reality": {
      "name": "Augmented Reality",
      "slug": "augmented-reality",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/augmented-reality",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/augmented-reality.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/augmented-reality.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/augmented-reality.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/augmented-reality.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/augmented-reality.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/augmented-reality.svg"
        }
      ],
      "tags": [
        "3D",
        "AR",
        "core",
        "essential",
        "immersive",
        "interface",
        "mixed-reality",
        "ui",
        "virtual"
      ]
    },
    "essentional-ui/hamburger-menu": {
      "name": "Hamburger Menu",
      "slug": "hamburger-menu",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/hamburger-menu",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/hamburger-menu.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/hamburger-menu.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/hamburger-menu.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/hamburger-menu.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/hamburger-menu.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/hamburger-menu.svg"
        }
      ],
      "tags": [
        "burger",
        "core",
        "essential",
        "interface",
        "menu",
        "nav",
        "navigation",
        "sidebar",
        "three-lines",
        "ui"
      ]
    },
    "essentional-ui/reorder": {
      "name": "Reorder",
      "slug": "reorder",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/reorder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/reorder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/reorder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/reorder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/reorder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/reorder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/reorder.svg"
        }
      ],
      "tags": [
        "core",
        "drag",
        "essential",
        "interface",
        "organize",
        "rearrange",
        "sort",
        "ui"
      ]
    },
    "essentional-ui/sort": {
      "name": "Sort",
      "slug": "sort",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/sort",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/sort.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/sort.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/sort.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/sort.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/sort.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/sort.svg"
        }
      ],
      "tags": [
        "A-Z",
        "arrange",
        "core",
        "essential",
        "filter",
        "interface",
        "order",
        "organize",
        "ui"
      ]
    },
    "essentional-ui/filter": {
      "name": "Filter",
      "slug": "filter",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/filter",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/filter.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/filter.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/filter.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/filter.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/filter.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/filter.svg"
        }
      ],
      "tags": [
        "core",
        "criteria",
        "essential",
        "funnel",
        "interface",
        "narrow",
        "refine",
        "sort",
        "ui"
      ]
    },
    "essentional-ui/paper-bin": {
      "name": "Paper Bin",
      "slug": "paper-bin",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/paper-bin",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/paper-bin.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/paper-bin.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/paper-bin.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/paper-bin.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/paper-bin.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/paper-bin.svg"
        }
      ],
      "tags": [
        "bin",
        "core",
        "delete",
        "essential",
        "interface",
        "recycle",
        "rubbish",
        "trash",
        "ui",
        "waste"
      ]
    },
    "essentional-ui/glasses": {
      "name": "Glasses",
      "slug": "glasses",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/glasses",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/glasses.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/glasses.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/glasses.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/glasses.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/glasses.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/glasses.svg"
        }
      ],
      "tags": [
        "core",
        "essential",
        "eyewear",
        "interface",
        "nerdy",
        "reading",
        "smart",
        "spectacles",
        "ui",
        "vision"
      ]
    },
    "essentional-ui/scissors": {
      "name": "Scissors",
      "slug": "scissors",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/scissors",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/scissors.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/scissors.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/scissors.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/scissors.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/scissors.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/scissors.svg"
        }
      ],
      "tags": [
        "core",
        "coupon",
        "craft",
        "cut",
        "essential",
        "interface",
        "snip",
        "trim",
        "ui"
      ]
    },
    "essentional-ui/scissors-square": {
      "name": "Scissors Square",
      "slug": "scissors-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/scissors-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/scissors-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/scissors-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/scissors-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/scissors-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/scissors-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/scissors-square.svg"
        }
      ],
      "tags": [
        "core",
        "coupon",
        "cut",
        "essential",
        "interface",
        "snip",
        "trim",
        "ui"
      ]
    },
    "essentional-ui/box-minimalistic": {
      "name": "Box Minimalistic",
      "slug": "box-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/box-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/box-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/box-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/box-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/box-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/box-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/box-minimalistic.svg"
        }
      ],
      "tags": [
        "container",
        "core",
        "essential",
        "interface",
        "minimal",
        "package",
        "parcel",
        "ui"
      ]
    },
    "essentional-ui/box": {
      "name": "Box",
      "slug": "box",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/box",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/box.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/box.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/box.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/box.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/box.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/box.svg"
        }
      ],
      "tags": [
        "container",
        "core",
        "delivery",
        "essential",
        "interface",
        "package",
        "parcel",
        "product",
        "shipping",
        "ui"
      ]
    },
    "essentional-ui/feed": {
      "name": "Feed",
      "slug": "feed",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/feed",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/feed.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/feed.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/feed.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/feed.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/feed.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/feed.svg"
        }
      ],
      "tags": [
        "RSS",
        "content",
        "core",
        "essential",
        "interface",
        "news",
        "stream",
        "timeline",
        "ui"
      ]
    },
    "essentional-ui/ferris-wheel": {
      "name": "Ferris Wheel",
      "slug": "ferris-wheel",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/ferris-wheel",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/ferris-wheel.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/ferris-wheel.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/ferris-wheel.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/ferris-wheel.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/ferris-wheel.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/ferris-wheel.svg"
        }
      ],
      "tags": [
        "amusement",
        "carnival",
        "core",
        "essential",
        "fair",
        "fun",
        "interface",
        "park",
        "ui"
      ]
    },
    "essentional-ui/perfume": {
      "name": "Perfume",
      "slug": "perfume",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/perfume",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/perfume.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/perfume.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/perfume.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/perfume.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/perfume.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/perfume.svg"
        }
      ],
      "tags": [
        "beauty",
        "core",
        "cosmetic",
        "essential",
        "fragrance",
        "interface",
        "scent",
        "spray",
        "ui"
      ]
    },
    "essentional-ui/sleeping": {
      "name": "Sleeping",
      "slug": "sleeping",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/sleeping",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/sleeping.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/sleeping.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/sleeping.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/sleeping.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/sleeping.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/sleeping.svg"
        }
      ],
      "tags": [
        "core",
        "dormant",
        "essential",
        "inactive",
        "interface",
        "night",
        "rest",
        "sleep",
        "ui",
        "zzz"
      ]
    },
    "essentional-ui/delivery": {
      "name": "Delivery",
      "slug": "delivery",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/delivery",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/delivery.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/delivery.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/delivery.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/delivery.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/delivery.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/delivery.svg"
        }
      ],
      "tags": [
        "core",
        "courier",
        "essential",
        "interface",
        "logistics",
        "package",
        "shipping",
        "transport",
        "truck",
        "ui"
      ]
    },
    "essentional-ui/gift": {
      "name": "Gift",
      "slug": "gift",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/gift",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/gift.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/gift.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/gift.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/gift.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/gift.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/gift.svg"
        }
      ],
      "tags": [
        "birthday",
        "bonus",
        "celebration",
        "core",
        "essential",
        "interface",
        "present",
        "reward",
        "surprise",
        "ui"
      ]
    },
    "essentional-ui/magic-stick": {
      "name": "Magic Stick",
      "slug": "magic-stick",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/magic-stick",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/magic-stick.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/magic-stick.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/magic-stick.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/magic-stick.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/magic-stick.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/magic-stick.svg"
        }
      ],
      "tags": [
        "AI",
        "auto",
        "core",
        "enchant",
        "essential",
        "generate",
        "interface",
        "ui",
        "wand",
        "wizard"
      ]
    },
    "essentional-ui/magic-stick-2": {
      "name": "Magic Stick 2",
      "slug": "magic-stick-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/magic-stick-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/magic-stick-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/magic-stick-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/magic-stick-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/magic-stick-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/magic-stick-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/magic-stick-2.svg"
        }
      ],
      "tags": [
        "auto",
        "core",
        "enchant",
        "essential",
        "interface",
        "ui",
        "wand",
        "wizard"
      ]
    },
    "essentional-ui/magic-stick-3": {
      "name": "Magic Stick 3",
      "slug": "magic-stick-3",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/magic-stick-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/magic-stick-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/magic-stick-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/magic-stick-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/magic-stick-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/magic-stick-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/magic-stick-3.svg"
        }
      ],
      "tags": [
        "auto",
        "core",
        "enchant",
        "essential",
        "interface",
        "ui",
        "wand",
        "wizard"
      ]
    },
    "essentional-ui/sledgehammer": {
      "name": "Sledgehammer",
      "slug": "sledgehammer",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/sledgehammer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/sledgehammer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/sledgehammer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/sledgehammer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/sledgehammer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/sledgehammer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/sledgehammer.svg"
        }
      ],
      "tags": [
        "break",
        "core",
        "demolish",
        "essential",
        "heavy",
        "interface",
        "strong",
        "tool",
        "ui"
      ]
    },
    "essentional-ui/magnet": {
      "name": "Magnet",
      "slug": "magnet",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/magnet",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/magnet.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/magnet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/magnet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/magnet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/magnet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/magnet.svg"
        }
      ],
      "tags": [
        "attract",
        "core",
        "essential",
        "horseshoe",
        "interface",
        "magnetic",
        "pull",
        "ui"
      ]
    },
    "essentional-ui/magnet-wave": {
      "name": "Magnet Wave",
      "slug": "magnet-wave",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/magnet-wave",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/magnet-wave.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/magnet-wave.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/magnet-wave.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/magnet-wave.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/magnet-wave.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/magnet-wave.svg"
        }
      ],
      "tags": [
        "active",
        "attract",
        "core",
        "essential",
        "interface",
        "magnetic",
        "pull",
        "ui"
      ]
    },
    "essentional-ui/flashlight": {
      "name": "Flashlight",
      "slug": "flashlight",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/flashlight",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/flashlight.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/flashlight.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/flashlight.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/flashlight.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/flashlight.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/flashlight.svg"
        }
      ],
      "tags": [
        "beam",
        "core",
        "dark",
        "essential",
        "illuminate",
        "interface",
        "light",
        "torch",
        "ui"
      ]
    },
    "essentional-ui/flashlight-on": {
      "name": "Flashlight On",
      "slug": "flashlight-on",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/flashlight-on",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/flashlight-on.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/flashlight-on.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/flashlight-on.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/flashlight-on.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/flashlight-on.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/flashlight-on.svg"
        }
      ],
      "tags": [
        "active",
        "beam",
        "core",
        "essential",
        "interface",
        "light",
        "on",
        "torch",
        "ui"
      ]
    },
    "essentional-ui/cursor": {
      "name": "Cursor",
      "slug": "cursor",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cursor",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cursor.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cursor.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cursor.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cursor.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cursor.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cursor.svg"
        }
      ],
      "tags": [
        "arrow",
        "click",
        "core",
        "essential",
        "interface",
        "mouse",
        "pointer",
        "select",
        "ui"
      ]
    },
    "essentional-ui/cursor-square": {
      "name": "Cursor Square",
      "slug": "cursor-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cursor-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cursor-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cursor-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cursor-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cursor-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cursor-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cursor-square.svg"
        }
      ],
      "tags": [
        "click",
        "core",
        "essential",
        "interface",
        "mouse",
        "pointer",
        "select",
        "ui"
      ]
    },
    "essentional-ui/cosmetic": {
      "name": "Cosmetic",
      "slug": "cosmetic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/cosmetic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/cosmetic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/cosmetic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/cosmetic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/cosmetic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/cosmetic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/cosmetic.svg"
        }
      ],
      "tags": [
        "beauty",
        "core",
        "essential",
        "interface",
        "lipstick",
        "makeup",
        "skincare",
        "ui"
      ]
    },
    "essentional-ui/mirror": {
      "name": "Mirror",
      "slug": "mirror",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/mirror",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/mirror.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/mirror.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/mirror.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/mirror.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/mirror.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/mirror.svg"
        }
      ],
      "tags": [
        "bathroom",
        "core",
        "essential",
        "glass",
        "interface",
        "reflect",
        "ui",
        "vanity"
      ]
    },
    "essentional-ui/confetti-minimalistic": {
      "name": "Confetti Minimalistic",
      "slug": "confetti-minimalistic",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/confetti-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/confetti-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/confetti-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/confetti-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/confetti-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/confetti-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/confetti-minimalistic.svg"
        }
      ],
      "tags": [
        "celebration",
        "congrats",
        "core",
        "essential",
        "interface",
        "minimal",
        "party",
        "ui"
      ]
    },
    "essentional-ui/confetti": {
      "name": "Confetti",
      "slug": "confetti",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/confetti",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/confetti.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/confetti.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/confetti.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/confetti.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/confetti.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/confetti.svg"
        }
      ],
      "tags": [
        "celebration",
        "congrats",
        "core",
        "essential",
        "festive",
        "interface",
        "party",
        "success",
        "ui"
      ]
    },
    "essentional-ui/hanger": {
      "name": "Hanger",
      "slug": "hanger",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/hanger",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/hanger.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/hanger.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/hanger.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/hanger.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/hanger.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/hanger.svg"
        }
      ],
      "tags": [
        "closet",
        "clothes",
        "coat",
        "core",
        "essential",
        "fashion",
        "interface",
        "ui",
        "wardrobe"
      ]
    },
    "essentional-ui/hanger-2": {
      "name": "Hanger 2",
      "slug": "hanger-2",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/hanger-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/hanger-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/hanger-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/hanger-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/hanger-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/hanger-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/hanger-2.svg"
        }
      ],
      "tags": [
        "closet",
        "clothes",
        "core",
        "essential",
        "fashion",
        "interface",
        "ui",
        "wardrobe"
      ]
    },
    "essentional-ui/body": {
      "name": "Body",
      "slug": "body",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/body",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/body.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/body.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/body.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/body.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/body.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/body.svg"
        }
      ],
      "tags": [
        "anatomy",
        "core",
        "essential",
        "figure",
        "human",
        "interface",
        "person",
        "silhouette",
        "ui"
      ]
    },
    "essentional-ui/t-shirt": {
      "name": "T-shirt",
      "slug": "t-shirt",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/t-shirt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/t-shirt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/t-shirt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/t-shirt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/t-shirt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/t-shirt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/t-shirt.svg"
        }
      ],
      "tags": [
        "apparel",
        "clothing",
        "core",
        "essential",
        "fashion",
        "interface",
        "merch",
        "tee",
        "ui",
        "wear"
      ]
    },
    "essentional-ui/skirt": {
      "name": "Skirt",
      "slug": "skirt",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/skirt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/skirt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/skirt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/skirt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/skirt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/skirt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/skirt.svg"
        }
      ],
      "tags": [
        "apparel",
        "clothing",
        "core",
        "dress",
        "essential",
        "fashion",
        "garment",
        "interface",
        "ui"
      ]
    },
    "essentional-ui/accessibility": {
      "name": "Accessibility",
      "slug": "accessibility",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/accessibility",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/accessibility.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/accessibility.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/accessibility.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/accessibility.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/accessibility.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/accessibility.svg"
        }
      ],
      "tags": [
        "a11y",
        "accessible",
        "core",
        "disability",
        "essential",
        "inclusive",
        "interface",
        "ui",
        "universal"
      ]
    },
    "essentional-ui/mask-sad": {
      "name": "Mask Sad",
      "slug": "mask-sad",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/mask-sad",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/mask-sad.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/mask-sad.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/mask-sad.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/mask-sad.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/mask-sad.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/mask-sad.svg"
        }
      ],
      "tags": [
        "core",
        "disguise",
        "essential",
        "interface",
        "sad",
        "theatre",
        "tragedy",
        "ui"
      ]
    },
    "essentional-ui/mask-happly": {
      "name": "Mask Happly",
      "slug": "mask-happly",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/mask-happly",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/mask-happly.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/mask-happly.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/mask-happly.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/mask-happly.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/mask-happly.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/mask-happly.svg"
        }
      ],
      "tags": [
        "anonymous",
        "comedy",
        "core",
        "disguise",
        "essential",
        "happy",
        "interface",
        "theatre",
        "ui"
      ]
    },
    "essentional-ui/masks": {
      "name": "Masks",
      "slug": "masks",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/masks",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/masks.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/masks.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/masks.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/masks.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/masks.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/masks.svg"
        }
      ],
      "tags": [
        "comedy-tragedy",
        "core",
        "drama",
        "essential",
        "interface",
        "performing",
        "theatre",
        "ui"
      ]
    },
    "essentional-ui/mention-square": {
      "name": "Mention Square",
      "slug": "mention-square",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/mention-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/mention-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/mention-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/mention-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/mention-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/mention-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/mention-square.svg"
        }
      ],
      "tags": [
        "@",
        "at",
        "core",
        "essential",
        "interface",
        "reference",
        "tag",
        "ui"
      ]
    },
    "essentional-ui/mention-circle": {
      "name": "Mention Circle",
      "slug": "mention-circle",
      "category": "essentional-ui",
      "categoryName": "Essentional, UI",
      "id": "essentional-ui/mention-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/essentional-ui/mention-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/essentional-ui/mention-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/essentional-ui/mention-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/essentional-ui/mention-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/essentional-ui/mention-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/essentional-ui/mention-circle.svg"
        }
      ],
      "tags": [
        "@",
        "at",
        "core",
        "essential",
        "interface",
        "notify",
        "reference",
        "tag",
        "ui"
      ]
    },
    "call/end-call-rounded": {
      "name": "End Call Rounded",
      "slug": "end-call-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/end-call-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/end-call-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/end-call-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/end-call-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/end-call-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/end-call-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/end-call-rounded.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "decline",
        "disconnect",
        "hangup",
        "phone",
        "stop",
        "telephone"
      ]
    },
    "call/phone-rounded": {
      "name": "Phone Rounded",
      "slug": "phone-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/phone-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/phone-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/phone-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/phone-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/phone-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/phone-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/phone-rounded.svg"
        }
      ],
      "tags": [
        "call",
        "calling",
        "communication",
        "contact",
        "dial",
        "phone",
        "telephone"
      ]
    },
    "call/phone-calling-rounded": {
      "name": "Phone Calling Rounded",
      "slug": "phone-calling-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/phone-calling-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/phone-calling-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/phone-calling-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/phone-calling-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/phone-calling-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/phone-calling-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/phone-calling-rounded.svg"
        }
      ],
      "tags": [
        "active",
        "calling",
        "communication",
        "contact",
        "incoming",
        "phone",
        "ringing",
        "telephone"
      ]
    },
    "call/call-cancel-rounded": {
      "name": "Call Cancel Rounded",
      "slug": "call-cancel-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-cancel-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-cancel-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-cancel-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-cancel-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-cancel-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-cancel-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-cancel-rounded.svg"
        }
      ],
      "tags": [
        "block",
        "calling",
        "communication",
        "contact",
        "decline",
        "phone",
        "reject",
        "telephone"
      ]
    },
    "call/outgoing-call-rounded": {
      "name": "Outgoing Call Rounded",
      "slug": "outgoing-call-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/outgoing-call-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/outgoing-call-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/outgoing-call-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/outgoing-call-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/outgoing-call-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/outgoing-call-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/outgoing-call-rounded.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "dial",
        "make-call",
        "phone",
        "telephone"
      ]
    },
    "call/incoming-call-rounded": {
      "name": "Incoming Call Rounded",
      "slug": "incoming-call-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/incoming-call-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/incoming-call-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/incoming-call-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/incoming-call-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/incoming-call-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/incoming-call-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/incoming-call-rounded.svg"
        }
      ],
      "tags": [
        "answer",
        "calling",
        "communication",
        "contact",
        "phone",
        "receive",
        "ringing",
        "telephone"
      ]
    },
    "call/call-dropped-rounded": {
      "name": "Call Dropped Rounded",
      "slug": "call-dropped-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-dropped-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-dropped-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-dropped-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-dropped-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-dropped-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-dropped-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-dropped-rounded.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "failed",
        "lost",
        "missed",
        "phone",
        "telephone"
      ]
    },
    "call/call-chat-rounded": {
      "name": "Call Chat Rounded",
      "slug": "call-chat-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-chat-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-chat-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-chat-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-chat-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-chat-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-chat-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-chat-rounded.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "message",
        "phone",
        "sms",
        "telephone",
        "text"
      ]
    },
    "call/call-medicine-rounded": {
      "name": "Call Medicine Rounded",
      "slug": "call-medicine-rounded",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-medicine-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-medicine-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-medicine-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-medicine-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-medicine-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-medicine-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-medicine-rounded.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "doctor",
        "emergency",
        "health",
        "phone",
        "telephone"
      ]
    },
    "call/phone": {
      "name": "Phone",
      "slug": "phone",
      "category": "call",
      "categoryName": "Call",
      "id": "call/phone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/phone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/phone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/phone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/phone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/phone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/phone.svg"
        }
      ],
      "tags": [
        "call",
        "calling",
        "communication",
        "contact",
        "dial",
        "mobile",
        "phone",
        "telephone"
      ]
    },
    "call/end-call": {
      "name": "End Call",
      "slug": "end-call",
      "category": "call",
      "categoryName": "Call",
      "id": "call/end-call",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/end-call.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/end-call.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/end-call.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/end-call.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/end-call.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/end-call.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "decline",
        "disconnect",
        "hangup",
        "phone",
        "stop",
        "telephone"
      ]
    },
    "call/phone-calling": {
      "name": "Phone Calling",
      "slug": "phone-calling",
      "category": "call",
      "categoryName": "Call",
      "id": "call/phone-calling",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/phone-calling.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/phone-calling.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/phone-calling.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/phone-calling.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/phone-calling.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/phone-calling.svg"
        }
      ],
      "tags": [
        "active",
        "calling",
        "communication",
        "contact",
        "dial",
        "incoming",
        "phone",
        "ringing",
        "telephone"
      ]
    },
    "call/call-cancel": {
      "name": "Call Cancel",
      "slug": "call-cancel",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-cancel",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-cancel.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-cancel.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-cancel.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-cancel.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-cancel.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-cancel.svg"
        }
      ],
      "tags": [
        "block",
        "calling",
        "communication",
        "contact",
        "decline",
        "phone",
        "reject",
        "telephone"
      ]
    },
    "call/outgoing-call": {
      "name": "Outgoing Call",
      "slug": "outgoing-call",
      "category": "call",
      "categoryName": "Call",
      "id": "call/outgoing-call",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/outgoing-call.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/outgoing-call.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/outgoing-call.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/outgoing-call.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/outgoing-call.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/outgoing-call.svg"
        }
      ],
      "tags": [
        "calling",
        "calling-out",
        "communication",
        "contact",
        "dial",
        "make-call",
        "phone",
        "telephone"
      ]
    },
    "call/incoming-call": {
      "name": "Incoming Call",
      "slug": "incoming-call",
      "category": "call",
      "categoryName": "Call",
      "id": "call/incoming-call",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/incoming-call.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/incoming-call.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/incoming-call.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/incoming-call.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/incoming-call.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/incoming-call.svg"
        }
      ],
      "tags": [
        "answer",
        "calling",
        "communication",
        "contact",
        "phone",
        "receive",
        "ringing",
        "telephone"
      ]
    },
    "call/call-dropped": {
      "name": "Call Dropped",
      "slug": "call-dropped",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-dropped",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-dropped.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-dropped.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-dropped.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-dropped.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-dropped.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-dropped.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "disconnected",
        "failed",
        "lost",
        "missed",
        "phone",
        "telephone"
      ]
    },
    "call/call-chat": {
      "name": "Call Chat",
      "slug": "call-chat",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-chat",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-chat.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-chat.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-chat.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-chat.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-chat.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-chat.svg"
        }
      ],
      "tags": [
        "calling",
        "communication",
        "contact",
        "message",
        "phone",
        "sms",
        "telephone",
        "text",
        "voicemail"
      ]
    },
    "call/call-medicine": {
      "name": "Call Medicine",
      "slug": "call-medicine",
      "category": "call",
      "categoryName": "Call",
      "id": "call/call-medicine",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/call-medicine.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/call-medicine.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/call-medicine.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/call-medicine.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/call-medicine.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/call-medicine.svg"
        }
      ],
      "tags": [
        "ambulance",
        "calling",
        "communication",
        "contact",
        "doctor",
        "emergency",
        "health",
        "hospital",
        "phone",
        "telephone"
      ]
    },
    "call/record-minimalistic": {
      "name": "Record Minimalistic",
      "slug": "record-minimalistic",
      "category": "call",
      "categoryName": "Call",
      "id": "call/record-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/record-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/record-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/record-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/record-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/record-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/record-minimalistic.svg"
        }
      ],
      "tags": [
        "active",
        "calling",
        "communication",
        "contact",
        "phone",
        "recording",
        "telephone"
      ]
    },
    "call/record-square": {
      "name": "Record Square",
      "slug": "record-square",
      "category": "call",
      "categoryName": "Call",
      "id": "call/record-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/record-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/record-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/record-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/record-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/record-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/record-square.svg"
        }
      ],
      "tags": [
        "active",
        "calling",
        "communication",
        "contact",
        "phone",
        "recording",
        "telephone"
      ]
    },
    "call/record-circle": {
      "name": "Record Circle",
      "slug": "record-circle",
      "category": "call",
      "categoryName": "Call",
      "id": "call/record-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/call/record-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/call/record-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/call/record-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/call/record-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/call/record-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/call/record-circle.svg"
        }
      ],
      "tags": [
        "active",
        "calling",
        "communication",
        "contact",
        "live",
        "phone",
        "recording",
        "telephone"
      ]
    },
    "medicine/dna": {
      "name": "DNA",
      "slug": "dna",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dna",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dna.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dna.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dna.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dna.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dna.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dna.svg"
        }
      ],
      "tags": [
        "biology",
        "clinical",
        "gene",
        "genetics",
        "genome",
        "health",
        "healthcare",
        "helix",
        "hereditary",
        "medical",
        "medicine",
        "pharmacy"
      ]
    },
    "medicine/bacteria": {
      "name": "Bacteria",
      "slug": "bacteria",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/bacteria",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/bacteria.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/bacteria.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/bacteria.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/bacteria.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/bacteria.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/bacteria.svg"
        }
      ],
      "tags": [
        "clinical",
        "germ",
        "gut",
        "health",
        "healthcare",
        "infection",
        "medical",
        "medicine",
        "microbe",
        "microorganism",
        "pharmacy"
      ]
    },
    "medicine/syringe": {
      "name": "Syringe",
      "slug": "syringe",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/syringe",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/syringe.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/syringe.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/syringe.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/syringe.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/syringe.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/syringe.svg"
        }
      ],
      "tags": [
        "clinical",
        "health",
        "healthcare",
        "injection",
        "jab",
        "medical",
        "medicine",
        "needle",
        "pharmacy",
        "shot",
        "vaccine"
      ]
    },
    "medicine/jar-of-pills": {
      "name": "Jar Of Pills",
      "slug": "jar-of-pills",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/jar-of-pills",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/jar-of-pills.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/jar-of-pills.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/jar-of-pills.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/jar-of-pills.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/jar-of-pills.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/jar-of-pills.svg"
        }
      ],
      "tags": [
        "bottle",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "prescription"
      ]
    },
    "medicine/jar-of-pills-2": {
      "name": "Jar Of Pills 2",
      "slug": "jar-of-pills-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/jar-of-pills-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/jar-of-pills-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/jar-of-pills-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/jar-of-pills-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/jar-of-pills-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/jar-of-pills-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/jar-of-pills-2.svg"
        }
      ],
      "tags": [
        "bottle",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "prescription"
      ]
    },
    "medicine/stethoscope": {
      "name": "Stethoscope",
      "slug": "stethoscope",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/stethoscope",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/stethoscope.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/stethoscope.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/stethoscope.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/stethoscope.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/stethoscope.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/stethoscope.svg"
        }
      ],
      "tags": [
        "clinical",
        "diagnose",
        "doctor",
        "examine",
        "health",
        "healthcare",
        "listen",
        "medical",
        "medicine",
        "pharmacy"
      ]
    },
    "medicine/pills-2": {
      "name": "Pills 2",
      "slug": "pills-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pills-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pills-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pills-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pills-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pills-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pills-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pills-2.svg"
        }
      ],
      "tags": [
        "capsules",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "tablets"
      ]
    },
    "medicine/pills-3": {
      "name": "Pills 3",
      "slug": "pills-3",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pills-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pills-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pills-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pills-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pills-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pills-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pills-3.svg"
        }
      ],
      "tags": [
        "capsules",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "tablets"
      ]
    },
    "medicine/benzene-ring": {
      "name": "Benzene Ring",
      "slug": "benzene-ring",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/benzene-ring",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/benzene-ring.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/benzene-ring.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/benzene-ring.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/benzene-ring.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/benzene-ring.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/benzene-ring.svg"
        }
      ],
      "tags": [
        "chemical",
        "chemistry",
        "clinical",
        "compound",
        "health",
        "healthcare",
        "medical",
        "medicine",
        "molecule",
        "organic",
        "pharmacy"
      ]
    },
    "medicine/thermometer": {
      "name": "Thermometer",
      "slug": "thermometer",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/thermometer",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/thermometer.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/thermometer.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/thermometer.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/thermometer.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/thermometer.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/thermometer.svg"
        }
      ],
      "tags": [
        "clinical",
        "cold",
        "fever",
        "health",
        "healthcare",
        "heat",
        "measure",
        "medical",
        "medicine",
        "pharmacy",
        "temperature"
      ]
    },
    "medicine/dropper": {
      "name": "Dropper",
      "slug": "dropper",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dropper",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dropper.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dropper.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dropper.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dropper.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dropper.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dropper.svg"
        }
      ],
      "tags": [
        "clinical",
        "dose",
        "essential-oil",
        "health",
        "healthcare",
        "liquid",
        "medical",
        "medicine",
        "pharmacy",
        "pipette",
        "tincture"
      ]
    },
    "medicine/dropper-2": {
      "name": "Dropper 2",
      "slug": "dropper-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dropper-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dropper-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dropper-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dropper-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dropper-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dropper-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dropper-2.svg"
        }
      ],
      "tags": [
        "clinical",
        "dose",
        "health",
        "healthcare",
        "liquid",
        "medical",
        "medicine",
        "pharmacy",
        "pipette"
      ]
    },
    "medicine/dropper-3": {
      "name": "Dropper 3",
      "slug": "dropper-3",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dropper-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dropper-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dropper-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dropper-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dropper-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dropper-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dropper-3.svg"
        }
      ],
      "tags": [
        "clinical",
        "dose",
        "health",
        "healthcare",
        "liquid",
        "medical",
        "medicine",
        "pharmacy",
        "pipette"
      ]
    },
    "medicine/dropper-minimalistic": {
      "name": "Dropper Minimalistic",
      "slug": "dropper-minimalistic",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dropper-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dropper-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dropper-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dropper-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dropper-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dropper-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dropper-minimalistic.svg"
        }
      ],
      "tags": [
        "clinical",
        "health",
        "healthcare",
        "liquid",
        "medical",
        "medicine",
        "minimal",
        "pharmacy",
        "pipette"
      ]
    },
    "medicine/dropper-minimalistic-2": {
      "name": "Dropper Minimalistic 2",
      "slug": "dropper-minimalistic-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/dropper-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/dropper-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/dropper-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/dropper-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/dropper-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/dropper-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/dropper-minimalistic-2.svg"
        }
      ],
      "tags": [
        "clinical",
        "health",
        "healthcare",
        "liquid",
        "medical",
        "medicine",
        "minimal",
        "pharmacy",
        "pipette"
      ]
    },
    "medicine/adhesive-plaster": {
      "name": "Adhesive Plaster",
      "slug": "adhesive-plaster",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/adhesive-plaster",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/adhesive-plaster.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/adhesive-plaster.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/adhesive-plaster.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/adhesive-plaster.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/adhesive-plaster.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/adhesive-plaster.svg"
        }
      ],
      "tags": [
        "bandage",
        "bandaid",
        "clinical",
        "first-aid",
        "health",
        "healthcare",
        "medical",
        "medicine",
        "pharmacy",
        "plaster",
        "wound"
      ]
    },
    "medicine/adhesive-plaster-2": {
      "name": "Adhesive Plaster 2",
      "slug": "adhesive-plaster-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/adhesive-plaster-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/adhesive-plaster-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/adhesive-plaster-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/adhesive-plaster-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/adhesive-plaster-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/adhesive-plaster-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/adhesive-plaster-2.svg"
        }
      ],
      "tags": [
        "bandage",
        "bandaid",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medicine",
        "pharmacy",
        "plaster",
        "wound"
      ]
    },
    "medicine/pill": {
      "name": "Pill",
      "slug": "pill",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pill",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pill.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pill.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pill.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pill.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pill.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pill.svg"
        }
      ],
      "tags": [
        "capsule",
        "clinical",
        "drug",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "supplement",
        "tablet"
      ]
    },
    "medicine/pills": {
      "name": "Pills",
      "slug": "pills",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pills",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pills.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pills.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pills.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pills.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pills.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pills.svg"
        }
      ],
      "tags": [
        "capsules",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medication",
        "medicine",
        "pharmacy",
        "supplements",
        "tablets"
      ]
    },
    "medicine/bone": {
      "name": "Bone",
      "slug": "bone",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/bone",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/bone.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/bone.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/bone.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/bone.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/bone.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/bone.svg"
        }
      ],
      "tags": [
        "calcium",
        "clinical",
        "health",
        "healthcare",
        "joint",
        "medical",
        "medicine",
        "orthopedic",
        "pharmacy",
        "skeleton"
      ]
    },
    "medicine/bone-crack": {
      "name": "Bone Crack",
      "slug": "bone-crack",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/bone-crack",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/bone-crack.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/bone-crack.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/bone-crack.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/bone-crack.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/bone-crack.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/bone-crack.svg"
        }
      ],
      "tags": [
        "clinical",
        "damage",
        "fracture",
        "health",
        "healthcare",
        "injury",
        "medical",
        "medicine",
        "pharmacy"
      ]
    },
    "medicine/bone-broken": {
      "name": "Bone Broken",
      "slug": "bone-broken",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/bone-broken",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/bone-broken.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/bone-broken.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/bone-broken.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/bone-broken.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/bone-broken.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/bone-broken.svg"
        }
      ],
      "tags": [
        "break",
        "clinical",
        "crack",
        "fracture",
        "health",
        "healthcare",
        "injury",
        "medical",
        "medicine",
        "pharmacy"
      ]
    },
    "medicine/bones": {
      "name": "Bones",
      "slug": "bones",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/bones",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/bones.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/bones.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/bones.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/bones.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/bones.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/bones.svg"
        }
      ],
      "tags": [
        "anatomy",
        "clinical",
        "health",
        "healthcare",
        "medical",
        "medicine",
        "pharmacy",
        "skeleton",
        "structure"
      ]
    },
    "medicine/test-tube": {
      "name": "Test Tube",
      "slug": "test-tube",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/test-tube",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/test-tube.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/test-tube.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/test-tube.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/test-tube.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/test-tube.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/test-tube.svg"
        }
      ],
      "tags": [
        "chemistry",
        "clinical",
        "experiment",
        "health",
        "healthcare",
        "lab",
        "medical",
        "medicine",
        "pharmacy",
        "research",
        "sample",
        "science"
      ]
    },
    "medicine/test-tube-minimalistic": {
      "name": "Test Tube Minimalistic",
      "slug": "test-tube-minimalistic",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/test-tube-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/test-tube-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/test-tube-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/test-tube-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/test-tube-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/test-tube-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/test-tube-minimalistic.svg"
        }
      ],
      "tags": [
        "clinical",
        "experiment",
        "health",
        "healthcare",
        "lab",
        "medical",
        "medicine",
        "minimal",
        "pharmacy",
        "science"
      ]
    },
    "medicine/pulse-2": {
      "name": "Pulse 2",
      "slug": "pulse-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pulse-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pulse-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pulse-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pulse-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pulse-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pulse-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pulse-2.svg"
        }
      ],
      "tags": [
        "clinical",
        "health",
        "healthcare",
        "heartbeat",
        "medical",
        "medicine",
        "pharmacy",
        "rhythm",
        "vital"
      ]
    },
    "medicine/pulse": {
      "name": "Pulse",
      "slug": "pulse",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/pulse",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/pulse.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/pulse.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/pulse.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/pulse.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/pulse.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/pulse.svg"
        }
      ],
      "tags": [
        "ECG",
        "clinical",
        "health",
        "healthcare",
        "heartbeat",
        "medical",
        "medicine",
        "monitoring",
        "pharmacy",
        "rhythm",
        "vital"
      ]
    },
    "medicine/heart-pulse": {
      "name": "Heart Pulse",
      "slug": "heart-pulse",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/heart-pulse",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/heart-pulse.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/heart-pulse.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/heart-pulse.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/heart-pulse.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/heart-pulse.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/heart-pulse.svg"
        }
      ],
      "tags": [
        "ECG",
        "alive",
        "cardio",
        "clinical",
        "health",
        "healthcare",
        "heartbeat",
        "medical",
        "medicine",
        "pharmacy",
        "vital"
      ]
    },
    "medicine/heart-pulse-2": {
      "name": "Heart Pulse 2",
      "slug": "heart-pulse-2",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/heart-pulse-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/heart-pulse-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/heart-pulse-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/heart-pulse-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/heart-pulse-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/heart-pulse-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/heart-pulse-2.svg"
        }
      ],
      "tags": [
        "ECG",
        "cardio",
        "clinical",
        "health",
        "healthcare",
        "heartbeat",
        "medical",
        "medicine",
        "pharmacy"
      ]
    },
    "medicine/medical-kit": {
      "name": "Medical Kit",
      "slug": "medical-kit",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/medical-kit",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/medical-kit.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/medical-kit.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/medical-kit.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/medical-kit.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/medical-kit.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/medical-kit.svg"
        }
      ],
      "tags": [
        "box",
        "clinical",
        "emergency",
        "first-aid",
        "health",
        "healthcare",
        "medical",
        "medicine",
        "pharmacy",
        "supplies"
      ]
    },
    "medicine/health": {
      "name": "Health",
      "slug": "health",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/health",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/health.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/health.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/health.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/health.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/health.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/health.svg"
        }
      ],
      "tags": [
        "clinical",
        "cross",
        "first-aid",
        "health",
        "healthcare",
        "hospital",
        "medical",
        "medicine",
        "pharmacy",
        "plus"
      ]
    },
    "medicine/virus": {
      "name": "Virus",
      "slug": "virus",
      "category": "medicine",
      "categoryName": "Medicine",
      "id": "medicine/virus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/medicine/virus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/medicine/virus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/medicine/virus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/medicine/virus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/medicine/virus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/medicine/virus.svg"
        }
      ],
      "tags": [
        "clinical",
        "covid",
        "disease",
        "flu",
        "germ",
        "health",
        "healthcare",
        "infection",
        "medical",
        "medicine",
        "pathogen",
        "pharmacy"
      ]
    },
    "home-furniture/condicioner": {
      "name": "Condicioner",
      "slug": "condicioner",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/condicioner",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/condicioner.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/condicioner.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/condicioner.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/condicioner.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/condicioner.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/condicioner.svg"
        }
      ],
      "tags": [
        "AC",
        "HVAC",
        "air-conditioning",
        "climate",
        "cooling",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living"
      ]
    },
    "home-furniture/condicioner-2": {
      "name": "Condicioner 2",
      "slug": "condicioner-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/condicioner-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/condicioner-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/condicioner-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/condicioner-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/condicioner-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/condicioner-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/condicioner-2.svg"
        }
      ],
      "tags": [
        "AC",
        "air-conditioning",
        "cooling",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living"
      ]
    },
    "home-furniture/speaker": {
      "name": "Speaker",
      "slug": "speaker",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/speaker",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/speaker.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/speaker.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/speaker.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/speaker.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/speaker.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/speaker.svg"
        }
      ],
      "tags": [
        "audio",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "music",
        "sound",
        "stereo",
        "subwoofer"
      ]
    },
    "home-furniture/speaker-minimalistic": {
      "name": "Speaker Minimalistic",
      "slug": "speaker-minimalistic",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/speaker-minimalistic",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/speaker-minimalistic.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/speaker-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/speaker-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/speaker-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/speaker-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/speaker-minimalistic.svg"
        }
      ],
      "tags": [
        "audio",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "minimal",
        "sound"
      ]
    },
    "home-furniture/remote-controller": {
      "name": "Remote Controller",
      "slug": "remote-controller",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/remote-controller",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/remote-controller.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/remote-controller.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/remote-controller.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/remote-controller.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/remote-controller.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/remote-controller.svg"
        }
      ],
      "tags": [
        "TV-remote",
        "control",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "wireless"
      ]
    },
    "home-furniture/remote-controller-minimalistic": {
      "name": "Remote Controller Minimalistic",
      "slug": "remote-controller-minimalistic",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/remote-controller-minimalistic",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/remote-controller-minimalistic.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/remote-controller-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/remote-controller-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/remote-controller-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/remote-controller-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/remote-controller-minimalistic.svg"
        }
      ],
      "tags": [
        "TV-remote",
        "control",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "minimal"
      ]
    },
    "home-furniture/remote-controller-2": {
      "name": "Remote Controller 2",
      "slug": "remote-controller-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/remote-controller-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/remote-controller-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/remote-controller-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/remote-controller-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/remote-controller-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/remote-controller-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/remote-controller-2.svg"
        }
      ],
      "tags": [
        "TV-remote",
        "control",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living"
      ]
    },
    "home-furniture/washing-machine-minimalistic": {
      "name": "Washing Machine Minimalistic",
      "slug": "washing-machine-minimalistic",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/washing-machine-minimalistic",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/washing-machine-minimalistic.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/washing-machine-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/washing-machine-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/washing-machine-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/washing-machine-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/washing-machine-minimalistic.svg"
        }
      ],
      "tags": [
        "clean",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "laundry",
        "living",
        "minimal"
      ]
    },
    "home-furniture/washing-machine": {
      "name": "Washing Machine",
      "slug": "washing-machine",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/washing-machine",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/washing-machine.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/washing-machine.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/washing-machine.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/washing-machine.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/washing-machine.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/washing-machine.svg"
        }
      ],
      "tags": [
        "appliance",
        "clean",
        "clothes",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "laundry",
        "living",
        "washer"
      ]
    },
    "home-furniture/sofa": {
      "name": "Sofa",
      "slug": "sofa",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/sofa",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/sofa.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/sofa.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/sofa.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/sofa.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/sofa.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/sofa.svg"
        }
      ],
      "tags": [
        "comfortable",
        "couch",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "living-room",
        "lounge",
        "settee"
      ]
    },
    "home-furniture/sofa-2": {
      "name": "Sofa 2",
      "slug": "sofa-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/sofa-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/sofa-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/sofa-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/sofa-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/sofa-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/sofa-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/sofa-2.svg"
        }
      ],
      "tags": [
        "couch",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "living-room",
        "settee"
      ]
    },
    "home-furniture/sofa-3": {
      "name": "Sofa 3",
      "slug": "sofa-3",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/sofa-3",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/sofa-3.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/sofa-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/sofa-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/sofa-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/sofa-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/sofa-3.svg"
        }
      ],
      "tags": [
        "couch",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "living-room",
        "settee"
      ]
    },
    "home-furniture/bedside-table-4": {
      "name": "Bedside Table 4",
      "slug": "bedside-table-4",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bedside-table-4",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bedside-table-4.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bedside-table-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bedside-table-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bedside-table-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bedside-table-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bedside-table-4.svg"
        }
      ],
      "tags": [
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "nightstand",
        "side-table"
      ]
    },
    "home-furniture/closet": {
      "name": "Closet",
      "slug": "closet",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/closet",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/closet.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/closet.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/closet.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/closet.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/closet.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/closet.svg"
        }
      ],
      "tags": [
        "clothes",
        "cupboard",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "storage",
        "wardrobe"
      ]
    },
    "home-furniture/trellis": {
      "name": "Trellis",
      "slug": "trellis",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/trellis",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/trellis.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/trellis.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/trellis.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/trellis.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/trellis.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/trellis.svg"
        }
      ],
      "tags": [
        "climb",
        "decor",
        "furniture",
        "garden",
        "home",
        "house",
        "interior",
        "lattice",
        "living",
        "outdoor",
        "plant"
      ]
    },
    "home-furniture/mirror": {
      "name": "Mirror",
      "slug": "mirror",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/mirror",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/mirror.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/mirror.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/mirror.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/mirror.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/mirror.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/mirror.svg"
        }
      ],
      "tags": [
        "bathroom",
        "decor",
        "furniture",
        "glass",
        "home",
        "house",
        "interior",
        "living",
        "reflect",
        "vanity"
      ]
    },
    "home-furniture/bath": {
      "name": "Bath",
      "slug": "bath",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bath",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bath.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bath.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bath.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bath.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bath.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bath.svg"
        }
      ],
      "tags": [
        "bathroom",
        "bathtub",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "shower",
        "soak",
        "tub",
        "wash"
      ]
    },
    "home-furniture/chandelier": {
      "name": "Chandelier",
      "slug": "chandelier",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/chandelier",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/chandelier.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/chandelier.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/chandelier.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/chandelier.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/chandelier.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/chandelier.svg"
        }
      ],
      "tags": [
        "ceiling",
        "decor",
        "elegant",
        "furniture",
        "home",
        "house",
        "interior",
        "lamp",
        "light",
        "living",
        "luxury"
      ]
    },
    "home-furniture/closet-2": {
      "name": "Closet 2",
      "slug": "closet-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/closet-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/closet-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/closet-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/closet-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/closet-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/closet-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/closet-2.svg"
        }
      ],
      "tags": [
        "clothes",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "storage",
        "wardrobe"
      ]
    },
    "home-furniture/bed": {
      "name": "Bed",
      "slug": "bed",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bed",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bed.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bed.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bed.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bed.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bed.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bed.svg"
        }
      ],
      "tags": [
        "bedroom",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "mattress",
        "night",
        "rest",
        "sleep"
      ]
    },
    "home-furniture/chair-2": {
      "name": "Chair 2",
      "slug": "chair-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/chair-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/chair-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/chair-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/chair-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/chair-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/chair-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/chair-2.svg"
        }
      ],
      "tags": [
        "decor",
        "desk",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "office-chair",
        "seat",
        "sit"
      ]
    },
    "home-furniture/lamp": {
      "name": "Lamp",
      "slug": "lamp",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/lamp",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/lamp.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/lamp.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/lamp.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/lamp.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/lamp.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/lamp.svg"
        }
      ],
      "tags": [
        "decor",
        "desk-lamp",
        "furniture",
        "home",
        "house",
        "illuminate",
        "interior",
        "light",
        "living",
        "reading",
        "table-lamp"
      ]
    },
    "home-furniture/floor-lamp": {
      "name": "Floor Lamp",
      "slug": "floor-lamp",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/floor-lamp",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/floor-lamp.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/floor-lamp.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/floor-lamp.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/floor-lamp.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/floor-lamp.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/floor-lamp.svg"
        }
      ],
      "tags": [
        "ambient",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "light",
        "living",
        "reading",
        "standing-lamp"
      ]
    },
    "home-furniture/floor-lamp-minimalistic": {
      "name": "Floor Lamp Minimalistic",
      "slug": "floor-lamp-minimalistic",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/floor-lamp-minimalistic",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/floor-lamp-minimalistic.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/floor-lamp-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/floor-lamp-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/floor-lamp-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/floor-lamp-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/floor-lamp-minimalistic.svg"
        }
      ],
      "tags": [
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "light",
        "living",
        "minimal",
        "standing-lamp"
      ]
    },
    "home-furniture/bedside-table": {
      "name": "Bedside Table",
      "slug": "bedside-table",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bedside-table",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bedside-table.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bedside-table.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bedside-table.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bedside-table.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bedside-table.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bedside-table.svg"
        }
      ],
      "tags": [
        "bedroom",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "nightstand",
        "side-table"
      ]
    },
    "home-furniture/bedside-table-2": {
      "name": "Bedside Table 2",
      "slug": "bedside-table-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bedside-table-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bedside-table-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bedside-table-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bedside-table-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bedside-table-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bedside-table-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bedside-table-2.svg"
        }
      ],
      "tags": [
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "nightstand",
        "side-table"
      ]
    },
    "home-furniture/bedside-table-3": {
      "name": "Bedside Table 3",
      "slug": "bedside-table-3",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bedside-table-3",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bedside-table-3.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bedside-table-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bedside-table-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bedside-table-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bedside-table-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bedside-table-3.svg"
        }
      ],
      "tags": [
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "nightstand",
        "side-table"
      ]
    },
    "home-furniture/smart-vacuum-cleaner": {
      "name": "Smart Vacuum Cleaner",
      "slug": "smart-vacuum-cleaner",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/smart-vacuum-cleaner",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/smart-vacuum-cleaner.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/smart-vacuum-cleaner.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/smart-vacuum-cleaner.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/smart-vacuum-cleaner.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/smart-vacuum-cleaner.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/smart-vacuum-cleaner.svg"
        }
      ],
      "tags": [
        "automated",
        "clean",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "robot",
        "roomba"
      ]
    },
    "home-furniture/smart-vacuum-cleaner-2": {
      "name": "Smart Vacuum Cleaner 2",
      "slug": "smart-vacuum-cleaner-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/smart-vacuum-cleaner-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/smart-vacuum-cleaner-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/smart-vacuum-cleaner-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/smart-vacuum-cleaner-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/smart-vacuum-cleaner-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/smart-vacuum-cleaner-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/smart-vacuum-cleaner-2.svg"
        }
      ],
      "tags": [
        "clean",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "robot",
        "roomba"
      ]
    },
    "home-furniture/fridge": {
      "name": "Fridge",
      "slug": "fridge",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/fridge",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/fridge.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/fridge.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/fridge.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/fridge.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/fridge.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/fridge.svg"
        }
      ],
      "tags": [
        "appliance",
        "cold",
        "decor",
        "freezer",
        "furniture",
        "home",
        "house",
        "interior",
        "kitchen",
        "living",
        "refrigerator"
      ]
    },
    "home-furniture/armchair": {
      "name": "Armchair",
      "slug": "armchair",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/armchair",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/armchair.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/armchair.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/armchair.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/armchair.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/armchair.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/armchair.svg"
        }
      ],
      "tags": [
        "chair",
        "comfortable",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "lounge",
        "relax",
        "seat"
      ]
    },
    "home-furniture/armchair-2": {
      "name": "Armchair 2",
      "slug": "armchair-2",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/armchair-2",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/armchair-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/armchair-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/armchair-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/armchair-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/armchair-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/armchair-2.svg"
        }
      ],
      "tags": [
        "chair",
        "comfortable",
        "decor",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "lounge",
        "seat"
      ]
    },
    "home-furniture/chair": {
      "name": "Chair",
      "slug": "chair",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/chair",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/chair.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/chair.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/chair.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/chair.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/chair.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/chair.svg"
        }
      ],
      "tags": [
        "decor",
        "dining",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "seat",
        "sit",
        "wooden"
      ]
    },
    "home-furniture/bar-chair": {
      "name": "Bar Chair",
      "slug": "bar-chair",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/bar-chair",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/bar-chair.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/bar-chair.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/bar-chair.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/bar-chair.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/bar-chair.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/bar-chair.svg"
        }
      ],
      "tags": [
        "counter",
        "decor",
        "furniture",
        "high-chair",
        "home",
        "house",
        "interior",
        "kitchen",
        "living",
        "stool"
      ]
    },
    "home-furniture/volume-knob": {
      "name": "Volume Knob",
      "slug": "volume-knob",
      "category": "home-furniture",
      "categoryName": "Home, Furniture",
      "id": "home-furniture/volume-knob",
      "weights": [
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/home-furniture/volume-knob.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/home-furniture/volume-knob.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/home-furniture/volume-knob.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/home-furniture/volume-knob.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/home-furniture/volume-knob.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/home-furniture/volume-knob.svg"
        }
      ],
      "tags": [
        "adjust",
        "audio",
        "control",
        "decor",
        "dial",
        "furniture",
        "home",
        "house",
        "interior",
        "living",
        "turn"
      ]
    },
    "network-it-programming/wi-fi-router-round": {
      "name": "Wi-Fi Router Round",
      "slug": "wi-fi-router-round",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/wi-fi-router-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/wi-fi-router-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/wi-fi-router-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/wi-fi-router-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/wi-fi-router-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/wi-fi-router-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/wi-fi-router-round.svg"
        }
      ],
      "tags": [
        "IT",
        "WiFi",
        "code",
        "coding",
        "developer",
        "internet",
        "programming",
        "software",
        "tech",
        "web",
        "wireless"
      ]
    },
    "network-it-programming/wi-fi-router-minimalistic": {
      "name": "Wi-Fi Router Minimalistic",
      "slug": "wi-fi-router-minimalistic",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/wi-fi-router-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/wi-fi-router-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/wi-fi-router-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/wi-fi-router-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/wi-fi-router-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/wi-fi-router-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/wi-fi-router-minimalistic.svg"
        }
      ],
      "tags": [
        "IT",
        "WiFi",
        "code",
        "coding",
        "developer",
        "internet",
        "minimal",
        "programming",
        "software",
        "tech",
        "web",
        "wireless"
      ]
    },
    "network-it-programming/wi-fi-router": {
      "name": "Wi-Fi Router",
      "slug": "wi-fi-router",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/wi-fi-router",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/wi-fi-router.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/wi-fi-router.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/wi-fi-router.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/wi-fi-router.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/wi-fi-router.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/wi-fi-router.svg"
        }
      ],
      "tags": [
        "IT",
        "WiFi",
        "broadband",
        "code",
        "coding",
        "connectivity",
        "developer",
        "internet",
        "network",
        "programming",
        "software",
        "tech",
        "web",
        "wireless"
      ]
    },
    "network-it-programming/sidebar-minimalistic": {
      "name": "Sidebar Minimalistic",
      "slug": "sidebar-minimalistic",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/sidebar-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/sidebar-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/sidebar-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/sidebar-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/sidebar-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/sidebar-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/sidebar-minimalistic.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "layout",
        "navigation",
        "panel",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/siderbar": {
      "name": "Siderbar",
      "slug": "siderbar",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/siderbar",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/siderbar.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/siderbar.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/siderbar.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/siderbar.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/siderbar.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/siderbar.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "layout",
        "menu",
        "navigation",
        "panel",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/sidebar-code": {
      "name": "Sidebar Code",
      "slug": "sidebar-code",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/sidebar-code",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/sidebar-code.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/sidebar-code.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/sidebar-code.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/sidebar-code.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/sidebar-code.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/sidebar-code.svg"
        }
      ],
      "tags": [
        "IDE",
        "IT",
        "code",
        "coding",
        "developer",
        "editor",
        "panel",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/translation-2": {
      "name": "Translation 2",
      "slug": "translation-2",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/translation-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/translation-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/translation-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/translation-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/translation-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/translation-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/translation-2.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "i18n",
        "language",
        "localization",
        "programming",
        "software",
        "tech",
        "translate",
        "web"
      ]
    },
    "network-it-programming/window-frame": {
      "name": "Window Frame",
      "slug": "window-frame",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/window-frame",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/window-frame.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/window-frame.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/window-frame.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/window-frame.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/window-frame.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/window-frame.svg"
        }
      ],
      "tags": [
        "IT",
        "app",
        "application",
        "browser",
        "code",
        "coding",
        "developer",
        "programming",
        "software",
        "tab",
        "tech",
        "web",
        "window"
      ]
    },
    "network-it-programming/usb-circle": {
      "name": "USB Circle",
      "slug": "usb-circle",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/usb-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/usb-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/usb-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/usb-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/usb-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/usb-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/usb-circle.svg"
        }
      ],
      "tags": [
        "IT",
        "cable",
        "code",
        "coding",
        "connection",
        "developer",
        "plug",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/usb": {
      "name": "USB",
      "slug": "usb",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/usb",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/usb.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/usb.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/usb.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/usb.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/usb.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/usb.svg"
        }
      ],
      "tags": [
        "IT",
        "cable",
        "code",
        "coding",
        "connection",
        "data-transfer",
        "developer",
        "plug",
        "port",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/usb-square": {
      "name": "USB Square",
      "slug": "usb-square",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/usb-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/usb-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/usb-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/usb-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/usb-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/usb-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/usb-square.svg"
        }
      ],
      "tags": [
        "IT",
        "cable",
        "code",
        "coding",
        "connection",
        "developer",
        "plug",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/screencast": {
      "name": "Screencast",
      "slug": "screencast",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/screencast",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/screencast.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/screencast.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/screencast.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/screencast.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/screencast.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/screencast.svg"
        }
      ],
      "tags": [
        "IT",
        "broadcast",
        "code",
        "coding",
        "demo",
        "developer",
        "present",
        "programming",
        "share-screen",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/code-circle": {
      "name": "Code Circle",
      "slug": "code-circle",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/code-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/code-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/code-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/code-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/code-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/code-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/code-circle.svg"
        }
      ],
      "tags": [
        "IT",
        "brackets",
        "circle",
        "code",
        "coding",
        "developer",
        "development",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/code-square": {
      "name": "Code Square",
      "slug": "code-square",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/code-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/code-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/code-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/code-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/code-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/code-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/code-square.svg"
        }
      ],
      "tags": [
        "IT",
        "brackets",
        "code",
        "coding",
        "developer",
        "development",
        "programming",
        "software",
        "square",
        "tech",
        "web"
      ]
    },
    "network-it-programming/code": {
      "name": "Code",
      "slug": "code",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/code",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/code.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/code.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/code.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/code.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/code.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/code.svg"
        }
      ],
      "tags": [
        "HTML",
        "IT",
        "brackets",
        "code",
        "coding",
        "developer",
        "development",
        "markup",
        "programming",
        "software",
        "syntax",
        "tech",
        "web"
      ]
    },
    "network-it-programming/code-2": {
      "name": "Code 2",
      "slug": "code-2",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/code-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/code-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/code-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/code-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/code-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/code-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/code-2.svg"
        }
      ],
      "tags": [
        "HTML",
        "IT",
        "brackets",
        "code",
        "coding",
        "developer",
        "development",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/slash-square": {
      "name": "Slash Square",
      "slug": "slash-square",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/slash-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/slash-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/slash-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/slash-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/slash-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/slash-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/slash-square.svg"
        }
      ],
      "tags": [
        "IT",
        "cancel",
        "code",
        "coding",
        "developer",
        "disabled",
        "no",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/slash-circle": {
      "name": "Slash Circle",
      "slug": "slash-circle",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/slash-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/slash-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/slash-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/slash-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/slash-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/slash-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/slash-circle.svg"
        }
      ],
      "tags": [
        "IT",
        "cancel",
        "code",
        "coding",
        "developer",
        "disabled",
        "forbidden",
        "no",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/programming": {
      "name": "Programming",
      "slug": "programming",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/programming",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/programming.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/programming.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/programming.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/programming.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/programming.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/programming.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "develop",
        "developer",
        "engineer",
        "programming",
        "script",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/screencast-2": {
      "name": "Screencast 2",
      "slug": "screencast-2",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/screencast-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/screencast-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/screencast-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/screencast-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/screencast-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/screencast-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/screencast-2.svg"
        }
      ],
      "tags": [
        "IT",
        "broadcast",
        "code",
        "coding",
        "developer",
        "present",
        "programming",
        "share-screen",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/translation": {
      "name": "Translation",
      "slug": "translation",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/translation",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/translation.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/translation.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/translation.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/translation.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/translation.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/translation.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "global",
        "i18n",
        "language",
        "localization",
        "programming",
        "software",
        "tech",
        "translate",
        "web"
      ]
    },
    "network-it-programming/station": {
      "name": "Station",
      "slug": "station",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/station",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/station.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/station.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/station.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/station.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/station.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/station.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "hub",
        "node",
        "programming",
        "server",
        "software",
        "tech",
        "web",
        "workstation"
      ]
    },
    "network-it-programming/station-minimalistic": {
      "name": "Station Minimalistic",
      "slug": "station-minimalistic",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/station-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/station-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/station-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/station-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/station-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/station-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/station-minimalistic.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "minimal",
        "programming",
        "server",
        "software",
        "tech",
        "web",
        "workstation"
      ]
    },
    "network-it-programming/structure": {
      "name": "Structure",
      "slug": "structure",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/structure",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/structure.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/structure.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/structure.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/structure.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/structure.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/structure.svg"
        }
      ],
      "tags": [
        "IT",
        "architecture",
        "code",
        "coding",
        "developer",
        "hierarchy",
        "org-chart",
        "programming",
        "sitemap",
        "software",
        "tech",
        "tree",
        "web"
      ]
    },
    "network-it-programming/command": {
      "name": "Command",
      "slug": "command",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/command",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/command.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/command.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/command.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/command.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/command.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/command.svg"
        }
      ],
      "tags": [
        "IT",
        "Mac",
        "cmd",
        "code",
        "coding",
        "developer",
        "keyboard",
        "programming",
        "shortcut",
        "software",
        "tech",
        "terminal",
        "web",
        "\u2318"
      ]
    },
    "network-it-programming/bug-minimalistic": {
      "name": "Bug Minimalistic",
      "slug": "bug-minimalistic",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/bug-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/bug-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/bug-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/bug-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/bug-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/bug-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/bug-minimalistic.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "debug",
        "defect",
        "developer",
        "error",
        "minimal",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/bug": {
      "name": "Bug",
      "slug": "bug",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/bug",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/bug.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/bug.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/bug.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/bug.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/bug.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/bug.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "debug",
        "defect",
        "developer",
        "error",
        "glitch",
        "issue",
        "problem",
        "programming",
        "software",
        "tech",
        "web"
      ]
    },
    "network-it-programming/hashtag": {
      "name": "Hashtag",
      "slug": "hashtag",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/hashtag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/hashtag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/hashtag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/hashtag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/hashtag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/hashtag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/hashtag.svg"
        }
      ],
      "tags": [
        "#",
        "IT",
        "code",
        "coding",
        "developer",
        "number",
        "pound",
        "programming",
        "social-media",
        "software",
        "tag",
        "tech",
        "topic",
        "web"
      ]
    },
    "network-it-programming/hashtag-square": {
      "name": "Hashtag Square",
      "slug": "hashtag-square",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/hashtag-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/hashtag-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/hashtag-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/hashtag-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/hashtag-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/hashtag-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/hashtag-square.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "number",
        "programming",
        "software",
        "tag",
        "tech",
        "topic",
        "web"
      ]
    },
    "network-it-programming/hashtag-circle": {
      "name": "Hashtag Circle",
      "slug": "hashtag-circle",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/hashtag-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/hashtag-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/hashtag-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/hashtag-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/hashtag-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/hashtag-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/hashtag-circle.svg"
        }
      ],
      "tags": [
        "IT",
        "code",
        "coding",
        "developer",
        "number",
        "programming",
        "software",
        "tag",
        "tech",
        "topic",
        "web"
      ]
    },
    "network-it-programming/hashtag-chat": {
      "name": "Hashtag Chat",
      "slug": "hashtag-chat",
      "category": "network-it-programming",
      "categoryName": "Network, IT, Programming",
      "id": "network-it-programming/hashtag-chat",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/network-it-programming/hashtag-chat.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/network-it-programming/hashtag-chat.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/network-it-programming/hashtag-chat.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/network-it-programming/hashtag-chat.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/network-it-programming/hashtag-chat.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/network-it-programming/hashtag-chat.svg"
        }
      ],
      "tags": [
        "IT",
        "channel",
        "code",
        "coding",
        "developer",
        "programming",
        "social",
        "software",
        "tag",
        "tech",
        "topic",
        "web"
      ]
    },
    "settings-fine-tuning/settings-minimalistic": {
      "name": "Settings Minimalistic",
      "slug": "settings-minimalistic",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/settings-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/settings-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/settings-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/settings-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/settings-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/settings-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/settings-minimalistic.svg"
        }
      ],
      "tags": [
        "admin",
        "cog",
        "configuration",
        "control",
        "customize",
        "gear",
        "minimal",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/settings": {
      "name": "Settings",
      "slug": "settings",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/settings",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/settings.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/settings.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/settings.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/settings.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/settings.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/settings.svg"
        }
      ],
      "tags": [
        "admin",
        "cog",
        "config",
        "configuration",
        "control",
        "customize",
        "gear",
        "options",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget": {
      "name": "Widget",
      "slug": "widget",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "card",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings",
        "tile"
      ]
    },
    "settings-fine-tuning/widget-2": {
      "name": "Widget 2",
      "slug": "widget-2",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-2.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget-6": {
      "name": "Widget 6",
      "slug": "widget-6",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-6",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-6.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-6.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-6.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-6.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-6.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-6.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget-3": {
      "name": "Widget 3",
      "slug": "widget-3",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-3.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget-4": {
      "name": "Widget 4",
      "slug": "widget-4",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-4.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget-5": {
      "name": "Widget 5",
      "slug": "widget-5",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-5",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-5.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-5.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-5.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-5.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-5.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-5.svg"
        }
      ],
      "tags": [
        "admin",
        "block",
        "component",
        "configuration",
        "control",
        "customize",
        "module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/widget-add": {
      "name": "Widget Add",
      "slug": "widget-add",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/widget-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/widget-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/widget-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/widget-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/widget-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/widget-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/widget-add.svg"
        }
      ],
      "tags": [
        "add-component",
        "admin",
        "configuration",
        "control",
        "create-widget",
        "customize",
        "new-module",
        "preferences",
        "settings"
      ]
    },
    "settings-fine-tuning/tuning-square": {
      "name": "Tuning Square",
      "slug": "tuning-square",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning-square.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "fine-tune",
        "preferences",
        "settings",
        "tweak"
      ]
    },
    "settings-fine-tuning/tuning-square-2": {
      "name": "Tuning Square 2",
      "slug": "tuning-square-2",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning-square-2.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "fine-tune",
        "preferences",
        "settings",
        "tweak"
      ]
    },
    "settings-fine-tuning/tuning": {
      "name": "Tuning",
      "slug": "tuning",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "equalizer",
        "fine-tune",
        "preferences",
        "settings",
        "sliders",
        "tweak"
      ]
    },
    "settings-fine-tuning/tuning-2": {
      "name": "Tuning 2",
      "slug": "tuning-2",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning-2.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "fine-tune",
        "preferences",
        "settings",
        "tweak"
      ]
    },
    "settings-fine-tuning/tuning-3": {
      "name": "Tuning 3",
      "slug": "tuning-3",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning-3.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "fine-tune",
        "preferences",
        "settings",
        "tweak"
      ]
    },
    "settings-fine-tuning/tuning-4": {
      "name": "Tuning 4",
      "slug": "tuning-4",
      "category": "settings-fine-tuning",
      "categoryName": "Settings, Fine Tuning",
      "id": "settings-fine-tuning/tuning-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/settings-fine-tuning/tuning-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/settings-fine-tuning/tuning-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/settings-fine-tuning/tuning-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/settings-fine-tuning/tuning-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/settings-fine-tuning/tuning-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/settings-fine-tuning/tuning-4.svg"
        }
      ],
      "tags": [
        "adjust",
        "admin",
        "configuration",
        "control",
        "customize",
        "fine-tune",
        "preferences",
        "settings",
        "tweak"
      ]
    },
    "text-formatting/eraser": {
      "name": "Eraser",
      "slug": "eraser",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/eraser",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/eraser.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/eraser.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/eraser.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/eraser.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/eraser.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/eraser.svg"
        }
      ],
      "tags": [
        "clean",
        "clear",
        "delete",
        "editor",
        "font",
        "formatting",
        "remove",
        "rubber",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/eraser-square": {
      "name": "Eraser Square",
      "slug": "eraser-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/eraser-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/eraser-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/eraser-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/eraser-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/eraser-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/eraser-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/eraser-square.svg"
        }
      ],
      "tags": [
        "clear",
        "delete",
        "editor",
        "font",
        "formatting",
        "remove",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/eraser-circle": {
      "name": "Eraser Circle",
      "slug": "eraser-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/eraser-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/eraser-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/eraser-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/eraser-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/eraser-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/eraser-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/eraser-circle.svg"
        }
      ],
      "tags": [
        "clear",
        "delete",
        "editor",
        "font",
        "formatting",
        "remove",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-italic": {
      "name": "Text Italic",
      "slug": "text-italic",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-italic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-italic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-italic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-italic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-italic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-italic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-italic.svg"
        }
      ],
      "tags": [
        "I",
        "editor",
        "emphasis",
        "font",
        "formatting",
        "italic",
        "slanted",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-italic-square": {
      "name": "Text Italic Square",
      "slug": "text-italic-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-italic-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-italic-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-italic-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-italic-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-italic-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-italic-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-italic-square.svg"
        }
      ],
      "tags": [
        "I",
        "editor",
        "font",
        "formatting",
        "italic",
        "slanted",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-italic-circle": {
      "name": "Text Italic Circle",
      "slug": "text-italic-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-italic-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-italic-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-italic-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-italic-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-italic-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-italic-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-italic-circle.svg"
        }
      ],
      "tags": [
        "I",
        "editor",
        "font",
        "formatting",
        "italic",
        "slanted",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-circle": {
      "name": "Text Circle",
      "slug": "text-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-circle.svg"
        }
      ],
      "tags": [
        "editor",
        "font",
        "formatting",
        "label",
        "text",
        "type",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-cross-circle": {
      "name": "Text Cross Circle",
      "slug": "text-cross-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-cross-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-cross-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-cross-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-cross-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-cross-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-cross-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-cross-circle.svg"
        }
      ],
      "tags": [
        "delete",
        "editor",
        "font",
        "formatting",
        "strikethrough",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-underline-circle": {
      "name": "Text Underline Circle",
      "slug": "text-underline-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-underline-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-underline-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-underline-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-underline-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-underline-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-underline-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-underline-circle.svg"
        }
      ],
      "tags": [
        "U",
        "editor",
        "font",
        "formatting",
        "text",
        "typography",
        "underline",
        "writing"
      ]
    },
    "text-formatting/text-bold-circle": {
      "name": "Text Bold Circle",
      "slug": "text-bold-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-bold-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-bold-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-bold-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-bold-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-bold-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-bold-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-bold-circle.svg"
        }
      ],
      "tags": [
        "B",
        "bold",
        "editor",
        "font",
        "formatting",
        "strong",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text": {
      "name": "Text",
      "slug": "text",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text.svg"
        }
      ],
      "tags": [
        "characters",
        "content",
        "editor",
        "font",
        "formatting",
        "label",
        "string",
        "text",
        "type",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-cross": {
      "name": "Text Cross",
      "slug": "text-cross",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-cross.svg"
        }
      ],
      "tags": [
        "delete",
        "editor",
        "font",
        "formatting",
        "remove-text",
        "strikethrough",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-square": {
      "name": "Text Square",
      "slug": "text-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-square.svg"
        }
      ],
      "tags": [
        "box",
        "editor",
        "font",
        "formatting",
        "label",
        "text",
        "type",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-cross-square": {
      "name": "Text Cross Square",
      "slug": "text-cross-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-cross-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-cross-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-cross-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-cross-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-cross-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-cross-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-cross-square.svg"
        }
      ],
      "tags": [
        "delete",
        "editor",
        "font",
        "formatting",
        "strikethrough",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-underline": {
      "name": "Text Underline",
      "slug": "text-underline",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-underline",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-underline.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-underline.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-underline.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-underline.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-underline.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-underline.svg"
        }
      ],
      "tags": [
        "U",
        "editor",
        "emphasis",
        "font",
        "formatting",
        "highlight",
        "text",
        "typography",
        "underline",
        "writing"
      ]
    },
    "text-formatting/text-underline-cross": {
      "name": "Text Underline Cross",
      "slug": "text-underline-cross",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-underline-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-underline-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-underline-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-underline-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-underline-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-underline-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-underline-cross.svg"
        }
      ],
      "tags": [
        "clear-format",
        "editor",
        "font",
        "formatting",
        "remove-underline",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-bold": {
      "name": "Text Bold",
      "slug": "text-bold",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-bold",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-bold.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-bold.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-bold.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-bold.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-bold.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-bold.svg"
        }
      ],
      "tags": [
        "B",
        "bold",
        "editor",
        "emphasis",
        "font",
        "formatting",
        "strong",
        "text",
        "typography",
        "weight",
        "writing"
      ]
    },
    "text-formatting/text-bold-square": {
      "name": "Text Bold Square",
      "slug": "text-bold-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-bold-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-bold-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-bold-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-bold-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-bold-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-bold-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-bold-square.svg"
        }
      ],
      "tags": [
        "B",
        "bold",
        "editor",
        "font",
        "formatting",
        "strong",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/paragraph-spacing": {
      "name": "Paragraph Spacing",
      "slug": "paragraph-spacing",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/paragraph-spacing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/paragraph-spacing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/paragraph-spacing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/paragraph-spacing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/paragraph-spacing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/paragraph-spacing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/paragraph-spacing.svg"
        }
      ],
      "tags": [
        "editor",
        "font",
        "formatting",
        "gap",
        "leading",
        "line-height",
        "spacing",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-square-2": {
      "name": "Text Square 2",
      "slug": "text-square-2",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-square-2.svg"
        }
      ],
      "tags": [
        "box",
        "editor",
        "font",
        "formatting",
        "label",
        "text",
        "type",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-selection": {
      "name": "Text Selection",
      "slug": "text-selection",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-selection",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-selection.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-selection.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-selection.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-selection.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-selection.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-selection.svg"
        }
      ],
      "tags": [
        "cursor",
        "editor",
        "font",
        "formatting",
        "highlight",
        "range",
        "select",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-circle": {
      "name": "Link Circle",
      "slug": "link-circle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-circle.svg"
        }
      ],
      "tags": [
        "URL",
        "chain",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-square": {
      "name": "Link Square",
      "slug": "link-square",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-square.svg"
        }
      ],
      "tags": [
        "URL",
        "chain",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-broken-minimalistic": {
      "name": "Link Broken Minimalistic",
      "slug": "link-broken-minimalistic",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-broken-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-broken-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-broken-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-broken-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-broken-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-broken-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-broken-minimalistic.svg"
        }
      ],
      "tags": [
        "disconnect",
        "editor",
        "font",
        "formatting",
        "minimal",
        "text",
        "typography",
        "unlink",
        "writing"
      ]
    },
    "text-formatting/link": {
      "name": "Link",
      "slug": "link",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link.svg"
        }
      ],
      "tags": [
        "URL",
        "chain",
        "connect",
        "editor",
        "font",
        "formatting",
        "href",
        "hyperlink",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-broken": {
      "name": "Link Broken",
      "slug": "link-broken",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-broken",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-broken.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-broken.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-broken.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-broken.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-broken.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-broken.svg"
        }
      ],
      "tags": [
        "broken-link",
        "disconnect",
        "editor",
        "font",
        "formatting",
        "text",
        "typography",
        "unlink",
        "writing"
      ]
    },
    "text-formatting/link-minimalistic": {
      "name": "Link Minimalistic",
      "slug": "link-minimalistic",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-minimalistic.svg"
        }
      ],
      "tags": [
        "URL",
        "chain",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "minimal",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-minimalistic-2": {
      "name": "Link Minimalistic 2",
      "slug": "link-minimalistic-2",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-minimalistic-2.svg"
        }
      ],
      "tags": [
        "URL",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "minimal",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-round": {
      "name": "Link Round",
      "slug": "link-round",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-round.svg"
        }
      ],
      "tags": [
        "URL",
        "chain",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/link-round-angle": {
      "name": "Link Round Angle",
      "slug": "link-round-angle",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/link-round-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/link-round-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/link-round-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/link-round-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/link-round-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/link-round-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/link-round-angle.svg"
        }
      ],
      "tags": [
        "URL",
        "angled",
        "editor",
        "font",
        "formatting",
        "hyperlink",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/backspace": {
      "name": "Backspace",
      "slug": "backspace",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/backspace",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/backspace.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/backspace.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/backspace.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/backspace.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/backspace.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/backspace.svg"
        }
      ],
      "tags": [
        "back",
        "clear",
        "delete",
        "editor",
        "erase",
        "font",
        "formatting",
        "remove",
        "text",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-field": {
      "name": "Text Field",
      "slug": "text-field",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-field",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-field.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-field.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-field.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-field.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-field.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-field.svg"
        }
      ],
      "tags": [
        "editor",
        "field",
        "font",
        "form",
        "formatting",
        "input",
        "text",
        "textbox",
        "typography",
        "writing"
      ]
    },
    "text-formatting/text-field-focus": {
      "name": "Text Field Focus",
      "slug": "text-field-focus",
      "category": "text-formatting",
      "categoryName": "Text Formatting",
      "id": "text-formatting/text-field-focus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/text-formatting/text-field-focus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/text-formatting/text-field-focus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/text-formatting/text-field-focus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/text-formatting/text-field-focus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/text-formatting/text-field-focus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/text-formatting/text-field-focus.svg"
        }
      ],
      "tags": [
        "active",
        "cursor",
        "editing",
        "editor",
        "font",
        "formatting",
        "input",
        "text",
        "typography",
        "writing"
      ]
    },
    "business-statistic/pie-chart": {
      "name": "Pie Chart",
      "slug": "pie-chart",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/pie-chart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/pie-chart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/pie-chart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/pie-chart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/pie-chart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/pie-chart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/pie-chart.svg"
        }
      ],
      "tags": [
        "analytics",
        "breakdown",
        "business",
        "chart",
        "dashboard",
        "data",
        "donut-chart",
        "percentage",
        "proportion",
        "reporting",
        "segment",
        "statistics"
      ]
    },
    "business-statistic/pie-chart-2": {
      "name": "Pie Chart 2",
      "slug": "pie-chart-2",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/pie-chart-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/pie-chart-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/pie-chart-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/pie-chart-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/pie-chart-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/pie-chart-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/pie-chart-2.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "donut-chart",
        "percentage",
        "proportion",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/pie-chart-3": {
      "name": "Pie Chart 3",
      "slug": "pie-chart-3",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/pie-chart-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/pie-chart-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/pie-chart-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/pie-chart-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/pie-chart-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/pie-chart-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/pie-chart-3.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "donut-chart",
        "percentage",
        "proportion",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/round-graph": {
      "name": "Round Graph",
      "slug": "round-graph",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/round-graph",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/round-graph.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/round-graph.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/round-graph.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/round-graph.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/round-graph.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/round-graph.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "circular",
        "dashboard",
        "data",
        "gauge",
        "meter",
        "radial",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/graph": {
      "name": "Graph",
      "slug": "graph",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "line-graph",
        "reporting",
        "statistics",
        "trend",
        "visualization"
      ]
    },
    "business-statistic/graph-up": {
      "name": "Graph Up",
      "slug": "graph-up",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph-up.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "growth",
        "increase",
        "positive",
        "profit",
        "reporting",
        "statistics",
        "success"
      ]
    },
    "business-statistic/graph-new": {
      "name": "Graph New",
      "slug": "graph-new",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph-new",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph-new.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph-new.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph-new.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph-new.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph-new.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph-new.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "fresh",
        "recent",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/graph-new-up": {
      "name": "Graph New Up",
      "slug": "graph-new-up",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph-new-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph-new-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph-new-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph-new-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph-new-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph-new-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph-new-up.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "growth",
        "increase",
        "positive",
        "recent",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/graph-down": {
      "name": "Graph Down",
      "slug": "graph-down",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph-down.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "decline",
        "decrease",
        "loss",
        "negative",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/graph-down-new": {
      "name": "Graph Down New",
      "slug": "graph-down-new",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/graph-down-new",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/graph-down-new.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/graph-down-new.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/graph-down-new.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/graph-down-new.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/graph-down-new.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/graph-down-new.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "decline",
        "decrease",
        "loss",
        "recent",
        "reporting",
        "statistics"
      ]
    },
    "business-statistic/presentation-graph": {
      "name": "Presentation Graph",
      "slug": "presentation-graph",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/presentation-graph",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/presentation-graph.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/presentation-graph.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/presentation-graph.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/presentation-graph.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/presentation-graph.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/presentation-graph.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "deck",
        "meeting",
        "pitch",
        "projector",
        "reporting",
        "slideshow",
        "statistics"
      ]
    },
    "business-statistic/diagram-up": {
      "name": "Diagram Up",
      "slug": "diagram-up",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/diagram-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/diagram-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/diagram-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/diagram-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/diagram-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/diagram-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/diagram-up.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "flowchart",
        "growth",
        "increase",
        "reporting",
        "statistics",
        "trend"
      ]
    },
    "business-statistic/diagram-down": {
      "name": "Diagram Down",
      "slug": "diagram-down",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/diagram-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/diagram-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/diagram-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/diagram-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/diagram-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/diagram-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/diagram-down.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "decline",
        "decrease",
        "flowchart",
        "reporting",
        "statistics",
        "trend"
      ]
    },
    "business-statistic/chart": {
      "name": "Chart",
      "slug": "chart",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/chart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/chart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/chart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/chart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/chart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/chart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/chart.svg"
        }
      ],
      "tags": [
        "analytics",
        "bar-chart",
        "business",
        "chart",
        "dashboard",
        "data",
        "graph",
        "report",
        "reporting",
        "statistics",
        "visualization"
      ]
    },
    "business-statistic/chart-square": {
      "name": "Chart Square",
      "slug": "chart-square",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/chart-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/chart-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/chart-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/chart-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/chart-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/chart-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/chart-square.svg"
        }
      ],
      "tags": [
        "analytics",
        "bar-chart",
        "business",
        "chart",
        "dashboard",
        "data",
        "graph",
        "report",
        "reporting",
        "statistics",
        "visualization"
      ]
    },
    "business-statistic/chat-square-2": {
      "name": "Chat Square 2",
      "slug": "chat-square-2",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/chat-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/chat-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/chat-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/chat-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/chat-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/chat-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/chat-square-2.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "graph",
        "reporting",
        "statistics",
        "visualization"
      ]
    },
    "business-statistic/course-up": {
      "name": "Course Up",
      "slug": "course-up",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/course-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/course-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/course-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/course-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/course-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/course-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/course-up.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "gain",
        "growth",
        "increase",
        "profit",
        "reporting",
        "rise",
        "statistics",
        "trend"
      ]
    },
    "business-statistic/course-down": {
      "name": "Course Down",
      "slug": "course-down",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/course-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/course-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/course-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/course-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/course-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/course-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/course-down.svg"
        }
      ],
      "tags": [
        "analytics",
        "business",
        "chart",
        "dashboard",
        "data",
        "decline",
        "decrease",
        "drop",
        "loss",
        "reporting",
        "statistics",
        "trend"
      ]
    },
    "business-statistic/chart-2": {
      "name": "Chart 2",
      "slug": "chart-2",
      "category": "business-statistic",
      "categoryName": "Business, Statistic",
      "id": "business-statistic/chart-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/business-statistic/chart-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/business-statistic/chart-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/business-statistic/chart-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/business-statistic/chart-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/business-statistic/chart-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/business-statistic/chart-2.svg"
        }
      ],
      "tags": [
        "analytics",
        "bar-chart",
        "business",
        "chart",
        "dashboard",
        "data",
        "graph",
        "report",
        "reporting",
        "statistics",
        "visualization"
      ]
    },
    "shopping-ecommerce/cart-4": {
      "name": "Cart 4",
      "slug": "cart-4",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-4.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-large": {
      "name": "Cart Large",
      "slug": "cart-large",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-large",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-large.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-large.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-large.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-large.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-large.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-large.svg"
        }
      ],
      "tags": [
        "big",
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-large-2": {
      "name": "Cart Large 2",
      "slug": "cart-large-2",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-large-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-large-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-large-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-large-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-large-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-large-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-large-2.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-large-minimalistic": {
      "name": "Cart Large Minimalistic",
      "slug": "cart-large-minimalistic",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-large-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-large-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-large-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-large-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-large-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-large-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-large-minimalistic.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "minimal",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store"
      ]
    },
    "shopping-ecommerce/cart-check": {
      "name": "Cart Check",
      "slug": "cart-check",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-check.svg"
        }
      ],
      "tags": [
        "buy",
        "checkout",
        "commerce",
        "confirmed",
        "ecommerce",
        "order",
        "purchase",
        "purchased",
        "retail",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/cart-cross": {
      "name": "Cart Cross",
      "slug": "cart-cross",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-cross.svg"
        }
      ],
      "tags": [
        "buy",
        "cancelled",
        "commerce",
        "ecommerce",
        "empty-cart",
        "purchase",
        "remove-item",
        "retail",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/cart-plus": {
      "name": "Cart Plus",
      "slug": "cart-plus",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-plus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-plus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-plus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-plus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-plus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-plus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-plus.svg"
        }
      ],
      "tags": [
        "add-item",
        "add-to-cart",
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/cart-large-3": {
      "name": "Cart Large 3",
      "slug": "cart-large-3",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-large-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-large-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-large-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-large-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-large-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-large-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-large-3.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-large-4": {
      "name": "Cart Large 4",
      "slug": "cart-large-4",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-large-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-large-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-large-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-large-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-large-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-large-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-large-4.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart": {
      "name": "Cart",
      "slug": "cart",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart.svg"
        }
      ],
      "tags": [
        "basket",
        "buy",
        "checkout",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-2": {
      "name": "Cart 2",
      "slug": "cart-2",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-2.svg"
        }
      ],
      "tags": [
        "basket",
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-3": {
      "name": "Cart 3",
      "slug": "cart-3",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-3.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/cart-5": {
      "name": "Cart 5",
      "slug": "cart-5",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/cart-5",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/cart-5.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/cart-5.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/cart-5.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/cart-5.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/cart-5.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/cart-5.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-cart",
        "store",
        "trolley"
      ]
    },
    "shopping-ecommerce/bag": {
      "name": "Bag",
      "slug": "bag",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag.svg"
        }
      ],
      "tags": [
        "buy",
        "carrier",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-bag",
        "store",
        "tote"
      ]
    },
    "shopping-ecommerce/bag-check": {
      "name": "Bag Check",
      "slug": "bag-check",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-check.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "confirmed",
        "ecommerce",
        "order-complete",
        "purchase",
        "purchased",
        "retail",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/bag-cross": {
      "name": "Bag Cross",
      "slug": "bag-cross",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-cross.svg"
        }
      ],
      "tags": [
        "buy",
        "cancelled",
        "commerce",
        "ecommerce",
        "empty",
        "purchase",
        "removed",
        "retail",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/bag-2": {
      "name": "Bag 2",
      "slug": "bag-2",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-2.svg"
        }
      ],
      "tags": [
        "buy",
        "carrier",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-bag",
        "store",
        "tote"
      ]
    },
    "shopping-ecommerce/bag-3": {
      "name": "Bag 3",
      "slug": "bag-3",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-3.svg"
        }
      ],
      "tags": [
        "buy",
        "carrier",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-bag",
        "store",
        "tote"
      ]
    },
    "shopping-ecommerce/bag-4": {
      "name": "Bag 4",
      "slug": "bag-4",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-4",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-4.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-4.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-4.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-4.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-4.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-4.svg"
        }
      ],
      "tags": [
        "buy",
        "carrier",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-bag",
        "store",
        "tote"
      ]
    },
    "shopping-ecommerce/bag-music": {
      "name": "Bag Music",
      "slug": "bag-music",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-music",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-music.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-music.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-music.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-music.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-music.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-music.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "music-store",
        "purchase",
        "records",
        "retail",
        "shopping",
        "store",
        "vinyl"
      ]
    },
    "shopping-ecommerce/bag-smile": {
      "name": "Bag Smile",
      "slug": "bag-smile",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-smile",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-smile.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-smile.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-smile.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-smile.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-smile.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-smile.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "good-purchase",
        "happy-shopping",
        "purchase",
        "retail",
        "satisfied",
        "shopping",
        "store"
      ]
    },
    "shopping-ecommerce/bag-music-2": {
      "name": "Bag Music 2",
      "slug": "bag-music-2",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-music-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-music-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-music-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-music-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-music-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-music-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-music-2.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "music-store",
        "purchase",
        "retail",
        "shopping",
        "store",
        "vinyl"
      ]
    },
    "shopping-ecommerce/bag-5": {
      "name": "Bag 5",
      "slug": "bag-5",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-5",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-5.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-5.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-5.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-5.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-5.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-5.svg"
        }
      ],
      "tags": [
        "buy",
        "carrier",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "shopping-bag",
        "store",
        "tote"
      ]
    },
    "shopping-ecommerce/bag-heart": {
      "name": "Bag Heart",
      "slug": "bag-heart",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/bag-heart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/bag-heart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/bag-heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/bag-heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/bag-heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/bag-heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/bag-heart.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "favourite",
        "liked",
        "purchase",
        "retail",
        "saved",
        "shopping",
        "store",
        "wishlist"
      ]
    },
    "shopping-ecommerce/shop": {
      "name": "Shop",
      "slug": "shop",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/shop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/shop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/shop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/shop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/shop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/shop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/shop.svg"
        }
      ],
      "tags": [
        "business",
        "buy",
        "commerce",
        "ecommerce",
        "market",
        "purchase",
        "retail",
        "shopping",
        "store",
        "storefront"
      ]
    },
    "shopping-ecommerce/shop-minimalistic": {
      "name": "Shop Minimalistic",
      "slug": "shop-minimalistic",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/shop-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/shop-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/shop-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/shop-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/shop-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/shop-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/shop-minimalistic.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "minimal",
        "purchase",
        "retail",
        "shopping",
        "store",
        "storefront"
      ]
    },
    "shopping-ecommerce/shop-2": {
      "name": "Shop 2",
      "slug": "shop-2",
      "category": "shopping-ecommerce",
      "categoryName": "Shopping, Ecommerce",
      "id": "shopping-ecommerce/shop-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/shopping-ecommerce/shop-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/shopping-ecommerce/shop-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/shopping-ecommerce/shop-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/shopping-ecommerce/shop-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/shopping-ecommerce/shop-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/shopping-ecommerce/shop-2.svg"
        }
      ],
      "tags": [
        "buy",
        "commerce",
        "ecommerce",
        "purchase",
        "retail",
        "shopping",
        "store",
        "storefront"
      ]
    },
    "nature-travel/fire": {
      "name": "Fire",
      "slug": "fire",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/fire",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/fire.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/fire.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/fire.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/fire.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/fire.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/fire.svg"
        }
      ],
      "tags": [
        "adventure",
        "blaze",
        "burn",
        "flame",
        "heat",
        "hot",
        "nature",
        "outdoor",
        "travel",
        "trending"
      ]
    },
    "nature-travel/flame": {
      "name": "Flame",
      "slug": "flame",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/flame",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/flame.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/flame.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/flame.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/flame.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/flame.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/flame.svg"
        }
      ],
      "tags": [
        "adventure",
        "blaze",
        "burn",
        "fire",
        "heat",
        "hot",
        "nature",
        "outdoor",
        "travel"
      ]
    },
    "nature-travel/fire-minimalistic": {
      "name": "Fire Minimalistic",
      "slug": "fire-minimalistic",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/fire-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/fire-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/fire-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/fire-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/fire-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/fire-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/fire-minimalistic.svg"
        }
      ],
      "tags": [
        "adventure",
        "burn",
        "flame",
        "hot",
        "minimal",
        "nature",
        "outdoor",
        "travel"
      ]
    },
    "nature-travel/fire-square": {
      "name": "Fire Square",
      "slug": "fire-square",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/fire-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/fire-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/fire-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/fire-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/fire-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/fire-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/fire-square.svg"
        }
      ],
      "tags": [
        "adventure",
        "burn",
        "contained",
        "flame",
        "hot",
        "nature",
        "outdoor",
        "travel"
      ]
    },
    "nature-travel/bonfire": {
      "name": "Bonfire",
      "slug": "bonfire",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/bonfire",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/bonfire.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/bonfire.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/bonfire.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/bonfire.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/bonfire.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/bonfire.svg"
        }
      ],
      "tags": [
        "adventure",
        "campfire",
        "camping",
        "flame",
        "nature",
        "outdoor",
        "travel",
        "warm"
      ]
    },
    "nature-travel/leaf": {
      "name": "Leaf",
      "slug": "leaf",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/leaf",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/leaf.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/leaf.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/leaf.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/leaf.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/leaf.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/leaf.svg"
        }
      ],
      "tags": [
        "adventure",
        "eco",
        "environment",
        "green",
        "natural",
        "nature",
        "organic",
        "outdoor",
        "plant",
        "travel",
        "tree"
      ]
    },
    "nature-travel/suitcase": {
      "name": "Suitcase",
      "slug": "suitcase",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/suitcase",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/suitcase.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/suitcase.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/suitcase.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/suitcase.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/suitcase.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/suitcase.svg"
        }
      ],
      "tags": [
        "adventure",
        "baggage",
        "holiday",
        "luggage",
        "nature",
        "outdoor",
        "travel",
        "trip",
        "vacation"
      ]
    },
    "nature-travel/suitcase-tag": {
      "name": "Suitcase Tag",
      "slug": "suitcase-tag",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/suitcase-tag",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/suitcase-tag.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/suitcase-tag.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/suitcase-tag.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/suitcase-tag.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/suitcase-tag.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/suitcase-tag.svg"
        }
      ],
      "tags": [
        "adventure",
        "baggage",
        "label",
        "luggage",
        "nature",
        "outdoor",
        "travel"
      ]
    },
    "nature-travel/suitcase-lines": {
      "name": "Suitcase Lines",
      "slug": "suitcase-lines",
      "category": "nature-travel",
      "categoryName": "Nature, Travel",
      "id": "nature-travel/suitcase-lines",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/nature-travel/suitcase-lines.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/nature-travel/suitcase-lines.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/nature-travel/suitcase-lines.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/nature-travel/suitcase-lines.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/nature-travel/suitcase-lines.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/nature-travel/suitcase-lines.svg"
        }
      ],
      "tags": [
        "adventure",
        "baggage",
        "luggage",
        "nature",
        "outdoor",
        "travel"
      ]
    },
    "school/diploma": {
      "name": "Diploma",
      "slug": "diploma",
      "category": "school",
      "categoryName": "School",
      "id": "school/diploma",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/diploma.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/diploma.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/diploma.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/diploma.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/diploma.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/diploma.svg"
        }
      ],
      "tags": [
        "academic",
        "award",
        "certificate",
        "degree",
        "education",
        "graduation",
        "knowledge",
        "learning",
        "qualification",
        "school",
        "study"
      ]
    },
    "school/diploma-verified": {
      "name": "Diploma Verified",
      "slug": "diploma-verified",
      "category": "school",
      "categoryName": "School",
      "id": "school/diploma-verified",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/diploma-verified.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/diploma-verified.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/diploma-verified.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/diploma-verified.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/diploma-verified.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/diploma-verified.svg"
        }
      ],
      "tags": [
        "academic",
        "accredited",
        "certified",
        "education",
        "knowledge",
        "learning",
        "school",
        "study",
        "verified"
      ]
    },
    "school/case-round-minimalistic": {
      "name": "Case Round Minimalistic",
      "slug": "case-round-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/case-round-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/case-round-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/case-round-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/case-round-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/case-round-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/case-round-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/case-round-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "briefcase",
        "education",
        "knowledge",
        "learning",
        "minimal",
        "portfolio",
        "school",
        "study"
      ]
    },
    "school/case-minimalistic": {
      "name": "Case Minimalistic",
      "slug": "case-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/case-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/case-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/case-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/case-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/case-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/case-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/case-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "briefcase",
        "education",
        "knowledge",
        "learning",
        "minimal",
        "portfolio",
        "school",
        "study"
      ]
    },
    "school/case": {
      "name": "Case",
      "slug": "case",
      "category": "school",
      "categoryName": "School",
      "id": "school/case",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/case.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/case.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/case.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/case.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/case.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/case.svg"
        }
      ],
      "tags": [
        "academic",
        "briefcase",
        "business",
        "education",
        "knowledge",
        "learning",
        "portfolio",
        "professional",
        "school",
        "study",
        "work"
      ]
    },
    "school/case-round": {
      "name": "Case Round",
      "slug": "case-round",
      "category": "school",
      "categoryName": "School",
      "id": "school/case-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/case-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/case-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/case-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/case-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/case-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/case-round.svg"
        }
      ],
      "tags": [
        "academic",
        "briefcase",
        "business",
        "education",
        "knowledge",
        "learning",
        "portfolio",
        "school",
        "study"
      ]
    },
    "school/square-academic-cap": {
      "name": "Square Academic Cap",
      "slug": "square-academic-cap",
      "category": "school",
      "categoryName": "School",
      "id": "school/square-academic-cap",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/square-academic-cap.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/square-academic-cap.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/square-academic-cap.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/square-academic-cap.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/square-academic-cap.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/square-academic-cap.svg"
        }
      ],
      "tags": [
        "academic",
        "degree",
        "education",
        "graduation",
        "hat",
        "knowledge",
        "learning",
        "mortarboard",
        "school",
        "study",
        "university"
      ]
    },
    "school/square-academic-cap-2": {
      "name": "Square Academic Cap 2",
      "slug": "square-academic-cap-2",
      "category": "school",
      "categoryName": "School",
      "id": "school/square-academic-cap-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/square-academic-cap-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/square-academic-cap-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/square-academic-cap-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/square-academic-cap-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/square-academic-cap-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/square-academic-cap-2.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "graduation",
        "knowledge",
        "learning",
        "mortarboard",
        "school",
        "study",
        "university"
      ]
    },
    "school/notebook-minimalistic": {
      "name": "Notebook Minimalistic",
      "slug": "notebook-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/notebook-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/notebook-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/notebook-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/notebook-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/notebook-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/notebook-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/notebook-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "journal",
        "knowledge",
        "learning",
        "minimal",
        "notepad",
        "school",
        "study"
      ]
    },
    "school/notebook-bookmark": {
      "name": "Notebook Bookmark",
      "slug": "notebook-bookmark",
      "category": "school",
      "categoryName": "School",
      "id": "school/notebook-bookmark",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/notebook-bookmark.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/notebook-bookmark.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/notebook-bookmark.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/notebook-bookmark.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/notebook-bookmark.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/notebook-bookmark.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "journal",
        "knowledge",
        "learning",
        "marked",
        "reading",
        "school",
        "study"
      ]
    },
    "school/notebook": {
      "name": "Notebook",
      "slug": "notebook",
      "category": "school",
      "categoryName": "School",
      "id": "school/notebook",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/notebook.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/notebook.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/notebook.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/notebook.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/notebook.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/notebook.svg"
        }
      ],
      "tags": [
        "academic",
        "book",
        "diary",
        "education",
        "journal",
        "knowledge",
        "learning",
        "memo",
        "notepad",
        "school",
        "study"
      ]
    },
    "school/notebook-square": {
      "name": "Notebook Square",
      "slug": "notebook-square",
      "category": "school",
      "categoryName": "School",
      "id": "school/notebook-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/notebook-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/notebook-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/notebook-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/notebook-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/notebook-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/notebook-square.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "journal",
        "knowledge",
        "learning",
        "notepad",
        "planner",
        "school",
        "study"
      ]
    },
    "school/book": {
      "name": "Book",
      "slug": "book",
      "category": "school",
      "categoryName": "School",
      "id": "school/book",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/book.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/book.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/book.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/book.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/book.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/book.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "library",
        "literature",
        "novel",
        "read",
        "school",
        "study",
        "textbook"
      ]
    },
    "school/book-minimalistic": {
      "name": "Book Minimalistic",
      "slug": "book-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/book-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/book-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/book-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/book-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/book-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/book-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/book-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "minimal",
        "read",
        "school",
        "study",
        "textbook"
      ]
    },
    "school/book-bookmark": {
      "name": "Book Bookmark",
      "slug": "book-bookmark",
      "category": "school",
      "categoryName": "School",
      "id": "school/book-bookmark",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/book-bookmark.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/book-bookmark.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/book-bookmark.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/book-bookmark.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/book-bookmark.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/book-bookmark.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "marked",
        "page",
        "reading",
        "saved",
        "school",
        "study"
      ]
    },
    "school/book-bookmark-minimalistic": {
      "name": "Book Bookmark Minimalistic",
      "slug": "book-bookmark-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/book-bookmark-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/book-bookmark-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/book-bookmark-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/book-bookmark-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/book-bookmark-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/book-bookmark-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/book-bookmark-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "minimal",
        "reading",
        "saved",
        "school",
        "study"
      ]
    },
    "school/book-2": {
      "name": "Book 2",
      "slug": "book-2",
      "category": "school",
      "categoryName": "School",
      "id": "school/book-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/book-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/book-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/book-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/book-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/book-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/book-2.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "novel",
        "read",
        "school",
        "study",
        "textbook"
      ]
    },
    "school/backpack": {
      "name": "Backpack",
      "slug": "backpack",
      "category": "school",
      "categoryName": "School",
      "id": "school/backpack",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/backpack.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/backpack.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/backpack.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/backpack.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/backpack.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/backpack.svg"
        }
      ],
      "tags": [
        "academic",
        "bag",
        "carry",
        "education",
        "hike",
        "knowledge",
        "learning",
        "rucksack",
        "school",
        "school-bag",
        "study"
      ]
    },
    "school/plus-minus": {
      "name": "Plus, Minus",
      "slug": "plus-minus",
      "category": "school",
      "categoryName": "School",
      "id": "school/plus-minus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/plus-minus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/plus-minus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/plus-minus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/plus-minus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/plus-minus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/plus-minus.svg"
        }
      ],
      "tags": [
        "academic",
        "arithmetic",
        "calculate",
        "education",
        "knowledge",
        "learning",
        "math",
        "school",
        "study",
        "\u00b1"
      ]
    },
    "school/calculator-minimalistic": {
      "name": "Calculator Minimalistic",
      "slug": "calculator-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/calculator-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/calculator-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/calculator-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/calculator-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/calculator-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/calculator-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/calculator-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "compute",
        "education",
        "knowledge",
        "learning",
        "math",
        "minimal",
        "school",
        "study"
      ]
    },
    "school/calculator": {
      "name": "Calculator",
      "slug": "calculator",
      "category": "school",
      "categoryName": "School",
      "id": "school/calculator",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/calculator.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/calculator.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/calculator.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/calculator.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/calculator.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/calculator.svg"
        }
      ],
      "tags": [
        "academic",
        "arithmetic",
        "calculate",
        "compute",
        "education",
        "knowledge",
        "learning",
        "math",
        "numbers",
        "school",
        "study"
      ]
    },
    "school/bookmark": {
      "name": "Bookmark",
      "slug": "bookmark",
      "category": "school",
      "categoryName": "School",
      "id": "school/bookmark",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/bookmark.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/bookmark.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/bookmark.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/bookmark.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/bookmark.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/bookmark.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "favourite",
        "flag",
        "knowledge",
        "later",
        "learning",
        "mark",
        "save",
        "school",
        "study"
      ]
    },
    "school/bookmark-square-minimalistic": {
      "name": "Bookmark Square Minimalistic",
      "slug": "bookmark-square-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/bookmark-square-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/bookmark-square-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/bookmark-square-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/bookmark-square-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/bookmark-square-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/bookmark-square-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/bookmark-square-minimalistic.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "favourite",
        "knowledge",
        "learning",
        "minimal",
        "save",
        "school",
        "study"
      ]
    },
    "school/bookmark-opened": {
      "name": "Bookmark Opened",
      "slug": "bookmark-opened",
      "category": "school",
      "categoryName": "School",
      "id": "school/bookmark-opened",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/bookmark-opened.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/bookmark-opened.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/bookmark-opened.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/bookmark-opened.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/bookmark-opened.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/bookmark-opened.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "knowledge",
        "learning",
        "open",
        "reading",
        "saved",
        "school",
        "study"
      ]
    },
    "school/bookmark-circle": {
      "name": "Bookmark Circle",
      "slug": "bookmark-circle",
      "category": "school",
      "categoryName": "School",
      "id": "school/bookmark-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/bookmark-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/bookmark-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/bookmark-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/bookmark-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/bookmark-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/bookmark-circle.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "favourite",
        "knowledge",
        "learning",
        "mark",
        "save",
        "school",
        "study"
      ]
    },
    "school/bookmark-square": {
      "name": "Bookmark Square",
      "slug": "bookmark-square",
      "category": "school",
      "categoryName": "School",
      "id": "school/bookmark-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/bookmark-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/bookmark-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/bookmark-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/bookmark-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/bookmark-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/bookmark-square.svg"
        }
      ],
      "tags": [
        "academic",
        "education",
        "favourite",
        "knowledge",
        "learning",
        "mark",
        "save",
        "school",
        "study"
      ]
    },
    "school/passport": {
      "name": "Passport",
      "slug": "passport",
      "category": "school",
      "categoryName": "School",
      "id": "school/passport",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/passport.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/passport.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/passport.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/passport.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/passport.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/passport.svg"
        }
      ],
      "tags": [
        "ID",
        "academic",
        "document",
        "education",
        "identity",
        "knowledge",
        "learning",
        "school",
        "study",
        "travel",
        "visa"
      ]
    },
    "school/passport-minimalistic": {
      "name": "Passport Minimalistic",
      "slug": "passport-minimalistic",
      "category": "school",
      "categoryName": "School",
      "id": "school/passport-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/passport-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/passport-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/passport-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/passport-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/passport-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/passport-minimalistic.svg"
        }
      ],
      "tags": [
        "ID",
        "academic",
        "education",
        "identity",
        "knowledge",
        "learning",
        "minimal",
        "school",
        "study",
        "travel"
      ]
    },
    "school/document": {
      "name": "Document",
      "slug": "document",
      "category": "school",
      "categoryName": "School",
      "id": "school/document",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/school/document.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/school/document.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/school/document.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/school/document.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/school/document.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/school/document.svg"
        }
      ],
      "tags": [
        "academic",
        "doc",
        "education",
        "file",
        "knowledge",
        "learning",
        "page",
        "paper",
        "school",
        "sheet",
        "study"
      ]
    },
    "design-tools/ruler": {
      "name": "Ruler",
      "slug": "ruler",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/ruler",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/ruler.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/ruler.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/ruler.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/ruler.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/ruler.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/ruler.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "dimension",
        "editor",
        "graphics",
        "length",
        "measure",
        "pixel",
        "size",
        "tools"
      ]
    },
    "design-tools/ruler-pen": {
      "name": "Ruler Pen",
      "slug": "ruler-pen",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/ruler-pen",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/ruler-pen.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/ruler-pen.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/ruler-pen.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/ruler-pen.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/ruler-pen.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/ruler-pen.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "draft",
        "draw",
        "editor",
        "graphics",
        "measure",
        "tools"
      ]
    },
    "design-tools/ruler-cross-pen": {
      "name": "Ruler Cross Pen",
      "slug": "ruler-cross-pen",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/ruler-cross-pen",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/ruler-cross-pen.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/ruler-cross-pen.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/ruler-cross-pen.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/ruler-cross-pen.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/ruler-cross-pen.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/ruler-cross-pen.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "draft",
        "draw",
        "editor",
        "graphics",
        "measure",
        "precision",
        "tools"
      ]
    },
    "design-tools/ruler-angular": {
      "name": "Ruler Angular",
      "slug": "ruler-angular",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/ruler-angular",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/ruler-angular.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/ruler-angular.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/ruler-angular.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/ruler-angular.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/ruler-angular.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/ruler-angular.svg"
        }
      ],
      "tags": [
        "angle",
        "creative",
        "degree",
        "design",
        "editor",
        "graphics",
        "measure",
        "protractor",
        "tools"
      ]
    },
    "design-tools/pipette": {
      "name": "Pipette",
      "slug": "pipette",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/pipette",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/pipette.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/pipette.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/pipette.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/pipette.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/pipette.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/pipette.svg"
        }
      ],
      "tags": [
        "color-picker",
        "colour-picker",
        "creative",
        "design",
        "editor",
        "eyedropper",
        "graphics",
        "sample",
        "tools"
      ]
    },
    "design-tools/three-squares": {
      "name": "Three Squares",
      "slug": "three-squares",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/three-squares",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/three-squares.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/three-squares.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/three-squares.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/three-squares.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/three-squares.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/three-squares.svg"
        }
      ],
      "tags": [
        "components",
        "creative",
        "design",
        "editor",
        "graphics",
        "grid",
        "layout",
        "tiles",
        "tools"
      ]
    },
    "design-tools/filters": {
      "name": "Filters",
      "slug": "filters",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/filters",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/filters.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/filters.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/filters.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/filters.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/filters.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/filters.svg"
        }
      ],
      "tags": [
        "adjust",
        "creative",
        "design",
        "editor",
        "effect",
        "graphics",
        "image",
        "photo",
        "tools"
      ]
    },
    "design-tools/flip-horizontal": {
      "name": "Flip Horizontal",
      "slug": "flip-horizontal",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/flip-horizontal",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/flip-horizontal.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/flip-horizontal.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/flip-horizontal.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/flip-horizontal.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/flip-horizontal.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/flip-horizontal.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "editor",
        "graphics",
        "horizontal",
        "mirror",
        "reflect",
        "tools",
        "transform"
      ]
    },
    "design-tools/flip-vertical": {
      "name": "Flip Vertical",
      "slug": "flip-vertical",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/flip-vertical",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/flip-vertical.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/flip-vertical.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/flip-vertical.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/flip-vertical.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/flip-vertical.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/flip-vertical.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "editor",
        "graphics",
        "mirror",
        "reflect",
        "tools",
        "transform",
        "vertical"
      ]
    },
    "design-tools/colour-tuneing": {
      "name": "Colour Tuneing",
      "slug": "colour-tuneing",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/colour-tuneing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/colour-tuneing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/colour-tuneing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/colour-tuneing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/colour-tuneing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/colour-tuneing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/colour-tuneing.svg"
        }
      ],
      "tags": [
        "HSL",
        "adjust",
        "brightness",
        "color",
        "creative",
        "design",
        "editor",
        "graphics",
        "hue",
        "saturation",
        "tools"
      ]
    },
    "design-tools/radial-blur": {
      "name": "Radial Blur",
      "slug": "radial-blur",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/radial-blur",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/radial-blur.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/radial-blur.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/radial-blur.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/radial-blur.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/radial-blur.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/radial-blur.svg"
        }
      ],
      "tags": [
        "blur",
        "bokeh",
        "creative",
        "design",
        "editor",
        "effect",
        "focus",
        "graphics",
        "tools"
      ]
    },
    "design-tools/mirror-left": {
      "name": "Mirror Left",
      "slug": "mirror-left",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/mirror-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/mirror-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/mirror-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/mirror-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/mirror-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/mirror-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/mirror-left.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "editor",
        "flip",
        "graphics",
        "reflect",
        "symmetry",
        "tools"
      ]
    },
    "design-tools/mirror-right": {
      "name": "Mirror Right",
      "slug": "mirror-right",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/mirror-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/mirror-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/mirror-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/mirror-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/mirror-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/mirror-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/mirror-right.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "editor",
        "flip",
        "graphics",
        "reflect",
        "symmetry",
        "tools"
      ]
    },
    "design-tools/crop-minimalistic": {
      "name": "Crop Minimalistic",
      "slug": "crop-minimalistic",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/crop-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/crop-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/crop-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/crop-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/crop-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/crop-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/crop-minimalistic.svg"
        }
      ],
      "tags": [
        "creative",
        "cut",
        "design",
        "editor",
        "frame",
        "graphics",
        "minimal",
        "resize",
        "tools",
        "trim"
      ]
    },
    "design-tools/crop": {
      "name": "Crop",
      "slug": "crop",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/crop",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/crop.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/crop.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/crop.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/crop.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/crop.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/crop.svg"
        }
      ],
      "tags": [
        "creative",
        "cut",
        "design",
        "editor",
        "frame",
        "graphics",
        "resize",
        "tools",
        "trim"
      ]
    },
    "design-tools/layers-minimalistic": {
      "name": "Layers Minimalistic",
      "slug": "layers-minimalistic",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/layers-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/layers-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/layers-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/layers-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/layers-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/layers-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/layers-minimalistic.svg"
        }
      ],
      "tags": [
        "creative",
        "design",
        "editor",
        "graphics",
        "overlap",
        "stack",
        "tools",
        "z-index"
      ]
    },
    "design-tools/layers": {
      "name": "Layers",
      "slug": "layers",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/layers",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/layers.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/layers.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/layers.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/layers.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/layers.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/layers.svg"
        }
      ],
      "tags": [
        "creative",
        "depth",
        "design",
        "editor",
        "graphics",
        "overlap",
        "stack",
        "tools",
        "z-index"
      ]
    },
    "design-tools/palette": {
      "name": "Palette",
      "slug": "palette",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/palette",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/palette.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/palette.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/palette.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/palette.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/palette.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/palette.svg"
        }
      ],
      "tags": [
        "art",
        "color",
        "colour",
        "creative",
        "design",
        "editor",
        "graphics",
        "paint",
        "swatch",
        "tools"
      ]
    },
    "design-tools/palette-round": {
      "name": "Palette Round",
      "slug": "palette-round",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/palette-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/palette-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/palette-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/palette-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/palette-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/palette-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/palette-round.svg"
        }
      ],
      "tags": [
        "art",
        "color",
        "colour",
        "creative",
        "design",
        "editor",
        "graphics",
        "paint",
        "tools"
      ]
    },
    "design-tools/pallete-2": {
      "name": "Pallete 2",
      "slug": "pallete-2",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/pallete-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/pallete-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/pallete-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/pallete-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/pallete-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/pallete-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/pallete-2.svg"
        }
      ],
      "tags": [
        "art",
        "color",
        "colour",
        "creative",
        "design",
        "editor",
        "graphics",
        "paint",
        "tools"
      ]
    },
    "design-tools/paint-roller": {
      "name": "Paint Roller",
      "slug": "paint-roller",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/paint-roller",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/paint-roller.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/paint-roller.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/paint-roller.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/paint-roller.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/paint-roller.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/paint-roller.svg"
        }
      ],
      "tags": [
        "colour",
        "creative",
        "decorate",
        "design",
        "editor",
        "fill",
        "graphics",
        "paint",
        "tools",
        "wall"
      ]
    },
    "design-tools/align-left": {
      "name": "Align Left",
      "slug": "align-left",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-left.svg"
        }
      ],
      "tags": [
        "alignment",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "left",
        "text-align",
        "tools"
      ]
    },
    "design-tools/align-right": {
      "name": "Align Right",
      "slug": "align-right",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-right.svg"
        }
      ],
      "tags": [
        "alignment",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "right",
        "text-align",
        "tools"
      ]
    },
    "design-tools/align-bottom": {
      "name": "Align Bottom",
      "slug": "align-bottom",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-bottom",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-bottom.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-bottom.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-bottom.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-bottom.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-bottom.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-bottom.svg"
        }
      ],
      "tags": [
        "alignment",
        "bottom",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "tools",
        "vertical"
      ]
    },
    "design-tools/align-top": {
      "name": "Align Top",
      "slug": "align-top",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-top",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-top.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-top.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-top.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-top.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-top.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-top.svg"
        }
      ],
      "tags": [
        "alignment",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "tools",
        "top",
        "vertical"
      ]
    },
    "design-tools/align-vertical-center": {
      "name": "Align Vertical Center",
      "slug": "align-vertical-center",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-vertical-center",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-vertical-center.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-vertical-center.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-vertical-center.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-vertical-center.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-vertical-center.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-vertical-center.svg"
        }
      ],
      "tags": [
        "alignment",
        "center",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "middle",
        "tools"
      ]
    },
    "design-tools/align-horizontal-center": {
      "name": "Align Horizontal Center",
      "slug": "align-horizontal-center",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-horizontal-center",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-horizontal-center.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-horizontal-center.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-horizontal-center.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-horizontal-center.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-horizontal-center.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-horizontal-center.svg"
        }
      ],
      "tags": [
        "alignment",
        "center",
        "creative",
        "design",
        "editor",
        "graphics",
        "layout",
        "middle",
        "tools"
      ]
    },
    "design-tools/align-horizonta-spacing": {
      "name": "Align Horizonta Spacing",
      "slug": "align-horizonta-spacing",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-horizonta-spacing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-horizonta-spacing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-horizonta-spacing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-horizonta-spacing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-horizonta-spacing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-horizonta-spacing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-horizonta-spacing.svg"
        }
      ],
      "tags": [
        "alignment",
        "creative",
        "design",
        "distribute",
        "editor",
        "graphics",
        "horizontal",
        "layout",
        "spacing",
        "tools"
      ]
    },
    "design-tools/align-vertical-spacing": {
      "name": "Align Vertical Spacing",
      "slug": "align-vertical-spacing",
      "category": "design-tools",
      "categoryName": "Design, Tools",
      "id": "design-tools/align-vertical-spacing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/design-tools/align-vertical-spacing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/design-tools/align-vertical-spacing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/design-tools/align-vertical-spacing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/design-tools/align-vertical-spacing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/design-tools/align-vertical-spacing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/design-tools/align-vertical-spacing.svg"
        }
      ],
      "tags": [
        "alignment",
        "creative",
        "design",
        "distribute",
        "editor",
        "graphics",
        "layout",
        "spacing",
        "tools",
        "vertical"
      ]
    },
    "food-kitchen/cup-hot": {
      "name": "Cup Hot",
      "slug": "cup-hot",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/cup-hot",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/cup-hot.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/cup-hot.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/cup-hot.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/cup-hot.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/cup-hot.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/cup-hot.svg"
        }
      ],
      "tags": [
        "brew",
        "chef",
        "coffee",
        "cooking",
        "culinary",
        "food",
        "hot-drink",
        "kitchen",
        "latte",
        "recipe",
        "tea",
        "warm"
      ]
    },
    "food-kitchen/cup": {
      "name": "Cup",
      "slug": "cup",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/cup",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/cup.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/cup.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/cup.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/cup.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/cup.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/cup.svg"
        }
      ],
      "tags": [
        "beverage",
        "chef",
        "coffee",
        "cooking",
        "culinary",
        "drink",
        "food",
        "kitchen",
        "mug",
        "recipe",
        "tea"
      ]
    },
    "food-kitchen/tea-cup": {
      "name": "Tea Cup",
      "slug": "tea-cup",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/tea-cup",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/tea-cup.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/tea-cup.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/tea-cup.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/tea-cup.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/tea-cup.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/tea-cup.svg"
        }
      ],
      "tags": [
        "brew",
        "chef",
        "cooking",
        "culinary",
        "drink",
        "food",
        "herbal",
        "hot",
        "kitchen",
        "recipe",
        "tea"
      ]
    },
    "food-kitchen/bottle": {
      "name": "Bottle",
      "slug": "bottle",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/bottle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/bottle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/bottle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/bottle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/bottle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/bottle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/bottle.svg"
        }
      ],
      "tags": [
        "beverage",
        "chef",
        "container",
        "cooking",
        "culinary",
        "drink",
        "food",
        "kitchen",
        "liquid",
        "recipe",
        "water"
      ]
    },
    "food-kitchen/cup-paper": {
      "name": "Cup Paper",
      "slug": "cup-paper",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/cup-paper",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/cup-paper.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/cup-paper.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/cup-paper.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/cup-paper.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/cup-paper.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/cup-paper.svg"
        }
      ],
      "tags": [
        "chef",
        "coffee",
        "cooking",
        "culinary",
        "disposable",
        "food",
        "kitchen",
        "recipe",
        "takeaway",
        "to-go"
      ]
    },
    "food-kitchen/donut": {
      "name": "Donut",
      "slug": "donut",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/donut",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/donut.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/donut.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/donut.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/donut.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/donut.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/donut.svg"
        }
      ],
      "tags": [
        "bakery",
        "chef",
        "cooking",
        "culinary",
        "doughnut",
        "food",
        "kitchen",
        "pastry",
        "recipe",
        "snack",
        "sweet",
        "treat"
      ]
    },
    "food-kitchen/donut-bitten": {
      "name": "Donut Bitten",
      "slug": "donut-bitten",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/donut-bitten",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/donut-bitten.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/donut-bitten.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/donut-bitten.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/donut-bitten.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/donut-bitten.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/donut-bitten.svg"
        }
      ],
      "tags": [
        "bite",
        "chef",
        "cooking",
        "culinary",
        "doughnut",
        "eaten",
        "food",
        "kitchen",
        "recipe",
        "snack"
      ]
    },
    "food-kitchen/chef-hat": {
      "name": "Chef Hat",
      "slug": "chef-hat",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/chef-hat",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/chef-hat.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/chef-hat.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/chef-hat.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/chef-hat.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/chef-hat.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/chef-hat.svg"
        }
      ],
      "tags": [
        "baker",
        "chef",
        "cook",
        "cooking",
        "culinary",
        "food",
        "kitchen",
        "professional",
        "recipe",
        "restaurant"
      ]
    },
    "food-kitchen/chef-hat-minimalistic": {
      "name": "Chef Hat Minimalistic",
      "slug": "chef-hat-minimalistic",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/chef-hat-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/chef-hat-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/chef-hat-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/chef-hat-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/chef-hat-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/chef-hat-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/chef-hat-minimalistic.svg"
        }
      ],
      "tags": [
        "baker",
        "chef",
        "cook",
        "cooking",
        "culinary",
        "food",
        "kitchen",
        "minimal",
        "recipe"
      ]
    },
    "food-kitchen/chef-hat-heart": {
      "name": "Chef Hat Heart",
      "slug": "chef-hat-heart",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/chef-hat-heart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/chef-hat-heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/chef-hat-heart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/chef-hat-heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/chef-hat-heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/chef-hat-heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/chef-hat-heart.svg"
        }
      ],
      "tags": [
        "chef",
        "cook",
        "cooking",
        "culinary",
        "favourite",
        "food",
        "kitchen",
        "love",
        "passion",
        "recipe"
      ]
    },
    "food-kitchen/wineglass-triangle": {
      "name": "Wineglass Triangle",
      "slug": "wineglass-triangle",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/wineglass-triangle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/wineglass-triangle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/wineglass-triangle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/wineglass-triangle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/wineglass-triangle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/wineglass-triangle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/wineglass-triangle.svg"
        }
      ],
      "tags": [
        "chef",
        "cocktail",
        "cooking",
        "culinary",
        "drink",
        "food",
        "kitchen",
        "martini",
        "recipe",
        "wine"
      ]
    },
    "food-kitchen/wineglass": {
      "name": "Wineglass",
      "slug": "wineglass",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/wineglass",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/wineglass.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/wineglass.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/wineglass.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/wineglass.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/wineglass.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/wineglass.svg"
        }
      ],
      "tags": [
        "alcohol",
        "bar",
        "chef",
        "cocktail",
        "cooking",
        "culinary",
        "drink",
        "food",
        "kitchen",
        "recipe",
        "toast",
        "wine"
      ]
    },
    "food-kitchen/rolling-pin": {
      "name": "Rolling Pin",
      "slug": "rolling-pin",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/rolling-pin",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/rolling-pin.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/rolling-pin.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/rolling-pin.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/rolling-pin.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/rolling-pin.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/rolling-pin.svg"
        }
      ],
      "tags": [
        "baking",
        "chef",
        "cooking",
        "culinary",
        "dough",
        "flatten",
        "food",
        "kitchen",
        "pastry",
        "recipe"
      ]
    },
    "food-kitchen/corkscrew": {
      "name": "Corkscrew",
      "slug": "corkscrew",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/corkscrew",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/corkscrew.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/corkscrew.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/corkscrew.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/corkscrew.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/corkscrew.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/corkscrew.svg"
        }
      ],
      "tags": [
        "bar",
        "bottle",
        "chef",
        "cooking",
        "culinary",
        "food",
        "kitchen",
        "opener",
        "recipe",
        "wine"
      ]
    },
    "food-kitchen/ladle": {
      "name": "Ladle",
      "slug": "ladle",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/ladle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/ladle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/ladle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/ladle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/ladle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/ladle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/ladle.svg"
        }
      ],
      "tags": [
        "chef",
        "cooking",
        "culinary",
        "food",
        "kitchen",
        "pot",
        "recipe",
        "serve",
        "soup",
        "spoon"
      ]
    },
    "food-kitchen/whisk": {
      "name": "Whisk",
      "slug": "whisk",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/whisk",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/whisk.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/whisk.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/whisk.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/whisk.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/whisk.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/whisk.svg"
        }
      ],
      "tags": [
        "baking",
        "beat",
        "chef",
        "cooking",
        "culinary",
        "egg",
        "food",
        "kitchen",
        "mix",
        "recipe",
        "stir"
      ]
    },
    "food-kitchen/oven-mitts": {
      "name": "Oven Mitts",
      "slug": "oven-mitts",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/oven-mitts",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/oven-mitts.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/oven-mitts.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/oven-mitts.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/oven-mitts.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/oven-mitts.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/oven-mitts.svg"
        }
      ],
      "tags": [
        "baking",
        "chef",
        "cooking",
        "culinary",
        "food",
        "gloves",
        "heat",
        "hot",
        "kitchen",
        "protection",
        "recipe"
      ]
    },
    "food-kitchen/oven-mitts-minimalistic": {
      "name": "Oven Mitts Minimalistic",
      "slug": "oven-mitts-minimalistic",
      "category": "food-kitchen",
      "categoryName": "Food, Kitchen",
      "id": "food-kitchen/oven-mitts-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/food-kitchen/oven-mitts-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/food-kitchen/oven-mitts-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/food-kitchen/oven-mitts-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/food-kitchen/oven-mitts-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/food-kitchen/oven-mitts-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/food-kitchen/oven-mitts-minimalistic.svg"
        }
      ],
      "tags": [
        "baking",
        "chef",
        "cooking",
        "culinary",
        "food",
        "heat",
        "kitchen",
        "minimal",
        "protection",
        "recipe"
      ]
    },
    "like/heart": {
      "name": "Heart",
      "slug": "heart",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "feedback",
        "like",
        "love",
        "passion",
        "rating",
        "valentine"
      ]
    },
    "like/star": {
      "name": "Star",
      "slug": "star",
      "category": "like",
      "categoryName": "Like",
      "id": "like/star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/star.svg"
        }
      ],
      "tags": [
        "appreciation",
        "bookmark",
        "celestial",
        "favourite",
        "feedback",
        "like",
        "love",
        "night",
        "rating"
      ]
    },
    "like/heart-angle": {
      "name": "Heart Angle",
      "slug": "heart-angle",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart-angle.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "feedback",
        "like",
        "love",
        "modern",
        "rating"
      ]
    },
    "like/star-shine": {
      "name": "Star Shine",
      "slug": "star-shine",
      "category": "like",
      "categoryName": "Like",
      "id": "like/star-shine",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/star-shine.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/star-shine.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/star-shine.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/star-shine.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/star-shine.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/star-shine.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "featured",
        "feedback",
        "glow",
        "like",
        "love",
        "premium",
        "rating",
        "sparkle"
      ]
    },
    "like/heart-broken": {
      "name": "Heart Broken",
      "slug": "heart-broken",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart-broken",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart-broken.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart-broken.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart-broken.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart-broken.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart-broken.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart-broken.svg"
        }
      ],
      "tags": [
        "appreciation",
        "breakup",
        "favourite",
        "feedback",
        "heartbreak",
        "like",
        "love",
        "rating",
        "sad",
        "split"
      ]
    },
    "like/hearts": {
      "name": "Hearts",
      "slug": "hearts",
      "category": "like",
      "categoryName": "Like",
      "id": "like/hearts",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/hearts.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/hearts.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/hearts.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/hearts.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/hearts.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/hearts.svg"
        }
      ],
      "tags": [
        "affection",
        "appreciation",
        "favourite",
        "feedback",
        "like",
        "love",
        "many",
        "multiple",
        "rating"
      ]
    },
    "like/heart-lock": {
      "name": "Heart Lock",
      "slug": "heart-lock",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart-lock",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart-lock.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart-lock.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart-lock.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart-lock.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart-lock.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart-lock.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "feedback",
        "like",
        "locked",
        "love",
        "private",
        "protected",
        "rating",
        "secret"
      ]
    },
    "like/heart-unlock": {
      "name": "Heart Unlock",
      "slug": "heart-unlock",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart-unlock",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart-unlock.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart-unlock.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart-unlock.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart-unlock.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart-unlock.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart-unlock.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "feedback",
        "free",
        "like",
        "love",
        "open",
        "rating",
        "unlocked"
      ]
    },
    "like/heart-shine": {
      "name": "Heart Shine",
      "slug": "heart-shine",
      "category": "like",
      "categoryName": "Like",
      "id": "like/heart-shine",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/heart-shine.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/heart-shine.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/heart-shine.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/heart-shine.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/heart-shine.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/heart-shine.svg"
        }
      ],
      "tags": [
        "appreciation",
        "favourite",
        "feedback",
        "like",
        "love",
        "popular",
        "rating",
        "sparkle"
      ]
    },
    "like/like": {
      "name": "Like",
      "slug": "like",
      "category": "like",
      "categoryName": "Like",
      "id": "like/like",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/like.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/like.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/like.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/like.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/like.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/like.svg"
        }
      ],
      "tags": [
        "agree",
        "appreciation",
        "approve",
        "favourite",
        "feedback",
        "good",
        "like",
        "love",
        "positive",
        "rating",
        "thumbs-up",
        "upvote"
      ]
    },
    "like/dislike": {
      "name": "Dislike",
      "slug": "dislike",
      "category": "like",
      "categoryName": "Like",
      "id": "like/dislike",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/dislike.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/dislike.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/dislike.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/dislike.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/dislike.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/dislike.svg"
        }
      ],
      "tags": [
        "appreciation",
        "bad",
        "disagree",
        "downvote",
        "favourite",
        "feedback",
        "like",
        "love",
        "negative",
        "rating",
        "thumbs-down"
      ]
    },
    "like/medal-ribbons-star": {
      "name": "Medal Ribbons Star",
      "slug": "medal-ribbons-star",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-ribbons-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-ribbons-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-ribbons-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-ribbons-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-ribbons-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-ribbons-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-ribbons-star.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "favourite",
        "feedback",
        "like",
        "love",
        "multiple",
        "rating",
        "star"
      ]
    },
    "like/medal-ribbon-star": {
      "name": "Medal Ribbon Star",
      "slug": "medal-ribbon-star",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-ribbon-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-ribbon-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-ribbon-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-ribbon-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-ribbon-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-ribbon-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-ribbon-star.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "excellence",
        "favourite",
        "feedback",
        "like",
        "love",
        "rating",
        "star"
      ]
    },
    "like/medal-ribbon": {
      "name": "Medal Ribbon",
      "slug": "medal-ribbon",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-ribbon",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-ribbon.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-ribbon.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-ribbon.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-ribbon.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-ribbon.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-ribbon.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "badge",
        "favourite",
        "feedback",
        "honour",
        "like",
        "love",
        "prize",
        "rating"
      ]
    },
    "like/medal-star": {
      "name": "Medal Star",
      "slug": "medal-star",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-star.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "favourite",
        "feedback",
        "gold",
        "like",
        "love",
        "rating",
        "winner"
      ]
    },
    "like/medal-star-circle": {
      "name": "Medal Star Circle",
      "slug": "medal-star-circle",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-star-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-star-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-star-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-star-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-star-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-star-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-star-circle.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "badge",
        "favourite",
        "feedback",
        "like",
        "love",
        "rating"
      ]
    },
    "like/medal-star-square": {
      "name": "Medal Star Square",
      "slug": "medal-star-square",
      "category": "like",
      "categoryName": "Like",
      "id": "like/medal-star-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/like/medal-star-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/like/medal-star-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/like/medal-star-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/like/medal-star-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/like/medal-star-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/like/medal-star-square.svg"
        }
      ],
      "tags": [
        "achievement",
        "appreciation",
        "award",
        "badge",
        "favourite",
        "feedback",
        "like",
        "love",
        "rating"
      ]
    },
    "arrows-action/send-twice-square": {
      "name": "Send Twice Square",
      "slug": "send-twice-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/send-twice-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/send-twice-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/send-twice-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/send-twice-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/send-twice-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/send-twice-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/send-twice-square.svg"
        }
      ],
      "tags": [
        "action",
        "batch",
        "dispatch",
        "interaction",
        "move",
        "navigation",
        "submit"
      ]
    },
    "arrows-action/recive-twice-square": {
      "name": "Recive Twice Square",
      "slug": "recive-twice-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/recive-twice-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/recive-twice-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/recive-twice-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/recive-twice-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/recive-twice-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/recive-twice-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/recive-twice-square.svg"
        }
      ],
      "tags": [
        "action",
        "batch",
        "incoming",
        "interaction",
        "move",
        "navigation",
        "receive"
      ]
    },
    "arrows-action/upload-twice-square": {
      "name": "Upload Twice Square",
      "slug": "upload-twice-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/upload-twice-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/upload-twice-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/upload-twice-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/upload-twice-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/upload-twice-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/upload-twice-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/upload-twice-square.svg"
        }
      ],
      "tags": [
        "action",
        "batch",
        "interaction",
        "move",
        "multiple",
        "navigation",
        "publish",
        "send"
      ]
    },
    "arrows-action/download-twice-square": {
      "name": "Download Twice Square",
      "slug": "download-twice-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/download-twice-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/download-twice-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/download-twice-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/download-twice-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/download-twice-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/download-twice-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/download-twice-square.svg"
        }
      ],
      "tags": [
        "action",
        "batch",
        "interaction",
        "move",
        "multiple",
        "navigation",
        "save"
      ]
    },
    "arrows-action/send-square": {
      "name": "Send Square",
      "slug": "send-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/send-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/send-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/send-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/send-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/send-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/send-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/send-square.svg"
        }
      ],
      "tags": [
        "action",
        "dispatch",
        "interaction",
        "move",
        "navigation",
        "post",
        "submit"
      ]
    },
    "arrows-action/recive-square": {
      "name": "Recive Square",
      "slug": "recive-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/recive-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/recive-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/recive-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/recive-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/recive-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/recive-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/recive-square.svg"
        }
      ],
      "tags": [
        "action",
        "get",
        "incoming",
        "interaction",
        "move",
        "navigation",
        "receive"
      ]
    },
    "arrows-action/upload-square": {
      "name": "Upload Square",
      "slug": "upload-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/upload-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/upload-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/upload-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/upload-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/upload-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/upload-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/upload-square.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation",
        "publish",
        "push",
        "send",
        "share",
        "square"
      ]
    },
    "arrows-action/download-square": {
      "name": "Download Square",
      "slug": "download-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/download-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/download-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/download-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/download-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/download-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/download-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/download-square.svg"
        }
      ],
      "tags": [
        "action",
        "fetch",
        "get",
        "interaction",
        "move",
        "navigation",
        "receive",
        "save",
        "square"
      ]
    },
    "arrows-action/undo-left-round": {
      "name": "Undo Left Round",
      "slug": "undo-left-round",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-left-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-left-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-left-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-left-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-left-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-left-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-left-round.svg"
        }
      ],
      "tags": [
        "action",
        "back",
        "interaction",
        "move",
        "navigation",
        "revert",
        "undo"
      ]
    },
    "arrows-action/undo-right-round": {
      "name": "Undo Right Round",
      "slug": "undo-right-round",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-right-round",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-right-round.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-right-round.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-right-round.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-right-round.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-right-round.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-right-round.svg"
        }
      ],
      "tags": [
        "action",
        "forward",
        "interaction",
        "move",
        "navigation",
        "redo",
        "repeat"
      ]
    },
    "arrows-action/undo-left": {
      "name": "Undo Left",
      "slug": "undo-left",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-left.svg"
        }
      ],
      "tags": [
        "action",
        "back",
        "history",
        "interaction",
        "move",
        "navigation",
        "revert",
        "undo"
      ]
    },
    "arrows-action/undo-right": {
      "name": "Undo Right",
      "slug": "undo-right",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-right.svg"
        }
      ],
      "tags": [
        "action",
        "forward",
        "interaction",
        "move",
        "navigation",
        "redo",
        "repeat"
      ]
    },
    "arrows-action/undo-left-round-square": {
      "name": "Undo Left Round Square",
      "slug": "undo-left-round-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-left-round-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-left-round-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-left-round-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-left-round-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-left-round-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-left-round-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-left-round-square.svg"
        }
      ],
      "tags": [
        "action",
        "back",
        "interaction",
        "move",
        "navigation",
        "revert",
        "undo"
      ]
    },
    "arrows-action/undo-right-round-square": {
      "name": "Undo Right Round Square",
      "slug": "undo-right-round-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-right-round-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-right-round-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-right-round-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-right-round-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-right-round-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-right-round-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-right-round-square.svg"
        }
      ],
      "tags": [
        "action",
        "forward",
        "interaction",
        "move",
        "navigation",
        "redo",
        "repeat"
      ]
    },
    "arrows-action/undo-left-square": {
      "name": "Undo Left Square",
      "slug": "undo-left-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-left-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-left-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-left-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-left-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-left-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-left-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-left-square.svg"
        }
      ],
      "tags": [
        "action",
        "back",
        "interaction",
        "move",
        "navigation",
        "revert",
        "undo"
      ]
    },
    "arrows-action/undo-right-square": {
      "name": "Undo Right Square",
      "slug": "undo-right-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/undo-right-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/undo-right-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/undo-right-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/undo-right-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/undo-right-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/undo-right-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/undo-right-square.svg"
        }
      ],
      "tags": [
        "action",
        "forward",
        "interaction",
        "move",
        "navigation",
        "redo",
        "repeat"
      ]
    },
    "arrows-action/square-bottom-up": {
      "name": "Square Bottom Up",
      "slug": "square-bottom-up",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/square-bottom-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/square-bottom-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/square-bottom-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/square-bottom-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/square-bottom-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/square-bottom-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/square-bottom-up.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/square-bottom-down": {
      "name": "Square Bottom Down",
      "slug": "square-bottom-down",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/square-bottom-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/square-bottom-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/square-bottom-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/square-bottom-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/square-bottom-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/square-bottom-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/square-bottom-down.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/square-top-up": {
      "name": "Square Top Up",
      "slug": "square-top-up",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/square-top-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/square-top-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/square-top-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/square-top-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/square-top-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/square-top-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/square-top-up.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/square-top-down": {
      "name": "Square Top Down",
      "slug": "square-top-down",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/square-top-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/square-top-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/square-top-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/square-top-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/square-top-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/square-top-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/square-top-down.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/scale": {
      "name": "Scale",
      "slug": "scale",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/scale",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/scale.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/scale.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/scale.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/scale.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/scale.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/scale.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation",
        "proportion",
        "resize",
        "size",
        "transform"
      ]
    },
    "arrows-action/minimize": {
      "name": "Minimize",
      "slug": "minimize",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/minimize",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/minimize.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/minimize.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/minimize.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/minimize.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/minimize.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/minimize.svg"
        }
      ],
      "tags": [
        "action",
        "collapse",
        "interaction",
        "move",
        "navigation",
        "reduce",
        "shrink",
        "smaller"
      ]
    },
    "arrows-action/maximize": {
      "name": "Maximize",
      "slug": "maximize",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/maximize",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/maximize.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/maximize.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/maximize.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/maximize.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/maximize.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/maximize.svg"
        }
      ],
      "tags": [
        "action",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/circle-bottom-up": {
      "name": "Circle Bottom Up",
      "slug": "circle-bottom-up",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/circle-bottom-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/circle-bottom-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/circle-bottom-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/circle-bottom-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/circle-bottom-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/circle-bottom-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/circle-bottom-up.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/circle-bottom-down": {
      "name": "Circle Bottom Down",
      "slug": "circle-bottom-down",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/circle-bottom-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/circle-bottom-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/circle-bottom-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/circle-bottom-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/circle-bottom-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/circle-bottom-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/circle-bottom-down.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/circle-top-down": {
      "name": "Circle Top Down",
      "slug": "circle-top-down",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/circle-top-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/circle-top-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/circle-top-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/circle-top-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/circle-top-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/circle-top-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/circle-top-down.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/circle-top-up": {
      "name": "Circle Top Up",
      "slug": "circle-top-up",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/circle-top-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/circle-top-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/circle-top-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/circle-top-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/circle-top-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/circle-top-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/circle-top-up.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/reorder": {
      "name": "Reorder",
      "slug": "reorder",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/reorder",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/reorder.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/reorder.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/reorder.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/reorder.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/reorder.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/reorder.svg"
        }
      ],
      "tags": [
        "action",
        "drag",
        "interaction",
        "move",
        "navigation",
        "organize",
        "rearrange",
        "sort"
      ]
    },
    "arrows-action/maximize-square-3": {
      "name": "Maximize Square 3",
      "slug": "maximize-square-3",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/maximize-square-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/maximize-square-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/maximize-square-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/maximize-square-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/maximize-square-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/maximize-square-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/maximize-square-3.svg"
        }
      ],
      "tags": [
        "action",
        "enlarge",
        "expand",
        "fullscreen",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/minimize-square-3": {
      "name": "Minimize Square 3",
      "slug": "minimize-square-3",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/minimize-square-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/minimize-square-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/minimize-square-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/minimize-square-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/minimize-square-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/minimize-square-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/minimize-square-3.svg"
        }
      ],
      "tags": [
        "action",
        "collapse",
        "interaction",
        "move",
        "navigation",
        "reduce",
        "shrink"
      ]
    },
    "arrows-action/maximize-square": {
      "name": "Maximize Square",
      "slug": "maximize-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/maximize-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/maximize-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/maximize-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/maximize-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/maximize-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/maximize-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/maximize-square.svg"
        }
      ],
      "tags": [
        "action",
        "enlarge",
        "expand",
        "fullscreen",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/maximize-square-minimalistic": {
      "name": "Maximize Square Minimalistic",
      "slug": "maximize-square-minimalistic",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/maximize-square-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/maximize-square-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/maximize-square-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/maximize-square-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/maximize-square-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/maximize-square-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/maximize-square-minimalistic.svg"
        }
      ],
      "tags": [
        "action",
        "enlarge",
        "expand",
        "fullscreen",
        "interaction",
        "minimal",
        "move",
        "navigation"
      ]
    },
    "arrows-action/minimize-square": {
      "name": "Minimize Square",
      "slug": "minimize-square",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/minimize-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/minimize-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/minimize-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/minimize-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/minimize-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/minimize-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/minimize-square.svg"
        }
      ],
      "tags": [
        "action",
        "collapse",
        "interaction",
        "move",
        "navigation",
        "reduce",
        "shrink"
      ]
    },
    "arrows-action/minimize-square-minimalistic": {
      "name": "Minimize Square Minimalistic",
      "slug": "minimize-square-minimalistic",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/minimize-square-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/minimize-square-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/minimize-square-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/minimize-square-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/minimize-square-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/minimize-square-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/minimize-square-minimalistic.svg"
        }
      ],
      "tags": [
        "action",
        "collapse",
        "interaction",
        "minimal",
        "move",
        "navigation",
        "reduce",
        "shrink"
      ]
    },
    "arrows-action/maximize-square-2": {
      "name": "Maximize Square 2",
      "slug": "maximize-square-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/maximize-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/maximize-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/maximize-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/maximize-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/maximize-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/maximize-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/maximize-square-2.svg"
        }
      ],
      "tags": [
        "action",
        "enlarge",
        "expand",
        "fullscreen",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/minimize-square-2": {
      "name": "Minimize Square 2",
      "slug": "minimize-square-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/minimize-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/minimize-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/minimize-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/minimize-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/minimize-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/minimize-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/minimize-square-2.svg"
        }
      ],
      "tags": [
        "action",
        "collapse",
        "interaction",
        "move",
        "navigation",
        "reduce",
        "shrink"
      ]
    },
    "arrows-action/logout-2": {
      "name": "Logout 2",
      "slug": "logout-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/logout-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/logout-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/logout-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/logout-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/logout-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/logout-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/logout-2.svg"
        }
      ],
      "tags": [
        "action",
        "disconnect",
        "exit",
        "interaction",
        "leave",
        "move",
        "navigation",
        "sign-out"
      ]
    },
    "arrows-action/login-2": {
      "name": "Login 2",
      "slug": "login-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/login-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/login-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/login-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/login-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/login-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/login-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/login-2.svg"
        }
      ],
      "tags": [
        "access",
        "action",
        "authenticate",
        "enter",
        "interaction",
        "move",
        "navigation",
        "sign-in"
      ]
    },
    "arrows-action/logout": {
      "name": "Logout",
      "slug": "logout",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/logout",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/logout.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/logout.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/logout.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/logout.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/logout.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/logout.svg"
        }
      ],
      "tags": [
        "action",
        "disconnect",
        "exit",
        "interaction",
        "leave",
        "move",
        "navigation",
        "sign-out"
      ]
    },
    "arrows-action/login": {
      "name": "Login",
      "slug": "login",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/login",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/login.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/login.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/login.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/login.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/login.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/login.svg"
        }
      ],
      "tags": [
        "access",
        "action",
        "authenticate",
        "enter",
        "interaction",
        "move",
        "navigation",
        "sign-in"
      ]
    },
    "arrows-action/import": {
      "name": "Import",
      "slug": "import",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/import",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/import.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/import.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/import.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/import.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/import.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/import.svg"
        }
      ],
      "tags": [
        "action",
        "bring-in",
        "incoming",
        "input",
        "interaction",
        "load",
        "move",
        "navigation"
      ]
    },
    "arrows-action/export": {
      "name": "Export",
      "slug": "export",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/export",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/export.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/export.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/export.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/export.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/export.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/export.svg"
        }
      ],
      "tags": [
        "action",
        "external",
        "interaction",
        "move",
        "navigation",
        "output",
        "send",
        "share"
      ]
    },
    "arrows-action/upload": {
      "name": "Upload",
      "slug": "upload",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/upload",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/upload.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/upload.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/upload.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/upload.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/upload.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/upload.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation",
        "publish",
        "push",
        "send",
        "share"
      ]
    },
    "arrows-action/download": {
      "name": "Download",
      "slug": "download",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/download",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/download.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/download.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/download.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/download.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/download.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/download.svg"
        }
      ],
      "tags": [
        "action",
        "fetch",
        "get",
        "interaction",
        "move",
        "navigation",
        "receive",
        "save"
      ]
    },
    "arrows-action/upload-minimalistic": {
      "name": "Upload Minimalistic",
      "slug": "upload-minimalistic",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/upload-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/upload-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/upload-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/upload-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/upload-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/upload-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/upload-minimalistic.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "minimal",
        "move",
        "navigation",
        "publish",
        "push",
        "send",
        "share"
      ]
    },
    "arrows-action/download-minimalistic": {
      "name": "Download Minimalistic",
      "slug": "download-minimalistic",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/download-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/download-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/download-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/download-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/download-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/download-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/download-minimalistic.svg"
        }
      ],
      "tags": [
        "action",
        "fetch",
        "get",
        "interaction",
        "minimal",
        "move",
        "navigation",
        "receive",
        "save"
      ]
    },
    "arrows-action/login-3": {
      "name": "Login 3",
      "slug": "login-3",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/login-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/login-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/login-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/login-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/login-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/login-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/login-3.svg"
        }
      ],
      "tags": [
        "access",
        "action",
        "authenticate",
        "enter",
        "interaction",
        "move",
        "navigation",
        "sign-in"
      ]
    },
    "arrows-action/logout-3": {
      "name": "Logout 3",
      "slug": "logout-3",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/logout-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/logout-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/logout-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/logout-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/logout-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/logout-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/logout-3.svg"
        }
      ],
      "tags": [
        "action",
        "disconnect",
        "exit",
        "interaction",
        "leave",
        "move",
        "navigation",
        "sign-out"
      ]
    },
    "arrows-action/exit": {
      "name": "Exit",
      "slug": "exit",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/exit",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/exit.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/exit.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/exit.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/exit.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/exit.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/exit.svg"
        }
      ],
      "tags": [
        "action",
        "close",
        "escape",
        "interaction",
        "leave",
        "move",
        "navigation",
        "quit"
      ]
    },
    "arrows-action/screen-share": {
      "name": "Screen Share",
      "slug": "screen-share",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/screen-share",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/screen-share.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/screen-share.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/screen-share.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/screen-share.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/screen-share.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/screen-share.svg"
        }
      ],
      "tags": [
        "action",
        "broadcast",
        "display",
        "interaction",
        "meeting",
        "move",
        "navigation",
        "present",
        "stream"
      ]
    },
    "arrows-action/forward": {
      "name": "Forward",
      "slug": "forward",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/forward",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/forward.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/forward.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/forward.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/forward.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/forward.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/forward.svg"
        }
      ],
      "tags": [
        "action",
        "advance",
        "interaction",
        "move",
        "navigation",
        "next",
        "send"
      ]
    },
    "arrows-action/reply": {
      "name": "Reply",
      "slug": "reply",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/reply",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/reply.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/reply.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/reply.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/reply.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/reply.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/reply.svg"
        }
      ],
      "tags": [
        "action",
        "answer",
        "back",
        "interaction",
        "move",
        "navigation",
        "respond"
      ]
    },
    "arrows-action/forward-2": {
      "name": "Forward 2",
      "slug": "forward-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/forward-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/forward-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/forward-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/forward-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/forward-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/forward-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/forward-2.svg"
        }
      ],
      "tags": [
        "action",
        "advance",
        "interaction",
        "move",
        "navigation",
        "next",
        "send"
      ]
    },
    "arrows-action/reply-2": {
      "name": "Reply 2",
      "slug": "reply-2",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/reply-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/reply-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/reply-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/reply-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/reply-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/reply-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/reply-2.svg"
        }
      ],
      "tags": [
        "action",
        "answer",
        "back",
        "interaction",
        "move",
        "navigation",
        "respond"
      ]
    },
    "arrows-action/arrow-to-down-left": {
      "name": "Arrow To Down Left",
      "slug": "arrow-to-down-left",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/arrow-to-down-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/arrow-to-down-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/arrow-to-down-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/arrow-to-down-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/arrow-to-down-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/arrow-to-down-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/arrow-to-down-left.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/arrow-to-down-right": {
      "name": "Arrow To Down Right",
      "slug": "arrow-to-down-right",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/arrow-to-down-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/arrow-to-down-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/arrow-to-down-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/arrow-to-down-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/arrow-to-down-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/arrow-to-down-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/arrow-to-down-right.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/arrow-to-top-right": {
      "name": "Arrow To Top Right",
      "slug": "arrow-to-top-right",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/arrow-to-top-right",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/arrow-to-top-right.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/arrow-to-top-right.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/arrow-to-top-right.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/arrow-to-top-right.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/arrow-to-top-right.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/arrow-to-top-right.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "arrows-action/arrow-to-top-left": {
      "name": "Arrow To Top Left",
      "slug": "arrow-to-top-left",
      "category": "arrows-action",
      "categoryName": "Arrows Action",
      "id": "arrows-action/arrow-to-top-left",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/arrows-action/arrow-to-top-left.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/arrows-action/arrow-to-top-left.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/arrows-action/arrow-to-top-left.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/arrows-action/arrow-to-top-left.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/arrows-action/arrow-to-top-left.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/arrows-action/arrow-to-top-left.svg"
        }
      ],
      "tags": [
        "action",
        "interaction",
        "move",
        "navigation"
      ]
    },
    "notes/document": {
      "name": "Document",
      "slug": "document",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/document",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/document.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/document.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/document.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/document.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/document.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/document.svg"
        }
      ],
      "tags": [
        "doc",
        "document",
        "documentation",
        "file",
        "notes",
        "page",
        "paper",
        "record",
        "sheet",
        "writing"
      ]
    },
    "notes/document-text": {
      "name": "Document Text",
      "slug": "document-text",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/document-text",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/document-text.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/document-text.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/document-text.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/document-text.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/document-text.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/document-text.svg"
        }
      ],
      "tags": [
        "article",
        "content",
        "document",
        "documentation",
        "notes",
        "page",
        "readme",
        "record",
        "writing"
      ]
    },
    "notes/document-add": {
      "name": "Document Add",
      "slug": "document-add",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/document-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/document-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/document-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/document-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/document-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/document-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/document-add.svg"
        }
      ],
      "tags": [
        "create",
        "document",
        "documentation",
        "new-document",
        "new-page",
        "notes",
        "record",
        "writing"
      ]
    },
    "notes/document-medicine": {
      "name": "Document Medicine",
      "slug": "document-medicine",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/document-medicine",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/document-medicine.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/document-medicine.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/document-medicine.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/document-medicine.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/document-medicine.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/document-medicine.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "medical-record",
        "notes",
        "prescription",
        "record",
        "report",
        "writing"
      ]
    },
    "notes/documents": {
      "name": "Documents",
      "slug": "documents",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/documents",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/documents.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/documents.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/documents.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/documents.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/documents.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/documents.svg"
        }
      ],
      "tags": [
        "batch",
        "document",
        "documentation",
        "files",
        "multiple",
        "notes",
        "pages",
        "papers",
        "record",
        "writing"
      ]
    },
    "notes/documents-minimalistic": {
      "name": "Documents Minimalistic",
      "slug": "documents-minimalistic",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/documents-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/documents-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/documents-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/documents-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/documents-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/documents-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/documents-minimalistic.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "minimal",
        "multiple",
        "notes",
        "pages",
        "record",
        "writing"
      ]
    },
    "notes/notes-minimalistic": {
      "name": "Notes Minimalistic",
      "slug": "notes-minimalistic",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/notes-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/notes-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/notes-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/notes-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/notes-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/notes-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/notes-minimalistic.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "memo",
        "minimal",
        "notes",
        "record",
        "sticky-note",
        "writing"
      ]
    },
    "notes/notes": {
      "name": "Notes",
      "slug": "notes",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/notes",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/notes.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/notes.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/notes.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/notes.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/notes.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/notes.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "jot",
        "memo",
        "notes",
        "record",
        "reminder",
        "sticky-note",
        "writing"
      ]
    },
    "notes/clipboard": {
      "name": "Clipboard",
      "slug": "clipboard",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard.svg"
        }
      ],
      "tags": [
        "board",
        "copy",
        "document",
        "documentation",
        "notes",
        "paste",
        "record",
        "task",
        "writing"
      ]
    },
    "notes/clipboard-list": {
      "name": "Clipboard List",
      "slug": "clipboard-list",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard-list",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard-list.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard-list.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard-list.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard-list.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard-list.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard-list.svg"
        }
      ],
      "tags": [
        "checklist",
        "document",
        "documentation",
        "items",
        "notes",
        "record",
        "tasks",
        "todo",
        "writing"
      ]
    },
    "notes/clipboard-text": {
      "name": "Clipboard Text",
      "slug": "clipboard-text",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard-text",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard-text.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard-text.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard-text.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard-text.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard-text.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard-text.svg"
        }
      ],
      "tags": [
        "content",
        "document",
        "documentation",
        "memo",
        "note",
        "notes",
        "record",
        "text",
        "writing"
      ]
    },
    "notes/clipboard-remove": {
      "name": "Clipboard Remove",
      "slug": "clipboard-remove",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard-remove.svg"
        }
      ],
      "tags": [
        "delete-task",
        "document",
        "documentation",
        "notes",
        "record",
        "remove-item",
        "writing"
      ]
    },
    "notes/clipboard-add": {
      "name": "Clipboard Add",
      "slug": "clipboard-add",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard-add",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard-add.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard-add.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard-add.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard-add.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard-add.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard-add.svg"
        }
      ],
      "tags": [
        "add-item",
        "create",
        "document",
        "documentation",
        "new-task",
        "notes",
        "record",
        "writing"
      ]
    },
    "notes/clipboard-check": {
      "name": "Clipboard Check",
      "slug": "clipboard-check",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/clipboard-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/clipboard-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/clipboard-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/clipboard-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/clipboard-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/clipboard-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/clipboard-check.svg"
        }
      ],
      "tags": [
        "completed",
        "document",
        "documentation",
        "done",
        "notes",
        "record",
        "verified",
        "writing"
      ]
    },
    "notes/notebook": {
      "name": "Notebook",
      "slug": "notebook",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/notebook",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/notebook.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/notebook.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/notebook.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/notebook.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/notebook.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/notebook.svg"
        }
      ],
      "tags": [
        "book",
        "diary",
        "document",
        "documentation",
        "journal",
        "memo",
        "notepad",
        "notes",
        "record",
        "writing"
      ]
    },
    "notes/archive-down-minimlistic": {
      "name": "Archive Down Minimlistic",
      "slug": "archive-down-minimlistic",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-down-minimlistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-down-minimlistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-down-minimlistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-down-minimlistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-down-minimlistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-down-minimlistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-down-minimlistic.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "download",
        "minimal",
        "notes",
        "record",
        "retrieve",
        "writing"
      ]
    },
    "notes/archive-up-minimlistic": {
      "name": "Archive Up Minimlistic",
      "slug": "archive-up-minimlistic",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-up-minimlistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-up-minimlistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-up-minimlistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-up-minimlistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-up-minimlistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-up-minimlistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-up-minimlistic.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "minimal",
        "notes",
        "record",
        "store",
        "upload",
        "writing"
      ]
    },
    "notes/archive-minimalistic": {
      "name": "Archive Minimalistic",
      "slug": "archive-minimalistic",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-minimalistic.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "filed",
        "minimal",
        "notes",
        "record",
        "store",
        "writing"
      ]
    },
    "notes/archive-down": {
      "name": "Archive Down",
      "slug": "archive-down",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-down",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-down.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-down.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-down.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-down.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-down.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-down.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "download",
        "notes",
        "record",
        "restore",
        "retrieve",
        "writing"
      ]
    },
    "notes/archive-up": {
      "name": "Archive Up",
      "slug": "archive-up",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-up",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-up.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-up.svg"
        }
      ],
      "tags": [
        "document",
        "documentation",
        "notes",
        "record",
        "save",
        "store",
        "upload",
        "writing"
      ]
    },
    "notes/archive-check": {
      "name": "Archive Check",
      "slug": "archive-check",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive-check.svg"
        }
      ],
      "tags": [
        "completed",
        "document",
        "documentation",
        "notes",
        "record",
        "stored",
        "verified",
        "writing"
      ]
    },
    "notes/archive": {
      "name": "Archive",
      "slug": "archive",
      "category": "notes",
      "categoryName": "Notes",
      "id": "notes/archive",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notes/archive.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notes/archive.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notes/archive.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notes/archive.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notes/archive.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notes/archive.svg"
        }
      ],
      "tags": [
        "backup",
        "document",
        "documentation",
        "filed",
        "history",
        "notes",
        "old",
        "record",
        "store",
        "writing"
      ]
    },
    "notifications/notification-unread": {
      "name": "Notification Unread",
      "slug": "notification-unread",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/notification-unread",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/notification-unread.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/notification-unread.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/notification-unread.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/notification-unread.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/notification-unread.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/notification-unread.svg"
        }
      ],
      "tags": [
        "alert",
        "badge",
        "dot",
        "new",
        "notification",
        "pending",
        "reminder",
        "update"
      ]
    },
    "notifications/notification-unread-lines": {
      "name": "Notification Unread Lines",
      "slug": "notification-unread-lines",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/notification-unread-lines",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/notification-unread-lines.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/notification-unread-lines.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/notification-unread-lines.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/notification-unread-lines.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/notification-unread-lines.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/notification-unread-lines.svg"
        }
      ],
      "tags": [
        "alert",
        "badge",
        "multiple",
        "new",
        "notification",
        "pending",
        "reminder",
        "update"
      ]
    },
    "notifications/notification-remove": {
      "name": "Notification Remove",
      "slug": "notification-remove",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/notification-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/notification-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/notification-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/notification-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/notification-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/notification-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/notification-remove.svg"
        }
      ],
      "tags": [
        "alert",
        "clear",
        "delete",
        "dismiss",
        "notification",
        "reminder",
        "update"
      ]
    },
    "notifications/notification-lines-remove": {
      "name": "Notification Lines Remove",
      "slug": "notification-lines-remove",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/notification-lines-remove",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/notification-lines-remove.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/notification-lines-remove.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/notification-lines-remove.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/notification-lines-remove.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/notification-lines-remove.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/notification-lines-remove.svg"
        }
      ],
      "tags": [
        "alert",
        "clear",
        "dismiss",
        "notification",
        "reminder",
        "remove",
        "update"
      ]
    },
    "notifications/bell": {
      "name": "Bell",
      "slug": "bell",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/bell",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/bell.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/bell.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/bell.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/bell.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/bell.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/bell.svg"
        }
      ],
      "tags": [
        "alarm",
        "alert",
        "notification",
        "reminder",
        "ring",
        "update"
      ]
    },
    "notifications/bell-bing": {
      "name": "Bell Bing",
      "slug": "bell-bing",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/bell-bing",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/bell-bing.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/bell-bing.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/bell-bing.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/bell-bing.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/bell-bing.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/bell-bing.svg"
        }
      ],
      "tags": [
        "active",
        "alert",
        "new",
        "notification",
        "reminder",
        "sound",
        "update"
      ]
    },
    "notifications/bell-off": {
      "name": "Bell Off",
      "slug": "bell-off",
      "category": "notifications",
      "categoryName": "Notifications",
      "id": "notifications/bell-off",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/notifications/bell-off.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/notifications/bell-off.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/notifications/bell-off.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/notifications/bell-off.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/notifications/bell-off.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/notifications/bell-off.svg"
        }
      ],
      "tags": [
        "alert",
        "disabled",
        "do-not-disturb",
        "mute",
        "notification",
        "reminder",
        "silent",
        "update"
      ]
    },
    "security/bomb": {
      "name": "Bomb",
      "slug": "bomb",
      "category": "security",
      "categoryName": "Security",
      "id": "security/bomb",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/bomb.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/bomb.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/bomb.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/bomb.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/bomb.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/bomb.svg"
        }
      ],
      "tags": [
        "access",
        "danger",
        "destroy",
        "explosive",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "threat"
      ]
    },
    "security/bomb-minimalistic": {
      "name": "Bomb Minimalistic",
      "slug": "bomb-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/bomb-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/bomb-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/bomb-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/bomb-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/bomb-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/bomb-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/bomb-minimalistic.svg"
        }
      ],
      "tags": [
        "access",
        "danger",
        "explosive",
        "lock",
        "minimal",
        "privacy",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/bomb-emoji": {
      "name": "Bomb Emoji",
      "slug": "bomb-emoji",
      "category": "security",
      "categoryName": "Security",
      "id": "security/bomb-emoji",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/bomb-emoji.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/bomb-emoji.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/bomb-emoji.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/bomb-emoji.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/bomb-emoji.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/bomb-emoji.svg"
        }
      ],
      "tags": [
        "access",
        "angry",
        "cartoon",
        "danger",
        "explosive",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/lock": {
      "name": "Lock",
      "slug": "lock",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock.svg"
        }
      ],
      "tags": [
        "access",
        "closed",
        "encrypted",
        "lock",
        "locked",
        "padlock",
        "privacy",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/lock-unlocked": {
      "name": "Lock Unlocked",
      "slug": "lock-unlocked",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-unlocked",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-unlocked.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-unlocked.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-unlocked.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-unlocked.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-unlocked.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-unlocked.svg"
        }
      ],
      "tags": [
        "access",
        "accessible",
        "lock",
        "open",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlocked"
      ]
    },
    "security/lock-password": {
      "name": "Lock Password",
      "slug": "lock-password",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-password",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-password.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-password.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-password.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-password.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-password.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-password.svg"
        }
      ],
      "tags": [
        "PIN",
        "access",
        "code",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/lock-password-unlocked": {
      "name": "Lock Password Unlocked",
      "slug": "lock-password-unlocked",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-password-unlocked",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-password-unlocked.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-password-unlocked.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-password-unlocked.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-password-unlocked.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-password-unlocked.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-password-unlocked.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "open",
        "password",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlocked"
      ]
    },
    "security/lock-keyhole-minimalistic": {
      "name": "Lock Keyhole Minimalistic",
      "slug": "lock-keyhole-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-keyhole-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-keyhole-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-keyhole-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-keyhole-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-keyhole-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-keyhole-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-keyhole-minimalistic.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "locked",
        "minimal",
        "privacy",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/lock-keyhole-minimalistic-unlocked": {
      "name": "Lock Keyhole Minimalistic Unlocked",
      "slug": "lock-keyhole-minimalistic-unlocked",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-keyhole-minimalistic-unlocked",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-keyhole-minimalistic-unlocked.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-keyhole-minimalistic-unlocked.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-keyhole-minimalistic-unlocked.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-keyhole-minimalistic-unlocked.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-keyhole-minimalistic-unlocked.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-keyhole-minimalistic-unlocked.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "minimal",
        "open",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlocked"
      ]
    },
    "security/lock-keyhole": {
      "name": "Lock Keyhole",
      "slug": "lock-keyhole",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-keyhole",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-keyhole.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-keyhole.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-keyhole.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-keyhole.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-keyhole.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-keyhole.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "locked",
        "padlock",
        "privacy",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/lock-keyhole-unlocked": {
      "name": "Lock Keyhole Unlocked",
      "slug": "lock-keyhole-unlocked",
      "category": "security",
      "categoryName": "Security",
      "id": "security/lock-keyhole-unlocked",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/lock-keyhole-unlocked.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/lock-keyhole-unlocked.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/lock-keyhole-unlocked.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/lock-keyhole-unlocked.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/lock-keyhole-unlocked.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/lock-keyhole-unlocked.svg"
        }
      ],
      "tags": [
        "access",
        "accessible",
        "lock",
        "open",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlocked"
      ]
    },
    "security/eye": {
      "name": "Eye",
      "slug": "eye",
      "category": "security",
      "categoryName": "Security",
      "id": "security/eye",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/eye.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/eye.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/eye.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/eye.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/eye.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/eye.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "see",
        "show",
        "view",
        "visibility",
        "visible",
        "watch"
      ]
    },
    "security/eye-closed": {
      "name": "Eye Closed",
      "slug": "eye-closed",
      "category": "security",
      "categoryName": "Security",
      "id": "security/eye-closed",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/eye-closed.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/eye-closed.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/eye-closed.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/eye-closed.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/eye-closed.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/eye-closed.svg"
        }
      ],
      "tags": [
        "access",
        "blind",
        "hidden",
        "hide",
        "invisible",
        "lock",
        "privacy",
        "private",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/siren-rounded": {
      "name": "Siren Rounded",
      "slug": "siren-rounded",
      "category": "security",
      "categoryName": "Security",
      "id": "security/siren-rounded",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/siren-rounded.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/siren-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/siren-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/siren-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/siren-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/siren-rounded.svg"
        }
      ],
      "tags": [
        "access",
        "alarm",
        "emergency",
        "lock",
        "police",
        "privacy",
        "protection",
        "safety",
        "security",
        "warning"
      ]
    },
    "security/siren": {
      "name": "Siren",
      "slug": "siren",
      "category": "security",
      "categoryName": "Security",
      "id": "security/siren",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/siren.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/siren.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/siren.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/siren.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/siren.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/siren.svg"
        }
      ],
      "tags": [
        "access",
        "alarm",
        "alert",
        "ambulance",
        "emergency",
        "lock",
        "police",
        "privacy",
        "protection",
        "safety",
        "security",
        "warning"
      ]
    },
    "security/password": {
      "name": "Password",
      "slug": "password",
      "category": "security",
      "categoryName": "Security",
      "id": "security/password",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/password.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/password.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/password.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/password.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/password.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/password.svg"
        }
      ],
      "tags": [
        "PIN",
        "access",
        "code",
        "credential",
        "dots",
        "lock",
        "privacy",
        "protection",
        "safety",
        "secret",
        "security"
      ]
    },
    "security/password-minimalistic": {
      "name": "Password Minimalistic",
      "slug": "password-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/password-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/password-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/password-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/password-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/password-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/password-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/password-minimalistic.svg"
        }
      ],
      "tags": [
        "PIN",
        "access",
        "code",
        "lock",
        "minimal",
        "privacy",
        "protection",
        "safety",
        "secret",
        "security"
      ]
    },
    "security/password-minimalistic-input": {
      "name": "Password Minimalistic Input",
      "slug": "password-minimalistic-input",
      "category": "security",
      "categoryName": "Security",
      "id": "security/password-minimalistic-input",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/password-minimalistic-input.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/password-minimalistic-input.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/password-minimalistic-input.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/password-minimalistic-input.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/password-minimalistic-input.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/password-minimalistic-input.svg"
        }
      ],
      "tags": [
        "PIN",
        "access",
        "code",
        "field",
        "form",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/key": {
      "name": "Key",
      "slug": "key",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key.svg"
        }
      ],
      "tags": [
        "access",
        "credential",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "secret",
        "security",
        "unlock"
      ]
    },
    "security/key-square": {
      "name": "Key Square",
      "slug": "key-square",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-square.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-square-2": {
      "name": "Key Square 2",
      "slug": "key-square-2",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-square-2.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-minimalistic": {
      "name": "Key Minimalistic",
      "slug": "key-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-minimalistic.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-minimalistic-square": {
      "name": "Key Minimalistic Square",
      "slug": "key-minimalistic-square",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-minimalistic-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-minimalistic-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-minimalistic-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-minimalistic-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-minimalistic-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-minimalistic-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-minimalistic-square.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-minimalistic-square-2": {
      "name": "Key Minimalistic Square 2",
      "slug": "key-minimalistic-square-2",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-minimalistic-square-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-minimalistic-square-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-minimalistic-square-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-minimalistic-square-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-minimalistic-square-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-minimalistic-square-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-minimalistic-square-2.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-minimalistic-2": {
      "name": "Key Minimalistic 2",
      "slug": "key-minimalistic-2",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-minimalistic-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-minimalistic-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-minimalistic-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-minimalistic-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-minimalistic-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-minimalistic-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-minimalistic-2.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "password",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/key-minimalistic-square-3": {
      "name": "Key Minimalistic Square 3",
      "slug": "key-minimalistic-square-3",
      "category": "security",
      "categoryName": "Security",
      "id": "security/key-minimalistic-square-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/key-minimalistic-square-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/key-minimalistic-square-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/key-minimalistic-square-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/key-minimalistic-square-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/key-minimalistic-square-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/key-minimalistic-square-3.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "unlock"
      ]
    },
    "security/incognito": {
      "name": "Incognito",
      "slug": "incognito",
      "category": "security",
      "categoryName": "Security",
      "id": "security/incognito",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/incognito.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/incognito.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/incognito.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/incognito.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/incognito.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/incognito.svg"
        }
      ],
      "tags": [
        "access",
        "anonymous",
        "disguise",
        "hidden",
        "lock",
        "privacy",
        "private",
        "protection",
        "safety",
        "security",
        "stealth"
      ]
    },
    "security/shield-minimalistic": {
      "name": "Shield Minimalistic",
      "slug": "shield-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-minimalistic.svg"
        }
      ],
      "tags": [
        "access",
        "guard",
        "lock",
        "minimal",
        "privacy",
        "protect",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/shield-up": {
      "name": "Shield Up",
      "slug": "shield-up",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-up",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-up.svg"
        }
      ],
      "tags": [
        "access",
        "improve",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "update",
        "upload"
      ]
    },
    "security/shield": {
      "name": "Shield",
      "slug": "shield",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield.svg"
        }
      ],
      "tags": [
        "access",
        "antivirus",
        "defend",
        "firewall",
        "guard",
        "lock",
        "privacy",
        "protect",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/shield-star": {
      "name": "Shield Star",
      "slug": "shield-star",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-star",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-star.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-star.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-star.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-star.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-star.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-star.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "premium",
        "privacy",
        "protection",
        "safety",
        "security",
        "trusted",
        "verified"
      ]
    },
    "security/shield-check": {
      "name": "Shield Check",
      "slug": "shield-check",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-check",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-check.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-check.svg"
        }
      ],
      "tags": [
        "access",
        "approved",
        "lock",
        "privacy",
        "protected",
        "protection",
        "safety",
        "secure",
        "security",
        "verified"
      ]
    },
    "security/shield-warning": {
      "name": "Shield Warning",
      "slug": "shield-warning",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-warning",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-warning.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-warning.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-warning.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-warning.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-warning.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-warning.svg"
        }
      ],
      "tags": [
        "access",
        "alert",
        "caution",
        "lock",
        "privacy",
        "protection",
        "risk",
        "safety",
        "security",
        "threat"
      ]
    },
    "security/shield-minus": {
      "name": "Shield Minus",
      "slug": "shield-minus",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-minus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-minus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-minus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-minus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-minus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-minus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-minus.svg"
        }
      ],
      "tags": [
        "access",
        "downgrade",
        "lock",
        "privacy",
        "protection",
        "remove-protection",
        "safety",
        "security"
      ]
    },
    "security/shield-plus": {
      "name": "Shield Plus",
      "slug": "shield-plus",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-plus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-plus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-plus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-plus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-plus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-plus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-plus.svg"
        }
      ],
      "tags": [
        "access",
        "add-protection",
        "enhance",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "upgrade"
      ]
    },
    "security/shield-cross": {
      "name": "Shield Cross",
      "slug": "shield-cross",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-cross.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "privacy",
        "protection",
        "rejected",
        "safety",
        "security",
        "unprotected",
        "vulnerable"
      ]
    },
    "security/shield-keyhole": {
      "name": "Shield Keyhole",
      "slug": "shield-keyhole",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-keyhole",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-keyhole.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-keyhole.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-keyhole.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-keyhole.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-keyhole.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-keyhole.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "locked",
        "privacy",
        "protected",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/shield-keyhole-minimalistic": {
      "name": "Shield Keyhole Minimalistic",
      "slug": "shield-keyhole-minimalistic",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-keyhole-minimalistic",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-keyhole-minimalistic.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-keyhole-minimalistic.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-keyhole-minimalistic.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-keyhole-minimalistic.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-keyhole-minimalistic.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-keyhole-minimalistic.svg"
        }
      ],
      "tags": [
        "access",
        "lock",
        "locked",
        "minimal",
        "privacy",
        "protection",
        "safety",
        "secure",
        "security"
      ]
    },
    "security/shield-user": {
      "name": "Shield User",
      "slug": "shield-user",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-user",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-user.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-user.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-user.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-user.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-user.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-user.svg"
        }
      ],
      "tags": [
        "access",
        "account-security",
        "lock",
        "privacy",
        "protection",
        "safety",
        "security",
        "user-protection"
      ]
    },
    "security/shield-network": {
      "name": "Shield Network",
      "slug": "shield-network",
      "category": "security",
      "categoryName": "Security",
      "id": "security/shield-network",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/shield-network.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/shield-network.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/shield-network.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/shield-network.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/shield-network.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/shield-network.svg"
        }
      ],
      "tags": [
        "VPN",
        "access",
        "firewall",
        "lock",
        "network-security",
        "privacy",
        "protection",
        "safety",
        "security"
      ]
    },
    "security/qr-code": {
      "name": "QR Code",
      "slug": "qr-code",
      "category": "security",
      "categoryName": "Security",
      "id": "security/qr-code",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/qr-code.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/qr-code.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/qr-code.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/qr-code.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/qr-code.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/qr-code.svg"
        }
      ],
      "tags": [
        "URL",
        "access",
        "barcode",
        "code",
        "link",
        "lock",
        "matrix",
        "privacy",
        "protection",
        "safety",
        "scan",
        "security"
      ]
    },
    "security/scanner-2": {
      "name": "Scanner 2",
      "slug": "scanner-2",
      "category": "security",
      "categoryName": "Security",
      "id": "security/scanner-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/scanner-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/scanner-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/scanner-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/scanner-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/scanner-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/scanner-2.svg"
        }
      ],
      "tags": [
        "access",
        "identify",
        "lock",
        "privacy",
        "protection",
        "read",
        "safety",
        "scan",
        "security"
      ]
    },
    "security/code-scan": {
      "name": "Code Scan",
      "slug": "code-scan",
      "category": "security",
      "categoryName": "Security",
      "id": "security/code-scan",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/code-scan.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/code-scan.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/code-scan.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/code-scan.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/code-scan.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/code-scan.svg"
        }
      ],
      "tags": [
        "QR",
        "access",
        "barcode",
        "identify",
        "lock",
        "privacy",
        "protection",
        "read",
        "safety",
        "scan",
        "security"
      ]
    },
    "security/scanner": {
      "name": "Scanner",
      "slug": "scanner",
      "category": "security",
      "categoryName": "Security",
      "id": "security/scanner",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/scanner.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/scanner.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/scanner.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/scanner.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/scanner.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/scanner.svg"
        }
      ],
      "tags": [
        "access",
        "barcode",
        "identify",
        "lock",
        "privacy",
        "protection",
        "read",
        "safety",
        "scan",
        "security"
      ]
    },
    "security/object-scan": {
      "name": "Object Scan",
      "slug": "object-scan",
      "category": "security",
      "categoryName": "Security",
      "id": "security/object-scan",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/object-scan.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/object-scan.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/object-scan.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/object-scan.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/object-scan.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/object-scan.svg"
        }
      ],
      "tags": [
        "AR",
        "access",
        "detect",
        "identify",
        "lock",
        "privacy",
        "protection",
        "recognize",
        "safety",
        "scan",
        "security"
      ]
    },
    "security/eye-scan": {
      "name": "Eye Scan",
      "slug": "eye-scan",
      "category": "security",
      "categoryName": "Security",
      "id": "security/eye-scan",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/security/eye-scan.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/security/eye-scan.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/security/eye-scan.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/security/eye-scan.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/security/eye-scan.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/security/eye-scan.svg"
        }
      ],
      "tags": [
        "access",
        "biometric",
        "identify",
        "lock",
        "privacy",
        "protection",
        "recognition",
        "retina",
        "safety",
        "security"
      ]
    },
    "users/user-rounded": {
      "name": "User Rounded",
      "slug": "user-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "avatar",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/users-group-rounded": {
      "name": "Users Group Rounded",
      "slug": "users-group-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/users-group-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/users-group-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/users-group-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/users-group-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/users-group-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/users-group-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/users-group-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "community",
        "group",
        "human",
        "member",
        "members",
        "organization",
        "people",
        "person",
        "profile",
        "team",
        "user"
      ]
    },
    "users/users-group-two-rounded": {
      "name": "Users Group Two Rounded",
      "slug": "users-group-two-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/users-group-two-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/users-group-two-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/users-group-two-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/users-group-two-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/users-group-two-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/users-group-two-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/users-group-two-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "couple",
        "duo",
        "human",
        "member",
        "pair",
        "partner",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/user-check-rounded": {
      "name": "User Check Rounded",
      "slug": "user-check-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-check-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-check-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-check-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-check-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-check-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-check-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-check-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "approved",
        "confirmed",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "user",
        "verified"
      ]
    },
    "users/user-cross-rounded": {
      "name": "User Cross Rounded",
      "slug": "user-cross-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-cross-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-cross-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-cross-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-cross-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-cross-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-cross-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-cross-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "delete",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "reject",
        "remove",
        "user"
      ]
    },
    "users/user-plus-rounded": {
      "name": "User Plus Rounded",
      "slug": "user-plus-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-plus-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-plus-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-plus-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-plus-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-plus-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-plus-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-plus-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "add-user",
        "human",
        "invite",
        "member",
        "people",
        "person",
        "profile",
        "register",
        "user"
      ]
    },
    "users/user-minus-rounded": {
      "name": "User Minus Rounded",
      "slug": "user-minus-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-minus-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-minus-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-minus-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-minus-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-minus-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-minus-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-minus-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "remove-user",
        "unfriend",
        "user"
      ]
    },
    "users/user-block-rounded": {
      "name": "User Block Rounded",
      "slug": "user-block-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-block-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-block-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-block-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-block-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-block-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-block-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-block-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "banned",
        "blocked",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "restricted",
        "user"
      ]
    },
    "users/user-circle": {
      "name": "User Circle",
      "slug": "user-circle",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-circle",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-circle.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-circle.svg"
        }
      ],
      "tags": [
        "account",
        "avatar",
        "human",
        "member",
        "people",
        "person",
        "photo",
        "profile",
        "profile-pic",
        "user"
      ]
    },
    "users/user-speak-rounded": {
      "name": "User Speak Rounded",
      "slug": "user-speak-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-speak-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-speak-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-speak-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-speak-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-speak-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-speak-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-speak-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "speaker",
        "talking",
        "user",
        "voice"
      ]
    },
    "users/user-heart-rounded": {
      "name": "User Heart Rounded",
      "slug": "user-heart-rounded",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-heart-rounded",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-heart-rounded.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-heart-rounded.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-heart-rounded.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-heart-rounded.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-heart-rounded.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-heart-rounded.svg"
        }
      ],
      "tags": [
        "account",
        "favourite",
        "human",
        "liked",
        "loved",
        "member",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/user-id": {
      "name": "User Id",
      "slug": "user-id",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-id",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-id.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-id.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-id.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-id.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-id.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-id.svg"
        }
      ],
      "tags": [
        "ID-card",
        "account",
        "badge",
        "credential",
        "human",
        "identity",
        "member",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/user": {
      "name": "User",
      "slug": "user",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user.svg"
        }
      ],
      "tags": [
        "account",
        "avatar",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/user-check": {
      "name": "User Check",
      "slug": "user-check",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-check",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-check.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-check.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-check.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-check.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-check.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-check.svg"
        }
      ],
      "tags": [
        "account",
        "approved",
        "confirmed",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "user",
        "verified"
      ]
    },
    "users/user-plus": {
      "name": "User Plus",
      "slug": "user-plus",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-plus",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-plus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-plus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-plus.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-plus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-plus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-plus.svg"
        }
      ],
      "tags": [
        "account",
        "add-user",
        "human",
        "invite",
        "member",
        "new-member",
        "people",
        "person",
        "profile",
        "register",
        "sign-up",
        "user"
      ]
    },
    "users/user-cross": {
      "name": "User Cross",
      "slug": "user-cross",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-cross",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-cross.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-cross.svg"
        }
      ],
      "tags": [
        "account",
        "delete",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "reject",
        "remove",
        "user"
      ]
    },
    "users/user-minus": {
      "name": "User Minus",
      "slug": "user-minus",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-minus",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-minus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-minus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-minus.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-minus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-minus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-minus.svg"
        }
      ],
      "tags": [
        "account",
        "delete",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "remove-user",
        "unfriend",
        "user"
      ]
    },
    "users/user-block": {
      "name": "User Block",
      "slug": "user-block",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-block",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-block.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-block.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-block.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-block.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-block.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-block.svg"
        }
      ],
      "tags": [
        "account",
        "banned",
        "blocked",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "restricted",
        "user"
      ]
    },
    "users/user-speak": {
      "name": "User Speak",
      "slug": "user-speak",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-speak",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-speak.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-speak.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-speak.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-speak.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-speak.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-speak.svg"
        }
      ],
      "tags": [
        "account",
        "human",
        "member",
        "people",
        "person",
        "presenter",
        "profile",
        "speaker",
        "talking",
        "user",
        "voice"
      ]
    },
    "users/user-heart": {
      "name": "User Heart",
      "slug": "user-heart",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-heart",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-heart.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-heart.svg"
        }
      ],
      "tags": [
        "account",
        "favourite",
        "human",
        "liked",
        "loved",
        "member",
        "people",
        "person",
        "profile",
        "user"
      ]
    },
    "users/user-hands": {
      "name": "User Hands",
      "slug": "user-hands",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-hands",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-hands.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-hands.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-hands.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-hands.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-hands.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-hands.svg"
        }
      ],
      "tags": [
        "account",
        "collaboration",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "support",
        "team",
        "user"
      ]
    },
    "users/user-hand-up": {
      "name": "User Hand Up",
      "slug": "user-hand-up",
      "category": "users",
      "categoryName": "Users",
      "id": "users/user-hand-up",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/users/user-hand-up.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/users/user-hand-up.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/users/user-hand-up.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/users/user-hand-up.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/users/user-hand-up.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/users/user-hand-up.svg"
        }
      ],
      "tags": [
        "account",
        "human",
        "member",
        "people",
        "person",
        "profile",
        "question",
        "raise-hand",
        "user",
        "volunteer"
      ]
    },
    "building-infrastructure/city": {
      "name": "City",
      "slug": "city",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/city",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/city.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/city.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/city.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/city.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/city.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/city.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "downtown",
        "metropolitan",
        "property",
        "real estate",
        "skyline",
        "town",
        "urban"
      ]
    },
    "building-infrastructure/buildings": {
      "name": "Buildings",
      "slug": "buildings",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/buildings",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/buildings.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/buildings.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/buildings.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/buildings.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/buildings.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/buildings.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "commercial",
        "office",
        "property",
        "real estate",
        "skyscraper",
        "urban"
      ]
    },
    "building-infrastructure/buildings-2": {
      "name": "Buildings 2",
      "slug": "buildings-2",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/buildings-2",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/buildings-2.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/buildings-2.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/buildings-2.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/buildings-2.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/buildings-2.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/buildings-2.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "commercial",
        "office",
        "property",
        "real estate",
        "skyscraper",
        "urban"
      ]
    },
    "building-infrastructure/buildings-3": {
      "name": "Buildings 3",
      "slug": "buildings-3",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/buildings-3",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/buildings-3.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/buildings-3.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/buildings-3.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/buildings-3.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/buildings-3.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/buildings-3.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "commercial",
        "office",
        "property",
        "real estate",
        "skyscraper",
        "urban"
      ]
    },
    "building-infrastructure/garage": {
      "name": "Garage",
      "slug": "garage",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/garage",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/garage.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/garage.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/garage.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/garage.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/garage.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/garage.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "car",
        "city",
        "parking",
        "property",
        "real estate",
        "storage",
        "vehicle"
      ]
    },
    "building-infrastructure/home": {
      "name": "Home",
      "slug": "home",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/home",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/home.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/home.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/home.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/home.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/home.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/home.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "homepage",
        "house",
        "main",
        "property",
        "real estate",
        "residence",
        "start"
      ]
    },
    "building-infrastructure/hospital": {
      "name": "Hospital",
      "slug": "hospital",
      "category": "building-infrastructure",
      "categoryName": "Building, Infrastructure",
      "id": "building-infrastructure/hospital",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/building-infrastructure/hospital.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/building-infrastructure/hospital.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/building-infrastructure/hospital.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/building-infrastructure/hospital.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/building-infrastructure/hospital.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/building-infrastructure/hospital.svg"
        }
      ],
      "tags": [
        "architecture",
        "building",
        "city",
        "clinic",
        "emergency",
        "health",
        "healthcare",
        "medical",
        "property",
        "real estate"
      ]
    },
    "hands/hand-heart": {
      "name": "Hand Heart",
      "slug": "hand-heart",
      "category": "hands",
      "categoryName": "Hands",
      "id": "hands/hand-heart",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/hands/hand-heart.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/hands/hand-heart.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/hands/hand-heart.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/hands/hand-heart.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/hands/hand-heart.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/hands/hand-heart.svg"
        }
      ],
      "tags": [
        "care",
        "charity",
        "donate",
        "gesture",
        "giving",
        "hand",
        "kindness",
        "love",
        "support",
        "volunteer"
      ]
    },
    "hands/hand-stars": {
      "name": "Hand Stars",
      "slug": "hand-stars",
      "category": "hands",
      "categoryName": "Hands",
      "id": "hands/hand-stars",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/hands/hand-stars.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/hands/hand-stars.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/hands/hand-stars.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/hands/hand-stars.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/hands/hand-stars.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/hands/hand-stars.svg"
        }
      ],
      "tags": [
        "excellent",
        "gesture",
        "giving",
        "hand",
        "magic",
        "premium",
        "quality",
        "sparkle",
        "support"
      ]
    },
    "hands/hand-pills": {
      "name": "Hand Pills",
      "slug": "hand-pills",
      "category": "hands",
      "categoryName": "Hands",
      "id": "hands/hand-pills",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/hands/hand-pills.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/hands/hand-pills.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/hands/hand-pills.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/hands/hand-pills.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/hands/hand-pills.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/hands/hand-pills.svg"
        }
      ],
      "tags": [
        "dose",
        "gesture",
        "giving",
        "hand",
        "medication",
        "pharmacy",
        "prescription",
        "support",
        "treatment"
      ]
    },
    "hands/hand-money": {
      "name": "Hand Money",
      "slug": "hand-money",
      "category": "hands",
      "categoryName": "Hands",
      "id": "hands/hand-money",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/hands/hand-money.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/hands/hand-money.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/hands/hand-money.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/hands/hand-money.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/hands/hand-money.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/hands/hand-money.svg"
        }
      ],
      "tags": [
        "cashback",
        "donate",
        "gesture",
        "giving",
        "hand",
        "pay",
        "payment",
        "receive",
        "support",
        "tip"
      ]
    },
    "hands/hand-shake": {
      "name": "Hand Shake",
      "slug": "hand-shake",
      "category": "hands",
      "categoryName": "Hands",
      "id": "hands/hand-shake",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/hands/hand-shake.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/hands/hand-shake.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/hands/hand-shake.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/hands/hand-shake.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/hands/hand-shake.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/hands/hand-shake.svg"
        }
      ],
      "tags": [
        "agreement",
        "collaboration",
        "deal",
        "gesture",
        "giving",
        "hand",
        "partnership",
        "support",
        "trust",
        "welcome"
      ]
    },
    "transport-parts-service/gas-station": {
      "name": "Gas Station",
      "slug": "gas-station",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/gas-station",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/gas-station.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/gas-station.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/gas-station.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/gas-station.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/gas-station.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/gas-station.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "diesel",
        "fuel",
        "petrol",
        "refuel",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/electric-refueling": {
      "name": "Electric Refueling",
      "slug": "electric-refueling",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/electric-refueling",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/electric-refueling.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/electric-refueling.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/electric-refueling.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/electric-refueling.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/electric-refueling.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/electric-refueling.svg"
        }
      ],
      "tags": [
        "EV",
        "automotive",
        "car",
        "charge",
        "commute",
        "electric-vehicle",
        "green",
        "plug-in",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/shock-absorber": {
      "name": "Shock Absorber",
      "slug": "shock-absorber",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/shock-absorber",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/shock-absorber.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/shock-absorber.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/shock-absorber.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/shock-absorber.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/shock-absorber.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/shock-absorber.svg"
        }
      ],
      "tags": [
        "absorb",
        "automotive",
        "car",
        "commute",
        "damper",
        "spring",
        "suspension",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/accumulator": {
      "name": "Accumulator",
      "slug": "accumulator",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/accumulator",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/accumulator.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/accumulator.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/accumulator.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/accumulator.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/accumulator.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/accumulator.svg"
        }
      ],
      "tags": [
        "automotive",
        "battery",
        "car",
        "cell",
        "charge",
        "commute",
        "energy",
        "power",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/transmission": {
      "name": "Transmission",
      "slug": "transmission",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/transmission",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/transmission.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/transmission.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/transmission.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/transmission.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/transmission.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/transmission.svg"
        }
      ],
      "tags": [
        "automatic",
        "automotive",
        "car",
        "commute",
        "drive",
        "gear",
        "gearbox",
        "manual",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/transmission-circle": {
      "name": "Transmission Circle",
      "slug": "transmission-circle",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/transmission-circle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/transmission-circle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/transmission-circle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/transmission-circle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/transmission-circle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/transmission-circle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/transmission-circle.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "drive",
        "gear",
        "gearbox",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/transmission-square": {
      "name": "Transmission Square",
      "slug": "transmission-square",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/transmission-square",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/transmission-square.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/transmission-square.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/transmission-square.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/transmission-square.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/transmission-square.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/transmission-square.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "drive",
        "gear",
        "gearbox",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/suspension": {
      "name": "Suspension",
      "slug": "suspension",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/suspension",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/suspension.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/suspension.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/suspension.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/suspension.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/suspension.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/suspension.svg"
        }
      ],
      "tags": [
        "absorber",
        "automotive",
        "car",
        "commute",
        "damper",
        "smooth",
        "spring",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/suspension-bolt": {
      "name": "Suspension Bolt",
      "slug": "suspension-bolt",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/suspension-bolt",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/suspension-bolt.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/suspension-bolt.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/suspension-bolt.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/suspension-bolt.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/suspension-bolt.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/suspension-bolt.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "electric",
        "powered",
        "spring",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/suspension-cross": {
      "name": "Suspension Cross",
      "slug": "suspension-cross",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/suspension-cross",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/suspension-cross.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/suspension-cross.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/suspension-cross.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/suspension-cross.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/suspension-cross.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/suspension-cross.svg"
        }
      ],
      "tags": [
        "automotive",
        "broken",
        "car",
        "commute",
        "damaged",
        "problem",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/tram": {
      "name": "Tram",
      "slug": "tram",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/tram",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/tram.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/tram.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/tram.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/tram.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/tram.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/tram.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "public-transport",
        "rail",
        "streetcar",
        "transport",
        "travel",
        "trolley",
        "vehicle"
      ]
    },
    "transport-parts-service/bus": {
      "name": "Bus",
      "slug": "bus",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/bus",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/bus.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/bus.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/bus.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/bus.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/bus.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/bus.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "coach",
        "commute",
        "public-transport",
        "ride",
        "transit",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/wheel-angle": {
      "name": "Wheel Angle",
      "slug": "wheel-angle",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/wheel-angle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/wheel-angle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/wheel-angle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/wheel-angle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/wheel-angle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/wheel-angle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/wheel-angle.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "steering",
        "tire",
        "transport",
        "travel",
        "turn",
        "tyre",
        "vehicle"
      ]
    },
    "transport-parts-service/wheel": {
      "name": "Wheel",
      "slug": "wheel",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/wheel",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/wheel.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/wheel.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/wheel.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/wheel.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/wheel.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/wheel.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "rim",
        "rotate",
        "round",
        "tire",
        "transport",
        "travel",
        "tyre",
        "vehicle"
      ]
    },
    "transport-parts-service/spedometer-middle": {
      "name": "Spedometer Middle",
      "slug": "spedometer-middle",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/spedometer-middle",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/spedometer-middle.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/spedometer-middle.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/spedometer-middle.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/spedometer-middle.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/spedometer-middle.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/spedometer-middle.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "dial",
        "gauge",
        "moderate",
        "speed",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/spedometer-max": {
      "name": "Spedometer Max",
      "slug": "spedometer-max",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/spedometer-max",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/spedometer-max.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/spedometer-max.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/spedometer-max.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/spedometer-max.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/spedometer-max.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/spedometer-max.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "dial",
        "fast",
        "gauge",
        "maximum",
        "speed",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/spedometer-low": {
      "name": "Spedometer Low",
      "slug": "spedometer-low",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/spedometer-low",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/spedometer-low.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/spedometer-low.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/spedometer-low.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/spedometer-low.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/spedometer-low.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/spedometer-low.svg"
        }
      ],
      "tags": [
        "RPM",
        "automotive",
        "car",
        "commute",
        "dial",
        "gauge",
        "slow",
        "speed",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "transport-parts-service/scooter": {
      "name": "Scooter",
      "slug": "scooter",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/scooter",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/scooter.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/scooter.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/scooter.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/scooter.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/scooter.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/scooter.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "moped",
        "ride",
        "transport",
        "travel",
        "two-wheel",
        "vehicle",
        "vespa"
      ]
    },
    "transport-parts-service/kick-scooter": {
      "name": "Kick Scooter",
      "slug": "kick-scooter",
      "category": "transport-parts-service",
      "categoryName": "Transport, Parts, Service",
      "id": "transport-parts-service/kick-scooter",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/transport-parts-service/kick-scooter.svg"
        },
        {
          "weight": "Broken",
          "weightSlug": "broken",
          "path": "svgs/broken/transport-parts-service/kick-scooter.svg"
        },
        {
          "weight": "Outline",
          "weightSlug": "outline",
          "path": "svgs/outline/transport-parts-service/kick-scooter.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/transport-parts-service/kick-scooter.svg"
        },
        {
          "weight": "Bold Duotone",
          "weightSlug": "bold-duotone",
          "path": "svgs/bold-duotone/transport-parts-service/kick-scooter.svg"
        },
        {
          "weight": "Line Duotone",
          "weightSlug": "line-duotone",
          "path": "svgs/line-duotone/transport-parts-service/kick-scooter.svg"
        }
      ],
      "tags": [
        "automotive",
        "car",
        "commute",
        "electric-scooter",
        "micro-mobility",
        "ride",
        "scooter",
        "transport",
        "travel",
        "vehicle"
      ]
    },
    "health-benefits/tooth": {
      "name": "Tooth",
      "slug": "tooth",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/tooth",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/tooth.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/tooth.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "dental",
        "dentist",
        "health",
        "nutrition",
        "oral",
        "smile",
        "teeth",
        "wellness"
      ]
    },
    "health-benefits/sleep-rest": {
      "name": "Sleep Rest",
      "slug": "sleep-rest",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/sleep-rest",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/sleep-rest.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/sleep-rest.svg"
        }
      ],
      "tags": [
        "bedtime",
        "benefit",
        "body",
        "health",
        "night",
        "nutrition",
        "recovery",
        "rest",
        "sleeping",
        "wellness",
        "zzz"
      ]
    },
    "health-benefits/relax": {
      "name": "Relax",
      "slug": "relax",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/relax",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/relax.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/relax.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "calm",
        "chill",
        "health",
        "nutrition",
        "peace",
        "stress-free",
        "unwind",
        "wellness",
        "zen"
      ]
    },
    "health-benefits/cognitive": {
      "name": "Cognitive",
      "slug": "cognitive",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/cognitive",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/cognitive.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/cognitive.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "brain",
        "clarity",
        "focus",
        "health",
        "intelligence",
        "mental",
        "nutrition",
        "thinking",
        "wellness"
      ]
    },
    "health-benefits/virus-immunity": {
      "name": "Virus Immunity",
      "slug": "virus-immunity",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/virus-immunity",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/virus-immunity.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/virus-immunity.svg"
        }
      ],
      "tags": [
        "antibody",
        "benefit",
        "body",
        "defence",
        "health",
        "immune",
        "nutrition",
        "protection",
        "resist",
        "wellness"
      ]
    },
    "health-benefits/stomach-digestion": {
      "name": "Stomach Digestion",
      "slug": "stomach-digestion",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/stomach-digestion",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/stomach-digestion.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/stomach-digestion.svg"
        },
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/stomach-digestion.svg"
        }
      ],
      "tags": [
        "belly",
        "benefit",
        "body",
        "digestion",
        "digestive",
        "gut",
        "health",
        "intestine",
        "nutrition",
        "tummy",
        "wellness"
      ]
    },
    "health-benefits/lungs": {
      "name": "Lungs",
      "slug": "lungs",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/lungs",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/lungs.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/lungs.svg"
        }
      ],
      "tags": [
        "air",
        "benefit",
        "body",
        "breath",
        "breathing",
        "health",
        "nutrition",
        "oxygen",
        "respiratory",
        "wellness"
      ]
    },
    "health-benefits/kidney": {
      "name": "Kidney",
      "slug": "kidney",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/kidney",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/kidney.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/kidney.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "detox",
        "filter",
        "health",
        "nutrition",
        "organ",
        "renal",
        "wellness"
      ]
    },
    "health-benefits/brain": {
      "name": "Brain",
      "slug": "brain",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/brain",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/brain.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/brain.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "cognitive",
        "health",
        "intelligence",
        "memory",
        "mental",
        "mind",
        "nutrition",
        "smart",
        "think",
        "wellness"
      ]
    },
    "health-benefits/bacteria": {
      "name": "Bacteria",
      "slug": "bacteria",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/bacteria",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/bacteria.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/bacteria.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "germ",
        "gut",
        "health",
        "infection",
        "microbe",
        "microorganism",
        "nutrition",
        "wellness"
      ]
    },
    "health-benefits/allergens": {
      "name": "Allergens",
      "slug": "allergens",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/allergens",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/allergens.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/allergens.svg"
        }
      ],
      "tags": [
        "allergy",
        "benefit",
        "body",
        "health",
        "intolerance",
        "nutrition",
        "reaction",
        "sensitive",
        "warning",
        "wellness"
      ]
    },
    "health-benefits/eye-health": {
      "name": "Eye Health",
      "slug": "eye-health",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/eye-health",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/health-benefits/eye-health.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "eye-care",
        "health",
        "nutrition",
        "optical",
        "see",
        "sight",
        "vision",
        "wellness"
      ]
    },
    "ingredients/vegetables": {
      "name": "Vegetables",
      "slug": "vegetables",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/vegetables",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/vegetables.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/vegetables.svg"
        }
      ],
      "tags": [
        "cooking",
        "dietary",
        "food",
        "garden",
        "greens",
        "ingredient",
        "nutrition",
        "produce",
        "recipe",
        "salad",
        "veg",
        "veggies"
      ]
    },
    "ingredients/knife-fork": {
      "name": "Knife Fork",
      "slug": "knife-fork",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/knife-fork",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/knife-fork.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/knife-fork.svg"
        }
      ],
      "tags": [
        "cooking",
        "cutlery",
        "dietary",
        "dining",
        "eat",
        "food",
        "ingredient",
        "meal",
        "nutrition",
        "recipe",
        "restaurant",
        "utensils"
      ]
    },
    "ingredients/carrot": {
      "name": "Carrot",
      "slug": "carrot",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/carrot",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/carrot.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/carrot.svg"
        }
      ],
      "tags": [
        "cooking",
        "dietary",
        "food",
        "healthy",
        "ingredient",
        "nutrition",
        "orange",
        "recipe",
        "root",
        "veg",
        "vegetable",
        "vitamin-A"
      ]
    },
    "ingredients/fish": {
      "name": "Fish",
      "slug": "fish",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/fish",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/fish.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/fish.svg"
        }
      ],
      "tags": [
        "aquatic",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "omega-3",
        "protein",
        "recipe",
        "salmon",
        "seafood"
      ]
    },
    "ingredients/cake": {
      "name": "Cake",
      "slug": "cake",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/cake",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/cake.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/cake.svg"
        }
      ],
      "tags": [
        "baking",
        "birthday",
        "celebration",
        "cooking",
        "dessert",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "recipe",
        "sweet",
        "treat"
      ]
    },
    "ingredients/meat": {
      "name": "Meat",
      "slug": "meat",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/meat",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/meat.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/meat.svg"
        }
      ],
      "tags": [
        "beef",
        "butcher",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "protein",
        "recipe",
        "red-meat",
        "steak"
      ]
    },
    "ingredients/chicken-steam": {
      "name": "Chicken Steam",
      "slug": "chicken-steam",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/chicken-steam",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/chicken-steam.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/chicken-steam.svg"
        }
      ],
      "tags": [
        "cooked",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "meat",
        "nutrition",
        "poultry",
        "protein",
        "recipe",
        "steam"
      ]
    },
    "ingredients/mint": {
      "name": "Mint",
      "slug": "mint",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/mint",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/mint.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/mint.svg"
        }
      ],
      "tags": [
        "cooking",
        "dietary",
        "flavour",
        "food",
        "fresh",
        "garnish",
        "green",
        "herb",
        "ingredient",
        "nutrition",
        "recipe"
      ]
    },
    "ingredients/sesame": {
      "name": "Sesame",
      "slug": "sesame",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/sesame",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/sesame.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/sesame.svg"
        }
      ],
      "tags": [
        "Asian",
        "allergy",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "recipe",
        "seed",
        "topping"
      ]
    },
    "ingredients/apple": {
      "name": "Apple",
      "slug": "apple",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/apple",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/apple.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/apple.svg"
        }
      ],
      "tags": [
        "cooking",
        "dietary",
        "food",
        "fruit",
        "healthy",
        "ingredient",
        "natural",
        "nutrition",
        "recipe",
        "snack",
        "vitamin"
      ]
    },
    "ingredients/shrimp": {
      "name": "Shrimp",
      "slug": "shrimp",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/shrimp",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/shrimp.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/shrimp.svg"
        }
      ],
      "tags": [
        "cooking",
        "crustacean",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "prawn",
        "recipe",
        "seafood",
        "shellfish"
      ]
    },
    "ingredients/peanut": {
      "name": "Peanut",
      "slug": "peanut",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/peanut",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/peanut.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/peanut.svg"
        }
      ],
      "tags": [
        "allergy",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "legume",
        "nut",
        "nutrition",
        "protein",
        "recipe",
        "snack"
      ]
    },
    "ingredients/egg-fresh": {
      "name": "Egg Fresh",
      "slug": "egg-fresh",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/egg-fresh",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/egg-fresh.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/egg-fresh.svg"
        }
      ],
      "tags": [
        "breakfast",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "nutrition",
        "oval",
        "poultry",
        "protein",
        "recipe"
      ]
    },
    "ingredients/egg-fried": {
      "name": "Egg Fried",
      "slug": "egg-fried",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/egg-fried",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/egg-fried.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/egg-fried.svg"
        }
      ],
      "tags": [
        "breakfast",
        "cooking",
        "dietary",
        "food",
        "fry",
        "ingredient",
        "nutrition",
        "recipe",
        "sunny-side-up"
      ]
    },
    "ingredients/soy-bean": {
      "name": "Soy Bean",
      "slug": "soy-bean",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/soy-bean",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/soy-bean.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/soy-bean.svg"
        }
      ],
      "tags": [
        "Asian",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "legume",
        "nutrition",
        "protein",
        "recipe",
        "soy",
        "tofu",
        "vegan"
      ]
    },
    "ingredients/legume": {
      "name": "Legume",
      "slug": "legume",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/legume",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/legume.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/legume.svg"
        }
      ],
      "tags": [
        "bean",
        "cooking",
        "dietary",
        "food",
        "ingredient",
        "lentil",
        "nutrition",
        "protein",
        "pulse",
        "recipe",
        "vegan"
      ]
    },
    "ingredients/cheese-dairy": {
      "name": "Cheese Dairy",
      "slug": "cheese-dairy",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/cheese-dairy",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/cheese-dairy.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/cheese-dairy.svg"
        }
      ],
      "tags": [
        "calcium",
        "cooking",
        "dairy",
        "dietary",
        "food",
        "fromage",
        "ingredient",
        "lactose",
        "milk",
        "nutrition",
        "recipe"
      ]
    },
    "ingredients/grain": {
      "name": "Grain",
      "slug": "grain",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/grain",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/grain.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/grain.svg"
        }
      ],
      "tags": [
        "cereal",
        "cooking",
        "dietary",
        "fibre",
        "food",
        "ingredient",
        "nutrition",
        "oat",
        "recipe",
        "rice",
        "wheat",
        "whole-grain"
      ]
    },
    "ingredients/sprout": {
      "name": "Sprout",
      "slug": "sprout",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/sprout",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/sprout.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/sprout.svg"
        }
      ],
      "tags": [
        "cooking",
        "dietary",
        "food",
        "fresh",
        "green",
        "growth",
        "ingredient",
        "microgreen",
        "nutrition",
        "recipe",
        "seedling",
        "young"
      ]
    },
    "ingredients/gluten": {
      "name": "Gluten",
      "slug": "gluten",
      "category": "ingredients",
      "categoryName": "Ingredients",
      "id": "ingredients/gluten",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/ingredients/gluten.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/ingredients/gluten.svg"
        }
      ],
      "tags": [
        "allergy",
        "bread",
        "celiac",
        "cooking",
        "dietary",
        "food",
        "grain",
        "ingredient",
        "intolerance",
        "nutrition",
        "recipe",
        "wheat"
      ]
    },
    "dogs/paw-flex": {
      "name": "Paw Flex",
      "slug": "paw-flex",
      "category": "dogs",
      "categoryName": "Dogs",
      "id": "dogs/paw-flex",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/dogs/paw-flex.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/dogs/paw-flex.svg"
        }
      ],
      "tags": [
        "animal",
        "canine",
        "dog",
        "footprint",
        "paw-print",
        "pet",
        "puppy",
        "track"
      ]
    },
    "dogs/dog-1": {
      "name": "Dog 1",
      "slug": "dog-1",
      "category": "dogs",
      "categoryName": "Dogs",
      "id": "dogs/dog-1",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/dogs/dog-1.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/dogs/dog-1.svg"
        }
      ],
      "tags": [
        "animal",
        "canine",
        "dog",
        "hound",
        "pet",
        "pooch",
        "pup",
        "puppy"
      ]
    },
    "dogs/dog-side": {
      "name": "Dog Side",
      "slug": "dog-side",
      "category": "dogs",
      "categoryName": "Dogs",
      "id": "dogs/dog-side",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/dogs/dog-side.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/dogs/dog-side.svg"
        }
      ],
      "tags": [
        "animal",
        "canine",
        "dog",
        "pet",
        "profile",
        "puppy",
        "silhouette"
      ]
    },
    "dogs/dog-2": {
      "name": "Dog 2",
      "slug": "dog-2",
      "category": "dogs",
      "categoryName": "Dogs",
      "id": "dogs/dog-2",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/dogs/dog-2.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/dogs/dog-2.svg"
        }
      ],
      "tags": [
        "animal",
        "canine",
        "dog",
        "hound",
        "pet",
        "pooch",
        "pup",
        "puppy"
      ]
    },
    "dogs/pet-food": {
      "name": "Pet Food",
      "slug": "pet-food",
      "category": "dogs",
      "categoryName": "Dogs",
      "id": "dogs/pet-food",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/dogs/pet-food.svg"
        },
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/dogs/pet-food.svg"
        }
      ],
      "tags": [
        "animal",
        "bowl",
        "canine",
        "dinner",
        "dog",
        "feeding",
        "kibble",
        "meal",
        "pet",
        "puppy"
      ]
    },
    "additional/add": {
      "name": "Add",
      "slug": "add",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/add",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/add.svg"
        }
      ],
      "tags": [
        "create",
        "extra",
        "insert",
        "misc",
        "new",
        "plus",
        "ui"
      ]
    },
    "additional/subtract": {
      "name": "Subtract",
      "slug": "subtract",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/subtract",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/subtract.svg"
        }
      ],
      "tags": [
        "delete",
        "extra",
        "minus",
        "misc",
        "reduce",
        "remove",
        "ui"
      ]
    },
    "additional/arrow-left": {
      "name": "Arrow Left",
      "slug": "arrow-left",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/arrow-left",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/arrow-left.svg"
        }
      ],
      "tags": [
        "back",
        "extra",
        "left",
        "misc",
        "previous",
        "return",
        "ui"
      ]
    },
    "additional/arrow-right": {
      "name": "Arrow Right",
      "slug": "arrow-right",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/arrow-right",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/arrow-right.svg"
        }
      ],
      "tags": [
        "continue",
        "extra",
        "forward",
        "misc",
        "next",
        "right",
        "ui"
      ]
    },
    "additional/arrow-up": {
      "name": "Arrow Up",
      "slug": "arrow-up",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/arrow-up",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/arrow-up.svg"
        }
      ],
      "tags": [
        "above",
        "ascend",
        "extra",
        "misc",
        "rise",
        "ui",
        "up"
      ]
    },
    "additional/arrow-down": {
      "name": "Arrow Down",
      "slug": "arrow-down",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/arrow-down",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/arrow-down.svg"
        }
      ],
      "tags": [
        "below",
        "descend",
        "down",
        "dropdown",
        "extra",
        "misc",
        "ui"
      ]
    },
    "additional/lightning": {
      "name": "Lightning",
      "slug": "lightning",
      "category": "additional",
      "categoryName": "Additional",
      "id": "additional/lightning",
      "weights": [
        {
          "weight": "Bold",
          "weightSlug": "bold",
          "path": "svgs/bold/additional/lightning.svg"
        }
      ],
      "tags": [
        "bolt",
        "electric",
        "energy",
        "extra",
        "fast",
        "flash",
        "misc",
        "power",
        "speed",
        "thunder",
        "ui"
      ]
    },
    "health-benefits/skin": {
      "name": "Skin",
      "slug": "skin",
      "category": "health-benefits",
      "categoryName": "Health Benefits",
      "id": "health-benefits/skin",
      "weights": [
        {
          "weight": "Linear",
          "weightSlug": "linear",
          "path": "svgs/linear/health-benefits/skin.svg"
        }
      ],
      "tags": [
        "benefit",
        "body",
        "coat",
        "complexion",
        "dermatology",
        "fur",
        "glow",
        "health",
        "nutrition",
        "wellness"
      ]
    }
  }
}